/**
 * @packageDocumentation
 * @category Translation
 */

import { Translation } from 'BomdisoftTranslations/utils';

// Translation
export const language: Translation = {
  amharic: 'ቋንቋ',
  arabic: 'اللغة',
  bengali: 'ভাষা',
  chinese: '语言',
  english: 'Language',
  estonian: 'Keel',
  filipino: 'Wika',
  french: 'Langue',
  german: 'Sprache',
  hindi: 'भाषा',
  indonesian: 'Bahasa',
  japanese: '言語',
  korean: '언어',
  portuguese: 'Idioma',
  russian: 'Язык',
  spanish: 'Idioma',
  swahili: 'Lugha',
  vietnamese: 'Ngôn ngữ',
};
export const languageText: Translation = language;

// Theme
export const themeText: Translation = {
  amharic: 'ገጽታ',
  arabic: 'السمة',
  bengali: 'থিম',
  chinese: '主题',
  english: 'Theme',
  estonian: 'Teema',
  filipino: 'Tema',
  french: 'Thème',
  german: 'Thema',
  hindi: 'थीम',
  indonesian: 'Tema',
  japanese: 'テーマ',
  korean: '테마',
  portuguese: 'Tema',
  russian: 'Тема',
  spanish: 'Tema',
  swahili: 'Mandhari',
  vietnamese: 'Chủ đề',
};
export const light: Translation = {
  amharic: 'ብርሃን',
  arabic: 'فاتح',
  bengali: 'হালকা',
  chinese: '浅色',
  english: 'Light',
  estonian: 'Valgus',
  filipino: 'Magaan',
  french: 'Lumière',
  german: 'Licht',
  hindi: 'हल्का',
  indonesian: 'Terang',
  japanese: 'ライト',
  korean: '밝게',
  portuguese: 'Claro',
  russian: 'Свет',
  spanish: 'Claro',
  swahili: 'Mwanga',
  vietnamese: 'Sáng',
};
export const dark: Translation = {
  amharic: 'ጨለማ',
  arabic: 'داكن',
  bengali: 'গাঢ়',
  chinese: '深色',
  english: 'Dark',
  estonian: 'Tume',
  filipino: 'Madilim',
  french: 'Sombre',
  german: 'Dunkel',
  hindi: 'गहरा',
  indonesian: 'Gelap',
  japanese: 'ダーク',
  korean: '어둡게',
  portuguese: 'Escuro',
  russian: 'Темный',
  spanish: 'Oscuro',
  swahili: 'Giza',
  vietnamese: 'Tối',
};
export const greenish: Translation = {
  amharic: 'አረንጓዴ',
  arabic: 'أخضر',
  bengali: 'সবুজ',
  chinese: '绿色',
  english: 'Green',
  estonian: 'Roheline',
  filipino: 'Berde',
  french: 'Verte',
  german: 'Grün',
  hindi: 'हरा',
  indonesian: 'Hijau',
  japanese: '緑',
  korean: '초록색',
  portuguese: 'Verde',
  russian: 'Зеленый',
  spanish: 'Verde',
  swahili: 'Kijani',
  vietnamese: 'Xanh lá',
};
export const blueish: Translation = {
  amharic: 'ሰማያዊ',
  arabic: 'أزرق',
  bengali: 'নীল',
  chinese: '蓝色',
  english: 'Blue',
  estonian: 'Sinine',
  filipino: 'Asul',
  french: 'Bleue',
  german: 'Blau',
  hindi: 'नीला',
  indonesian: 'Biru',
  japanese: '青',
  korean: '파란색',
  portuguese: 'Azul',
  russian: 'Синий',
  spanish: 'Azul',
  swahili: 'Bluu',
  vietnamese: 'Xanh dương',
};
export const greyish: Translation = {
  amharic: 'ግራጫ',
  arabic: 'رمادي',
  bengali: 'ধূসর',
  chinese: '灰色',
  english: 'Grey',
  estonian: 'Hall',
  filipino: 'Kulay-abo',
  french: 'Grise',
  german: 'Grau',
  hindi: 'भूरा',
  indonesian: 'Abu-abu',
  japanese: 'グレー',
  korean: '회색',
  portuguese: 'Cinza',
  russian: 'Серый',
  spanish: 'Gris',
  swahili: 'Kijivu',
  vietnamese: 'Xám',
};
export const alternate: Translation = {
  amharic: 'ተለዋጭ',
  arabic: 'بديل',
  bengali: 'বিকল্প',
  chinese: '交替',
  english: 'Alternate',
  estonian: 'Alternatiivne',
  filipino: 'Alternatibo',
  french: 'Alterner',
  german: 'Alternativ',
  hindi: 'वैकल्पिक',
  indonesian: 'Alternatif',
  japanese: '代替',
  korean: '교대',
  portuguese: 'Alternado',
  russian: 'Альтернативный',
  spanish: 'Alternar',
  swahili: 'Badala',
  vietnamese: 'Thay thế',
};

// Data Grid
export const invalidFileRemoved: Translation = {
  amharic: 'ልክ ያልሆነ ፋይል ተወግዷል',
  arabic: 'تم إزالة الملف غير الصالح',
  bengali: 'অবৈধ ফাইল সরানো হয়েছে',
  chinese: '无效文件已删除',
  english: 'Invalid file removed',
  estonian: 'Vale fail kustutatud',
  filipino: 'Tinanggal ang di-wastong file',
  french: 'Fichier invalide supprimé',
  german: 'Ungültige Datei entfernt',
  hindi: 'अवैध फ़ाइल हटाई गई',
  indonesian: 'File tidak valid dihapus',
  japanese: '無効なファイルが削除されました',
  korean: '유효하지 않은 파일이 제거됨',
  portuguese: 'Arquivo inválido removido',
  russian: 'Неверный файл удален',
  spanish: 'Archivo inválido eliminado',
  swahili: 'Faili batili imeondolewa',
  vietnamese: 'Đã xóa tệp không hợp lệ',
};

// Dialogs
export const terms: Translation = {
  amharic: 'የአገልግሎት ውሎች',
  arabic: 'شروط الخدمة',
  bengali: 'পরিষেবার শর্তাবলী',
  chinese: '服务条款',
  english: 'Terms of Service',
  estonian: `Kasutustingimused`,
  filipino: 'Mga tuntunin ng serbisyo',
  french: `Conditions d'utilisation`,
  german: `Nutzungsbedingungen`,
  hindi: 'सेवा की शर्तें',
  indonesian: 'Ketentuan layanan',
  japanese: '利用規約',
  korean: '서비스 약관',
  portuguese: 'Termos de serviço',
  russian: `Условия использования`,
  spanish: 'Términos de servicio',
  swahili: 'Masharti ya huduma',
  vietnamese: 'Điều khoản dịch vụ',
};
export const privacy: Translation = {
  amharic: 'የግላዊነት ፖሊሲ',
  arabic: 'سياسة الخصوصية',
  bengali: 'গোপনীয়তা নীতি',
  chinese: '隐私政策',
  english: 'Privacy Policy',
  estonian: `Privaatsuspoliitika`,
  filipino: 'Patakaran sa privacy',
  french: 'Politique de confidentialité',
  german: `Datenschutz-Bestimmungen`,
  hindi: 'गोपनीयता नीति',
  indonesian: 'Kebijakan privasi',
  japanese: 'プライバシーポリシー',
  korean: '개인정보 처리방침',
  portuguese: 'Política de privacidade',
  russian: `Политика конфиденциальности`,
  spanish: 'Política de privacidad',
  swahili: 'Sera ya faragha',
  vietnamese: 'Chính sách bảo mật',
};
export const closeText: Translation = {
  amharic: 'ዝጋ',
  arabic: 'إغلاق',
  bengali: 'বন্ধ করুন',
  chinese: '关闭',
  english: 'Close',
  estonian: `Sulge`,
  filipino: 'Isara',
  french: 'Fermer',
  german: 'Schließen',
  hindi: 'बंद करें',
  indonesian: 'Tutup',
  japanese: '閉じる',
  korean: '닫기',
  portuguese: 'Fechar',
  russian: `Закрывать`,
  spanish: 'Cerrar',
  swahili: 'Funga',
  vietnamese: 'Đóng',
};
export const resizeText: Translation = {
  amharic: 'መጠን ቀይር',
  arabic: 'تغيير الحجم',
  bengali: 'আকার পরিবর্তন করুন',
  chinese: '调整大小',
  english: 'Resize',
  estonian: 'Muuda suurust',
  filipino: 'Baguhin ang laki',
  french: 'Redimensionner',
  german: 'Größe ändern',
  hindi: 'आकार बदलें',
  indonesian: 'Ubah ukuran',
  japanese: 'サイズを変更',
  korean: '크기 조정',
  portuguese: 'Redimensionar',
  russian: 'Изменить размер',
  spanish: 'Cambiar tamaño',
  swahili: 'Badilisha ukubwa',
  vietnamese: 'Thay đổi kích thước',
};
export const privacyAndTerms: Translation = {
  amharic: 'ውሎች እና ግላዊነት',
  arabic: 'الشروط والخصوصية',
  bengali: 'শর্তাবলী এবং গোপনীয়তা',
  chinese: '条款和隐私',
  english: `Terms & Privacy`,
  estonian: `Tingimused ja privaatsus`,
  filipino: 'Mga tuntunin at privacy',
  french: `Conditions et confidentialité`,
  german: `Bedingungen & Datenschutz`,
  hindi: 'नियम और गोपनीयता',
  indonesian: 'Syarat & privasi',
  japanese: '利用規約とプライバシー',
  korean: '약관 및 개인정보',
  portuguese: 'Termos e privacidade',
  russian: `Условия и конфиденциальность`,
  spanish: 'Términos y privacidad',
  swahili: 'Masharti na faragha',
  vietnamese: 'Điều khoản & quyền riêng tư',
};

// Inputs
export const disabledLocationInputInfo: Translation = {
  amharic: 'እባክዎ ይህንን መረጃ ለመቀየር ወደ አካባቢ ምርጫ ይመለሱ',
  arabic: 'يرجى العودة إلى اختيار الموقع لتغيير هذه المعلومات',
  bengali: 'এই তথ্য পরিবর্তন করতে অনুগ্রহ করে অবস্থান নির্বাচনে ফিরে যান',
  chinese: '请返回位置选择以更改此信息',
  english: 'Please go back to location selection to change this information',
  estonian: 'Palun tagasi asukoha valimisele, et muuta seda infot',
  filipino: 'Mangyaring bumalik sa pagpili ng lokasyon upang baguhin ang impormasyong ito',
  french: "Veuillez revenir à la sélection de l'emplacement pour modifier cette information",
  german: 'Bitte gehen Sie zurück zur Standortauswahl, um diese Information zu ändern',
  hindi: 'कृपया इस जानकारी को बदलने के लिए स्थान चयन पर वापस जाएं',
  indonesian: 'Silakan kembali ke pemilihan lokasi untuk mengubah informasi ini',
  japanese: 'この情報を変更するには、場所の選択に戻ってください',
  korean: '이 정보를 변경하려면 위치 선택으로 돌아가십시오',
  portuguese: 'Por favor, volte à seleção de localização para alterar esta informação',
  russian: 'Пожалуйста, вернитесь к выбору местоположения, чтобы изменить эту информацию',
  spanish: 'Por favor, vuelva a la selección de ubicación para cambiar esta información',
  swahili: 'Tafadhali rudi kwenye uchaguzi wa eneo kubadilisha habari hii',
  vietnamese: 'Vui lòng quay lại lựa chọn vị trí để thay đổi thông tin này',
};
export const useThisAddress: Translation = {
  amharic: 'ይህንን አድራሻ ተጠቀም',
  arabic: 'استخدم هذا العنوان',
  bengali: 'এই ঠিকানা ব্যবহার করুন',
  chinese: '使用此地址',
  english: 'Use this address',
  estonian: 'Kasuta seda aadressi',
  filipino: 'Gamitin ang address na ito',
  french: 'Utiliser cette adresse',
  german: 'Diese Adresse verwenden',
  hindi: 'इस पते का उपयोग करें',
  indonesian: 'Gunakan alamat ini',
  japanese: 'このアドレスを使用',
  korean: '이 주소 사용',
  portuguese: 'Usar este endereço',
  russian: 'Использовать этот адрес',
  spanish: 'Usar esta dirección',
  swahili: 'Tumia anwani hii',
  vietnamese: 'Sử dụng địa chỉ này',
};
export const excellent: Translation = {
  amharic: 'በጣም ጥሩ',
  arabic: 'ممتاز',
  bengali: 'চমৎকার',
  chinese: '优秀',
  english: 'excellent',
  estonian: 'hästi',
  filipino: 'mahusay',
  french: 'excellent',
  german: 'ausgezeichnet',
  hindi: 'उत्कृष्ट',
  indonesian: 'sangat baik',
  japanese: '優秀',
  korean: '우수',
  portuguese: 'excelente',
  russian: 'отлично',
  spanish: 'excelente',
  swahili: 'bora kabisa',
  vietnamese: 'xuất sắc',
};
export const good: Translation = {
  amharic: 'ጥሩ',
  arabic: 'جيد',
  bengali: 'ভাল',
  chinese: '好',
  english: 'good',
  estonian: 'hästi',
  filipino: 'mabuti',
  french: 'bien',
  german: 'gut',
  hindi: 'अच्छा',
  indonesian: 'baik',
  japanese: '良い',
  korean: '좋음',
  portuguese: 'bom',
  russian: 'хорошо',
  spanish: 'bueno',
  swahili: 'nzuri',
  vietnamese: 'tốt',
};
export const ok: Translation = {
  amharic: 'እሺ',
  arabic: 'حسنا',
  bengali: 'ঠিক আছে',
  chinese: '可以',
  english: 'ok',
  estonian: 'hästi',
  filipino: 'okay',
  french: `d'accord`,
  german: 'in Ordnung',
  hindi: 'ठीक है',
  indonesian: 'oke',
  japanese: 'まあまあ',
  korean: '괜찮음',
  portuguese: 'ok',
  russian: 'хорошо',
  spanish: 'aceptable',
  swahili: 'sawa',
  vietnamese: 'được',
};
export const poor: Translation = {
  amharic: 'መጥፎ',
  arabic: 'سيء',
  bengali: 'খারাপ',
  chinese: '差',
  english: 'poor',
  estonian: 'halb',
  filipino: 'mahinang',
  french: 'pauvre',
  german: 'schlecht',
  hindi: 'खराब',
  indonesian: 'buruk',
  japanese: '悪い',
  korean: '나쁨',
  portuguese: 'ruim',
  russian: 'плохо',
  spanish: 'pobre',
  swahili: 'mbaya',
  vietnamese: 'kém',
};
export const useless: Translation = {
  amharic: 'ዋጋ የሌለው',
  arabic: 'عديم الفائدة',
  bengali: 'অকেজো',
  chinese: '无用',
  english: 'useless',
  estonian: 'kõrvalekaal',
  filipino: 'walang silbi',
  french: 'inutile',
  german: 'nutzlos',
  hindi: 'बेकार',
  indonesian: 'tidak berguna',
  japanese: '役に立たない',
  korean: '쓸모없음',
  portuguese: 'inútil',
  russian: 'бесполезно',
  spanish: 'inútil',
  swahili: 'bila faida',
  vietnamese: 'vô dụng',
};
export const phoneT: Translation = {
  amharic: 'ስልክ',
  arabic: 'هاتف',
  bengali: 'ফোন',
  chinese: '电话',
  english: 'Phone',
  estonian: 'Telefon',
  filipino: 'Telepono',
  french: 'Téléphone',
  german: 'Telefon',
  hindi: 'फ़ोन',
  indonesian: 'Telepon',
  japanese: '電話',
  korean: '전화',
  portuguese: 'Telefone',
  russian: 'Телефон',
  spanish: 'Teléfono',
  swahili: 'Simu',
  vietnamese: 'Điện thoại',
};

// Notifications
export const notificationsText: Translation = {
  amharic: 'ማሳወቂያዎች',
  arabic: 'إشعارات',
  bengali: 'বিজ্ঞপ্তি',
  chinese: '通知',
  english: 'Notifications',
  estonian: 'Märguanded',
  filipino: 'Mga notipikasyon',
  french: 'Avis',
  german: 'Benachrichtigungen',
  hindi: 'सूचनाएं',
  indonesian: 'Notifikasi',
  japanese: '通知',
  korean: '알림',
  portuguese: 'Notificações',
  russian: 'Уведомления',
  spanish: 'Notificaciones',
  swahili: 'Arifa',
  vietnamese: 'Thông báo',
};
export const markAllAsReadText: Translation = {
  amharic: 'ሁሉንም እንደተነበበ ምልክት አድርግ',
  arabic: 'وضع علامة على الكل كمقروء',
  bengali: 'সবগুলি পড়া হিসাবে চিহ্নিত করুন',
  chinese: '标记所有为已读',
  english: 'Mark all as read',
  estonian: 'Märgi kõik loetuks',
  filipino: 'Markahan ang lahat bilang nabasa',
  french: 'Tout marquer comme lu',
  german: 'Alle als gelesen markieren',
  hindi: 'सभी को पढ़ा हुआ के रूप में चिह्नित करें',
  indonesian: 'Tandai semua sebagai sudah dibaca',
  japanese: 'すべて既読にする',
  korean: '모두 읽음으로 표시',
  portuguese: 'Marcar tudo como lido',
  russian: 'отметить все как прочитанное',
  spanish: 'Marcar todo como leído',
  swahili: 'Weka alama zote zimesomwa',
  vietnamese: 'Đánh dấu tất cả là đã đọc',
};
export const lostConnection: Translation = {
  amharic: 'ይቅርታ፣ ግንኙነትዎን አጥተዋል!',
  arabic: 'عذرًا، فقدت الاتصال!',
  bengali: 'ওহ, আপনি সংযোগ হারিয়েছেন!',
  chinese: '糟糕，您失去了连接！',
  english: `Oops, you lost connection!`,
  estonian: 'Oih, ühendus katkes!',
  filipino: 'Oops, nawala ang iyong koneksyon!',
  french: 'Oups, vous avez perdu la connexion!',
  german: 'Hoppla, du hast die Verbindung verloren!',
  hindi: 'ओह, आपने कनेक्शन खो दिया!',
  indonesian: 'Ups, Anda kehilangan koneksi!',
  japanese: 'おっと、接続が切れました！',
  korean: '앗, 연결이 끊어졌습니다!',
  portuguese: 'Ops, você perdeu a conexão!',
  russian: 'Ой, вы потеряли связь!',
  spanish: '¡Ups, perdiste la conexión!',
  swahili: 'Samahani, umepoteza muunganisho!',
  vietnamese: 'Rất tiếc, bạn đã mất kết nối!',
};
export const connectionRestored: Translation = {
  amharic: 'ግንኙነት ተመልሷል!',
  arabic: 'تم استعادة الاتصال!',
  bengali: 'সংযোগ পুনরুদ্ধার করা হয়েছে!',
  chinese: '连接已恢复！',
  english: `Connection restored!`,
  estonian: 'Ühendus taastatud!',
  filipino: 'Naibalik ang koneksyon!',
  french: 'Connexion rétablie!',
  german: 'Verbindung wiederhergestellt!',
  hindi: 'कनेक्शन बहाल हो गया!',
  indonesian: 'Koneksi dipulihkan!',
  japanese: '接続が復元されました！',
  korean: '연결이 복원되었습니다!',
  portuguese: 'Conexão restaurada!',
  russian: 'Связь восстановлена!',
  spanish: '¡Conexión restaurada!',
  swahili: 'Muunganisho umerejelewa!',
  vietnamese: 'Đã khôi phục kết nối!',
};
export const backOnlineTitle: Translation = {
  amharic: 'እንደገና መስመር ላይ ነዎት',
  arabic: 'عدت متصلًا بالإنترنت',
  bengali: 'আপনি আবার অনলাইনে ফিরেছেন',
  chinese: '已重新联网',
  english: 'You’re back online',
  estonian: 'Olete taas võrgus',
  filipino: 'Online ka na ulit',
  french: 'Vous êtes de nouveau en ligne',
  german: 'Sie sind wieder online',
  hindi: 'आप फिर से ऑनलाइन हैं',
  indonesian: 'Anda kembali online',
  japanese: 'オンラインに戻りました',
  korean: '다시 온라인 상태입니다',
  portuguese: 'Você está online novamente',
  russian: 'Вы снова в сети',
  spanish: 'Vuelves a estar en línea',
  swahili: 'Umerudi mtandaoni',
  vietnamese: 'Bạn đã trực tuyến trở lại',
};
export const savedCopyNotice: Translation = {
  amharic: 'ይህ ገጽ ከመስመር ውጭ በነበሩበት ጊዜ የታየ የተቀመጠ ቅጂ ነው።',
  arabic: 'هذه الصفحة نسخة محفوظة عُرضت أثناء انقطاع اتصالك.',
  bengali: 'এই পৃষ্ঠাটি একটি সংরক্ষিত কপি, যা আপনি অফলাইনে থাকার সময় দেখানো হয়েছে।',
  chinese: '此页面是您离线时显示的已保存副本。',
  english: 'This page is a copy saved while you were offline.',
  estonian: 'See leht on salvestatud koopia, mida näidati, kui olite võrguühenduseta.',
  filipino: 'Ang pahinang ito ay naka-save na kopya na ipinakita habang offline ka.',
  french: 'Cette page est une copie enregistrée, affichée pendant que vous étiez hors ligne.',
  german: 'Diese Seite ist eine gespeicherte Kopie, angezeigt, während Sie offline waren.',
  hindi: 'यह पेज एक सहेजी गई प्रति है, जो आपके ऑफ़लाइन रहते समय दिखाई गई।',
  indonesian: 'Halaman ini adalah salinan tersimpan yang ditampilkan saat Anda offline.',
  japanese: 'このページは、オフライン中に表示された保存済みのコピーです。',
  korean: '이 페이지는 오프라인 상태일 때 표시된 저장된 사본입니다.',
  portuguese: 'Esta página é uma cópia salva, exibida enquanto você estava offline.',
  russian: 'Эта страница является сохранённой копией, показанной, пока вы были не в сети.',
  spanish: 'Esta página es una copia guardada que se mostró mientras estabas sin conexión.',
  swahili: 'Ukurasa huu ni nakala iliyohifadhiwa, iliyoonyeshwa ulipokuwa nje ya mtandao.',
  vietnamese: 'Trang này là bản sao đã lưu, được hiển thị khi bạn ngoại tuyến.',
};
export const reloadPage: Translation = {
  amharic: 'እንደገና ጫን',
  arabic: 'إعادة التحميل',
  bengali: 'আবার লোড করুন',
  chinese: '重新加载',
  english: 'Reload',
  estonian: 'Laadi uuesti',
  filipino: 'I-reload',
  french: 'Recharger',
  german: 'Neu laden',
  hindi: 'फिर से लोड करें',
  indonesian: 'Muat ulang',
  japanese: '再読み込み',
  korean: '새로고침',
  portuguese: 'Recarregar',
  russian: 'Перезагрузить',
  spanish: 'Recargar',
  swahili: 'Pakia upya',
  vietnamese: 'Tải lại',
};
export const showAllText: Translation = {
  amharic: 'ሁሉንም አሳይ',
  arabic: 'عرض الكل',
  bengali: 'সবগুলি দেখান',
  chinese: '显示全部',
  english: 'Show All',
  estonian: 'Näita kõiki',
  filipino: 'Ipakita lahat',
  french: 'Afficher tout',
  german: 'Alle anzeigen',
  hindi: 'सभी दिखाएं',
  indonesian: 'Tampilkan semua',
  japanese: 'すべて表示',
  korean: '모두 표시',
  portuguese: 'Mostrar tudo',
  russian: 'Показать все',
  spanish: 'Mostrar todo',
  swahili: 'Onyesha zote',
  vietnamese: 'Hiển thị tất cả',
};
export const itemsSelected: Translation = {
  amharic: 'የተመረጡ ንጥሎች',
  arabic: 'العناصر المحددة',
  bengali: 'নির্বাচিত আইটেম',
  chinese: '已选项目',
  english: 'Items Selected',
  estonian: 'Valitud üksused',
  filipino: 'Mga piniling item',
  french: 'Éléments sélectionnés',
  german: 'Ausgewählte Elemente',
  hindi: 'चयनित आइटम',
  indonesian: 'Item terpilih',
  japanese: '選択されたアイテム',
  korean: '선택한 항목',
  portuguese: 'Itens selecionados',
  russian: 'Выбранные элементы',
  spanish: 'Elementos seleccionados',
  swahili: 'Vitu vilivyochaguliwa',
  vietnamese: 'Mục đã chọn',
};
export const showSelected: Translation = {
  amharic: 'የተመረጠውን አሳይ',
  arabic: 'عرض المحدد',
  bengali: 'নির্বাচিত দেখান',
  chinese: '显示已选',
  english: 'Show Selected',
  estonian: 'Näita valitud',
  filipino: 'Ipakita ang pinili',
  french: 'Afficher les sélectionnés',
  german: 'Ausgewählte anzeigen',
  hindi: 'चयनित दिखाएं',
  indonesian: 'Tampilkan terpilih',
  japanese: '選択項目を表示',
  korean: '선택한 항목 표시',
  portuguese: 'Mostrar selecionados',
  russian: 'Показать выбранные',
  spanish: 'Mostrar seleccionados',
  swahili: 'Onyesha vilivyochaguliwa',
  vietnamese: 'Hiển thị đã chọn',
};

// Navigation
export const homeText: Translation = {
  amharic: 'ቤት',
  arabic: 'الصفحة الرئيسية',
  bengali: 'হোম',
  chinese: '首页',
  english: 'Home',
  estonian: 'Kodu',
  filipino: 'Bahay',
  french: 'Domicile',
  german: 'Heim',
  hindi: 'होम',
  indonesian: 'Beranda',
  japanese: 'ホーム',
  korean: '홈',
  portuguese: 'Início',
  russian: 'Дом',
  spanish: 'Inicio',
  swahili: 'Nyumbani',
  vietnamese: 'Trang chủ',
};
export const menuText: Translation = {
  amharic: 'ምናሌ',
  arabic: 'القائمة',
  bengali: 'মেনু',
  chinese: '菜单',
  english: 'Menu',
  estonian: 'Menüü',
  filipino: 'Menu',
  french: 'Menu',
  german: 'Menü',
  hindi: 'मेनू',
  indonesian: 'Menu',
  japanese: 'メニュー',
  korean: '메뉴',
  portuguese: 'Menu',
  russian: 'Меню',
  spanish: 'Menú',
  swahili: 'Menyu',
  vietnamese: 'Menu',
};
export const infoText: Translation = {
  amharic: 'መረጃ',
  arabic: 'معلومات',
  bengali: 'তথ্য',
  chinese: '信息',
  english: 'Info',
  estonian: 'Info',
  filipino: 'Impormasyon',
  french: 'Info',
  german: 'Info',
  hindi: 'जानकारी',
  indonesian: 'Info',
  japanese: '情報',
  korean: '정보',
  portuguese: 'Info',
  russian: 'Информация',
  spanish: 'Info',
  swahili: 'Taarifa',
  vietnamese: 'Thông tin',
};
export const changeTheme: Translation = {
  amharic: 'ገጽታ ቀይር',
  arabic: 'تغيير السمة',
  bengali: 'থিম পরিবর্তন করুন',
  chinese: '更改主题',
  english: 'Change theme',
  estonian: 'Muuda teemat',
  filipino: 'Baguhin ang tema',
  french: 'Change le thème',
  german: 'Thema ändern',
  hindi: 'थीम बदलें',
  indonesian: 'Ubah tema',
  japanese: 'テーマを変更',
  korean: '테마 변경',
  portuguese: 'Mudar tema',
  russian: 'Изменить тему',
  spanish: 'Cambiar tema',
  swahili: 'Badilisha mandhari',
  vietnamese: 'Thay đổi chủ đề',
};
export const settingsText: Translation = {
  amharic: 'ቅንብሮች',
  arabic: 'الإعدادات',
  bengali: 'সেটিংস',
  chinese: '设置',
  english: 'Settings',
  estonian: 'Seaded',
  filipino: 'Mga setting',
  french: 'Paramètres',
  german: 'Einstellungen',
  hindi: 'सेटिंग्स',
  indonesian: 'Pengaturan',
  japanese: '設定',
  korean: '설정',
  portuguese: 'Configurações',
  russian: 'Настройки',
  spanish: 'Configuración',
  swahili: 'Mipangilio',
  vietnamese: 'Cài đặt',
};
export const stats: Translation = {
  amharic: 'ስታቲስቲክስ',
  arabic: 'إحصائيات',
  bengali: 'পরিসংখ্যান',
  chinese: '统计',
  english: 'Stats',
  estonian: 'Statistika',
  filipino: 'Mga istatistika',
  french: 'Développement',
  german: 'Statistiken',
  hindi: 'आंकड़े',
  indonesian: 'Statistik',
  japanese: '統計',
  korean: '통계',
  portuguese: 'Estatísticas',
  russian: 'Статистика',
  spanish: 'Estadísticas',
  swahili: 'Takwimu',
  vietnamese: 'Thống kê',
};
export const schedulesText: Translation = {
  amharic: 'ጊዜ ሰሌዳዎች',
  arabic: 'الجداول',
  bengali: 'সময়সূচি',
  chinese: '日程',
  english: 'Schedules',
  estonian: 'Ajakirjed',
  filipino: 'Mga iskedyul',
  french: 'Des horaires',
  german: 'Termine',
  hindi: 'कार्यक्रम',
  indonesian: 'Jadwal',
  japanese: 'スケジュール',
  korean: '일정',
  portuguese: 'Horários',
  russian: 'Графики',
  spanish: 'Horarios',
  swahili: 'Ratiba',
  vietnamese: 'Lịch trình',
};
export const usersText: Translation = {
  amharic: 'ተጠቃሚዎች',
  arabic: 'المستخدمون',
  bengali: 'ব্যবহারকারীরা',
  chinese: '用户',
  english: 'Users',
  estonian: 'Kasutajad',
  filipino: 'Mga user',
  french: 'Utilisateurs',
  german: 'Benutzer',
  hindi: 'उपयोगकर्ता',
  indonesian: 'Pengguna',
  japanese: 'ユーザー',
  korean: '사용자',
  portuguese: 'Usuários',
  russian: 'Пользователи',
  spanish: 'Usuarios',
  swahili: 'Watumiaji',
  vietnamese: 'Người dùng',
};
export const ticketsText: Translation = {
  amharic: 'ትኬቶች',
  arabic: 'التذاكر',
  bengali: 'টিকিট',
  chinese: '票',
  english: 'Tickets',
  estonian: 'Bileed',
  filipino: 'Mga tiket',
  french: 'Des billets',
  german: 'Tickets',
  hindi: 'टिकट',
  indonesian: 'Tiket',
  japanese: 'チケット',
  korean: '티켓',
  portuguese: 'Bilhetes',
  russian: 'Билеты',
  spanish: 'Tickets',
  swahili: 'Tiketi',
  vietnamese: 'Vé',
};
export const salaryText: Translation = {
  amharic: 'ደሞዝ',
  arabic: 'الرواتب',
  bengali: 'বেতন',
  chinese: '薪资',
  english: 'Salaries',
  estonian: 'Töötasu',
  filipino: 'Mga sahod',
  french: 'Les salaires',
  german: 'Gehälter',
  hindi: 'वेतन',
  indonesian: 'Gaji',
  japanese: '給与',
  korean: '급여',
  portuguese: 'Salários',
  russian: 'Заработная плата',
  spanish: 'Salarios',
  swahili: 'Mishahara',
  vietnamese: 'Lương',
};
export const watchText: Translation = {
  amharic: 'ሰዓት',
  arabic: 'ساعة',
  bengali: 'ঘড়ি',
  chinese: '手表',
  english: 'Watch',
  estonian: 'Kell',
  filipino: 'Relo',
  french: 'Montre',
  german: 'Uhr',
  hindi: 'घड़ी',
  indonesian: 'Jam',
  japanese: '時計',
  korean: '시계',
  portuguese: 'Relógio',
  russian: 'Смотреть',
  spanish: 'Reloj',
  swahili: 'Saa',
  vietnamese: 'Đồng hồ',
};
export const expand: Translation = {
  amharic: 'አስፋፋ',
  arabic: 'توسيع',
  bengali: 'প্রসারিত করুন',
  chinese: '展开',
  english: 'Expand',
  estonian: 'Suurendada',
  filipino: 'Palawakin',
  french: `s'agrandir`,
  german: 'Erweitern',
  hindi: 'विस्तार करें',
  indonesian: 'Perluas',
  japanese: '展開',
  korean: '확장',
  portuguese: 'Expandir',
  russian: 'Расширить',
  spanish: 'Expandir',
  swahili: 'Panua',
  vietnamese: 'Mở rộng',
};
export const collapse: Translation = {
  amharic: 'አሰባስብ',
  arabic: 'طي',
  bengali: 'সংকুচিত করুন',
  chinese: '折叠',
  english: 'Collapse',
  estonian: 'Kokku',
  filipino: 'Tiklupin',
  french: `s'écrouler`,
  german: 'Zusammenziehen',
  hindi: 'संक्षिप्त करें',
  indonesian: 'Ciutkan',
  japanese: '折りたたむ',
  korean: '축소',
  portuguese: 'Recolher',
  russian: 'Свернуть',
  spanish: 'Contraer',
  swahili: 'Kunja',
  vietnamese: 'Thu gọn',
};
export const pricingText: Translation = {
  amharic: 'ዋጋ አወጣጥ',
  arabic: 'التسعير',
  bengali: 'মূল্য নির্ধারণ',
  chinese: '定价',
  english: 'Pricing',
  estonian: 'Hinnad',
  filipino: 'Presyo',
  french: 'Tarifs',
  german: 'Preise',
  hindi: 'मूल्य निर्धारण',
  indonesian: 'Harga',
  japanese: '料金',
  korean: '가격',
  portuguese: 'Preços',
  russian: 'Цены',
  spanish: 'Precios',
  swahili: 'Bei',
  vietnamese: 'Giá cả',
};

export const downloadAPP: Translation = {
  amharic: 'መተግበሪያውን አውርድ',
  arabic: 'تحميل التطبيق',
  bengali: 'অ্যাপ ডাউনলোড করুন',
  chinese: '下载应用',
  english: `Download the app`,
  estonian: `Laadige rakendus alla`,
  filipino: 'I-download ang app',
  french: `Téléchargez l'application`,
  german: `Laden Sie die Anwendung herunter`,
  hindi: 'ऐप डाउनलोड करें',
  indonesian: 'Unduh aplikasi',
  japanese: 'アプリをダウンロード',
  korean: '앱 다운로드',
  portuguese: 'Baixar o aplicativo',
  russian: `Скачать приложение`,
  spanish: 'Descargar la aplicación',
  swahili: 'Pakua programu',
  vietnamese: 'Tải ứng dụng',
};
export const shared: Translation = {
  amharic: 'ተጋርቷል!',
  arabic: 'مشترك!',
  bengali: 'শেয়ার করা হয়েছে!',
  chinese: '已分享！',
  english: `Shared!`,
  estonian: `Jagatud!`,
  filipino: 'Ibinah agi!',
  french: `Partagé!`,
  german: `Geteilt!`,
  hindi: 'साझा किया गया!',
  indonesian: 'Dibagikan!',
  japanese: '共有されました！',
  korean: '공유됨!',
  portuguese: 'Compartilhado!',
  russian: `Поделенно!`,
  spanish: '¡Compartido!',
  swahili: 'Imeshirikiwa!',
  vietnamese: 'Đã chia sẻ!',
};

export const id: Translation = {
  amharic: 'መለያ',
  arabic: 'معرف',
  bengali: 'আইডি',
  chinese: 'ID',
  english: 'ID',
  estonian: 'ID',
  filipino: 'ID',
  french: 'Identifiant',
  german: 'ICH WÜRDE',
  hindi: 'आईडी',
  indonesian: 'ID',
  japanese: 'ID',
  korean: 'ID',
  portuguese: 'ID',
  russian: 'ИДЕНТИФИКАТОР',
  spanish: 'ID',
  swahili: 'Kitambulisho',
  vietnamese: 'ID',
};
export const name: Translation = {
  amharic: 'ስም',
  arabic: 'الاسم',
  bengali: 'নাম',
  chinese: '姓名',
  english: 'Name',
  estonian: 'Nimi',
  filipino: 'Pangalan',
  french: 'Nom',
  german: 'Name',
  hindi: 'नाम',
  indonesian: 'Nama',
  japanese: '名前',
  korean: '이름',
  portuguese: 'Nome',
  russian: 'Имя',
  spanish: 'Nombre',
  swahili: 'Jina',
  vietnamese: 'Tên',
};
export const nameText: Translation = name;
export const descriptionText: Translation = {
  amharic: 'መግለጫ',
  arabic: 'الوصف',
  bengali: 'বর্ণনা',
  chinese: '描述',
  english: 'Description',
  estonian: 'Kirjeldus',
  filipino: 'Paglalarawan',
  french: 'Description',
  german: 'Beschreibung',
  hindi: 'विवरण',
  indonesian: 'Deskripsi',
  japanese: '説明',
  korean: '설명',
  portuguese: 'Descrição',
  russian: 'Описание',
  spanish: 'Descripción',
  swahili: 'Maelezo',
  vietnamese: 'Mô tả',
};
export const countryCode: Translation = {
  amharic: 'የአገር ኮድ',
  arabic: 'رمز البلد',
  bengali: 'দেশের কোড',
  chinese: '国家代码',
  english: 'Country Code',
  estonian: 'Riigi Kood',
  filipino: 'Code ng bansa',
  french: 'Code Postal',
  german: 'Landesvorwahl',
  hindi: 'देश कोड',
  indonesian: 'Kode negara',
  japanese: '国番号',
  korean: '국가 코드',
  portuguese: 'Código do país',
  russian: 'Код страны',
  spanish: 'Código de país',
  swahili: 'Nambari ya nchi',
  vietnamese: 'Mã quốc gia',
};
export const lastUpdateTime: Translation = {
  amharic: 'የመጨረሻ ማዘመኛ ጊዜ',
  arabic: 'وقت آخر تحديث',
  bengali: 'শেষ আপডেট সময়',
  chinese: '最后更新时间',
  english: 'Last Update Time',
  estonian: 'Viimase värskenduse aeg',
  filipino: 'Oras ng huling update',
  french: 'Heure de la dernière mise à jour',
  german: 'Zeit der letzten Aktualisierung',
  hindi: 'अंतिम अपडेट समय',
  indonesian: 'Waktu pembaruan terakhir',
  japanese: '最終更新時刻',
  korean: '마지막 업데이트 시간',
  portuguese: 'Hora da última atualização',
  russian: 'Время последнего обновления',
  spanish: 'Hora de última actualización',
  swahili: 'Wakati wa sasisho la mwisho',
  vietnamese: 'Thời gian cập nhật cuối',
};
export const statusText: Translation = {
  amharic: 'ሁኔታ',
  arabic: 'الحالة',
  bengali: 'অবস্থা',
  chinese: '状态',
  english: 'Status',
  estonian: 'Olek',
  filipino: 'Katayuan',
  french: 'Statut',
  german: 'Status',
  hindi: 'स्थिति',
  indonesian: 'Status',
  japanese: 'ステータス',
  korean: '상태',
  portuguese: 'Status',
  russian: 'Статус',
  spanish: 'Estado',
  swahili: 'Hali',
  vietnamese: 'Trạng thái',
};
export const feeText: Translation = {
  amharic: 'ክፍያ',
  arabic: 'رسوم',
  bengali: 'ফি',
  chinese: '费用',
  english: 'Fee',
  estonian: 'Makse',
  filipino: 'Bayad',
  french: 'Frais',
  german: 'Gebühr',
  hindi: 'शुल्क',
  indonesian: 'Biaya',
  japanese: '料金',
  korean: '수수료',
  portuguese: 'Taxa',
  russian: 'Платеж',
  spanish: 'Tarifa',
  swahili: 'Ada',
  vietnamese: 'Phí',
};
export const updatedBy: Translation = {
  amharic: 'የዘመነው',
  arabic: 'تم التحديث بواسطة',
  bengali: 'দ্বারা আপডেট',
  chinese: '更新者',
  english: 'Updated By',
  estonian: 'Värskendanud',
  filipino: 'Na-update ni',
  french: 'Mis à jour par',
  german: 'Aktualisiert von',
  hindi: 'द्वारा अपडेट',
  indonesian: 'Diperbarui oleh',
  japanese: '更新者',
  korean: '업데이트 담당자',
  portuguese: 'Atualizado por',
  russian: 'Обновлено',
  spanish: 'Actualizado por',
  swahili: 'Imesasishwa na',
  vietnamese: 'Cập nhật bởi',
};
export const active: Translation = {
  amharic: 'ንቁ',
  arabic: 'نشط',
  bengali: 'সক্রিয়',
  chinese: '活跃',
  english: 'Active',
  estonian: 'Aktiivne',
  filipino: 'Aktibo',
  french: 'Actif',
  german: 'Aktiv',
  hindi: 'सक্रিয',
  indonesian: 'Aktif',
  japanese: 'アクティブ',
  korean: '활성',
  portuguese: 'Ativo',
  russian: 'Активный',
  spanish: 'Activo',
  swahili: 'Hai',
  vietnamese: 'Hoạt động',
};
export const inactive: Translation = {
  amharic: 'ንቁ ያልሆነ',
  arabic: 'غير نشط',
  bengali: 'নিষ্ক্রিয়',
  chinese: '不活跃',
  english: 'Inactive',
  estonian: 'Mitteaktiivne',
  filipino: 'Hindi aktibo',
  french: 'Inactif',
  german: 'Inaktiv',
  hindi: 'निष्क्रिय',
  indonesian: 'Tidak aktif',
  japanese: '非アクティブ',
  korean: '비활성',
  portuguese: 'Inativo',
  russian: 'Неактивный',
  spanish: 'Inactivo',
  swahili: 'Haipo hai',
  vietnamese: 'Không hoạt động',
};
export const edit: Translation = {
  amharic: 'አርትዕ',
  arabic: 'تحرير',
  bengali: 'সম্পাদনা',
  chinese: '编辑',
  english: 'Edit',
  estonian: 'Muuda',
  filipino: 'I-edit',
  french: 'Éditer',
  german: 'Bearbeiten',
  hindi: 'संपादित करें',
  indonesian: 'Edit',
  japanese: '編集',
  korean: '편집',
  portuguese: 'Editar',
  russian: 'Редактировать',
  spanish: 'Editar',
  swahili: 'Hariri',
  vietnamese: 'Chỉnh sửa',
};
export const editText: Translation = edit;
export const OK: Translation = {
  amharic: 'እሺ',
  arabic: 'حسنا',
  bengali: 'ঠিক আছে',
  chinese: '确定',
  english: 'OK',
  estonian: 'Okei',
  filipino: 'OK',
  french: `d'accord`,
  german: 'OK',
  hindi: 'ठीक है',
  indonesian: 'OK',
  japanese: 'OK',
  korean: '확인',
  portuguese: 'OK',
  russian: 'ХОРОШО',
  spanish: 'OK',
  swahili: 'Sawa',
  vietnamese: 'OK',
};
export const deleteText: Translation = {
  amharic: 'ሰርዝ',
  arabic: 'حذف',
  bengali: 'মুছে ফেলুন',
  chinese: '删除',
  english: 'Delete',
  estonian: 'Kustuta',
  filipino: 'Tanggalin',
  french: 'Supprimer',
  german: 'Löschen',
  hindi: 'हटाएं',
  indonesian: 'Hapus',
  japanese: '削除',
  korean: '삭제',
  portuguese: 'Excluir',
  russian: 'Удалить',
  spanish: 'Eliminar',
  swahili: 'Futa',
  vietnamese: 'Xóa',
};
export const add: Translation = {
  amharic: 'አክል',
  arabic: 'إضافة',
  bengali: 'যোগ করুন',
  chinese: '添加',
  english: 'Add',
  estonian: 'Lisama',
  filipino: 'Idagdag',
  french: 'Ajouter',
  german: 'Hinzufügen',
  hindi: 'जोड़ें',
  indonesian: 'Tambah',
  japanese: '追加',
  korean: '추가',
  portuguese: 'Adicionar',
  russian: 'Добавлять',
  spanish: 'Agregar',
  swahili: 'Ongeza',
  vietnamese: 'Thêm',
};
export const addText: Translation = add;
export const cleanTableText: Translation = {
  amharic: 'አፅዳ',
  arabic: 'نظف',
  bengali: 'পরিষ্কার করুন',
  chinese: '清理',
  english: 'Clean',
  estonian: 'Korista ära',
  filipino: 'Linisin',
  french: 'Nettoyer',
  german: 'Aufräumen',
  hindi: 'साफ करें',
  indonesian: 'Bersihkan',
  japanese: 'クリーン',
  korean: '정리',
  portuguese: 'Limpar',
  russian: 'Чистый',
  spanish: 'Limpiar',
  swahili: 'Safisha',
  vietnamese: 'Dọn dẹp',
};
export const unauthorized: Translation = {
  amharic: 'ያልተፈቀደ',
  arabic: 'غير مصرح',
  bengali: 'অননুমোদিত',
  chinese: '未授权',
  english: 'Unauthorized',
  estonian: 'Volitamata',
  filipino: 'Walang pahintulot',
  french: 'Non autorisé',
  german: 'Unbefugt',
  hindi: 'अनधिकृत',
  indonesian: 'Tidak sah',
  japanese: '無許可',
  korean: '무단',
  portuguese: 'Não autorizado',
  russian: 'Несанкционированный',
  spanish: 'No autorizado',
  swahili: 'Haijaidhinishwa',
  vietnamese: 'Không được phép',
};
export const processing: Translation = {
  amharic: 'በማስኬድ ላይ',
  arabic: 'جاري المعالجة',
  bengali: 'প্রক্রিয়াকরণ',
  chinese: '处理中',
  english: 'Processing',
  estonian: 'Töötlemine',
  filipino: 'Pinoproseso',
  french: 'En traitement',
  german: 'Wird bearbeitet',
  hindi: 'प्रसंस्करण',
  indonesian: 'Memproses',
  japanese: '処理中',
  korean: '처리 중',
  portuguese: 'Processando',
  russian: 'Обработка',
  spanish: 'Procesando',
  swahili: 'Inachakatwa',
  vietnamese: 'Đang xử lý',
};
export const saved: Translation = {
  amharic: 'ተቀምጧል',
  arabic: 'تم الحفظ',
  bengali: 'সংরক্ষিত',
  chinese: '已保存',
  english: 'Saved',
  estonian: 'Salvestatud',
  filipino: 'Nai-save',
  french: 'Enregistré',
  german: 'Gespeichert',
  hindi: 'सहेजा गया',
  indonesian: 'Disimpan',
  japanese: '保存済み',
  korean: '저장됨',
  portuguese: 'Salvo',
  russian: 'Сохранено',
  spanish: 'Guardado',
  swahili: 'Imehifadhiwa',
  vietnamese: 'Đã lưu',
};
export const deleting: Translation = {
  amharic: 'በመሰረዝ ላይ',
  arabic: 'جاري الحذف',
  bengali: 'মুছে ফেলা হচ্ছে',
  chinese: '删除中',
  english: 'Deleting',
  estonian: 'Kustutamine',
  filipino: 'Tinatanggal',
  french: 'Suppression',
  german: 'Löschen',
  hindi: 'हटाया जा रहा है',
  indonesian: 'Menghapus',
  japanese: '削除中',
  korean: '삭제 중',
  portuguese: 'Excluindo',
  russian: 'Удаление',
  spanish: 'Eliminando',
  swahili: 'Inafutwa',
  vietnamese: 'Đang xóa',
};
export const deleted: Translation = {
  amharic: 'ተሰርዟል',
  arabic: 'تم الحذف',
  bengali: 'মুছে ফেলা হয়েছে',
  chinese: '已删除',
  english: 'Deleted',
  estonian: 'Kustutatud',
  filipino: 'Tinanggal',
  french: 'Supprimé',
  german: 'Gelöscht',
  hindi: 'हटा दिया गया',
  indonesian: 'Dihapus',
  japanese: '削除済み',
  korean: '삭제됨',
  portuguese: 'Excluído',
  russian: 'Удалено',
  spanish: 'Eliminado',
  swahili: 'Imefutwa',
  vietnamese: 'Đã xóa',
};
export const deactivating: Translation = {
  amharic: 'በማቦዘን ላይ',
  arabic: 'جاري التعطيل',
  bengali: 'নিষ্ক্রিয় করা হচ্ছে',
  chinese: '停用中',
  english: 'Deactivating',
  estonian: 'Deaktiveerimine',
  filipino: 'Dini-deactivate',
  french: 'Désactivation',
  german: 'Deaktivieren',
  hindi: 'निष्क्रिय किया जा रहा है',
  indonesian: 'Menonaktifkan',
  japanese: '無効化中',
  korean: '비활성화 중',
  portuguese: 'Desativando',
  russian: 'Деактивация',
  spanish: 'Desactivando',
  swahili: 'Inazimwa',
  vietnamese: 'Đang vô hiệu hóa',
};
export const deactivated: Translation = {
  amharic: 'ተቦዝኗል',
  arabic: 'تم التعطيل',
  bengali: 'নিষ্ক্রিয় করা হয়েছে',
  chinese: '已停用',
  english: 'Deactivated',
  estonian: 'Deaktiveeritud',
  filipino: 'Na-deactivate',
  french: 'Désactivé',
  german: 'Deaktiviert',
  hindi: 'निष्क्रिय',
  indonesian: 'Dinonaktifkan',
  japanese: '無効化済み',
  korean: '비활성화됨',
  portuguese: 'Desativado',
  russian: 'Деактивирован',
  spanish: 'Desactivado',
  swahili: 'Imezimwa',
  vietnamese: 'Đã vô hiệu hóa',
};
export const tryAgain: Translation = {
  amharic: 'እባክዎ እንደገና ይሞክሩ',
  arabic: 'يرجى المحاولة مرة أخرى',
  bengali: 'অনুগ্রহ করে আবার চেষ্টা করুন',
  chinese: '请再试一次',
  english: 'Please try again',
  estonian: 'Palun proovi uuesti',
  filipino: 'Mangyaring subukan muli',
  french: 'Veuillez réessayer',
  german: 'Bitte versuche es erneut',
  hindi: 'कृपया पुनः प्रयास करें',
  indonesian: 'Silakan coba lagi',
  japanese: 'もう一度お試しください',
  korean: '다시 시도해 주세요',
  portuguese: 'Por favor tente novamente',
  russian: 'Пожалуйста, попробуйте еще раз',
  spanish: 'Por favor intente de nuevo',
  swahili: 'Tafadhali jaribu tena',
  vietnamese: 'Vui lòng thử lại',
};
export const invalidName: Translation = {
  amharic: 'ልክ ያልሆነ ስም',
  arabic: 'اسم غير صالح',
  bengali: 'অবৈধ নাম',
  chinese: '无效名称',
  english: 'Invalid name',
  estonian: 'Vale nimi',
  filipino: 'Di-wastong pangalan',
  french: 'Nom incorrect',
  german: 'Ungültiger Name',
  hindi: 'अवैध नाम',
  indonesian: 'Nama tidak valid',
  japanese: '無効な名前',
  korean: '유효하지 않은 이름',
  portuguese: 'Nome inválido',
  russian: 'Неверное имя',
  spanish: 'Nombre inválido',
  swahili: 'Jina batili',
  vietnamese: 'Tên không hợp lệ',
};
export const invalidDescription: Translation = {
  amharic: 'ልክ ያልሆነ መግለጫ',
  arabic: 'وصف غير صالح',
  bengali: 'অবৈধ বর্ণনা',
  chinese: '无效描述',
  english: 'Invalid description',
  estonian: 'Vale kirjeldus',
  filipino: 'Di-wastong paglalarawan',
  french: 'Description invalide',
  german: 'Ungültige Beschreibung',
  hindi: 'अवैध विवरण',
  indonesian: 'Deskripsi tidak valid',
  japanese: '無効な説明',
  korean: '유효하지 않은 설명',
  portuguese: 'Descrição inválida',
  russian: 'Неверное описание',
  spanish: 'Descripción inválida',
  swahili: 'Maelezo batili',
  vietnamese: 'Mô tả không hợp lệ',
};
export const invalidData: Translation = {
  amharic: 'ልክ ያልሆነ መረጃ',
  arabic: 'بيانات غير صالحة',
  bengali: 'অবৈধ ডেটা',
  chinese: '无效数据',
  english: 'Invalid data',
  estonian: 'Kehtetud andmed',
  filipino: 'Di-wastong data',
  french: 'Données invalides',
  german: 'Ungültige Daten',
  hindi: 'अवैध डेटा',
  indonesian: 'Data tidak valid',
  japanese: '無効なデータ',
  korean: '유효하지 않은 데이터',
  portuguese: 'Dados inválidos',
  russian: 'Неверные данные',
  spanish: 'Datos inválidos',
  swahili: 'Data batili',
  vietnamese: 'Dữ liệu không hợp lệ',
};
export const refreshDataText: Translation = {
  amharic: 'አድስ',
  arabic: 'تحديث',
  bengali: 'রিফ্রেশ',
  chinese: '刷新',
  english: 'Refresh',
  estonian: 'Värskenda',
  filipino: 'I-refresh',
  french: 'Rafraîchir',
  german: 'Aktualisierung',
  hindi: 'रीफ्रेश',
  indonesian: 'Segarkan',
  japanese: '更新',
  korean: '새로고침',
  portuguese: 'Atualizar',
  russian: 'Обновить',
  spanish: 'Actualizar',
  swahili: 'Sasisha',
  vietnamese: 'Làm mới',
};
// NOTE: saveLabel, at the end of this file, is byte-identical to this one.
// Folding the two is safe and changes no rendered string.
export const save: Translation = {
  amharic: 'አስቀምጥ',
  arabic: 'حفظ',
  bengali: 'সংরক্ষণ',
  chinese: '保存',
  english: 'Save',
  estonian: 'Salvesta',
  filipino: 'I-save',
  french: 'Enregistrer',
  german: 'Speichern',
  hindi: 'सहेजें',
  indonesian: 'Simpan',
  japanese: '保存',
  korean: '저장',
  portuguese: 'Salvar',
  russian: 'Сохранить',
  spanish: 'Guardar',
  swahili: 'Hifadhi',
  vietnamese: 'Lưu',
};
export const apply: Translation = {
  amharic: 'ተግብር',
  arabic: 'تطبيق',
  bengali: 'প্রয়োগ করুন',
  chinese: '应用',
  english: 'Apply',
  estonian: 'Rakenda',
  filipino: 'Ilapat',
  french: 'Appliquer',
  german: 'Anwenden',
  hindi: 'लागू करें',
  indonesian: 'Terapkan',
  japanese: '適用',
  korean: '적용',
  portuguese: 'Aplicar',
  russian: 'Применить',
  spanish: 'Aplicar',
  swahili: 'Tekeleza',
  vietnamese: 'Áp dụng',
};
// NOTE: cancelLabel, at the end of this file, carries the same English and a
// different Estonian (Loobu against this Tühista). Folding the two ships a copy
// change in Estonian, so they are deliberately both here.
export const cancel: Translation = {
  amharic: 'ሰርዝ',
  arabic: 'إلغاء',
  bengali: 'বাতিল',
  chinese: '取消',
  english: 'Cancel',
  estonian: 'Tühista',
  filipino: 'Kanselahin',
  french: 'Annuler',
  german: 'Abbrechen',
  hindi: 'रद्द करें',
  indonesian: 'Batal',
  japanese: 'キャンセル',
  korean: '취소',
  portuguese: 'Cancelar',
  russian: 'Отмена',
  spanish: 'Cancelar',
  swahili: 'Ghairi',
  vietnamese: 'Hủy',
};
export const framework: Translation = {
  amharic: 'ማዕቀፎች',
  arabic: 'أطر عمل',
  bengali: 'ফ্রেমওয়ার্ক',
  chinese: '框架',
  english: 'Frameworks',
  estonian: 'Raamistik',
  filipino: 'Mga framework',
  french: 'Cadre',
  german: 'Rahmenwerke',
  hindi: 'फ्रेमवर्क',
  indonesian: 'Kerangka kerja',
  japanese: 'フレームワーク',
  korean: '프레임워크',
  portuguese: 'Frameworks',
  russian: 'Рамки',
  spanish: 'Marcos',
  swahili: 'Mifumo',
  vietnamese: 'Khung',
};
export const fundamental: Translation = {
  amharic: 'መሰረታዊ',
  arabic: 'أساسي',
  bengali: 'মৌলিক',
  chinese: '基本',
  english: 'Fundamental',
  estonian: 'Fundamentaalne',
  filipino: 'Pundamental',
  french: 'Fondamental',
  german: 'Grundlegend',
  hindi: 'मौलिक',
  indonesian: 'Fundamental',
  japanese: '基本的',
  korean: '기본',
  portuguese: 'Fundamental',
  russian: 'Фундаментальный',
  spanish: 'Fundamental',
  swahili: 'Ya kimsingi',
  vietnamese: 'Cơ bản',
};
export const database: Translation = {
  amharic: 'የውሂብ ጎታ',
  arabic: 'قاعدة البيانات',
  bengali: 'ডাটাবেস',
  chinese: '数据库',
  english: 'Database',
  estonian: 'Andmebaas',
  filipino: 'Database',
  french: 'Base de données',
  german: 'Datenbank',
  hindi: 'डेटाबेस',
  indonesian: 'Basis data',
  japanese: 'データベース',
  korean: '데이터베이스',
  portuguese: 'Banco de dados',
  russian: 'База данных',
  spanish: 'Base de datos',
  swahili: 'Hifadhidata',
  vietnamese: 'Cơ sở dữ liệu',
};
export const infrastructure: Translation = {
  amharic: 'መሠረተ ልማት',
  arabic: 'البنية التحتية',
  bengali: 'অবকাঠামো',
  chinese: '基础设施',
  english: 'Infrastructure',
  estonian: 'Infrastruktuur',
  filipino: 'Imprastraktura',
  french: 'Infrastructure',
  german: 'Infrastruktur',
  hindi: 'बुनियादी ढांचा',
  indonesian: 'Infrastruktur',
  japanese: 'インフラストラクチャ',
  korean: '인프라',
  portuguese: 'Infraestrutura',
  russian: 'Инфраструктура',
  spanish: 'Infraestructura',
  swahili: 'Miundombinu',
  vietnamese: 'Cơ sở hạ tầng',
};
export const tool: Translation = {
  amharic: 'መሳሪያ',
  arabic: 'أداة',
  bengali: 'হাতিয়ার',
  chinese: '工具',
  english: 'Tool',
  estonian: 'Tööriist',
  filipino: 'Kagamitan',
  french: 'Outil',
  german: 'Werkzeug',
  hindi: 'उपकरण',
  indonesian: 'Alat',
  japanese: 'ツール',
  korean: '도구',
  portuguese: 'Ferramenta',
  russian: 'Инструмент',
  spanish: 'Herramienta',
  swahili: 'Chombo',
  vietnamese: 'Công cụ',
};
export const testing: Translation = {
  amharic: 'ሙከራ',
  arabic: 'اختبار',
  bengali: 'পরীক্ষা',
  chinese: '测试',
  english: 'Testing',
  estonian: 'Testimine',
  filipino: 'Pagsusulit',
  french: 'Essai',
  german: 'Testen',
  hindi: 'परीक्षण',
  indonesian: 'Pengujian',
  japanese: 'テスト',
  korean: '테스트',
  portuguese: 'Teste',
  russian: 'Тестирование',
  spanish: 'Pruebas',
  swahili: 'Kujaribu',
  vietnamese: 'Kiểm tra',
};
export const dashboardText: Translation = {
  amharic: 'ዳሽቦርድ',
  arabic: 'لوحة المعلومات',
  bengali: 'ড্যাশবোর্ড',
  chinese: '仪表板',
  english: `Dashboard`,
  estonian: `Armatuurlaud`,
  filipino: 'Dashboard',
  french: 'Tableau de bord',
  german: 'Armaturenbrett',
  hindi: 'डैशबोर्ड',
  indonesian: 'Dasbor',
  japanese: 'ダッシュボード',
  korean: '대시보드',
  portuguese: 'Painel',
  russian: `Панель приборов`,
  spanish: 'Panel de control',
  swahili: 'Dashibodi',
  vietnamese: 'Bảng điều khiển',
};
export const reportsText: Translation = {
  amharic: 'ሪፖርቶች',
  arabic: 'التقارير',
  bengali: 'প্রতিবেদন',
  chinese: '报告',
  english: `Reports`,
  estonian: `Aruanded`,
  filipino: 'Mga ulat',
  french: 'Rapports',
  german: 'Berichte',
  hindi: 'रिपोर्ट',
  indonesian: 'Laporan',
  japanese: 'レポート',
  korean: '보고서',
  portuguese: 'Relatórios',
  russian: `отчеты`,
  spanish: 'Reportes',
  swahili: 'Ripoti',
  vietnamese: 'Báo cáo',
};
export const peopleText: Translation = {
  amharic: 'ሰዎች',
  arabic: 'الأشخاص',
  bengali: 'মানুষ',
  chinese: '人员',
  english: `People`,
  estonian: `Inimesed`,
  filipino: 'Mga tao',
  french: 'Personnes',
  german: 'Menschen',
  hindi: 'लोग',
  indonesian: 'Orang',
  japanese: '人々',
  korean: '사람들',
  portuguese: 'Pessoas',
  russian: `Люди`,
  spanish: 'Personas',
  swahili: 'Watu',
  vietnamese: 'Mọi người',
};
export const helpText: Translation = {
  amharic: 'እገዛ',
  arabic: 'مساعدة',
  bengali: 'সাহায্য',
  chinese: '帮助',
  english: `Help`,
  estonian: `Abi`,
  filipino: 'Tulong',
  french: 'Aider',
  german: 'Helfen',
  hindi: 'सहायता',
  indonesian: 'Bantuan',
  japanese: 'ヘルプ',
  korean: '도움말',
  portuguese: 'Ajuda',
  russian: `Помощь`,
  spanish: 'Ayuda',
  swahili: 'Msaada',
  vietnamese: 'Trợ giúp',
};
export const rolesText: Translation = {
  amharic: 'ሚናዎች',
  arabic: 'الأدوار',
  bengali: 'ভূমিকা',
  chinese: '角色',
  english: `Roles`,
  estonian: `Rollid`,
  filipino: 'Mga tungkulin',
  french: 'Les rôles',
  german: 'Rollen',
  hindi: 'भूमिकाएं',
  indonesian: 'Peran',
  japanese: '役割',
  korean: '역할',
  portuguese: 'Funções',
  russian: `Роли`,
  spanish: 'Roles',
  swahili: 'Majukumu',
  vietnamese: 'Vai trò',
};
export const requestsText: Translation = {
  amharic: 'ጥያቄዎች',
  arabic: 'الطلبات',
  bengali: 'অনুরোধ',
  chinese: '请求',
  english: `Requests`,
  estonian: `Taotlused`,
  filipino: 'Mga kahilingan',
  french: 'Demandes',
  german: 'Anfragen',
  hindi: 'अनुरोध',
  indonesian: 'Permintaan',
  japanese: 'リクエスト',
  korean: '요청',
  portuguese: 'Solicitações',
  russian: `Запросы`,
  spanish: 'Solicitudes',
  swahili: 'Maombi',
  vietnamese: 'Yêu cầu',
};
export const subjectsText: Translation = {
  amharic: 'ትምህርቶች',
  arabic: 'المواضيع',
  bengali: 'বিষয়',
  chinese: '科目',
  english: `Subjects`,
  estonian: `Õppeained`,
  filipino: 'Mga paksa',
  french: 'Sujettes',
  german: 'Fächer',
  hindi: 'विषय',
  indonesian: 'Subjek',
  japanese: '科目',
  korean: '과목',
  portuguese: 'Assuntos',
  russian: `Предметы`,
  spanish: 'Asignaturas',
  swahili: 'Masomo',
  vietnamese: 'Chủ đề',
};
export const playerText: Translation = {
  amharic: 'ተጫዋች',
  arabic: 'لاعب',
  bengali: 'খেলোয়াড়',
  chinese: '玩家',
  english: `Player`,
  estonian: `Mängija`,
  filipino: 'Manlalaro',
  french: 'Joueuse',
  german: 'Spieler',
  hindi: 'खिलाड़ी',
  indonesian: 'Pemain',
  japanese: 'プレイヤー',
  korean: '플레이어',
  portuguese: 'Jogador',
  russian: `Игрок`,
  spanish: 'Jugador',
  swahili: 'Mchezaji',
  vietnamese: 'Người chơi',
};
export const profileText: Translation = {
  amharic: 'መገለጫ',
  arabic: 'الملف الشخصي',
  bengali: 'প্রোফাইল',
  chinese: '个人资料',
  english: 'Profile',
  estonian: 'Profiil',
  filipino: 'Profile',
  french: 'Profil',
  german: 'Profil',
  hindi: 'प्रोफ़ाइल',
  indonesian: 'Profil',
  japanese: 'プロフィール',
  korean: '프로필',
  portuguese: 'Perfil',
  russian: 'Профиль',
  spanish: 'Perfil',
  swahili: 'Wasifu',
  vietnamese: 'Hồ sơ',
};
export const billing: Translation = {
  amharic: 'የክፍያ ሂሳብ',
  arabic: 'الفواتير',
  bengali: 'বিলিং',
  chinese: '计费',
  english: 'Billing',
  estonian: 'Arveldamine',
  filipino: 'Pagsingil',
  french: 'Facturation',
  german: 'Abrechnung',
  hindi: 'बिलिंग',
  indonesian: 'Penagihan',
  japanese: '請求',
  korean: '청구',
  portuguese: 'Faturamento',
  russian: 'Выставление счетов',
  spanish: 'Facturación',
  swahili: 'Ankara',
  vietnamese: 'Thanh toán',
};
export const billingText: Translation = billing;
export const subscriptionsText: Translation = {
  amharic: 'ምዝገባዎች',
  arabic: 'الاشتراكات',
  bengali: 'সাবস্ক্রিপশন',
  chinese: '订阅',
  english: 'Subscriptions',
  estonian: 'Tellimused',
  filipino: 'Mga subscription',
  french: 'Abonnements',
  german: 'Abonnements',
  hindi: 'सदस्यताएं',
  indonesian: 'Langganan',
  japanese: 'サブスクリプション',
  korean: '구독',
  portuguese: 'Assinaturas',
  russian: 'Подписки',
  spanish: 'Suscripciones',
  swahili: 'Usajili',
  vietnamese: 'Đăng ký',
};
export const logoutText: Translation = {
  amharic: 'ውጣ',
  arabic: 'تسجيل الخروج',
  bengali: 'লগ আউট',
  chinese: '登出',
  english: 'Logout',
  estonian: 'Logi välja',
  filipino: 'Mag-logout',
  french: 'Se déconnecter',
  german: 'Abmelden',
  hindi: 'लॉग आउट',
  indonesian: 'Keluar',
  japanese: 'ログアウト',
  korean: '로그아웃',
  portuguese: 'Sair',
  russian: 'Выйти',
  spanish: 'Cerrar sesión',
  swahili: 'Toka',
  vietnamese: 'Đăng xuất',
};
export const roleT: Translation = {
  amharic: 'ሚና',
  arabic: 'الدور',
  bengali: 'ভূমিকা',
  chinese: '角色',
  english: 'Role',
  estonian: 'Roll',
  filipino: 'Tungkulin',
  french: 'Rôle',
  german: 'Rolle',
  hindi: 'भूमिका',
  indonesian: 'Peran',
  japanese: '役割',
  korean: '역할',
  portuguese: 'Função',
  russian: 'Роль',
  spanish: 'Rol',
  swahili: 'Jukumu',
  vietnamese: 'Vai trò',
};
export const countryText: Translation = {
  amharic: 'አገር',
  arabic: 'البلد',
  bengali: 'দেশ',
  chinese: '国家',
  english: 'Country',
  estonian: 'Riik',
  filipino: 'Bansa',
  french: 'Pays',
  german: 'Land',
  hindi: 'देश',
  indonesian: 'Negara',
  japanese: '国',
  korean: '국가',
  portuguese: 'País',
  russian: 'Страна',
  spanish: 'País',
  swahili: 'Nchi',
  vietnamese: 'Quốc gia',
};
export const locationT: Translation = {
  amharic: 'አካባቢ',
  arabic: 'الموقع',
  bengali: 'অবস্থান',
  chinese: '位置',
  english: 'Location',
  estonian: 'Asukoht',
  filipino: 'Lokasyon',
  french: 'Emplacement',
  german: 'Ort',
  hindi: 'स्थान',
  indonesian: 'Lokasi',
  japanese: '場所',
  korean: '위치',
  portuguese: 'Localização',
  russian: 'Расположение',
  spanish: 'Ubicación',
  swahili: 'Mahali',
  vietnamese: 'Vị trí',
};
export const activeText: Translation = {
  amharic: 'ንቁ',
  arabic: 'نشط',
  bengali: 'সক্রিয়',
  chinese: '活跃',
  english: 'Active',
  estonian: 'Aktiivne',
  filipino: 'Aktibo',
  french: 'Actif',
  german: 'Aktiv',
  hindi: 'सक্রिয',
  indonesian: 'Aktif',
  japanese: 'アクティブ',
  korean: '활성',
  portuguese: 'Ativo',
  russian: 'Активный',
  spanish: 'Activo',
  swahili: 'Hai',
  vietnamese: 'Hoạt động',
};
// NOTE: navGroupAccount, at the end of this file, carries the same English and a
// different Russian (Аккаунт against this Счет). Folding the two ships a copy
// change in Russian, so they are deliberately both here.
export const account: Translation = {
  amharic: 'መለያ',
  arabic: 'الحساب',
  bengali: 'অ্যাকাউন্ট',
  chinese: '账户',
  english: 'Account',
  estonian: 'Konto',
  filipino: 'Account',
  french: 'Compte',
  german: 'Konto',
  hindi: 'खाता',
  indonesian: 'Akun',
  japanese: 'アカウント',
  korean: '계정',
  portuguese: 'Conta',
  russian: 'Счет',
  spanish: 'Cuenta',
  swahili: 'Akaunti',
  vietnamese: 'Tài khoản',
};
export const deleteAccountText: Translation = {
  amharic: 'መለያ ሰርዝ',
  arabic: 'حذف الحساب',
  bengali: 'অ্যাকাউন্ট মুছুন',
  chinese: '删除账户',
  english: 'Delete Account',
  estonian: 'Kustuta konto',
  filipino: 'Tanggalin ang account',
  french: 'Supprimer le compte',
  german: 'Konto löschen',
  hindi: 'खाता हटाएं',
  indonesian: 'Hapus akun',
  japanese: 'アカウント削除',
  korean: '계정 삭제',
  portuguese: 'Excluir conta',
  russian: 'Удалить аккаунт',
  spanish: 'Eliminar cuenta',
  swahili: 'Futa akaunti',
  vietnamese: 'Xóa tài khoản',
};
export const password: Translation = {
  amharic: 'የይለፍ ቃል',
  arabic: 'كلمة المرور',
  bengali: 'পাসওয়ার্ড',
  chinese: '密码',
  english: 'Password',
  estonian: 'Passwort',
  filipino: 'Password',
  french: 'Mot de passe',
  german: 'Parool',
  hindi: 'पासवर्ड',
  indonesian: 'Kata sandi',
  japanese: 'パスワード',
  korean: '비밀번호',
  portuguese: 'Senha',
  russian: 'Пароль',
  spanish: 'Contraseña',
  swahili: 'Nenosiri',
  vietnamese: 'Mật khẩu',
};
export const email: Translation = {
  amharic: 'ኢሜይል',
  arabic: 'البريد الإلكتروني',
  bengali: 'ইমেল',
  chinese: '电子邮件',
  english: 'Email',
  estonian: 'Meil',
  filipino: 'Email',
  french: 'E-mail',
  german: 'Email',
  hindi: 'ईमेल',
  indonesian: 'Email',
  japanese: 'メール',
  korean: '이메일',
  portuguese: 'E-mail',
  russian: 'Электронная почта',
  spanish: 'Correo electrónico',
  swahili: 'Barua pepe',
  vietnamese: 'Email',
};
export const emailText: Translation = email;
export const resetPasswordText: Translation = {
  amharic: 'የይለፍ ቃል ዳግም አስጀምር',
  arabic: 'إعادة تعيين كلمة المرور',
  bengali: 'পাসওয়ার্ড রিসেট করুন',
  chinese: '重置密码',
  english: 'Reset Password',
  estonian: 'Lähtestage parool',
  filipino: 'I-reset ang password',
  french: 'réinitialiser le mot de passe',
  german: 'Passwort zurücksetzen',
  hindi: 'पासवर्ड रीसेट करें',
  indonesian: 'Reset kata sandi',
  japanese: 'パスワードをリセット',
  korean: '비밀번호 재설정',
  portuguese: 'Redefinir senha',
  russian: 'Сброс пароля',
  spanish: 'Restablecer contraseña',
  swahili: 'Weka upya nenosiri',
  vietnamese: 'Đặt lại mật khẩu',
};
export const updatePassword: Translation = {
  amharic: 'የይለፍ ቃል አዘምን',
  arabic: 'تحديث كلمة المرور',
  bengali: 'পাসওয়ার্ড আপডেট করুন',
  chinese: '更新密码',
  english: 'Update Password',
  estonian: 'Värskenda parooli',
  filipino: 'I-update ang password',
  french: 'Mettre à jour le mot de passe',
  german: 'Kennwort aktualisieren',
  hindi: 'पासवर्ड अपडेट करें',
  indonesian: 'Perbarui kata sandi',
  japanese: 'パスワードを更新',
  korean: '비밀번호 업데이트',
  portuguese: 'Atualizar senha',
  russian: 'Обновить пароль',
  spanish: 'Actualizar contraseña',
  swahili: 'Sasisha nenosiri',
  vietnamese: 'Cập nhật mật khẩu',
};
export const accountCreated: Translation = {
  amharic: 'መለያ ተፈጥሯል',
  arabic: 'تم إنشاء الحساب',
  bengali: 'অ্যাকাউন্ট তৈরি হয়েছে',
  chinese: '账户已创建',
  english: 'Account Created',
  estonian: 'Konto loodud',
  filipino: 'Account na-create',
  french: 'Compte créé',
  german: 'Account erstellt',
  hindi: 'खाता बनाया गया',
  indonesian: 'Akun dibuat',
  japanese: 'アカウント作成済み',
  korean: '계정 생성됨',
  portuguese: 'Conta criada',
  russian: 'Аккаунт создан',
  spanish: 'Cuenta creada',
  swahili: 'Akaunti imeundwa',
  vietnamese: 'Đã tạo tài khoản',
};
export const saving: Translation = {
  amharic: 'በማስቀመጥ ላይ',
  arabic: 'حفظ',
  bengali: 'সংরক্ষণ করা হচ্ছে',
  chinese: '保存中',
  english: 'Saving',
  estonian: 'Salvestamine',
  filipino: 'Sine-save',
  french: 'Enregistrement',
  german: 'Wird gespeichert',
  hindi: 'सहेज रहा है',
  indonesian: 'Menyimpan',
  japanese: '保存中',
  korean: '저장 중',
  portuguese: 'Salvando',
  russian: 'Сохранение',
  spanish: 'Guardando',
  swahili: 'Inahifadhi',
  vietnamese: 'Đang lưu',
};
export const noUsers: Translation = {
  amharic: 'ተጠቃሚዎች የሉም',
  arabic: 'لا يوجد مستخدمون',
  bengali: 'কোনো ব্যবহারকারী নেই',
  chinese: '无用户',
  english: 'No users',
  estonian: 'Kasutajaid pole',
  filipino: 'Walang mga user',
  french: 'Aucun utilisateur',
  german: 'Keine Benutzer',
  hindi: 'कोई उपयोगकर्ता नहीं',
  indonesian: 'Tidak ada pengguna',
  japanese: 'ユーザーなし',
  korean: '사용자 없음',
  portuguese: 'Sem usuários',
  russian: 'Нет пользователей',
  spanish: 'Sin usuarios',
  swahili: 'Hakuna watumiaji',
  vietnamese: 'Không có người dùng',
};
export const updated: Translation = {
  amharic: 'ተዘምኗል',
  arabic: 'تم التحديث',
  bengali: 'আপডেট করা হয়েছে',
  chinese: '已更新',
  english: 'Updated',
  estonian: 'Uuendatud',
  filipino: 'Na-update',
  french: 'Actualisé',
  german: 'Aktualisiert',
  hindi: 'अपडेट किया गया',
  indonesian: 'Diperbarui',
  japanese: '更新済み',
  korean: '업데이트됨',
  portuguese: 'Atualizado',
  russian: 'Обновлено',
  spanish: 'Actualizado',
  swahili: 'Imesasishwa',
  vietnamese: 'Đã cập nhật',
};
export const updateRole: Translation = {
  amharic: 'ሚና ቀይር',
  arabic: 'تغيير الدور',
  bengali: 'ভূমিকা পরিবর্তন করুন',
  chinese: '更改角色',
  english: 'Change role',
  estonian: 'Muuda rolli',
  filipino: 'Baguhin ang role',
  french: 'Changer de rôle',
  german: 'Rolle wechseln',
  hindi: 'भूमिका बदलें',
  indonesian: 'Ubah peran',
  japanese: '役割を変更',
  korean: '역할 변경',
  portuguese: 'Alterar função',
  russian: 'Изменить роль',
  spanish: 'Cambiar rol',
  swahili: 'Badilisha jukumu',
  vietnamese: 'Thay đổi vai trò',
};
export const updateEmail: Translation = {
  amharic: 'ኢሜይል አዘምን',
  arabic: 'تحديث البريد الإلكتروني',
  bengali: 'ইমেল আপডেট করুন',
  chinese: '更新电子邮件',
  english: 'Update email',
  estonian: 'Värskenda e-posti',
  filipino: 'I-update ang email',
  french: `Mettre à jour l'e-mail`,
  german: 'E-Mail aktualisieren',
  hindi: 'ईमेल अपडेट करें',
  indonesian: 'Perbarui email',
  japanese: 'メールを更新',
  korean: '이메일 업데이트',
  portuguese: 'Atualizar e-mail',
  russian: 'Обновить адрес электронной почты',
  spanish: 'Actualizar correo electrónico',
  swahili: 'Sasisha barua pepe',
  vietnamese: 'Cập nhật email',
};

export const withdraw: Translation = {
  amharic: 'አውጣ',
  arabic: 'سحب',
  bengali: 'তুলে নিন',
  chinese: '提取',
  english: 'Withdraw',
  estonian: 'Välja võtta',
  filipino: 'Mag-withdraw',
  french: 'Retirer',
  german: 'Auszahlen',
  hindi: 'निकालें',
  indonesian: 'Tarik',
  japanese: '引き出す',
  korean: '인출',
  portuguese: 'Sacar',
  russian: 'Вывести',
  spanish: 'Retirar',
  swahili: 'Ondoa',
  vietnamese: 'Rút',
};
export const deposit: Translation = {
  amharic: 'አስቀምጥ',
  arabic: 'إيداع',
  bengali: 'জমা দিন',
  chinese: '存入',
  english: 'Deposit',
  estonian: 'Sisse võtta',
  filipino: 'Mag-deposit',
  french: 'Déposer',
  german: 'Einzahlen',
  hindi: 'जमा करें',
  indonesian: 'Setor',
  japanese: '預ける',
  korean: '입금',
  portuguese: 'Depositar',
  russian: 'Внести',
  spanish: 'Depositar',
  swahili: 'Weka',
  vietnamese: 'Gửi',
};
export const creditsText: Translation = {
  amharic: 'ክሬዲቶች',
  arabic: 'الأرصدة',
  bengali: 'ক্রেডিট',
  chinese: '积分',
  english: 'Credits',
  estonian: 'Krediidid',
  filipino: 'Mga credit',
  french: 'Crédits',
  german: 'Kredite',
  hindi: 'क्रेडिट',
  indonesian: 'Kredit',
  japanese: 'クレジット',
  korean: '크레딧',
  portuguese: 'Créditos',
  russian: 'Кредиты',
  spanish: 'Créditos',
  swahili: 'Mikopo',
  vietnamese: 'Tín dụng',
};
export const paymentServiceText: Translation = {
  amharic: 'የክፍያ አገልግሎት',
  arabic: 'خدمة الدفع',
  bengali: 'পেমেন্ট সেবা',
  chinese: '支付服务',
  english: 'Payment service',
  estonian: 'Makse teenus',
  filipino: 'Serbisyo ng pagbabayad',
  french: 'Service de paiement',
  german: 'Zahlungsdienst',
  hindi: 'भुगतान सेवा',
  indonesian: 'Layanan pembayaran',
  japanese: '決済サービス',
  korean: '결제 서비스',
  portuguese: 'Serviço de pagamento',
  russian: 'Платежный сервис',
  spanish: 'Servicio de pago',
  swahili: 'Huduma ya malipo',
  vietnamese: 'Dịch vụ thanh toán',
};
export const enterAmount: Translation = {
  amharic: 'እባክዎ ትክክለኛ መጠን ያስገቡ',
  arabic: 'يرجى إدخال مبلغ صالح',
  bengali: 'অনুগ্রহ করে একটি বৈধ পরিমাণ লিখুন',
  chinese: '请输入有效金额',
  english: 'Please enter a valid amount',
  estonian: 'Palun sisestage korrekt summa',
  filipino: 'Mangyaring maglagay ng wastong halaga',
  french: `Veuillez saisir un montant valide`,
  german: 'Bitte geben Sie eine gültige Summe ein',
  hindi: 'कृपया एक वैध राशि दर्ज करें',
  indonesian: 'Silakan masukkan jumlah yang valid',
  japanese: '有効な金額を入力してください',
  korean: '유효한 금액을 입력하세요',
  portuguese: 'Por favor insira um valor válido',
  russian: 'Пожалуйста, введите допустимую сумму',
  spanish: 'Por favor ingrese un monto válido',
  swahili: 'Tafadhali weka kiasi halali',
  vietnamese: 'Vui lòng nhập số tiền hợp lệ',
};
export const update: Translation = {
  amharic: 'አዘምን',
  arabic: 'تحديث',
  bengali: 'আপডেট',
  chinese: '更新',
  english: 'Update',
  estonian: 'Värskenda',
  filipino: 'I-update',
  french: 'Mettre à jour',
  german: 'Aktualisieren',
  hindi: 'अपडेट',
  indonesian: 'Perbarui',
  japanese: '更新',
  korean: '업데이트',
  portuguese: 'Atualizar',
  russian: 'Обновить',
  spanish: 'Actualizar',
  swahili: 'Sasisha',
  vietnamese: 'Cập nhật',
};
export const confirmT: Translation = {
  amharic: 'አረጋግጥ',
  arabic: 'تأكيد',
  bengali: 'নিশ্চিত করুন',
  chinese: '确认',
  english: 'Confirm',
  estonian: 'Kinnita',
  filipino: 'Kumpirmahin',
  french: 'Confirmer',
  german: 'Bestätigen',
  hindi: 'पुष्टि करें',
  indonesian: 'Konfirmasi',
  japanese: '確認',
  korean: '확인',
  portuguese: 'Confirmar',
  russian: 'Подтвердить',
  spanish: 'Confirmar',
  swahili: 'Thibitisha',
  vietnamese: 'Xác nhận',
};
export const deactivate: Translation = {
  amharic: 'አቦዝን',
  arabic: 'إلغاء التنشيط',
  bengali: 'নিষ্ক্রিয় করুন',
  chinese: '停用',
  english: 'Deactivate',
  estonian: 'Deaktivieren',
  filipino: 'I-deactivate',
  french: 'Désactiver',
  german: 'Deaktivieren',
  hindi: 'निष्क्रिय करें',
  indonesian: 'Nonaktifkan',
  japanese: '無効化',
  korean: '비활성화',
  portuguese: 'Desativar',
  russian: 'Деактивировать',
  spanish: 'Desactivar',
  swahili: 'Zima',
  vietnamese: 'Vô hiệu hóa',
};
export const activate: Translation = {
  amharic: 'አንቃ',
  arabic: 'تنشيط',
  bengali: 'সক্রিয় করুন',
  chinese: '激活',
  english: 'Activate',
  estonian: 'Aktivieren',
  filipino: 'I-activate',
  french: 'Activer',
  german: 'Aktivieren',
  hindi: 'सक्रिय करें',
  indonesian: 'Aktifkan',
  japanese: '有効化',
  korean: '활성화',
  portuguese: 'Ativar',
  russian: 'Активировать',
  spanish: 'Activar',
  swahili: 'Amilisha',
  vietnamese: 'Kích hoạt',
};
export const areYouSure: Translation = {
  amharic: 'እርግጠኛ ነዎት?',
  arabic: 'هل أنت متأكد؟',
  bengali: 'আপনি কি নিশ্চিত?',
  chinese: '你确定吗？',
  english: 'Are you sure?',
  estonian: 'Oled kindel?',
  filipino: 'Sigurado ka ba?',
  french: 'Es-tu sûr?',
  german: 'Bist du sicher?',
  hindi: 'क्या आप सुनिश्चित हैं?',
  indonesian: 'Apakah Anda yakin?',
  japanese: '本当によろしいですか？',
  korean: '확실합니까?',
  portuguese: 'Tem certeza?',
  russian: 'Вы уверены?',
  spanish: '¿Está seguro?',
  swahili: 'Una uhakika?',
  vietnamese: 'Bạn có chắc không?',
};
export const enterConfirmText: Translation = {
  amharic: 'እባክዎ ትክክለኛ የማረጋገጫ ጽሑፍ ያስገቡ',
  arabic: 'يرجى إدخال نص تأكيد صالح',
  bengali: 'অনুগ্রহ করে বৈধ নিশ্চিতকরণ পাঠ্য লিখুন',
  chinese: '请输入有效的确认文本',
  english: 'Please enter valid confirm text',
  estonian: 'Palun sisestage korrekt tekst',
  filipino: 'Mangyaring maglagay ng wastong teksto ng kumpirmasyon',
  french: `Veuillez saisir un texte de confirmation valide`,
  german: 'Bitte geben Sie einen gültigen Bestätigungstext ein',
  hindi: 'कृपया मान्य पुष्टि पाठ दर्ज करें',
  indonesian: 'Silakan masukkan teks konfirmasi yang valid',
  japanese: '有効な確認テキストを入力してください',
  korean: '유효한 확인 텍스트를 입력하세요',
  portuguese: 'Por favor insira um texto de confirmação válido',
  russian: 'Пожалуйста, введите допустимый текст подтверждения',
  spanish: 'Por favor ingrese un texto de confirmación válido',
  swahili: 'Tafadhali weka maandishi sahihi ya uthibitisho',
  vietnamese: 'Vui lòng nhập văn bản xác nhận hợp lệ',
};
export const amountText: Translation = {
  amharic: 'መጠን',
  arabic: 'المبلغ',
  bengali: 'পরিমাণ',
  chinese: '金额',
  english: 'Amount',
  estonian: 'Summa',
  filipino: 'Halaga',
  french: 'Montant',
  german: 'Betrag',
  hindi: 'राशि',
  indonesian: 'Jumlah',
  japanese: '金額',
  korean: '금액',
  portuguese: 'Valor',
  russian: 'Сумма',
  spanish: 'Monto',
  swahili: 'Kiasi',
  vietnamese: 'Số tiền',
};
export const receiptText: Translation = {
  amharic: 'ደረሰኝ',
  arabic: 'إيصال',
  bengali: 'রসিদ',
  chinese: '收据',
  english: 'Receipt',
  estonian: 'Saabumine',
  filipino: 'Resibo',
  french: 'Reçu',
  german: 'Empfangen',
  hindi: 'रसीद',
  indonesian: 'Tanda terima',
  japanese: '領収書',
  korean: '영수증',
  portuguese: 'Recibo',
  russian: 'Чек',
  spanish: 'Recibo',
  swahili: 'Risiti',
  vietnamese: 'Biên lai',
};
export const keepDialogOpenText: Translation = {
  amharic: 'መገናኛውን ክፍት አድርግ',
  arabic: 'إبقاء مربع الحوار مفتوحًا',
  bengali: 'ডায়ালগ খোলা রাখুন',
  chinese: '保持对话框打开',
  english: 'Keep dialog open',
  estonian: 'Dialoog avamiseks',
  filipino: 'Panatilihing bukas ang dialog',
  french: 'Garder la boîte de dialogue ouverte',
  german: 'Dialog öffnen lassen',
  hindi: 'संवाद खुला रखें',
  indonesian: 'Biarkan dialog terbuka',
  japanese: 'ダイアログを開いたままにする',
  korean: '대화상자 열어두기',
  portuguese: 'Manter diálogo aberto',
  russian: 'Оставить диалог открытым',
  spanish: 'Mantener diálogo abierto',
  swahili: 'Weka mazungumzo wazi',
  vietnamese: 'Giữ hộp thoại mở',
};
export const alreadyExist: Translation = {
  amharic: 'አስቀድሞ አለ',
  arabic: 'موجود بالفعل',
  bengali: 'ইতিমধ্যে বিদ্যমান',
  chinese: '已存在',
  english: 'already exists',
  estonian: 'on juba olemas',
  filipino: 'mayroon na',
  french: 'existe déjà',
  german: 'existiert bereits',
  hindi: 'पहले से मौजूद है',
  indonesian: 'sudah ada',
  japanese: 'すでに存在します',
  korean: '이미 존재함',
  portuguese: 'já existe',
  russian: 'уже существует',
  spanish: 'ya existe',
  swahili: 'tayari ipo',
  vietnamese: 'đã tồn tại',
};
export const enterLocation: Translation = {
  amharic: 'እባክዎ ትክክለኛ አካባቢ ያስገቡ',
  arabic: 'يرجى إدخال موقع صالح',
  bengali: 'অনুগ্রহ করে একটি বৈধ অবস্থান লিখুন',
  chinese: '请输入有效位置',
  english: 'Please enter a valid location',
  estonian: 'Palun sisestage korrekt asukoht',
  filipino: 'Mangyaring maglagay ng wastong lokasyon',
  french: `Veuillez entrer un emplacement valide`,
  german: 'Bitte geben Sie eine gültige Adresse ein',
  hindi: 'कृपया एक वैध स्थान दर्ज करें',
  indonesian: 'Silakan masukkan lokasi yang valid',
  japanese: '有効な場所を入力してください',
  korean: '유효한 위치를 입력하세요',
  portuguese: 'Por favor insira uma localização válida',
  russian: 'Пожалуйста, введите допустимое местоположение',
  spanish: 'Por favor ingrese una ubicación válida',
  swahili: 'Tafadhali weka eneo halali',
  vietnamese: 'Vui lòng nhập vị trí hợp lệ',
};
export const passwordText: Translation = {
  amharic: 'የይለፍ ቃል',
  arabic: 'كلمة المرور',
  bengali: 'পাসওয়ার্ড',
  chinese: '密码',
  english: 'Password',
  estonian: 'Parool',
  filipino: 'Password',
  french: 'Mot de passe',
  german: 'Passwort',
  hindi: 'पासवर्ड',
  indonesian: 'Kata sandi',
  japanese: 'パスワード',
  korean: '비밀번호',
  portuguese: 'Senha',
  russian: 'Пароль',
  spanish: 'Contraseña',
  swahili: 'Nenosiri',
  vietnamese: 'Mật khẩu',
};
export const confirmPassword: Translation = {
  amharic: 'የይለፍ ቃል አረጋግጥ',
  arabic: 'تأكيد كلمة المرور',
  bengali: 'পাসওয়ার্ড নিশ্চিত করুন',
  chinese: '确认密码',
  english: 'Confirm password',
  estonian: 'Parooli kinnitamine',
  filipino: 'Kumpirmahin ang password',
  french: 'Confirmez le mot de passe',
  german: 'Kennwort bestätigen',
  hindi: 'पासवर्ड की पुष्टि करें',
  indonesian: 'Konfirmasi kata sandi',
  japanese: 'パスワードを確認',
  korean: '비밀번호 확인',
  portuguese: 'Confirmar senha',
  russian: 'Подтвердите пароль',
  spanish: 'Confirmar contraseña',
  swahili: 'Thibitisha nenosiri',
  vietnamese: 'Xác nhận mật khẩu',
};
export const passwordHelper: Translation = {
  amharic: 'የይለፍ ቃል ቢያንስ 1 ትልቅ ፊደል፣ 1 ትንሽ ፊደል፣ 1 ቁጥር፣ 1 ልዩ ቁምፊ መያዝ አለበት እና ቢያንስ 8 ርዝመት ሊኖረው ይገባል',
  arabic: 'يجب أن تحتوي كلمة المرور على حرف كبير واحد على الأقل، وحرف صغير واحد، ورقم واحد، وحرف خاص واحد ويجب أن يكون الحد الأدنى للطول 8',
  bengali: 'পাসওয়ার্ডে কমপক্ষে 1টি বড় হাতের অক্ষর, 1টি ছোট হাতের অক্ষর, 1টি সংখ্যা, 1টি বিশেষ অক্ষর থাকতে হবে এবং ন্যূনতম দৈর্ঘ্য 8 হতে হবে',
  chinese: '密码必须包含至少1个大写字母、1个小写字母、1个数字、1个特殊字符，最小长度为8',
  english: 'Password must contain at least 1 uppercase, 1 lowercase, 1 digit, 1 special character and must be a minimum length of 8',
  estonian: 'Parool peab sisaldama vähemalt ühte suurt tähte, ühte väiket tähte, ühte numbrit, ühte erikut tähte ja peab olema vähemalt 8 tähemärki pikk',
  filipino: 'Ang password ay dapat maglaman ng hindi bababa sa 1 uppercase, 1 lowercase, 1 digit, 1 special character at dapat may minimum na haba na 8',
  french: 'Le mot de passe doit contenir au moins 1 majuscule, 1 minuscule, 1 chiffre, 1 caractère spécial et doit avoir une longueur minimale de 8',
  german: 'Das Passwort muss mindestens 1 Großbuchstaben, 1 Kleinbuchstaben, 1 Ziffer, 1 Sonderzeichen und eine Mindestlänge von 8 Zeichen enthalten',
  hindi: 'पासवर्ड में कम से कम 1 अपरकेस, 1 लोअरकेस, 1 अंक, 1 विशेष वर्ण होना चाहिए और न्यूनतम लंबाई 8 होनी चाहिए',
  indonesian: 'Kata sandi harus berisi setidaknya 1 huruf besar, 1 huruf kecil, 1 digit, 1 karakter khusus dan harus memiliki panjang minimum 8',
  japanese: 'パスワードには少なくとも大文字1文字、小文字1文字、数字1桁、特殊文字1文字が含まれ、最小長さは8でなければなりません',
  korean: '비밀번호는 최소 1개의 대문자, 1개의 소문자, 1개의 숫자, 1개의 특수 문자를 포함해야 하며 최소 길이는 8이어야 합니다',
  portuguese: 'A senha deve conter pelo menos 1 maiúscula, 1 minúscula, 1 dígito, 1 caractere especial e deve ter um comprimento mínimo de 8',
  russian: 'Пароль должен содержать хотя бы одну заглавную букву, одну строчную букву, одну цифру, один специальный символ и должен быть минимум 8 символов',
  spanish: 'La contraseña debe contener al menos 1 mayúscula, 1 minúscula, 1 dígito, 1 carácter especial y debe tener una longitud mínima de 8',
  swahili: 'Nenosiri lazima liwe na angalau herufi 1 kubwa, 1 ndogo, 1 tarakimu, 1 kibainishi maalum na lazima iwe na urefu wa chini wa 8',
  vietnamese: 'Mật khẩu phải chứa ít nhất 1 chữ hoa, 1 chữ thường, 1 chữ số, 1 ký tự đặc biệt và phải có độ dài tối thiểu là 8',
};
export const hide: Translation = {
  amharic: 'ደብቅ',
  arabic: 'إخفاء',
  bengali: 'লুকান',
  chinese: '隐藏',
  english: 'Hide',
  estonian: 'Peida',
  filipino: 'Itago',
  french: 'Cacher',
  german: 'Verstecken',
  hindi: 'छिपाएं',
  indonesian: 'Sembunyikan',
  japanese: '非表示',
  korean: '숨기기',
  portuguese: 'Esconder',
  russian: 'Скрыть',
  spanish: 'Ocultar',
  swahili: 'Ficha',
  vietnamese: 'Ẩn',
};
export const show: Translation = {
  amharic: 'አሳይ',
  arabic: 'عرض',
  bengali: 'দেখান',
  chinese: '显示',
  english: 'Show',
  estonian: 'Näita',
  filipino: 'Ipakita',
  french: 'Montre moi',
  german: 'Anzeigen',
  hindi: 'दिखाएं',
  indonesian: 'Tampilkan',
  japanese: '表示',
  korean: '표시',
  portuguese: 'Mostrar',
  russian: 'Показать',
  spanish: 'Mostrar',
  swahili: 'Onyesha',
  vietnamese: 'Hiển thị',
};
export const address: Translation = {
  amharic: 'አድራሻ',
  arabic: 'العنوان',
  bengali: 'ঠিকানা',
  chinese: '地址',
  english: 'Address',
  estonian: 'Aadress',
  filipino: 'Address',
  french: 'Adresse',
  german: 'Adresse',
  hindi: 'पता',
  indonesian: 'Alamat',
  japanese: '住所',
  korean: '주소',
  portuguese: 'Endereço',
  russian: 'Адрес',
  spanish: 'Dirección',
  swahili: 'Anwani',
  vietnamese: 'Địa chỉ',
};
export const roleText: Translation = {
  amharic: 'ሚና',
  arabic: 'الدور',
  bengali: 'ভূমিকা',
  chinese: '角色',
  english: 'Role',
  estonian: 'Roll',
  filipino: 'Tungkulin',
  french: 'Rôle',
  german: 'Rolle',
  hindi: 'भूमिका',
  indonesian: 'Peran',
  japanese: '役割',
  korean: '역할',
  portuguese: 'Função',
  russian: 'Роль',
  spanish: 'Rol',
  swahili: 'Jukumu',
  vietnamese: 'Vai trò',
};
export const addUser: Translation = {
  amharic: 'ተጠቃሚ አክል',
  arabic: 'إضافة مستخدم',
  bengali: 'ব্যবহারকারী যোগ করুন',
  chinese: '添加用户',
  english: 'Add User',
  estonian: 'Lisa kasutaja',
  filipino: 'Idagdag ang user',
  french: 'Ajouter un utilisateur',
  german: 'Benutzer hinzufügen',
  hindi: 'उपयोगकर्ता जोड़ें',
  indonesian: 'Tambah pengguna',
  japanese: 'ユーザーを追加',
  korean: '사용자 추가',
  portuguese: 'Adicionar usuário',
  russian: 'Добавить пользователя',
  spanish: 'Agregar usuario',
  swahili: 'Ongeza mtumiaji',
  vietnamese: 'Thêm người dùng',
};
export const firstNameText: Translation = {
  amharic: 'የመጀመሪያ ስም',
  arabic: 'الاسم الأول',
  bengali: 'প্রথম নাম',
  chinese: '名字',
  english: 'First name',
  estonian: 'Eesnimi',
  filipino: 'Pangalan',
  french: 'Prénom',
  german: 'Vorname',
  hindi: 'पहला नाम',
  indonesian: 'Nama depan',
  japanese: '名',
  korean: '이름',
  portuguese: 'Nome',
  russian: 'Имя',
  spanish: 'Nombre',
  swahili: 'Jina la kwanza',
  vietnamese: 'Tên',
};
export const lastNameText: Translation = {
  amharic: 'የአባት ስም',
  arabic: 'اسم العائلة',
  bengali: 'শেষ নাম',
  chinese: '姓氏',
  english: 'Last name',
  estonian: 'Perekonnanimi',
  filipino: 'Apelyido',
  french: 'Nom de famille',
  german: 'Nachname',
  hindi: 'उपनाम',
  indonesian: 'Nama belakang',
  japanese: '姓',
  korean: '성',
  portuguese: 'Sobrenome',
  russian: 'Фамилия',
  spanish: 'Apellido',
  swahili: 'Jina la ukoo',
  vietnamese: 'Họ',
};
export const enterAddress: Translation = {
  amharic: 'እባክዎ ትክክለኛ አድራሻ ያስገቡ',
  arabic: 'يرجى إدخال عنوان صالح',
  bengali: 'অনুগ্রহ করে একটি বৈধ ঠিকানা লিখুন',
  chinese: '请输入有效地址',
  english: 'Please enter a valid address',
  estonian: 'Palun sisestage korrekt asukoht',
  filipino: 'Mangyaring maglagay ng wastong address',
  french: `s'il-vous-plaît entrez une adresse valide`,
  german: 'Bitte geben Sie eine gültige Adresse ein',
  hindi: 'कृपया एक वैध पता दर्ज करें',
  indonesian: 'Silakan masukkan alamat yang valid',
  japanese: '有効な住所を入力してください',
  korean: '유효한 주소를 입력하세요',
  portuguese: 'Por favor insira um endereço válido',
  russian: 'Пожалуйста, введите допустимый адрес',
  spanish: 'Por favor ingrese una dirección válida',
  swahili: 'Tafadhali weka anwani halali',
  vietnamese: 'Vui lòng nhập địa chỉ hợp lệ',
};
export const enterPhone: Translation = {
  amharic: 'እባክዎ ትክክለኛ ስልክ ቁጥር ያስገቡ',
  arabic: 'يرجى إدخال رقم هاتف صالح',
  bengali: 'অনুগ্রহ করে একটি বৈধ ফোন নম্বর লিখুন',
  chinese: '请输入有效电话号码',
  english: 'Please enter a valid phone number',
  estonian: 'Palun sisestage korrekt telefoninumber',
  filipino: 'Mangyaring maglagay ng wastong numero ng telepono',
  french: `s'il vous plaît entrer un numéro de téléphone valide`,
  german: 'Bitte geben Sie eine gültige Telefonnummer ein',
  hindi: 'कृपया एक वैध फोन नंबर दर्ज करें',
  indonesian: 'Silakan masukkan nomor telepon yang valid',
  japanese: '有効な電話番号を入力してください',
  korean: '유효한 전화번호를 입력하세요',
  portuguese: 'Por favor insira um número de telefone válido',
  russian: 'Пожалуйста, введите допустимый номер телефона',
  spanish: 'Por favor ingrese un número de teléfono válido',
  swahili: 'Tafadhali weka nambari ya simu halali',
  vietnamese: 'Vui lòng nhập số điện thoại hợp lệ',
};
export const enterValidEmail: Translation = {
  amharic: 'እባክዎ ትክክለኛ ኢሜይል ያስገቡ',
  arabic: 'يرجى إدخال بريد إلكتروني صالح',
  bengali: 'অনুগ্রহ করে একটি বৈধ ইমেল লিখুন',
  chinese: '请输入有效电子邮件',
  english: 'Please enter a valid email',
  estonian: 'Palun sisestage korrekt e-posti aadress',
  filipino: 'Mangyaring maglagay ng wastong email',
  french: 'Veuillez entrer un email valide',
  german: 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
  hindi: 'कृपया एक वैध ईमेल दर्ज करें',
  indonesian: 'Silakan masukkan email yang valid',
  japanese: '有効なメールアドレスを入力してください',
  korean: '유효한 이메일을 입력하세요',
  portuguese: 'Por favor insira um e-mail válido',
  russian: 'Пожалуйста, введите допустимый адрес электронной почты',
  spanish: 'Por favor ingrese un correo electrónico válido',
  swahili: 'Tafadhali weka barua pepe halali',
  vietnamese: 'Vui lòng nhập email hợp lệ',
};
export const enterName: Translation = {
  amharic: 'እባክዎ ስም ያስገቡ',
  arabic: 'يرجى إدخال الاسم',
  bengali: 'অনুগ্রহ করে নাম লিখুন',
  chinese: '请输入姓名',
  english: 'Please enter name',
  estonian: 'Palun sisestage nimi',
  filipino: 'Mangyaring maglagay ng pangalan',
  french: 'Veuillez saisir le nom',
  german: 'Bitte geben Sie einen Namen ein',
  hindi: 'कृपया नाम दर्ज करें',
  indonesian: 'Silakan masukkan nama',
  japanese: '名前を入力してください',
  korean: '이름을 입력하세요',
  portuguese: 'Por favor insira o nome',
  russian: 'Пожалуйста, введите имя',
  spanish: 'Por favor ingrese el nombre',
  swahili: 'Tafadhali weka jina',
  vietnamese: 'Vui lòng nhập tên',
};
export const enterEmail: Translation = {
  amharic: 'እባክዎ ኢሜይል ያስገቡ',
  arabic: 'يرجى إدخال البريد الإلكتروني',
  bengali: 'অনুগ্রহ করে ইমেল লিখুন',
  chinese: '请输入电子邮件',
  english: 'Please enter email',
  estonian: 'Palun sisestage e-posti aadress',
  filipino: 'Mangyaring maglagay ng email',
  french: 'Veuillez entrer un email',
  german: 'Bitte geben Sie eine E-Mail-Adresse ein',
  hindi: 'कृपया ईमेल दर्ज करें',
  indonesian: 'Silakan masukkan email',
  japanese: 'メールアドレスを入力してください',
  korean: '이메일을 입력하세요',
  portuguese: 'Por favor insira o e-mail',
  russian: 'Пожалуйста, введите адрес электронной почты',
  spanish: 'Por favor ingrese el correo electrónico',
  swahili: 'Tafadhali weka barua pepe',
  vietnamese: 'Vui lòng nhập email',
};
export const enterRole: Translation = {
  amharic: 'እባክዎ ሚና ያስገቡ',
  arabic: 'يرجى إدخال الدور',
  bengali: 'অনুগ্রহ করে ভূমিকা লিখুন',
  chinese: '请输入角色',
  english: 'Please enter role',
  estonian: 'Palun sisestage roll',
  filipino: 'Mangyaring maglagay ng role',
  french: 'Veuillez entrer un rôle',
  german: 'Bitte geben Sie eine Rolle ein',
  hindi: 'कृपया भूमिका दर्ज करें',
  indonesian: 'Silakan masukkan peran',
  japanese: '役割を入力してください',
  korean: '역할을 입력하세요',
  portuguese: 'Por favor insira a função',
  russian: 'Пожалуйста, введите роль',
  spanish: 'Por favor ingrese el rol',
  swahili: 'Tafadhali weka jukumu',
  vietnamese: 'Vui lòng nhập vai trò',
};
export const enterFirstName: Translation = {
  amharic: 'እባክዎ የመጀመሪያ ስም ያስገቡ',
  arabic: 'يرجى إدخال الاسم الأول',
  bengali: 'অনুগ্রহ করে প্রথম নাম লিখুন',
  chinese: '请输入名字',
  english: 'Please enter first name',
  estonian: 'Palun sisestage eesnimi',
  filipino: 'Mangyaring maglagay ng pangalan',
  french: 'Veuillez saisir le prénom',
  german: 'Bitte geben Sie einen Vornamen ein',
  hindi: 'कृपया पहला नाम दर्ज करें',
  indonesian: 'Silakan masukkan nama depan',
  japanese: '名を入力してください',
  korean: '이름을 입력하세요',
  portuguese: 'Por favor insira o nome',
  russian: 'Пожалуйста, введите имя',
  spanish: 'Por favor ingrese el nombre',
  swahili: 'Tafadhali weka jina la kwanza',
  vietnamese: 'Vui lòng nhập tên',
};
export const enterLastName: Translation = {
  amharic: 'እባክዎ የአባት ስም ያስገቡ',
  arabic: 'يرجى إدخال اسم العائلة',
  bengali: 'অনুগ্রহ করে শেষ নাম লিখুন',
  chinese: '请输入姓氏',
  english: 'Please enter last name',
  estonian: 'Palun sisestage perekonnanimi',
  filipino: 'Mangyaring maglagay ng apelyido',
  french: 'Veuillez saisir le nom de famille',
  german: 'Bitte geben Sie einen Nachnamen ein',
  hindi: 'कृपया उपनाम दर्ज करें',
  indonesian: 'Silakan masukkan nama belakang',
  japanese: '姓を入力してください',
  korean: '성을 입력하세요',
  portuguese: 'Por favor insira o sobrenome',
  russian: 'Пожалуйста, введите фамилию',
  spanish: 'Por favor ingrese el apellido',
  swahili: 'Tafadhali weka jina la ukoo',
  vietnamese: 'Vui lòng nhập họ',
};
export const enterValidPassword: Translation = {
  amharic: 'እባክዎ ትክክለኛ የይለፍ ቃል ያስገቡ',
  arabic: 'يرجى إدخال كلمة مرور صالحة',
  bengali: 'অনুগ্রহ করে একটি বৈধ পাসওয়ার্ড লিখুন',
  chinese: '请输入有效密码',
  english: 'Please enter a valid password',
  estonian: 'Palun sisestage korrekt parool',
  filipino: 'Mangyaring maglagay ng wastong password',
  french: `Entrer un mot de passe valide s'il vous plait`,
  german: 'Bitte geben Sie ein gültiges Passwort ein',
  hindi: 'कृपया एक वैध पासवर्ड दर्ज करें',
  indonesian: 'Silakan masukkan kata sandi yang valid',
  japanese: '有効なパスワードを入力してください',
  korean: '유효한 비밀번호를 입력하세요',
  portuguese: 'Por favor insira uma senha válida',
  russian: 'Пожалуйста, введите допустимый пароль',
  spanish: 'Por favor ingrese una contraseña válida',
  swahili: 'Tafadhali weka nenosiri halali',
  vietnamese: 'Vui lòng nhập mật khẩu hợp lệ',
};
export const passwordsDoNotMatch: Translation = {
  amharic: 'የይለፍ ቃሎች አይዛመዱም',
  arabic: 'كلمات المرور لا تتطابق',
  bengali: 'পাসওয়ার্ড মিলছে না',
  chinese: '密码不匹配',
  english: 'Passwords do not match',
  estonian: 'Paroolid ei kattu',
  filipino: 'Hindi tugma ang mga password',
  french: 'Les mots de passe ne correspondent pas',
  german: 'Die Passwörter stimmen nicht überein',
  hindi: 'पासवर्ड मेल नहीं खाते',
  indonesian: 'Kata sandi tidak cocok',
  japanese: 'パスワードが一致しません',
  korean: '비밀번호가 일치하지 않습니다',
  portuguese: 'As senhas não correspondem',
  russian: 'Пароли не совпадают',
  spanish: 'Las contraseñas no coinciden',
  swahili: 'Nenosiri hazilingani',
  vietnamese: 'Mật khẩu không khớp',
};
export const invalidEmail: Translation = {
  amharic: 'ልክ ያልሆነ ኢሜይል',
  arabic: 'بريد إلكتروني غير صالح',
  bengali: 'অবৈধ ইমেল',
  chinese: '无效电子邮件',
  english: 'Invalid email',
  estonian: 'Vigane e-posti aadress',
  filipino: 'Di-wastong email',
  french: 'Email invalide',
  german: 'Ungültige E-Mail-Adresse',
  hindi: 'अवैध ईमेल',
  indonesian: 'Email tidak valid',
  japanese: '無効なメール',
  korean: '유효하지 않은 이메일',
  portuguese: 'E-mail inválido',
  russian: 'Неверный адрес электронной почты',
  spanish: 'Correo electrónico inválido',
  swahili: 'Barua pepe batili',
  vietnamese: 'Email không hợp lệ',
};
export const enterValidChargeSum: Translation = {
  amharic: 'እባክዎ ትክክለኛ የክፍያ ድምር ያስገቡ',
  arabic: 'يرجى إدخال مبلغ رسوم صالح',
  bengali: 'অনুগ্রহ করে বৈধ চার্জ সমষ্টি লিখুন',
  chinese: '请输入有效收费金额',
  english: 'Please enter valid charge sum',
  estonian: 'Palun sisestage korrekt maks',
  filipino: 'Mangyaring maglagay ng wastong halaga ng singil',
  french: `Veuillez saisir une somme de frais valide`,
  german: 'Bitte geben Sie eine gültige Gebühr ein',
  hindi: 'कृपया वैध शुल्क राशि दर्ज करें',
  indonesian: 'Silakan masukkan jumlah biaya yang valid',
  japanese: '有効な料金合計を入力してください',
  korean: '유효한 요금 합계를 입력하세요',
  portuguese: 'Por favor insira uma soma de cobrança válida',
  russian: 'Пожалуйста, введите допустимую сумму комиссии',
  spanish: 'Por favor ingrese una suma de cargo válida',
  swahili: 'Tafadhali weka jumla ya malipo halali',
  vietnamese: 'Vui lòng nhập tổng phí hợp lệ',
};
export const enterValidNumber: Translation = {
  amharic: 'እባክዎ ትክክለኛ ስልክ ቁጥር ያስገቡ',
  arabic: 'يرجى إدخال رقم هاتف صالح',
  bengali: 'অনুগ্রহ করে একটি বৈধ ফোন নম্বর লিখুন',
  chinese: '请输入有效电话号码',
  english: 'Please enter a valid phone number',
  estonian: 'Palun sisestage korrekt telefoninumber',
  filipino: 'Mangyaring maglagay ng wastong numero ng telepono',
  french: `s'il vous plaît entrer un numéro de téléphone valide`,
  german: 'Bitte geben Sie eine gültige Telefonnummer ein',
  hindi: 'कृपया एक वैध फोन नंबर दर्ज करें',
  indonesian: 'Silakan masukkan nomor telepon yang valid',
  japanese: '有効な電話番号を入力してください',
  korean: '유효한 전화번호를 입력하세요',
  portuguese: 'Por favor insira um número de telefone válido',
  russian: 'Пожалуйста, введите допустимый номер телефона',
  spanish: 'Por favor ingrese un número de teléfono válido',
  swahili: 'Tafadhali weka nambari ya simu halali',
  vietnamese: 'Vui lòng nhập số điện thoại hợp lệ',
};
export const chargeSumText: Translation = {
  amharic: 'የክፍያ ድምር',
  arabic: 'مجموع الرسوم',
  bengali: 'চার্জ সমষ্টি',
  chinese: '收费金额',
  english: 'Charge sum',
  estonian: 'Maksumakse summa',
  filipino: 'Kabuuan ng singil',
  french: 'Somme des frais',
  german: 'Gebührssumme',
  hindi: 'शुल्क राशि',
  indonesian: 'Jumlah biaya',
  japanese: '料金合計',
  korean: '요금 합계',
  portuguese: 'Soma de cobrança',
  russian: 'Сумма комиссии',
  spanish: 'Suma de cargo',
  swahili: 'Jumla ya malipo',
  vietnamese: 'Tổng phí',
};
export const deleteUserText: Translation = {
  amharic: 'ተጠቃሚ ሰርዝ',
  arabic: 'حذف المستخدم',
  bengali: 'ব্যবহারকারী মুছুন',
  chinese: '删除用户',
  english: 'Delete User',
  estonian: 'Kustuta kasutaja',
  filipino: 'Tanggalin ang user',
  french: `Supprimer l'utilisateur`,
  german: 'Benutzer löschen',
  hindi: 'उपयोगकर्ता हटाएं',
  indonesian: 'Hapus pengguna',
  japanese: 'ユーザーを削除',
  korean: '사용자 삭제',
  portuguese: 'Excluir usuário',
  russian: 'Удалить пользователя',
  spanish: 'Eliminar usuario',
  swahili: 'Futa mtumiaji',
  vietnamese: 'Xóa người dùng',
};
export const accountDeleted: Translation = {
  amharic: 'መለያ ተሰርዟል',
  arabic: 'تم حذف الحساب',
  bengali: 'অ্যাকাউন্ট মুছে ফেলা হয়েছে',
  chinese: '账户已删除',
  english: 'Account deleted',
  estonian: 'Konto kustutatud',
  filipino: 'Tinanggal ang account',
  french: 'Compte supprimé',
  german: 'Konto gelöscht',
  hindi: 'खाता हटा दिया गया',
  indonesian: 'Akun dihapus',
  japanese: 'アカウント削除済み',
  korean: '계정 삭제됨',
  portuguese: 'Conta excluída',
  russian: 'Аккаунт удален',
  spanish: 'Cuenta eliminada',
  swahili: 'Akaunti imefutwa',
  vietnamese: 'Đã xóa tài khoản',
};
export const accountReactivated: Translation = {
  amharic: 'መለያ እንደገና ነቅቷል',
  arabic: 'تم إعادة تنشيط الحساب',
  bengali: 'অ্যাকাউন্ট পুনরায় সক্রিয় করা হয়েছে',
  chinese: '账户已重新激活',
  english: 'Account reactivated',
  estonian: 'Konto reaktiveeritud',
  filipino: 'Muling na-activate ang account',
  french: 'Compte réactivé',
  german: 'Konto reaktiviert',
  hindi: 'खाता पुनः सक्रिय किया गया',
  indonesian: 'Akun diaktifkan kembali',
  japanese: 'アカウント再有効化済み',
  korean: '계정 재활성화됨',
  portuguese: 'Conta reativada',
  russian: 'Аккаунт активирован',
  spanish: 'Cuenta reactivada',
  swahili: 'Akaunti imewezesha tena',
  vietnamese: 'Đã kích hoạt lại tài khoản',
};
export const changePicture: Translation = {
  amharic: 'ምስል ቀይር',
  arabic: 'تغيير الصورة',
  bengali: 'ছবি পরিবর্তন করুন',
  chinese: '更改图片',
  english: 'Change Picture',
  estonian: 'Pilt muuta',
  filipino: 'Baguhin ang larawan',
  french: 'Changer la photo',
  german: 'Bild ändern',
  hindi: 'चित्र बदलें',
  indonesian: 'Ubah gambar',
  japanese: '画像を変更',
  korean: '사진 변경',
  portuguese: 'Alterar imagem',
  russian: 'Изменить фото',
  spanish: 'Cambiar imagen',
  swahili: 'Badilisha picha',
  vietnamese: 'Thay đổi hình ảnh',
};
export const loggedOut: Translation = {
  amharic: 'ውጥተዋል!',
  arabic: 'تم تسجيل الخروج!',
  bengali: 'লগ আউট হয়েছে!',
  chinese: '已登出！',
  english: 'Logged out!',
  estonian: 'Logitud välja!',
  filipino: 'Naka-logout!',
  french: 'Déconnecté!',
  german: 'Ausgeloggt!',
  hindi: 'लॉग आउट हो गया!',
  indonesian: 'Keluar!',
  japanese: 'ログアウトしました！',
  korean: '로그아웃됨!',
  portuguese: 'Sessão encerrada!',
  russian: 'Вы вышли!',
  spanish: '¡Sesión cerrada!',
  swahili: 'Umetoka!',
  vietnamese: 'Đã đăng xuất!',
};
export const details: Translation = {
  amharic: 'ዝርዝሮች',
  arabic: 'التفاصيل',
  bengali: 'বিস্তারিত',
  chinese: '详细信息',
  english: 'Details',
  estonian: 'Üksikasjad',
  filipino: 'Mga detalye',
  french: 'Détails',
  german: 'Details',
  hindi: 'विवरण',
  indonesian: 'Rincian',
  japanese: '詳細',
  korean: '세부정보',
  portuguese: 'Detalhes',
  russian: 'Детали',
  spanish: 'Detalles',
  swahili: 'Maelezo',
  vietnamese: 'Chi tiết',
};
export const passwordResetHelper: Translation = {
  amharic: 'የተጠቃሚው የይለፍ ቃል ወደ ነባሪ ይመለሳል',
  arabic: 'ستتم إعادة تعيين كلمة مرور المستخدم إلى الافتراضية',
  bengali: 'ব্যবহারকারীর পাসওয়ার্ড ডিফল্টে রিসেট হবে',
  chinese: '用户密码将重置为默认值',
  english: 'Password for user will be reset to default',
  estonian: 'Kasutaja parool kustutatakse vaikimisi',
  filipino: 'Ang password ng user ay ire-reset sa default',
  french: `Le mot de passe de l'utilisateur sera réinitialisé par défaut`,
  german: 'Das Passwort für den Benutzer wird auf das Standardpasswort zurückgesetzt',
  hindi: 'उपयोगकर्ता का पासवर्ड डिफ़ॉल्ट पर रीसेट हो जाएगा',
  indonesian: 'Kata sandi pengguna akan direset ke default',
  japanese: 'ユーザーのパスワードがデフォルトにリセットされます',
  korean: '사용자 비밀번호가 기본값으로 재설정됩니다',
  portuguese: 'A senha do usuário será redefinida para o padrão',
  russian: 'Пароль для пользователя будет сброшен на стандартный',
  spanish: 'La contraseña del usuario se restablecerá a la predeterminada',
  swahili: 'Nenosiri la mtumiaji litarejeshwa kwa chaguo-msingi',
  vietnamese: 'Mật khẩu cho người dùng sẽ được đặt lại về mặc định',
};
export const emailHelper: Translation = {
  amharic: 'የአሁኑን የመግቢያ ኢሜይልዎን ያስገቡ',
  arabic: 'أدخل بريدك الإلكتروني الحالي لتسجيل الدخول',
  bengali: 'আপনার বর্তমান সাইন-ইন ইমেল লিখুন',
  chinese: '输入您当前的登录电子邮件',
  english: 'Enter your current sign-in email',
  estonian: 'Sisestage oma praegune sisselogimis-e-posti aadress',
  filipino: 'Ilagay ang iyong kasalukuyang sign-in email',
  french: 'Saisissez votre adresse e-mail de connexion actuelle',
  german: 'Geben Sie Ihre aktuelle Anmelde-E-Mail-Adresse ein',
  hindi: 'अपना वर्तमान साइन-इन ईमेल दर्ज करें',
  indonesian: 'Masukkan email login Anda saat ini',
  japanese: '現在のサインインメールアドレスを入力してください',
  korean: '현재 로그인 이메일을 입력하세요',
  portuguese: 'Insira seu e-mail de login atual',
  russian: 'Введите ваш текущий адрес электронной почты для входа',
  spanish: 'Ingrese su correo electrónico de inicio de sesión actual',
  swahili: 'Weka barua pepe yako ya sasa ya kuingia',
  vietnamese: 'Nhập email đăng nhập hiện tại của bạn',
};
export const confirmEmail: Translation = {
  amharic: 'ኢሜይል አረጋግጥ',
  arabic: 'تأكيد البريد الإلكتروني',
  bengali: 'ইমেল নিশ্চিত করুন',
  chinese: '确认电子邮件',
  english: 'Confirm Email',
  estonian: 'Kinnitage oma e-posti aadress',
  filipino: 'Kumpirmahin ang email',
  french: 'Confirmez votre email',
  german: 'Bestätigen Sie Ihre E-Mail-Adresse',
  hindi: 'ईमेल की पुष्टि करें',
  indonesian: 'Konfirmasi email',
  japanese: 'メールアドレスを確認',
  korean: '이메일 확인',
  portuguese: 'Confirmar e-mail',
  russian: 'Подтвердите адрес электронной почты',
  spanish: 'Confirmar correo electrónico',
  swahili: 'Thibitisha barua pepe',
  vietnamese: 'Xác nhận email',
};
export const newEmail: Translation = {
  amharic: 'አዲስ ኢሜይል',
  arabic: 'بريد إلكتروني جديد',
  bengali: 'নতুন ইমেল',
  chinese: '新电子邮件',
  english: 'New Email',
  estonian: 'Uus e-posti aadress',
  filipino: 'Bagong email',
  french: 'Nouveau courriel',
  german: 'Neue E-Mail-Adresse',
  hindi: 'नया ईमेल',
  indonesian: 'Email baru',
  japanese: '新しいメールアドレス',
  korean: '새 이메일',
  portuguese: 'Novo e-mail',
  russian: 'Новый адрес электронной почты',
  spanish: 'Nuevo correo electrónico',
  swahili: 'Barua pepe mpya',
  vietnamese: 'Email mới',
};
export const deleteAccountHint: Translation = {
  amharic: 'መለያው ለ30 ቀናት ይተኛል። በዚያ ጊዜ ውስጥ በእጅ ከልክ ካልነቃ መለያው በራስ-ሰር ለዘለአለም ይሰረዛል። ተጠቃሚው በእንቅልፍ ወቅት ስርዓቱን ማግኘት አይችልም።',
  arabic: 'سيتم إسبات الحساب لمدة 30 يومًا. إذا لم يتم إعادة تنشيطه يدويًا خلال ذلك الوقت، فسيتم حذف الحساب تلقائيًا بشكل دائم. لن يتمكن المستخدم من الوصول إلى النظام خلال فترة الإسبات.',
  bengali: 'অ্যাকাউন্ট 30 দিনের জন্য হাইবারনেট করা হবে। যদি সেই সময়ের মধ্যে ম্যানুয়ালি পুনরায় সক্রিয় না করা হয়, তাহলে অ্যাকাউন্ট স্বয়ংক্রিয়ভাবে স্থায়ীভাবে মুছে ফেলা হবে। হাইবারনেশন সময়কালে ব্যবহারকারীর সিস্টেমে অ্যাক্সেস থাকবে না।',
  chinese: '账户将休眠30天。如果在该时间内未手动重新激活，账户将自动永久删除。用户在休眠期间将无法访问系统。',
  english: 'Account will be hibernated for 30 days. If not manually reactivated within that time, account will be automatically permanently deleted. User will not have access to system during hibernation period.',
  estonian: 'Konto jääb 30 päeva möödumiseni. Kui see ei ole käsitsi reaktiveeritud, kustutatakse konto automaatselt püsivalt. Kasutaja ei saa süsteemi kasutada möödumise ajal.',
  filipino: 'Ang account ay ihi-hibernate sa loob ng 30 araw. Kung hindi mano-manong muling i-activate sa loob ng panahong iyon, ang account ay awtomatikong permanenteng tatanggalin. Ang user ay hindi makaka-access sa system sa panahon ng hibernation.',
  french: `Le compte sera mis en veille pendant 30 jours. S'il n'est pas réactivé manuellement dans ce délai, le compte sera automatiquement supprimé définitivement. L'utilisateur n'aura pas accès au système pendant la période d'hibernation.`,
  german: 'Das Konto wird 30 Tage lang inaktiv gespeichert. Wenn es nicht manuell reaktiviert wird, wird das Konto automatisch dauerhaft gelöscht. Der Benutzer hat während der Inaktivierungsphase keinen Zugriff auf das System.',
  hindi: 'खाता 30 दिनों के लिए हाइबरनेट किया जाएगा। यदि उस समय के भीतर मैन्युअल रूप से पुनः सक्रिय नहीं किया जाता है, तो खाता स्वचालित रूप से स्थायी रूप से हटा दिया जाएगा। हाइबरनेशन अवधि के दौरान उपयोगकर्ता के पास सिस्टम तक पहुंच नहीं होगी।',
  indonesian: 'Akun akan dihibernasi selama 30 hari. Jika tidak diaktifkan kembali secara manual dalam waktu tersebut, akun akan dihapus secara permanen secara otomatis. Pengguna tidak akan memiliki akses ke sistem selama periode hibernasi.',
  japanese: 'アカウントは30日間休止状態になります。その間に手動で再アクティブ化されない場合、アカウントは自動的に完全に削除されます。ユーザーは休止期間中にシステムにアクセスできません。',
  korean: '계정이 30일 동안 휴면 상태가 됩니다. 해당 기간 내에 수동으로 재활성화하지 않으면 계정이 자동으로 영구 삭제됩니다. 사용자는 휴면 기간 동안 시스템에 액세스할 수 없습니다.',
  portuguese: 'A conta será hibernada por 30 dias. Se não for reativada manualmente dentro desse prazo, a conta será automaticamente excluída permanentemente. O usuário não terá acesso ao sistema durante o período de hibernação.',
  russian: 'Аккаунт будет заморожен на 30 дней. Если не будет ручную активирован в течение этого времени, аккаунт будет автоматически удален навсегда. Пользователь не будет иметь доступ к системе в период заморозки.',
  spanish: 'La cuenta se hibernará durante 30 días. Si no se reactiva manualmente dentro de ese tiempo, la cuenta se eliminará automáticamente de forma permanente. El usuario no tendrá acceso al sistema durante el período de hibernación.',
  swahili: 'Akaunti italala kwa siku 30. Ikiwa haita​wezeshwa tena kwa mikono ndani ya muda huo, akaunti itafutwa kiotomatiki kabisa. Mtumiaji hatapata ufikiaji wa mfumo wakati wa kipindi cha kulala.',
  vietnamese: 'Tài khoản sẽ được ngủ đông trong 30 ngày. Nếu không được kích hoạt lại thủ công trong thời gian đó, tài khoản sẽ tự động bị xóa vĩnh viễn. Người dùng sẽ không có quyền truy cập vào hệ thống trong thời gian ngủ đông.',
};
export const markedForDeletionHint: Translation = {
  amharic: 'ይህ ተጠቃሚ ለመሰረዝ ምልክት ተደርጎበታል። የእነሱን ንቁ ሁኔታ ለማዘመን፣ መጀመሪያ ለመሰረዝ ምልክት መወገድ አለበት (እንደገና ማንቃት)። ተጠቃሚን እንደገና ለማንቃት እገዛ ለማግኘት ድጋፍን ወይም ሱፐር ተጠቃሚዎችን ያነጋግሩ።',
  arabic: 'تم وضع علامة على هذا المستخدم للحذف. لتحديث حالته النشطة، يجب أولاً إلغاء وضع علامة عليه للحذف (إعادة التنشيط). للحصول على المساعدة في إعادة تنشيط المستخدم، اتصل بالدعم أو المستخدمين الفائقين.',
  bengali: 'এই ব্যবহারকারীকে মুছে ফেলার জন্য চিহ্নিত করা হয়েছে। তাদের সক্রিয় অবস্থা আপডেট করতে, তাদের প্রথমে মুছে ফেলার জন্য চিহ্ন মুক্ত করতে হবে (পুনরায় সক্রিয়)। ব্যবহারকারী পুনরায় সক্রিয় করার জন্য সাহায্যের জন্য, সহায়তা বা সুপার ব্যবহারকারীদের সাথে যোগাযোগ করুন।',
  chinese: '此用户已被标记为删除。要更新其活动状态，必须首先取消标记为删除（重新激活）。如需重新激活用户的帮助，请联系支持人员或超级用户。',
  english: 'This user has been marked for deletion. To update their active state, they must first be unmarked for deletion (reactivated). For help reactivating user, contact support or superusers.',
  estonian: 'Kasutaja on märgitud kustutamiseks. Selleks, et aktualiseerida nende aktiivse oleku, peavad nad esmalt olema märgitud kustutamiseks (reaktiveeritud). Kasutaja reaktiveerimiseks võta ühendust abi- või ülemüüriga.',
  filipino: 'Ang user na ito ay minarkahan para sa pagtanggal. Upang i-update ang kanilang aktibong estado, dapat muna silang alisin ang marka para sa pagtanggal (muling i-activate). Para sa tulong sa muling pag-activate ng user, makipag-ugnayan sa suporta o mga superuser.',
  french: `Cet utilisateur a été marqué pour suppression. Pour mettre à jour leur état actif, ils doivent d'abord être démarqués pour suppression (réactivés). Pour obtenir de l'aide pour réactiver l'utilisateur, contactez le support ou les superutilisateurs.`,
  german: 'Dieser Benutzer wurde für die Löschung markiert. Um ihren aktiven Status zu aktualisieren, müssen sie zuerst für die Löschung markiert werden (reaktiviert). Für Hilfe beim Reaktivieren des Benutzers wenden Sie sich an den Support oder an Superbenutzer.',
  hindi: 'इस उपयोगकर्ता को हटाने के लिए चिह्नित किया गया है। उनकी सक्रिय स्थिति को अपडेट करने के लिए, उन्हें पहले हटाने के लिए अचिह्नित किया जाना चाहिए (पुनः सक्रिय)। उपयोगकर्ता को पुनः सक्रिय करने में सहायता के लिए, समर्थन या सुपरयूजर्स से संपर्क करें।',
  indonesian: 'Pengguna ini telah ditandai untuk dihapus. Untuk memperbarui status aktif mereka, mereka harus terlebih dahulu dihapus tandanya untuk penghapusan (diaktifkan kembali). Untuk bantuan mengaktifkan kembali pengguna, hubungi dukungan atau superuser.',
  japanese: 'このユーザーは削除対象としてマークされています。アクティブ状態を更新するには、まず削除のマークを解除する必要があります（再アクティブ化）。ユーザーの再アクティブ化のサポートが必要な場合は、サポートまたはスーパーユーザーにお問い合わせください。',
  korean: '이 사용자는 삭제로 표시되었습니다. 활성 상태를 업데이트하려면 먼저 삭제 표시를 해제해야 합니다(재활성화). 사용자 재활성화에 대한 도움이 필요하면 지원팀 또는 슈퍼유저에게 문의하십시오.',
  portuguese: 'Este usuário foi marcado para exclusão. Para atualizar seu estado ativo, eles devem primeiro ser desmarcados para exclusão (reativados). Para obter ajuda para reativar o usuário, entre em contato com o suporte ou superusuários.',
  russian: 'Этот пользователь помечен для удаления. Чтобы обновить их активное состояние, они должны сначала быть отмечены для удаления (реактивированы). Для получения помощи по реактивации пользователя обратитесь в службу поддержки или суперпользователей.',
  spanish: 'Este usuario ha sido marcado para eliminación. Para actualizar su estado activo, primero deben ser desmarcados para eliminación (reactivados). Para obtener ayuda para reactivar al usuario, contacte con el soporte o superusuarios.',
  swahili: 'Mtumiaji huyu amewekwa alama kwa kufutwa. Ili kusasisha hali yao hai, lazima kwanza waondolewe alama kwa kufutwa (kuwezeshwa tena). Kwa msaada wa kuwaamsha mtumiaji, wasiliana na msaada au watumiaji bora.',
  vietnamese: 'Người dùng này đã được đánh dấu để xóa. Để cập nhật trạng thái hoạt động của họ, trước tiên họ phải được bỏ đánh dấu để xóa (kích hoạt lại). Để được trợ giúp kích hoạt lại người dùng, hãy liên hệ với bộ phận hỗ trợ hoặc siêu người dùng.',
};

export const accountOwnerName: Translation = {
  amharic: 'የመለያ ባለቤት',
  arabic: 'صاحب الحساب',
  bengali: 'অ্যাকাউন্ট মালিক',
  chinese: '账户所有者',
  english: `Account owner`,
  estonian: 'Konto omanik',
  filipino: 'May-ari ng account',
  french: 'Propriétaire du compte',
  german: 'Kontoinhaber',
  hindi: 'खाता स्वामी',
  indonesian: 'Pemilik akun',
  japanese: 'アカウント所有者',
  korean: '계정 소유자',
  portuguese: 'Proprietário da conta',
  russian: 'Владелец счета',
  spanish: 'Propietario de la cuenta',
  swahili: 'Mmiliki wa akaunti',
  vietnamese: 'Chủ tài khoản',
};
export const accountNumber: Translation = {
  amharic: 'የመለያ ቁጥር',
  arabic: 'رقم الحساب',
  bengali: 'অ্যাকাউন্ট নম্বর',
  chinese: '账号',
  english: `Account number`,
  estonian: 'Konto number',
  filipino: 'Numero ng account',
  french: 'Numéro de compte',
  german: 'Kontonummer',
  hindi: 'खाता संख्या',
  indonesian: 'Nomor akun',
  japanese: 'アカウント番号',
  korean: '계정 번호',
  portuguese: 'Número da conta',
  russian: 'Номер счета',
  spanish: 'Número de cuenta',
  swahili: 'Nambari ya akaunti',
  vietnamese: 'Số tài khoản',
};

export const heading: Translation = {
  amharic: 'ሙሉ የ fullstack ገንቢ መመሪያ',
  arabic: 'الدليل الكامل لمطور fullstack',
  bengali: 'সম্পূর্ণ ফুলস্ট্যাক ডেভেলপার গাইড',
  chinese: '完整的全栈开发者指南',
  english: 'The complete fullstack developer guide',
  estonian: 'Täielik täiskomplekti arendaja juhend',
  filipino: 'Ang kumpletong gabay sa fullstack developer',
  french: 'Le guide complet du développeur fullstack',
  german: 'Das vollständige Leitfaden für Fullstack-Entwickler',
  hindi: 'पूर्ण फुलस्टैक डेवलपर गाइड',
  indonesian: 'Panduan lengkap pengembang fullstack',
  japanese: '完全なフルスタック開発者ガイド',
  korean: '완전한 풀스택 개발자 가이드',
  portuguese: 'O guia completo do desenvolvedor fullstack',
  russian: 'Полное руководство для разработчиков полного стека',
  spanish: 'La guía completa para desarrolladores fullstack',
  swahili: 'Mwongozo kamili wa msanidi programu wa fullstack',
  vietnamese: 'Hướng dẫn đầy đủ về nhà phát triển fullstack',
};
export const overview: Translation = {
  amharic: 'የኢንዱስትሪ ባለሙያዎች እገዛ እና ድጋፍ በመጠቀም፣ የቅርብ ቴክኖሎጂ እና መሳሪያዎችን በመጠቀም ሙሉ የfull-stack መተግበሪያዎችን እንዴት እንደሚገነቡ ይማሩ!',
  arabic: 'تعلم كيفية بناء تطبيقات كاملة full-stack، باستخدام أحدث التقنيات والأدوات، بمساعدة ودعم من خبراء الصناعة!',
  bengali: 'শিল্প বিশেষজ্ঞদের সাহায্য এবং সহায়তা সহ, সর্বশেষ প্রযুক্তি এবং সরঞ্জামগুলি ব্যবহার করে সম্পূর্ণ ফুল-স্ট্যাক অ্যাপ্লিকেশন তৈরি করতে শিখুন!',
  chinese: '学习如何构建完整的全栈应用程序，利用最新的技术和工具，并获得行业专家的帮助和支持！',
  english: 'Learn how to build complete full-stack applications, leveraging the latest tech and tools, with help and support from industry experts!',
  estonian: 'Õppige valdkonnaekspertide abiga ja toel uusimaid tehnoloogiaid ja tööriistu kasutades koostama terviklikke täisviru rakendusi!',
  filipino: 'Matuto kung paano bumuo ng kumpletong full-stack na mga application, na ginagamit ang pinakabagong tech at tools, na may tulong at suporta mula sa mga eksperto sa industriya!',
  french: `Apprenez à créer des applications complètes complètes, en tirant parti des technologies et des outils les plus récents, avec l'aide et le soutien d'experts du secteur!`,
  german: 'Erhalten Sie umfassende Anleitungen für Fullstack-Entwickler, die auf den neuesten Technologien und Tools basieren, mit Unterstützung und Hilfe von Experten aus der Branche!',
  hindi: 'उद्योग विशेषज्ञों की मदद और समर्थन के साथ, नवीनतम तकनीक और उपकरणों का लाभ उठाते हुए, पूर्ण full-stack एप्लिकेशन बनाना सीखें!',
  indonesian: 'Pelajari cara membangun aplikasi full-stack lengkap, memanfaatkan teknologi dan alat terbaru, dengan bantuan dan dukungan dari para ahli industri!',
  japanese: '業界の専門家からのヘルプとサポートを受けて、最新の技術とツールを活用して完全なフルスタックアプリケーションを構築する方法を学びましょう！',
  korean: '업계 전문가의 도움과 지원을 받아 최신 기술과 도구를 활용하여 완전한 풀스택 애플리케이션을 구축하는 방법을 배우십시오!',
  portuguese: 'Aprenda a construir aplicações full-stack completas, aproveitando as mais recentes tecnologias e ferramentas, com ajuda e suporte de especialistas da indústria!',
  russian: 'Узнайте, как создавать полные приложения с полным стеком, используя новейшие технологии и инструменты, с помощью и поддержкой отраслевых экспертов!',
  spanish: '¡Aprenda a construir aplicaciones full-stack completas, aprovechando la última tecnología y herramientas, con ayuda y soporte de expertos de la industria!',
  swahili: 'Jifunze jinsi ya kujenga programu kamili za full-stack, ukitumia teknolojia na zana za hivi karibuni, kwa msaada na msaada kutoka kwa wataalamu wa tasnia!',
  vietnamese: 'Tìm hiểu cách xây dựng các ứng dụng full-stack hoàn chỉnh, tận dụng công nghệ và công cụ mới nhất, với sự giúp đỡ và hỗ trợ từ các chuyên gia ngành!',
};

export const getTheApp: Translation = {
  amharic: 'መተግበሪያውን ያግኙ',
  arabic: 'احصل على التطبيق',
  bengali: 'অ্যাপ পান',
  chinese: '获取应用',
  english: 'Get the App',
  estonian: 'Hankige rakendus',
  filipino: 'Kunin ang app',
  french: `Obtenir l'application`,
  german: 'Hol dir die App',
  hindi: 'ऐप प्राप्त करें',
  indonesian: 'Dapatkan aplikasi',
  japanese: 'アプリを入手',
  korean: '앱 받기',
  portuguese: 'Obter o aplicativo',
  russian: 'Получить приложение',
  spanish: 'Obtener la aplicación',
  swahili: 'Pata programu',
  vietnamese: 'Tải ứng dụng',
};
export const learnMore: Translation = {
  amharic: 'ተጨማሪ ይወቁ',
  arabic: 'تعلم المزيد',
  bengali: 'আরো জানুন',
  chinese: '了解更多',
  english: 'Learn More',
  estonian: 'Lisateave',
  filipino: 'Matuto pa',
  french: 'Apprendre encore plus',
  german: 'Lern mehr',
  hindi: 'और जानें',
  indonesian: 'Pelajari lebih lanjut',
  japanese: '詳細を見る',
  korean: '더 알아보기',
  portuguese: 'Saiba mais',
  russian: 'Учить больше',
  spanish: 'Aprende más',
  swahili: 'Jifunze zaidi',
  vietnamese: 'Tìm hiểu thêm',
};

export const getStarted: Translation = {
  amharic: 'ጀምር',
  arabic: 'ابدأ',
  bengali: 'শুরু করুন',
  chinese: '开始',
  english: `Get Started`,
  estonian: `Alustama`,
  filipino: 'Magsimula',
  french: `Commencer`,
  german: `Loslegen`,
  hindi: 'शुरू करें',
  indonesian: 'Mulai',
  japanese: '始める',
  korean: '시작하기',
  portuguese: 'Começar',
  russian: `Начать`,
  spanish: 'Empezar',
  swahili: 'Anza',
  vietnamese: 'Bắt đầu',
};

export const loginText: Translation = {
  amharic: 'ግባ',
  arabic: 'تسجيل الدخول',
  bengali: 'লগইন',
  chinese: '登录',
  english: `Login`,
  estonian: `Logi sisse`,
  filipino: 'Mag-login',
  french: `Connexion`,
  german: `Anmeldung`,
  hindi: 'लॉगिन',
  indonesian: 'Masuk',
  japanese: 'ログイン',
  korean: '로그인',
  portuguese: 'Entrar',
  russian: `Авторизоваться`,
  spanish: 'Acceso',
  swahili: 'Ingia',
  vietnamese: 'Đăng nhập',
};

export const withEmailAndPassword: Translation = {
  amharic: 'በኢሜይል እና የይለፍ ቃል',
  arabic: 'بالبريد الإلكتروني وكلمة المرور',
  bengali: 'ইমেল এবং পাসওয়ার্ড দিয়ে',
  chinese: '使用电子邮件和密码',
  english: 'with email and password',
  estonian: 'meili ja parooliga',
  filipino: 'sa email at password',
  french: `avec email et mot de passe`,
  german: 'mit E-Mail und Passwort',
  hindi: 'ईमेल और पासवर्ड के साथ',
  indonesian: 'dengan email dan kata sandi',
  japanese: 'メールアドレスとパスワードで',
  korean: '이메일과 비밀번호로',
  portuguese: 'com e-mail e senha',
  russian: 'с электронной почтой и паролем',
  spanish: 'con correo electrónico y contraseña',
  swahili: 'kwa barua pepe na nenosiri',
  vietnamese: 'với email và mật khẩu',
};
export const forgotPassword: Translation = {
  amharic: 'የይለፍ ቃል ረሳሁ',
  arabic: 'نسيت كلمة المرور',
  bengali: 'পাসওয়ার্ড ভুলে গেছেন',
  chinese: '忘记密码',
  english: 'Forgot password',
  estonian: 'Unustasid parooli',
  filipino: 'Nakalimutan ang password',
  french: 'Mot de passe oublié',
  german: 'Passwort vergessen',
  hindi: 'पासवर्ड भूल गए',
  indonesian: 'Lupa kata sandi',
  japanese: 'パスワードを忘れた',
  korean: '비밀번호를 잊으셨나요',
  portuguese: 'Esqueci minha senha',
  russian: 'Забыли пароль',
  spanish: 'Olvidé mi contraseña',
  swahili: 'Umesahau nenosiri',
  vietnamese: 'Quên mật khẩu',
};
export const referTitleText: Translation = {
  amharic: 'Bomdisoftን ይምከሩ እና £100 ያግኙ',
  arabic: 'أوصِ ببومديسوفت واكسب 100 جنيه إسترليني',
  bengali: 'Bomdisoft রেফার করুন এবং £100 উপার্জন করুন',
  chinese: '推荐Bomdisoft并赚取100英镑',
  english: 'Refer Bomdisoft and earn £100',
  estonian: 'Viidake Bomdisoft-ile ja teenige 100 naela',
  filipino: 'Irekomenda ang Bomdisoft at kumita ng £100',
  french: 'Parrainez Bomdisoft et gagnez 100 £',
  german: 'Verweisen Sie auf Bomdisoft und erhalten Sie 100 £',
  hindi: 'Bomdisoft को रेफर करें और £100 कमाएं',
  indonesian: 'Rujuk Bomdisoft dan dapatkan £100',
  japanese: 'Bomdisoftを紹介して£100を獲得',
  korean: 'Bomdisoft를 추천하고 £100를 받으세요',
  portuguese: 'Indique Bomdisoft e ganhe £100',
  russian: 'Пригласите Bomdisoft и заработайте 100 фунтов стерлингов',
  spanish: 'Refiere Bomdisoft y gana £100',
  swahili: 'Elekeza Bomdisoft na upate £100',
  vietnamese: 'Giới thiệu Bomdisoft và kiếm £100',
};
export const referDescriptionText: Translation = {
  amharic: 'Bomdisoftን እወዳለሁ? ወዳጅ ይምከሩ እና ለእያንዳንዱ አዲስ ምዝገባ የ£100 ስጦታ ካርድ ያግኙ።',
  arabic: 'تحب بومديسوفت؟ أوصِ بصديق واحصل على بطاقة هدايا بقيمة 100 جنيه إسترليني لكل اشتراك جديد.',
  bengali: 'Bomdisoft পছন্দ করছেন? একজন বন্ধুকে রেফার করুন এবং প্রতিটি নতুন সাবস্ক্রিপশনের জন্য £100 উপহার কার্ড পান।',
  chinese: '喜欢Bomdisoft吗？推荐朋友，每次新订阅可获得100英镑礼品卡。',
  english: 'Loving Bomdisoft? Refer a friend and get a £100 gift card for each new subscription.',
  estonian: 'Kas teile meeldib Bomdisoft? Soovitage sõber ja saate iga uue tellimuse eest 100-naelase kinkekaardi.',
  filipino: 'Gustong-gusto ang Bomdisoft? Mag-refer ng kaibigan at makatanggap ng £100 gift card para sa bawat bagong subscription.',
  french: 'Vous aimez Bomdisoft ? Parrainez un ami et recevez une carte-cadeau de 100 £ pour chaque nouvel abonnement.',
  german: 'Lieben Sie Bomdisoft? Verweisen Sie einen Freund und erhalten Sie eine 100 £-Geschenkkarte für jeden neuen Vertrag.',
  hindi: 'Bomdisoft को पसंद कर रहे हैं? एक दोस्त को रेफर करें और प्रत्येक नई सदस्यता के लिए £100 का उपहार कार्ड प्राप्त करें।',
  indonesian: 'Menyukai Bomdisoft? Rujuk teman dan dapatkan kartu hadiah £100 untuk setiap langganan baru.',
  japanese: 'Bomdisoftが好きですか？友達を紹介して、新規サブスクリプションごとに£100のギフトカードを獲得しましょう。',
  korean: 'Bomdisoft를 좋아하시나요? 친구를 추천하고 새 구독마다 £100 기프트 카드를 받으세요.',
  portuguese: 'Amando Bomdisoft? Indique um amigo e ganhe um cartão presente de £100 para cada nova assinatura.',
  russian: 'Любите Bomdisoft? Пригласите друга и получите подарочную карту на 100 фунтов стерлингов за каждую новую подписку.',
  spanish: '¿Te encanta Bomdisoft? Refiere a un amigo y obtén una tarjeta de regalo de £100 por cada nueva suscripción.',
  swahili: 'Unapenda Bomdisoft? Elekeza rafiki na upate kadi ya zawadi ya £100 kwa kila usajili mpya.',
  vietnamese: 'Yêu thích Bomdisoft? Giới thiệu bạn bè và nhận thẻ quà tặng £100 cho mỗi đăng ký mới.',
};
export const learnMoreText: Translation = {
  amharic: 'ተጨማሪ ይወቁ',
  arabic: 'تعلم المزيد',
  bengali: 'আরো জানুন',
  chinese: '了解更多',
  english: 'Learn more',
  estonian: 'Lisateave',
  filipino: 'Matuto pa',
  french: 'Apprendre encore plus',
  german: 'Lern mehr',
  hindi: 'और जानें',
  indonesian: 'Pelajari lebih lanjut',
  japanese: '詳細を見る',
  korean: '더 알아보기',
  portuguese: 'Saiba mais',
  russian: 'Узнать больше',
  spanish: 'Más información',
  swahili: 'Jifunze zaidi',
  vietnamese: 'Tìm hiểu thêm',
};
export const versionText: Translation = {
  amharic: 'ስሪት',
  arabic: 'إصدار',
  bengali: 'সংস্করণ',
  chinese: '版本',
  english: 'version',
  estonian: 'versioon',
  filipino: 'bersyon',
  french: 'version',
  german: 'version',
  hindi: 'संस्करण',
  indonesian: 'versi',
  japanese: 'バージョン',
  korean: '버전',
  portuguese: 'versão',
  russian: 'версия',
  spanish: 'versión',
  swahili: 'toleo',
  vietnamese: 'phiên bản',
};
export const resetLinkSent: Translation = {
  amharic: 'የይለፍ ቃል ዳግም ማስጀመሪያ አገናኝ ተልኳል!',
  arabic: 'تم إرسال رابط إعادة تعيين كلمة المرور!',
  bengali: 'পাসওয়ার্ড রিসেট লিঙ্ক পাঠানো হয়েছে!',
  chinese: '密码重置链接已发送！',
  english: 'Password reset link sent!',
  estonian: 'Parooli lähtestamise link saadeti!',
  filipino: 'Naipadala na ang link ng pag-reset ng password!',
  french: `Lien de réinitialisation du mot de passe envoyé!`,
  german: 'Link zum Zurücksetzen des Passworts gesendet!',
  hindi: 'पासवर्ड रीसेट लिंक भेज दिया गया!',
  indonesian: 'Link reset kata sandi terkirim!',
  japanese: 'パスワードリセットリンクが送信されました！',
  korean: '비밀번호 재설정 링크가 전송되었습니다!',
  portuguese: 'Link de redefinição de senha enviado!',
  russian: 'Ссылка на сброс пароля отправлена!',
  spanish: '¡Enlace de restablecimiento de contraseña enviado!',
  swahili: 'Kiungo cha kuweka upya nenosiri kimetumwa!',
  vietnamese: 'Đã gửi liên kết đặt lại mật khẩu!',
};
export const passwordResetInfo: Translation = {
  amharic: 'መለያዎ አሁንም ንቁ ከሆነ የይለፍ ቃል ዳግም ማስጀመሪያ አገናኝ ወደ ኢሜልዎ ይላካል',
  arabic: 'سيتم إرسال رابط إعادة تعيين كلمة المرور إلى بريدك الإلكتروني إذا كان حسابك لا يزال نشطًا',
  bengali: 'আপনার অ্যাকাউন্ট এখনও সক্রিয় থাকলে আপনার ইমেলে একটি পাসওয়ার্ড রিসেট লিঙ্ক পাঠানো হবে',
  chinese: '如果您的账户仍处于活动状态，密码重置链接将发送到您的电子邮件',
  english: 'A password reset link will be sent to your email if your account is still active',
  estonian: 'Kui teie konto on endiselt aktiivne, saadetakse teie meilile parooli lähtestamise link',
  filipino: 'Ang isang link ng pag-reset ng password ay ipapadala sa iyong email kung ang iyong account ay aktibo pa rin',
  french: `Un lien de réinitialisation du mot de passe vous sera envoyé par e-mail si votre compte est toujours actif`,
  german: 'Ein Link zum Zurücksetzen des Passworts wird an Ihre E-Mail-Adresse gesendet, wenn Ihr Konto noch aktiv ist',
  hindi: 'यदि आपका खाता अभी भी सक्रिय है तो आपके ईमेल पर एक पासवर्ड रीसेट लिंक भेजा जाएगा',
  indonesian: 'Link reset kata sandi akan dikirim ke email Anda jika akun Anda masih aktif',
  japanese: 'アカウントがまだアクティブな場合、パスワードリセットリンクがメールに送信されます',
  korean: '계정이 여전히 활성 상태인 경우 비밀번호 재설정 링크가 이메일로 전송됩니다',
  portuguese: 'Um link de redefinição de senha será enviado para seu e-mail se sua conta ainda estiver ativa',
  russian: 'Если ваш аккаунт все еще активен, на ваш электронный адрес будет отправлен ссылка для сброса пароля',
  spanish: 'Se enviará un enlace de restablecimiento de contraseña a su correo electrónico si su cuenta aún está activa',
  swahili: 'Kiungo cha kuweka upya nenosiri kitatumwa kwa barua pepe yako ikiwa akaunti yako bado ni hai',
  vietnamese: 'Một liên kết đặt lại mật khẩu sẽ được gửi đến email của bạn nếu tài khoản của bạn vẫn còn hoạt động',
};
export const sendResetLink: Translation = {
  amharic: 'አገናኝ ላክ',
  arabic: 'إرسال رابط',
  bengali: 'লিঙ্ক পাঠান',
  chinese: '发送链接',
  english: 'Send link',
  estonian: 'Saada link',
  filipino: 'Ipadala ang link',
  french: `Envoyer un lien`,
  german: 'Link senden',
  hindi: 'लिंक भेजें',
  indonesian: 'Kirim tautan',
  japanese: 'リンクを送信',
  korean: '링크 전송',
  portuguese: 'Enviar link',
  russian: 'Отправить ссылку',
  spanish: 'Enviar enlace',
  swahili: 'Tuma kiungo',
  vietnamese: 'Gửi liên kết',
};
export const emailPlaceholder: Translation = {
  amharic: 'የኢሜይል አድራሻ እዚህ ያስገቡ...',
  arabic: 'أدخل عنوان البريد الإلكتروني هنا...',
  bengali: 'এখানে ইমেল ঠিকানা লিখুন...',
  chinese: '在此输入电子邮件地址...',
  english: 'enter email address here...',
  estonian: 'sisesta siia meiliaadress...',
  filipino: 'ilagay ang email address dito...',
  french: `entrez l'adresse e-mail ici...`,
  german: 'Geben Sie hier Ihre E-Mail-Adresse ein...',
  hindi: 'यहां ईमेल पता दर्ज करें...',
  indonesian: 'masukkan alamat email di sini...',
  japanese: 'ここにメールアドレスを入力してください...',
  korean: '여기에 이메일 주소를 입력하세요...',
  portuguese: 'insira o endereço de e-mail aqui...',
  russian: 'введите адрес электронной почты здесь...',
  spanish: 'ingrese la dirección de correo electrónico aquí...',
  swahili: 'weka anwani ya barua pepe hapa...',
  vietnamese: 'nhập địa chỉ email ở đây...',
};
export const namePlaceholder: Translation = {
  amharic: 'ስም እዚህ ያስገቡ...',
  arabic: 'أدخل الاسم هنا...',
  bengali: 'এখানে নাম লিখুন...',
  chinese: '在此输入姓名...',
  english: 'enter name here...',
  estonian: 'sisesta nimi siia...',
  filipino: 'ilagay ang pangalan dito...',
  french: `entrez le nom ici...`,
  german: 'Geben Sie hier Ihren Namen ein...',
  hindi: 'यहां नाम दर्ज करें...',
  indonesian: 'masukkan nama di sini...',
  japanese: 'ここに名前を入力してください...',
  korean: '여기에 이름을 입력하세요...',
  portuguese: 'insira o nome aqui...',
  russian: 'введите имя здесь...',
  spanish: 'ingrese el nombre aquí...',
  swahili: 'weka jina hapa...',
  vietnamese: 'nhập tên ở đây...',
};
export const passwordPlaceholder: Translation = {
  amharic: 'የይለፍ ቃል እዚህ ያስገቡ...',
  arabic: 'أدخل كلمة المرور هنا...',
  bengali: 'এখানে পাসওয়ার্ড লিখুন...',
  chinese: '在此输入密码...',
  english: 'enter password here...',
  estonian: 'sisesta parool siia...',
  filipino: 'ilagay ang password dito...',
  french: 'entrez le mot de passe ici...',
  german: 'Geben Sie hier Ihr Passwort ein...',
  hindi: 'यहां पासवर्ड दर्ज करें...',
  indonesian: 'masukkan kata sandi di sini...',
  japanese: 'ここにパスワードを入力してください...',
  korean: '여기에 비밀번호를 입력하세요...',
  portuguese: 'insira a senha aqui...',
  russian: 'введите пароль здесь...',
  spanish: 'ingrese la contraseña aquí...',
  swahili: 'weka nenosiri hapa...',
  vietnamese: 'nhập mật khẩu ở đây...',
};
export const passwordConfirmPlaceholder: Translation = {
  amharic: 'የይለፍ ቃል እዚህ እንደገና ያስገቡ...',
  arabic: 'أعد إدخال كلمة المرور هنا...',
  bengali: 'এখানে পাসওয়ার্ড পুনরায় লিখুন...',
  chinese: '在此重新输入密码...',
  english: 're-enter password here...',
  estonian: 'sisesta parool uuesti siia...',
  filipino: 'muling ilagay ang password dito...',
  french: 're-entrez le mot de passe ici...',
  german: 'Geben Sie hier Ihr Passwort erneut ein...',
  hindi: 'यहां पासवर्ड पुनः दर्ज करें...',
  indonesian: 'masukkan kembali kata sandi di sini...',
  japanese: 'ここにパスワードを再入力してください...',
  korean: '여기에 비밀번호를 다시 입력하세요...',
  portuguese: 'insira a senha novamente aqui...',
  russian: 'введите пароль здесь...',
  spanish: 'vuelva a ingresar la contraseña aquí...',
  swahili: 'weka tena nenosiri hapa...',
  vietnamese: 'nhập lại mật khẩu ở đây...',
};
export const adminLogin: Translation = {
  amharic: 'የአስተዳዳሪ መግቢያ',
  arabic: 'تسجيل دخول المسؤول',
  bengali: 'অ্যাডমিন লগইন',
  chinese: '管理员登录',
  english: 'Admin login',
  estonian: `Logi sisse`,
  filipino: 'Admin login',
  french: 'Connexion admin.',
  german: 'Admin-Anmeldung',
  hindi: 'व्यवस्थापक लॉगिन',
  indonesian: 'Login admin',
  japanese: '管理者ログイン',
  korean: '관리자 로그인',
  portuguese: 'Login de administrador',
  russian: `Авторизоваться`,
  spanish: 'Inicio de sesión de administrador',
  swahili: 'Kuingia kwa msimamizi',
  vietnamese: 'Đăng nhập quản trị',
};
export const invalidCredentials: Translation = {
  amharic: 'ልክ ያልሆነ ምስክርነቶች',
  arabic: 'بيانات اعتماد غير صالحة',
  bengali: 'অবৈধ শংসাপত্র',
  chinese: '无效凭据',
  english: `Invalid credentials`,
  estonian: 'Vigased kredentsiaalid',
  filipino: 'Di-wastong mga kredensyal',
  french: 'Credenciais inválidas',
  german: 'Ungültige Anmeldeinformationen',
  hindi: 'अमान्य क्रेडेंशियल',
  indonesian: 'Kredensial tidak valid',
  japanese: '無効な認証情報',
  korean: '잘못된 자격 증명',
  portuguese: 'Credenciais inválidas',
  russian: 'Неверные учетные данные',
  spanish: 'Credenciales inválidas',
  swahili: 'Vitambulisho batili',
  vietnamese: 'Thông tin xác thực không hợp lệ',
};
export const login: Translation = {
  amharic: 'ግባ',
  arabic: 'تسجيل الدخول',
  bengali: 'লগইন',
  chinese: '登录',
  english: `Login`,
  estonian: 'Logi sisse',
  filipino: 'Mag-login',
  french: 'Connexion',
  german: 'Anmeldung',
  hindi: 'लॉगिन',
  indonesian: 'Masuk',
  japanese: 'ログイン',
  korean: '로그인',
  portuguese: 'Entrar',
  russian: 'Авторизоваться',
  spanish: 'Iniciar sesión',
  swahili: 'Ingia',
  vietnamese: 'Đăng nhập',
};
// NOTE: metaTitle, at the end of this file, carries the same English and a
// different Amharic and Hindi. Folding the two ships a copy change in both, so
// they are deliberately both here.
export const signIn: Translation = {
  amharic: 'ግባ',
  arabic: 'تسجيل الدخول',
  bengali: 'সাইন ইন',
  chinese: '登录',
  english: `Sign in`,
  estonian: 'Logi sisse',
  filipino: 'Mag-sign in',
  french: 'Se connecter',
  german: 'Anmelden',
  hindi: 'साइन इन',
  indonesian: 'Masuk',
  japanese: 'サインイン',
  korean: '로그인',
  portuguese: 'Entrar',
  russian: 'Войти',
  spanish: 'Iniciar sesión',
  swahili: 'Ingia',
  vietnamese: 'Đăng nhập',
};
export const signInExpired: Translation = {
  amharic: 'ያ መግቢያ ብዙ ጊዜ ወስዷል፣ ስለዚህ አብቅቷል።',
  arabic: 'استغرقت عملية تسجيل الدخول تلك وقتا طويلا، فانتهت صلاحيتها.',
  bengali: 'সেই সাইন ইন করতে অনেক সময় লেগেছিল, তাই এটির মেয়াদ শেষ হয়ে গেছে।',
  chinese: '那次登录耗时过长，已经过期。',
  english: 'That sign in took too long, so it expired.',
  estonian: 'See sisselogimine võttis liiga kaua aega ja aegus.',
  filipino: 'Masyadong natagalan ang pag-sign in na iyon, kaya nag-expire ito.',
  french: 'Cette connexion a pris trop de temps et a expiré.',
  german: 'Die Anmeldung hat zu lange gedauert und ist abgelaufen.',
  hindi: 'साइन इन करने में बहुत समय लग गया, इसलिए यह समाप्त हो गया।',
  indonesian: 'Proses masuk itu memakan waktu terlalu lama, jadi kedaluwarsa.',
  japanese: 'そのサインインは時間がかかりすぎたため、期限切れになりました。',
  korean: '그 로그인은 시간이 너무 오래 걸려 만료되었습니다.',
  portuguese: 'Esse login demorou demais e expirou.',
  russian: 'Этот вход занял слишком много времени и истёк.',
  spanish: 'Ese inicio de sesión tardó demasiado, así que caducó.',
  swahili: 'Kuingia huko kulichukua muda mrefu mno, hivyo muda wake umeisha.',
  vietnamese: 'Lần đăng nhập đó mất quá nhiều thời gian nên đã hết hạn.',
};

export const signInFailed: Translation = {
  amharic: 'ያ መግቢያ አልተጠናቀቀም።',
  arabic: 'لم تكتمل عملية تسجيل الدخول تلك.',
  bengali: 'সেই সাইন ইন সম্পন্ন হয়নি।',
  chinese: '那次登录未能完成。',
  english: 'That sign in did not finish.',
  estonian: 'See sisselogimine ei õnnestunud.',
  filipino: 'Hindi natapos ang pag-sign in na iyon.',
  french: 'Cette connexion ne s’est pas terminée.',
  german: 'Die Anmeldung wurde nicht abgeschlossen.',
  hindi: 'वह साइन इन पूरा नहीं हुआ।',
  indonesian: 'Proses masuk itu belum selesai.',
  japanese: 'そのサインインは完了しませんでした。',
  korean: '그 로그인이 완료되지 않았습니다.',
  portuguese: 'Esse login não foi concluído.',
  russian: 'Этот вход не был завершён.',
  spanish: 'Ese inicio de sesión no se completó.',
  swahili: 'Kuingia huko hakukukamilika.',
  vietnamese: 'Lần đăng nhập đó chưa hoàn tất.',
};
export const passwordReset: Translation = {
  amharic: 'የይለፍ ቃል ዳግም ማስጀመር',
  arabic: 'إعادة تعيين كلمة المرور',
  bengali: 'পাসওয়ার্ড রিসেট',
  chinese: '密码重置',
  english: `Password Reset`,
  estonian: 'Parooli lähtestamine',
  filipino: 'I-reset ang password',
  french: 'Réinitialisation du mot de passe',
  german: 'Passwort zurücksetzen',
  hindi: 'पासवर्ड रीसेट',
  indonesian: 'Reset kata sandi',
  japanese: 'パスワードリセット',
  korean: '비밀번호 재설정',
  portuguese: 'Redefinição de senha',
  russian: 'Сброс пароля',
  spanish: 'Restablecimiento de contraseña',
  swahili: 'Kuweka upya nenosiri',
  vietnamese: 'Đặt lại mật khẩu',
};
export const createClientAccount: Translation = {
  amharic: 'የደንበኛ መለያ ፍጠር',
  arabic: 'إنشاء حساب عميل',
  bengali: 'ক্লায়েন্ট অ্যাকাউন্ট তৈরি করুন',
  chinese: '创建客户账户',
  english: `Create Client Account`,
  estonian: 'Klientkonto loomine',
  filipino: 'Lumikha ng client account',
  french: 'Créer un compte client',
  german: 'Kundenkonto erstellen',
  hindi: 'ग्राहक खाता बनाएं',
  indonesian: 'Buat akun klien',
  japanese: 'クライアントアカウントを作成',
  korean: '고객 계정 만들기',
  portuguese: 'Criar conta de cliente',
  russian: 'Создать клиентский аккаунт',
  spanish: 'Crear cuenta de cliente',
  swahili: 'Unda akaunti ya mteja',
  vietnamese: 'Tạo tài khoản khách hàng',
};
export const createWorkerAccount: Translation = {
  amharic: 'የሰራተኛ መለያ ፍጠር',
  arabic: 'إنشاء حساب عامل',
  bengali: 'কর্মী অ্যাকাউন্ট তৈরি করুন',
  chinese: '创建工作人员账户',
  english: `Create Worker Account`,
  estonian: 'Töötaja konto loomine',
  filipino: 'Lumikha ng worker account',
  french: 'Créer un compte travailleur',
  german: 'Arbeiterkonto erstellen',
  hindi: 'कर्मचारी खाता बनाएं',
  indonesian: 'Buat akun pekerja',
  japanese: 'ワーカーアカウントを作成',
  korean: '작업자 계정 만들기',
  portuguese: 'Criar conta de trabalhador',
  russian: 'Создать рабочий аккаунт',
  spanish: 'Crear cuenta de trabajador',
  swahili: 'Unda akaunti ya mfanyakazi',
  vietnamese: 'Tạo tài khoản nhân viên',
};

export const status: Translation = statusText;
export const viewText: Translation = {
  amharic: 'እይታ',
  arabic: 'عرض',
  bengali: 'দেখুন',
  chinese: '查看',
  english: 'View',
  estonian: 'Vaade',
  filipino: 'Tingnan',
  french: 'Voir',
  german: 'Ansicht',
  hindi: 'देखें',
  indonesian: 'Lihat',
  japanese: '表示',
  korean: '보기',
  portuguese: 'Visualizar',
  russian: 'Вид',
  spanish: 'Vista',
  swahili: 'Tazama',
  vietnamese: 'Xem',
};
export const saveViewText: Translation = {
  amharic: 'እይታ አስቀምጥ',
  arabic: 'حفظ العرض',
  bengali: 'দৃশ্য সংরক্ষণ করুন',
  chinese: '保存视图',
  english: 'Save view',
  estonian: 'Salvesta vaade',
  filipino: 'I-save ang view',
  french: 'Enregistrer la vue',
  german: 'Ansicht speichern',
  hindi: 'दृश्य सहेजें',
  indonesian: 'Simpan tampilan',
  japanese: '表示を保存',
  korean: '보기 저장',
  portuguese: 'Salvar visualização',
  russian: 'Сохранить представление',
  spanish: 'Guardar vista',
  swahili: 'Hifadhi mtazamo',
  vietnamese: 'Lưu chế độ xem',
};
export const sortBy: Translation = {
  amharic: 'በ መሰረት ደርድር',
  arabic: 'ترتيب حسب',
  bengali: 'দ্বারা সাজান',
  chinese: '排序依据',
  english: 'Sort by',
  estonian: 'Sorteeri',
  filipino: 'Ayusin ayon sa',
  french: 'Trier par',
  german: 'Sortieren nach',
  hindi: 'द्वारा क्रमबद्ध करें',
  indonesian: 'Urutkan berdasarkan',
  japanese: '並べ替え',
  korean: '정렬 기준',
  portuguese: 'Ordenar por',
  russian: 'Сортировать по',
  spanish: 'Ordenar por',
  swahili: 'Panga kwa',
  vietnamese: 'Sắp xếp theo',
};
export const orderBy: Translation = {
  amharic: 'በ መሰረት አዘዝ',
  arabic: 'طلب حسب',
  bengali: 'দ্বারা অর্ডার',
  chinese: '排序依据',
  english: 'Order by',
  estonian: 'Järjesta',
  filipino: 'Ayusin ayon sa',
  french: 'Ordonner par',
  german: 'Sortieren nach',
  hindi: 'द्वारा आदेश',
  indonesian: 'Pesan berdasarkan',
  japanese: '順序',
  korean: '정렬 기준',
  portuguese: 'Ordenar por',
  russian: 'Сортировать по',
  spanish: 'Ordenar por',
  swahili: 'Agiza kwa',
  vietnamese: 'Sắp xếp theo',
};
export const commentText: Translation = {
  amharic: 'አስተያየት',
  arabic: 'تعليق',
  bengali: 'মন্তব্য',
  chinese: '评论',
  english: 'Comment',
  estonian: 'Kommentaar',
  filipino: 'Komento',
  french: 'Commenter',
  german: 'Kommentar',
  hindi: 'टिप्पणी',
  indonesian: 'Komentar',
  japanese: 'コメント',
  korean: '댓글',
  portuguese: 'Comentário',
  russian: 'Комментарий',
  spanish: 'Comentario',
  swahili: 'Maoni',
  vietnamese: 'Bình luận',
};
export const submit: Translation = {
  amharic: 'አስገባ',
  arabic: 'إرسال',
  bengali: 'জমা দিন',
  chinese: '提交',
  english: 'Submit',
  estonian: 'Esita',
  filipino: 'Isumite',
  french: 'Soumettre',
  german: 'Einreichen',
  hindi: 'सबमिट',
  indonesian: 'Kirim',
  japanese: '送信',
  korean: '제출',
  portuguese: 'Enviar',
  russian: 'Отправить',
  spanish: 'Enviar',
  swahili: 'Wasilisha',
  vietnamese: 'Gửi',
};
export const companyText: Translation = {
  amharic: 'ኩባንያ',
  arabic: 'شركة',
  bengali: 'কোম্পানি',
  chinese: '公司',
  english: 'Company',
  estonian: 'Kohandatud',
  filipino: 'Kumpanya',
  french: 'Développement',
  german: 'Unternehmen',
  hindi: 'कंपनी',
  indonesian: 'Perusahaan',
  japanese: '会社',
  korean: '회사',
  portuguese: 'Empresa',
  russian: 'ИНДИВИДУАЛЬНЫЙ',
  spanish: 'Empresa',
  swahili: 'Kampuni',
  vietnamese: 'Công ty',
};
export const help: Translation = {
  amharic: 'እገዛ',
  arabic: 'مساعدة',
  bengali: 'সাহায্য',
  chinese: '帮助',
  english: 'Help',
  estonian: 'Abi',
  filipino: 'Tulong',
  french: 'Help',
  german: 'Hilfe',
  hindi: 'सहायता',
  indonesian: 'Bantuan',
  japanese: 'ヘルプ',
  korean: '도움말',
  portuguese: 'Ajuda',
  russian: 'Помощь',
  spanish: 'Ayuda',
  swahili: 'Msaada',
  vietnamese: 'Trợ giúp',
};
export const info: Translation = {
  amharic: 'መረጃ',
  arabic: 'معلومات',
  bengali: 'তথ্য',
  chinese: '信息',
  english: 'Info',
  estonian: 'Info',
  filipino: 'Impormasyon',
  french: 'Info',
  german: 'Informationen',
  hindi: 'जानकारी',
  indonesian: 'Info',
  japanese: '情報',
  korean: '정보',
  portuguese: 'Info',
  russian: 'Информация',
  spanish: 'Info',
  swahili: 'Taarifa',
  vietnamese: 'Thông tin',
};

export const messagesText: Translation = {
  amharic: 'መልዕክቶች',
  arabic: 'الرسائل',
  bengali: 'বার্তা',
  chinese: '消息',
  english: 'Messages',
  estonian: 'Sõnumid',
  filipino: 'Mga mensahe',
  french: 'Messages',
  german: 'Nachrichten',
  hindi: 'संदेश',
  indonesian: 'Pesan',
  japanese: 'メッセージ',
  korean: '메시지',
  portuguese: 'Mensagens',
  russian: 'Сообщения',
  spanish: 'Mensajes',
  swahili: 'Ujumbe',
  vietnamese: 'Tin nhắn',
};
export const newText: Translation = {
  amharic: 'አዲስ',
  arabic: 'جديد',
  bengali: 'নতুন',
  chinese: '新',
  english: 'New',
  estonian: 'Uus',
  filipino: 'Bago',
  french: 'Nouveau',
  german: 'Neu',
  hindi: 'नया',
  indonesian: 'Baru',
  japanese: '新規',
  korean: '새로운',
  portuguese: 'Novo',
  russian: 'Новый',
  spanish: 'Nuevo',
  swahili: 'Mpya',
  vietnamese: 'Mới',
};
export const recipientsText: Translation = {
  amharic: 'ተቀባዮች',
  arabic: 'المستلمون',
  bengali: 'প্রাপক',
  chinese: '收件人',
  english: 'Recipients',
  estonian: 'Saajad',
  filipino: 'Mga tatanggap',
  french: 'Destinataires',
  german: 'Empfänger',
  hindi: 'प्राप्तकर्ता',
  indonesian: 'Penerima',
  japanese: '受信者',
  korean: '수신자',
  portuguese: 'Destinatários',
  russian: 'Получатели',
  spanish: 'Destinatarios',
  swahili: 'Wapokeaji',
  vietnamese: 'Người nhận',
};
export const smsText: Translation = {
  amharic: 'ኤስኤምኤስ',
  arabic: 'رسالة نصية',
  bengali: 'এসএমএস',
  chinese: '短信',
  english: 'SMS',
  estonian: 'SMS',
  filipino: 'SMS',
  french: 'SMS',
  german: 'SMS',
  hindi: 'SMS',
  indonesian: 'SMS',
  japanese: 'SMS',
  korean: 'SMS',
  portuguese: 'SMS',
  russian: 'СМС',
  spanish: 'SMS',
  swahili: 'SMS',
  vietnamese: 'SMS',
};
export const sendText: Translation = {
  amharic: 'ላክ',
  arabic: 'إرسال',
  bengali: 'পাঠান',
  chinese: '发送',
  english: 'Send',
  estonian: 'Saada',
  filipino: 'Ipadala',
  french: 'Envoyer',
  german: 'Senden',
  hindi: 'भेजें',
  indonesian: 'Kirim',
  japanese: '送信',
  korean: '보내기',
  portuguese: 'Enviar',
  russian: 'Отправить',
  spanish: 'Enviar',
  swahili: 'Tuma',
  vietnamese: 'Gửi',
};
export const enterMessageText: Translation = {
  amharic: 'መልእክትዎን እዚህ ያስገቡ...',
  arabic: 'أدخل رسالتك هنا...',
  bengali: 'এখানে আপনার বার্তা লিখুন...',
  chinese: '在此输入您的消息...',
  english: 'Enter your message here...',
  estonian: 'Sisesta oma sõnum siia...',
  filipino: 'Ilagay ang iyong mensahe dito...',
  french: 'Entrez votre message ici...',
  german: 'Geben Sie hier Ihre Nachricht ein...',
  hindi: 'अपना संदेश यहां दर्ज करें...',
  indonesian: 'Masukkan pesan Anda di sini...',
  japanese: 'ここにメッセージを入力してください...',
  korean: '여기에 메시지를 입력하세요...',
  portuguese: 'Insira sua mensagem aqui...',
  russian: 'Введите ваше сообщение здесь...',
  spanish: 'Ingrese su mensaje aquí...',
  swahili: 'Weka ujumbe wako hapa...',
  vietnamese: 'Nhập tin nhắn của bạn ở đây...',
};
export const progress: Translation = {
  amharic: 'እድገት',
  arabic: 'التقدم',
  bengali: 'অগ্রগতি',
  chinese: '进度',
  english: 'Progress',
  estonian: 'Edasi',
  filipino: 'Pag-unlad',
  french: 'Progrès',
  german: 'Fortschritt',
  hindi: 'प्रगति',
  indonesian: 'Kemajuan',
  japanese: '進捗',
  korean: '진행',
  portuguese: 'Progresso',
  russian: 'Прогресс',
  spanish: 'Progreso',
  swahili: 'Maendeleo',
  vietnamese: 'Tiến độ',
};
export const courses: Translation = {
  amharic: 'ኮርሶች',
  arabic: 'الدورات',
  bengali: 'কোর্স',
  chinese: '课程',
  english: 'Courses',
  estonian: 'Kursused',
  filipino: 'Mga kurso',
  french: 'Cours',
  german: 'Kurse',
  hindi: 'पाठ्यक्रम',
  indonesian: 'Kursus',
  japanese: 'コース',
  korean: '강좌',
  portuguese: 'Cursos',
  russian: 'Курсы',
  spanish: 'Cursos',
  swahili: 'Kozi',
  vietnamese: 'Khóa học',
};
export const wishlist: Translation = {
  amharic: 'የምኞት ዝርዝር',
  arabic: 'قائمة الأمنيات',
  bengali: 'ইচ্ছা তালিকা',
  chinese: '愿望清单',
  english: 'Wishlist',
  estonian: 'Soovituste loend',
  filipino: 'Wishlist',
  french: 'Liste de souhaits',
  german: 'Wunschliste',
  hindi: 'इच्छा सूची',
  indonesian: 'Daftar keinginan',
  japanese: 'ウィッシュリスト',
  korean: '위시리스트',
  portuguese: 'Lista de desejos',
  russian: 'Список желаний',
  spanish: 'Lista de deseos',
  swahili: 'Orodha ya matakwa',
  vietnamese: 'Danh sách mong muốn',
};
export const send: Translation = sendText;
export const serviceText: Translation = {
  amharic: 'አገልግሎት',
  arabic: 'خدمة',
  bengali: 'সেবা',
  chinese: '服务',
  english: 'Service',
  estonian: 'Teenus',
  filipino: 'Serbisyo',
  french: 'Service',
  german: 'Dienst',
  hindi: 'सेवा',
  indonesian: 'Layanan',
  japanese: 'サービス',
  korean: '서비스',
  portuguese: 'Serviço',
  russian: 'Сервис',
  spanish: 'Servicio',
  swahili: 'Huduma',
  vietnamese: 'Dịch vụ',
};
export const requestService: Translation = {
  amharic: 'አገልግሎት ጠይቅ',
  arabic: 'طلب خدمة',
  bengali: 'সেবা অনুরোধ করুন',
  chinese: '请求服务',
  english: 'Request a service',
  estonian: 'Taotlege teenust',
  filipino: 'Humiling ng serbisyo',
  french: 'Demander un service',
  german: 'Fordern Sie eine Dienstleistung an',
  hindi: 'सेवा का अनुरोध करें',
  indonesian: 'Minta layanan',
  japanese: 'サービスをリクエスト',
  korean: '서비스 요청',
  portuguese: 'Solicitar um serviço',
  russian: 'Запросить услугу',
  spanish: 'Solicitar un servicio',
  swahili: 'Omba huduma',
  vietnamese: 'Yêu cầu dịch vụ',
};
export const servicesText: Translation = {
  amharic: 'አገልግሎቶች',
  arabic: 'الخدمات',
  bengali: 'সেবা',
  chinese: '服务',
  english: `Services`,
  estonian: `Teenused`,
  filipino: 'Mga serbisyo',
  french: `Prestations de service`,
  german: `Dienstleistungen`,
  hindi: 'सेवाएं',
  indonesian: 'Layanan',
  japanese: 'サービス',
  korean: '서비스',
  portuguese: 'Serviços',
  russian: `Услуги`,
  spanish: 'Servicios',
  swahili: 'Huduma',
  vietnamese: 'Dịch vụ',
};
export const position: Translation = {
  amharic: 'ቦታ',
  arabic: 'موقع',
  bengali: 'অবস্থান',
  chinese: '职位',
  english: 'Position',
  estonian: 'Positsioon',
  filipino: 'Posisyon',
  french: 'Position',
  german: 'Position',
  hindi: 'स्थिति',
  indonesian: 'Posisi',
  japanese: 'ポジション',
  korean: '위치',
  portuguese: 'Posição',
  russian: 'Позиция',
  spanish: 'Posición',
  swahili: 'Nafasi',
  vietnamese: 'Vị trí',
};
export const firstName: Translation = {
  amharic: 'የመጀመሪያ ስም',
  arabic: 'الاسم الأول',
  bengali: 'প্রথম নাম',
  chinese: '名字',
  english: 'First name',
  estonian: 'Eesnimi',
  filipino: 'Pangalan',
  french: 'Prénom',
  german: 'Vorname',
  hindi: 'पहला नाम',
  indonesian: 'Nama depan',
  japanese: '名',
  korean: '이름',
  portuguese: 'Nome',
  russian: 'Имя',
  spanish: 'Nombre',
  swahili: 'Jina la kwanza',
  vietnamese: 'Tên',
};
export const lastName: Translation = {
  amharic: 'የአባት ስም',
  arabic: 'اسم العائلة',
  bengali: 'শেষ নাম',
  chinese: '姓氏',
  english: 'Last name',
  estonian: 'Perekonnanimi',
  filipino: 'Apelyido',
  french: 'Nom de famille',
  german: 'Nachname',
  hindi: 'उपनाम',
  indonesian: 'Nama belakang',
  japanese: '姓',
  korean: '성',
  portuguese: 'Sobrenome',
  russian: 'Фамилия',
  spanish: 'Apellido',
  swahili: 'Jina la ukoo',
  vietnamese: 'Họ',
};
export const darkTheme: Translation = {
  amharic: 'ጨለማ ገጽታ',
  arabic: 'سمة داكنة',
  bengali: 'গাঢ় থিম',
  chinese: '深色主题',
  english: 'Dark Theme',
  estonian: 'Tume teema',
  filipino: 'Madilim na tema',
  french: 'Thème sombre',
  german: 'Dunkles Thema',
  hindi: 'गहरा थीम',
  indonesian: 'Tema gelap',
  japanese: 'ダークテーマ',
  korean: '어두운 테마',
  portuguese: 'Tema escuro',
  russian: 'Темная тема',
  spanish: 'Tema oscuro',
  swahili: 'Mandhari meusi',
  vietnamese: 'Chủ đề tối',
};
export const allowEmails: Translation = {
  amharic: 'ኢሜይሎችን ፍቀድ',
  arabic: 'السماح بالبريد الإلكتروني',
  bengali: 'ইমেল অনুমতি দিন',
  chinese: '允许电子邮件',
  english: 'Allow Emails',
  estonian: 'Luba e-kirjad',
  filipino: 'Payagan ang mga email',
  french: 'Autoriser les E-mail',
  german: 'E-Mails zulassen',
  hindi: 'ईमेल की अनुमति दें',
  indonesian: 'Izinkan email',
  japanese: 'メールを許可',
  korean: '이메일 허용',
  portuguese: 'Permitir e-mails',
  russian: 'Разрешить электронную почту',
  spanish: 'Permitir correos electrónicos',
  swahili: 'Ruhusu barua pepe',
  vietnamese: 'Cho phép email',
};
export const allowNotifications: Translation = {
  amharic: 'ማሳወቂያዎችን ፍቀድ',
  arabic: 'السماح بالإشعارات',
  bengali: 'বিজ্ঞপ্তি অনুমতি দিন',
  chinese: '允许通知',
  english: 'Allow Notifications',
  estonian: 'Luba teavitused',
  filipino: 'Payagan ang mga notipikasyon',
  french: 'Autoriser les notifications',
  german: 'Benachrichtigungen zulassen',
  hindi: 'सूचनाओं की अनुमति दें',
  indonesian: 'Izinkan notifikasi',
  japanese: '通知を許可',
  korean: '알림 허용',
  portuguese: 'Permitir notificações',
  russian: 'Разрешить уведомления',
  spanish: 'Permitir notificaciones',
  swahili: 'Ruhusu arifa',
  vietnamese: 'Cho phép thông báo',
};
export const allowSMS: Translation = {
  amharic: 'ኤስኤምኤስ ፍቀድ',
  arabic: 'السماح بالرسائل النصية',
  bengali: 'এসএমএস অনুমতি দিন',
  chinese: '允许短信',
  english: 'Allow SMS',
  estonian: 'Luba SMS',
  filipino: 'Payagan ang SMS',
  french: 'Autoriser les SMS',
  german: 'SMS zulassen',
  hindi: 'SMS की अनुमति दें',
  indonesian: 'Izinkan SMS',
  japanese: 'SMSを許可',
  korean: 'SMS 허용',
  portuguese: 'Permitir SMS',
  russian: 'Разрешить SMS',
  spanish: 'Permitir SMS',
  swahili: 'Ruhusu SMS',
  vietnamese: 'Cho phép SMS',
};
export const approved: Translation = {
  amharic: 'ጸድቋል',
  arabic: 'موافق عليه',
  bengali: 'অনুমোদিত',
  chinese: '已批准',
  english: 'Approved',
  estonian: 'Kinnitatud',
  filipino: 'Naaprubahan',
  french: 'Approuvé',
  german: 'Genehmigt',
  hindi: 'स्वीकृत',
  indonesian: 'Disetujui',
  japanese: '承認済み',
  korean: '승인됨',
  portuguese: 'Aprovado',
  russian: 'Одобрено',
  spanish: 'Aprobado',
  swahili: 'Imeidhinishwa',
  vietnamese: 'Đã phê duyệt',
};
export const started: Translation = {
  amharic: 'ተጀምሯል',
  arabic: 'بدأ',
  bengali: 'শুরু হয়েছে',
  chinese: '已开始',
  english: 'Started',
  estonian: 'Alustatud',
  filipino: 'Nasimulan',
  french: 'Commencé',
  german: 'Gestartet',
  hindi: 'शुरू किया',
  indonesian: 'Dimulai',
  japanese: '開始済み',
  korean: '시작됨',
  portuguese: 'Iniciado',
  russian: 'Начато',
  spanish: 'Iniciado',
  swahili: 'Imeanza',
  vietnamese: 'Đã bắt đầu',
};
export const logout: Translation = logoutText;
export const deleteUser: Translation = {
  amharic: 'መለያ ሰርዝ',
  arabic: 'حذف الحساب',
  bengali: 'অ্যাকাউন্ট মুছুন',
  chinese: '删除账户',
  english: 'Delete account',
  estonian: 'Kustuta konto',
  filipino: 'Tanggalin ang account',
  french: 'Supprimer le compte',
  german: 'Konto löschen',
  hindi: 'खाता हटाएं',
  indonesian: 'Hapus akun',
  japanese: 'アカウント削除',
  korean: '계정 삭제',
  portuguese: 'Excluir conta',
  russian: 'Удалить аккаунт',
  spanish: 'Eliminar cuenta',
  swahili: 'Futa akaunti',
  vietnamese: 'Xóa tài khoản',
};
export const reactivateUser: Translation = {
  amharic: 'መለያ እንደገና አንቃ',
  arabic: 'إعادة تنشيط الحساب',
  bengali: 'অ্যাকাউন্ট পুনরায় সক্রিয় করুন',
  chinese: '重新激活账户',
  english: 'Reactivate account',
  estonian: 'Aktiveeri konto uuesti',
  filipino: 'Muling i-activate ang account',
  french: 'Réactiver le compte',
  german: 'Konto reaktivieren',
  hindi: 'खाता पुनः सक्रिय करें',
  indonesian: 'Aktifkan kembali akun',
  japanese: 'アカウントを再アクティブ化',
  korean: '계정 재활성화',
  portuguese: 'Reativar conta',
  russian: 'Активировать аккаунт',
  spanish: 'Reactivar cuenta',
  swahili: 'Washa tena akaunti',
  vietnamese: 'Kích hoạt lại tài khoản',
};
export const selectProfilePicture: Translation = {
  amharic: 'እባክዎ አዲስ የመገለጫ ምስል ይምረጡ',
  arabic: 'يرجى تحديد صورة ملف شخصي جديدة',
  bengali: 'অনুগ্রহ করে একটি নতুন প্রোফাইল ছবি নির্বাচন করুন',
  chinese: '请选择新的个人资料图片',
  english: 'Please select a new profile picture',
  estonian: 'Palun valige uus profiilipilt',
  filipino: 'Mangyaring pumili ng bagong profile picture',
  french: 'Développement',
  german: 'Bitte wählen Sie ein neues Profilbild',
  hindi: 'कृपया एक नई प्रोफ़ाइल तस्वीर चुनें',
  indonesian: 'Silakan pilih foto profil baru',
  japanese: '新しいプロフィール写真を選択してください',
  korean: '새 프로필 사진을 선택하세요',
  portuguese: 'Por favor selecione uma nova foto de perfil',
  russian: 'Пожалуйста, выберите новую фотографию профиля',
  spanish: 'Por favor seleccione una nueva foto de perfil',
  swahili: 'Tafadhali chagua picha mpya ya wasifu',
  vietnamese: 'Vui lòng chọn ảnh hồ sơ mới',
};
export const frontend: Translation = {
  amharic: 'ፊት-መጨረሻ',
  arabic: 'الواجهة الأمامية',
  bengali: 'ফ্রন্টএন্ড',
  chinese: '前端',
  english: 'Frontend',
  estonian: 'Kasutajaliides',
  filipino: 'Frontend',
  french: 'Interface utilisateur',
  german: 'Frontend',
  hindi: 'फ्रंटएंड',
  indonesian: 'Frontend',
  japanese: 'フロントエンド',
  korean: '프론트엔드',
  portuguese: 'Frontend',
  russian: 'Фронтенд',
  spanish: 'Frontend',
  swahili: 'Mbeleni',
  vietnamese: 'Frontend',
};
export const backend: Translation = {
  amharic: 'ኋለ-መጨረሻ',
  arabic: 'الخلفية',
  bengali: 'ব্যাকএন্ড',
  chinese: '后端',
  english: 'Backend',
  estonian: 'Serveripoolne',
  filipino: 'Backend',
  french: 'Côté serveur',
  german: 'Backend',
  hindi: 'बैकएंड',
  indonesian: 'Backend',
  japanese: 'バックエンド',
  korean: '백엔드',
  portuguese: 'Backend',
  russian: 'Бэкенд',
  spanish: 'Backend',
  swahili: 'Nyuma',
  vietnamese: 'Backend',
};
export const mobile: Translation = {
  amharic: 'ተንቀሳቃሽ',
  arabic: 'الهاتف المحمول',
  bengali: 'মোবাইল',
  chinese: '移动',
  english: 'Mobile',
  estonian: 'Mobiilne',
  filipino: 'Mobile',
  french: 'Mobile',
  german: 'Mobil',
  hindi: 'मोबाइल',
  indonesian: 'Seluler',
  japanese: 'モバイル',
  korean: '모바일',
  portuguese: 'Móvel',
  russian: 'Мобильный',
  spanish: 'Móvil',
  swahili: 'Simu',
  vietnamese: 'Di động',
};
export const cicd: Translation = {
  amharic: 'CI/CD',
  arabic: 'CI/CD',
  bengali: 'CI/CD',
  chinese: 'CI/CD',
  english: 'CI/CD',
  estonian: 'CI/CD',
  filipino: 'CI/CD',
  french: 'CI/CD',
  german: 'CI/CD',
  hindi: 'CI/CD',
  indonesian: 'CI/CD',
  japanese: 'CI/CD',
  korean: 'CI/CD',
  portuguese: 'CI/CD',
  russian: 'CI/CD',
  spanish: 'CI/CD',
  swahili: 'CI/CD',
  vietnamese: 'CI/CD',
};
export const hosting: Translation = {
  amharic: 'አስተናጋጅነት',
  arabic: 'الاستضافة',
  bengali: 'হোস্টিং',
  chinese: '托管',
  english: 'Hosting',
  estonian: 'Majutus',
  filipino: 'Hosting',
  french: 'Hébergement',
  german: 'Hosting',
  hindi: 'होस्टिंग',
  indonesian: 'Hosting',
  japanese: 'ホスティング',
  korean: '호스팅',
  portuguese: 'Hospedagem',
  russian: 'Хостинг',
  spanish: 'Alojamiento',
  swahili: 'Uhifadhi',
  vietnamese: 'Lưu trữ',
};
export const api: Translation = {
  amharic: 'API',
  arabic: 'API',
  bengali: 'API',
  chinese: 'API',
  english: 'API',
  estonian: 'API',
  filipino: 'API',
  french: 'API',
  german: 'API',
  hindi: 'API',
  indonesian: 'API',
  japanese: 'API',
  korean: 'API',
  portuguese: 'API',
  russian: 'API',
  spanish: 'API',
  swahili: 'API',
  vietnamese: 'API',
};
export const languages: Translation = {
  amharic: 'ቋንቋዎች',
  arabic: 'اللغات',
  bengali: 'ভাষা',
  chinese: '语言',
  english: 'Languages',
  estonian: 'Keeled',
  filipino: 'Mga wika',
  french: 'Langues',
  german: 'Sprachen',
  hindi: 'भाषाएं',
  indonesian: 'Bahasa',
  japanese: '言語',
  korean: '언어',
  portuguese: 'Idiomas',
  russian: 'Языки',
  spanish: 'Idiomas',
  swahili: 'Lugha',
  vietnamese: 'Ngôn ngữ',
};
export const frameworks: Translation = {
  amharic: 'ማዕቀፎች',
  arabic: 'أطر العمل',
  bengali: 'ফ্রেমওয়ার্ক',
  chinese: '框架',
  english: 'Frameworks',
  estonian: 'Raamistikud',
  filipino: 'Mga framework',
  french: 'Cadres',
  german: 'Frameworks',
  hindi: 'फ्रेमवर्क',
  indonesian: 'Kerangka kerja',
  japanese: 'フレームワーク',
  korean: '프레임워크',
  portuguese: 'Frameworks',
  russian: 'Фреймворки',
  spanish: 'Marcos de trabajo',
  swahili: 'Mifumo',
  vietnamese: 'Khung',
};
export const databases: Translation = {
  amharic: 'የውሂብ ጎታዎች',
  arabic: 'قواعد البيانات',
  bengali: 'ডাটাবেস',
  chinese: '数据库',
  english: 'Databases',
  estonian: 'Andmebaasid',
  filipino: 'Mga database',
  french: 'Bases de données',
  german: 'Datenbanken',
  hindi: 'डेटाबेस',
  indonesian: 'Basis data',
  japanese: 'データベース',
  korean: '데이터베이스',
  portuguese: 'Bancos de dados',
  russian: 'Базы данных',
  spanish: 'Bases de datos',
  swahili: 'Hifadhidata',
  vietnamese: 'Cơ sở dữ liệu',
};
export const alreadyLoggedIn: Translation = {
  amharic: 'አስቀድመው ገብተዋል!',
  arabic: 'أنت مسجل دخولك بالفعل!',
  bengali: 'আপনি ইতিমধ্যে লগইন করেছেন!',
  chinese: '您已登录！',
  english: `You are already logged in!`,
  estonian: `Sa oled juba sisse logitud!`,
  filipino: 'Naka-login ka na!',
  french: `Vous êtes déjà connecté!`,
  german: `Du bist bereits eingeloggt!`,
  hindi: 'आप पहले से लॉग इन हैं!',
  indonesian: 'Anda sudah masuk!',
  japanese: 'すでにログインしています！',
  korean: '이미 로그인되어 있습니다!',
  portuguese: 'Você já está conectado!',
  russian: `Вы уже вошли в систему!`,
  spanish: '¡Ya has iniciado sesión!',
  swahili: 'Tayari umeingia!',
  vietnamese: 'Bạn đã đăng nhập!',
};
export const signUp: Translation = {
  amharic: 'ተመዝገብ',
  arabic: 'سجل',
  bengali: 'সাইন আপ',
  chinese: '注册',
  english: `Sign Up`,
  estonian: `Registreeri`,
  filipino: 'Mag-sign up',
  french: `S'inscrire`,
  german: `Melden Sie sich an`,
  hindi: 'साइन अप',
  indonesian: 'Daftar',
  japanese: 'サインアップ',
  korean: '가입',
  portuguese: 'Inscrever-se',
  russian: `Зарегистрироваться`,
  spanish: 'Registrarse',
  swahili: 'Jisajili',
  vietnamese: 'Đăng ký',
};

export const shiftDepartmentsText: Translation = {
  amharic: 'የሽግግር ክፍሎች',
  arabic: 'أقسام الورديات',
  bengali: 'শিফট বিভাগ',
  chinese: '轮班部门',
  english: 'Shift Departments',
  estonian: 'Niiskuse osad',
  filipino: 'Mga departamento ng shift',
  french: 'Départements de décalage',
  german: 'Schichtabteilungen',
  hindi: 'शिफ्ट विभाग',
  indonesian: 'Departemen shift',
  japanese: 'シフト部門',
  korean: '교대 부서',
  portuguese: 'Departamentos de turnos',
  russian: 'Сменные отделения',
  spanish: 'Departamentos de turnos',
  swahili: 'Idara za zamu',
  vietnamese: 'Phòng ban ca làm',
};
export const bookAppointment: Translation = {
  amharic: 'ቀጠሮ ይይዙ',
  arabic: 'حجز موعد',
  bengali: 'অ্যাপয়েন্টমেন্ট বুক করুন',
  chinese: '预约',
  english: 'Book an appointment',
  estonian: 'Broneeri kokkusobivus',
  filipino: 'Mag-book ng appointment',
  french: 'Réserver un rendez-vous',
  german: 'Termin buchen',
  hindi: 'अपॉइंटमेंट बुक करें',
  indonesian: 'Buat janji temu',
  japanese: '予約する',
  korean: '약속 예약',
  portuguese: 'Agendar um compromisso',
  russian: 'Записаться на прием',
  spanish: 'Reservar una cita',
  swahili: 'Weka miadi',
  vietnamese: 'Đặt lịch hẹn',
};
export const choosePath: Translation = {
  amharic: 'መንገድ ይምረጡ',
  arabic: 'اختر مسارًا',
  bengali: 'একটি পথ বেছে নিন',
  chinese: '选择路径',
  english: 'Choose a path',
  estonian: 'Vali teek',
  filipino: 'Pumili ng landas',
  french: 'Choisir un chemin',
  german: 'Wählen Sie einen Weg',
  hindi: 'एक रास्ता चुनें',
  indonesian: 'Pilih jalur',
  japanese: 'パスを選択',
  korean: '경로 선택',
  portuguese: 'Escolher um caminho',
  russian: 'Выберите путь',
  spanish: 'Elegir un camino',
  swahili: 'Chagua njia',
  vietnamese: 'Chọn một con đường',
};
export const choosePathInfo: Translation = {
  amharic: 'ልዩ የሶፍትዌር ምህንድስና ደረጃ ለማግኘት ማወቅ የሚያስፈልግዎትን ሁሉ የሚሰጥ የተበጀ የመንገድ ካርታ ይከተሉ',
  arabic: 'اتبع خارطة طريق مخصصة توفر لك كل ما تحتاج إلى معرفته لتحقيق مستوى معين من هندسة البرمجيات',
  bengali: 'একটি কাস্টমাইজড রোডম্যাপ অনুসরণ করুন যা সফটওয়্যার ইঞ্জিনিয়ারিংয়ের একটি নির্দিষ্ট স্তর অর্জনের জন্য আপনার যা জানা প্রয়োজন তা সবকিছু সরবরাহ করে',
  chinese: '遵循量身定制的路线图，为您提供达到特定软件工程水平所需了解的一切',
  english: 'Follow a tailored roadmap that provides you all you need to know to attain a specific level of software engineering',
  estonian: 'Jälgi kohandatud teek, mis annab teile kõik, mida te peate teadma, et saavutada konkreetse tarkvara inseneri taseme',
  filipino: 'Sundin ang isang customized na roadmap na nagbibigay sa iyo ng lahat ng kailangan mong malaman upang makamit ang isang tiyak na antas ng software engineering',
  french: 'Suivez un chemin personnalisé qui vous fournit tout ce que vous devez savoir pour atteindre un certain niveau de génie logiciel',
  german: 'Folgen Sie einem angepassten Weg, der Ihnen alles liefert, was Sie wissen müssen, um ein bestimmtes Niveau von Software-Ingenieurwesen zu erreichen',
  hindi: 'एक अनुरूप रोडमैप का पालन करें जो आपको सॉफ्टवेयर इंजीनियरिंग के एक विशिष्ट स्तर को प्राप्त करने के लिए जानने की आवश्यकता वाली हर चीज प्रदान करता है',
  indonesian: 'Ikuti peta jalan yang disesuaikan yang memberi Anda semua yang perlu Anda ketahui untuk mencapai tingkat tertentu dalam rekayasa perangkat lunak',
  japanese: 'ソフトウェアエンジニアリングの特定のレベルを達成するために知っておく必要があるすべてを提供する、カスタマイズされたロードマップに従ってください',
  korean: '소프트웨어 엔지니어링의 특정 수준을 달성하기 위해 알아야 할 모든 것을 제공하는 맞춤형 로드맵을 따르세요',
  portuguese: 'Siga um roteiro personalizado que fornece tudo o que você precisa saber para atingir um nível específico de engenharia de software',
  russian: 'Следуйте индивидуальному пути, который предоставляет вам все, что вам нужно знать, чтобы достичь определенного уровня программирования',
  spanish: 'Sigue una hoja de ruta personalizada que te proporciona todo lo que necesitas saber para alcanzar un nivel específico de ingeniería de software',
  swahili: 'Fuata ramani iliyobinafsishwa inayokupa kila kitu unachohitaji kujua ili kufikia kiwango maalum cha uhandisi wa programu',
  vietnamese: 'Theo dõi lộ trình được tùy chỉnh cung cấp cho bạn tất cả những gì bạn cần biết để đạt được một mức độ cụ thể của kỹ thuật phần mềm',
};
export const chooseYourLearningPath: Translation = {
  amharic: 'የመማሪያ ጎዳናዎን ይምረጡ',
  arabic: 'اختر مسار التعلم الخاص بك',
  bengali: 'আপনার শেখার পথ বেছে নিন',
  chinese: '选择您的学习路径',
  english: 'Choose Your Learning Path',
  estonian: 'Valige oma õpitee',
  filipino: 'Piliin ang Iyong Landas sa Pag-aaral',
  french: "Choisissez votre parcours d'apprentissage",
  german: 'Wählen Sie Ihren Lernpfad',
  hindi: 'अपना सीखने का मार्ग चुनें',
  indonesian: 'Pilih Jalur Pembelajaran Anda',
  japanese: '学習パスを選択してください',
  korean: '학습 경로를 선택하세요',
  portuguese: 'Escolha Seu Caminho de Aprendizado',
  russian: 'Выберите свой путь обучения',
  spanish: 'Elige tu ruta de aprendizaje',
  swahili: 'Chagua Njia Yako ya Kujifunza',
  vietnamese: 'Chọn Lộ Trình Học Tập Của Bạn',
};
export const chooseYourLearningPathDescription: Translation = {
  amharic: 'ሰፊ ስርዓተ ትምህርታችንን ያስሱ እና ለሶፍትዌር ልማት ጉዞዎ ፍጹም ጎዳና ያግኙ።',
  arabic: 'استكشف مناهجنا الشاملة وابحث عن المسار المثالي لرحلتك في تطوير البرمجيات.',
  bengali: 'আমাদের ব্যাপক পাঠ্যক্রম অন্বেষণ করুন এবং আপনার সফটওয়্যার ডেভেলপমেন্ট যাত্রার জন্য নিখুঁত পথ খুঁজুন।',
  chinese: '探索我们全面的课程，找到适合您软件开发之旅的完美路径。',
  english: 'Explore our comprehensive curriculum and find the perfect path for your software development journey.',
  estonian: 'Tutvuge meie põhjaliku õppekavaga ja leidke oma tarkvaraarenduse teekonnale ideaalne rada.',
  filipino: 'Galugarin ang aming komprehensibong kurikulum at hanapin ang perpektong landas para sa iyong paglalakbay sa software development.',
  french: 'Explorez notre programme complet et trouvez le parcours idéal pour votre parcours de développement logiciel.',
  german: 'Erkunden Sie unseren umfassenden Lehrplan und finden Sie den perfekten Weg für Ihre Softwareentwicklungsreise.',
  hindi: 'हमारे व्यापक पाठ्यक्रम का अन्वेषण करें और अपनी सॉफ्टवेयर डेवलपमेंट यात्रा के लिए सही मार्ग खोजें।',
  indonesian: 'Jelajahi kurikulum komprehensif kami dan temukan jalur sempurna untuk perjalanan pengembangan perangkat lunak Anda.',
  japanese: '包括的なカリキュラムを探索し、ソフトウェア開発の旅に最適なパスを見つけてください。',
  korean: '포괄적인 커리큘럼을 탐색하고 소프트웨어 개발 여정에 완벽한 경로를 찾으세요.',
  portuguese: 'Explore nosso currículo abrangente e encontre o caminho perfeito para sua jornada de desenvolvimento de software.',
  russian: 'Изучите нашу обширную программу и найдите идеальный путь для вашего пути разработки программного обеспечения.',
  spanish: 'Explora nuestro plan de estudios integral y encuentra el camino perfecto para tu viaje de desarrollo de software.',
  swahili: 'Chunguza mtaala wetu kamili na upate njia bora kwa safari yako ya uendelezaji wa programu.',
  vietnamese: 'Khám phá chương trình giảng dạy toàn diện của chúng tôi và tìm con đường hoàn hảo cho hành trình phát triển phần mềm của bạn.',
};
export const learningPathsDiagram: Translation = {
  amharic: 'የትምህርት መንገዶች ሥዕላዊ መግለጫ',
  arabic: 'مخطط مسارات التعلم',
  bengali: 'শেখার পথের ডায়াগ্রাম',
  chinese: '学习路径图',
  english: 'Learning paths diagram',
  estonian: 'Õpiteede diagramm',
  filipino: 'Diagram ng mga learning path',
  french: "Diagramme des parcours d'apprentissage",
  german: 'Diagramm der Lernpfade',
  hindi: 'शिक्षण पथ आरेख',
  indonesian: 'Diagram jalur pembelajaran',
  japanese: '学習パスの図',
  korean: '학습 경로 다이어그램',
  portuguese: 'Diagrama de caminhos de aprendizado',
  russian: 'Диаграмма учебных маршрутов',
  spanish: 'Diagrama de rutas de aprendizaje',
  swahili: 'Mchoro wa njia za kujifunza',
  vietnamese: 'Sơ đồ lộ trình học tập',
};
export const recommendedForBeginners: Translation = {
  amharic: 'ለጀማሪዎች የሚመከር',
  arabic: 'موصى به للمبتدئين',
  bengali: 'নতুনদের জন্য প্রস্তাবিত',
  chinese: '推荐给初学者',
  english: 'Recommended for beginners',
  estonian: 'Soovitatav alustajatele',
  filipino: 'Inirerekumenda para sa mga nagsisimula',
  french: 'Recommandé pour les débutants',
  german: 'Empfohlen für Anfänger',
  hindi: 'शुरुआती लोगों के लिए अनुशंसित',
  indonesian: 'Direkomendasikan untuk pemula',
  japanese: '初心者におすすめ',
  korean: '초보자에게 권장',
  portuguese: 'Recomendado para iniciantes',
  russian: 'Рекомендуется для начинающих',
  spanish: 'Recomendado para principiantes',
  swahili: 'Inashauriwa kwa wanaoanza',
  vietnamese: 'Khuyến nghị cho người mới bắt đầu',
};

export const invalidCredits: Translation = {
  amharic: 'ልክ ያልሆነ ክሬዲቶች',
  arabic: 'أرصدة غير صالحة',
  bengali: 'অবৈধ ক্রেডিট',
  chinese: '无效积分',
  english: 'Invalid credits',
  estonian: 'Vigased krediidid',
  filipino: 'Di-wastong mga credit',
  french: 'Crédits invalides',
  german: 'Ungültige Kredite',
  hindi: 'अवैध क्रेडिट',
  indonesian: 'Kredit tidak valid',
  japanese: '無効なクレジット',
  korean: '유효하지 않은 크레딧',
  portuguese: 'Créditos inválidos',
  russian: 'Неверные кредиты',
  spanish: 'Créditos inválidos',
  swahili: 'Mikopo batili',
  vietnamese: 'Tín dụng không hợp lệ',
};
export const invalidPhone: Translation = {
  amharic: 'ልክ ያልሆነ ስልክ ቁጥር',
  arabic: 'رقم هاتف غير صالح',
  bengali: 'অবৈধ ফোন নম্বর',
  chinese: '无效电话号码',
  english: 'Invalid phone number',
  estonian: 'Vigane telefoninumber',
  filipino: 'Di-wastong numero ng telepono',
  french: 'Numéro de téléphone invalide',
  german: 'Ungültige Telefonnummer',
  hindi: 'अवैध फोन नंबर',
  indonesian: 'Nomor telepon tidak valid',
  japanese: '無効な電話番号',
  korean: '유효하지 않은 전화번호',
  portuguese: 'Número de telefone inválido',
  russian: 'Неверный номер телефона',
  spanish: 'Número de teléfono inválido',
  swahili: 'Nambari ya simu batili',
  vietnamese: 'Số điện thoại không hợp lệ',
};
export const momoNumber: Translation = {
  amharic: 'የMoMo ቁጥር',
  arabic: 'رقم MoMo',
  bengali: 'MoMo নম্বর',
  chinese: 'MoMo号码',
  english: 'MoMo number',
  estonian: 'MoMo number',
  filipino: 'Numero ng MoMo',
  french: 'Numéro MoMo',
  german: 'MoMo-Nummer',
  hindi: 'MoMo नंबर',
  indonesian: 'Nomor MoMo',
  japanese: 'MoMo番号',
  korean: 'MoMo 번호',
  portuguese: 'Número MoMo',
  russian: 'Номер MoMo',
  spanish: 'Número MoMo',
  swahili: 'Nambari ya MoMo',
  vietnamese: 'Số MoMo',
};

export const openInNewTabText: Translation = {
  amharic: 'በአዲስ ትር ውስጥ ክፈት',
  arabic: 'فتح في علامة تبويب جديدة',
  bengali: 'নতুন ট্যাবে খুলুন',
  chinese: '在新标签页中打开',
  english: 'Open in New Tab',
  estonian: 'Ava uues aknas',
  filipino: 'Buksan sa bagong tab',
  french: 'Ouvrir dans un nouvel onglet',
  german: 'In ein neues Fenster öffnen',
  hindi: 'नए टैब में खोलें',
  indonesian: 'Buka di tab baru',
  japanese: '新しいタブで開く',
  korean: '새 탭에서 열기',
  portuguese: 'Abrir em nova aba',
  russian: 'Открыть в новой вкладке',
  spanish: 'Abrir en nueva pestaña',
  swahili: 'Fungua katika kichupo kipya',
  vietnamese: 'Mở trong tab mới',
};
export const printDetailsText: Translation = {
  amharic: 'ዝርዝሮች አትም',
  arabic: 'طباعة التفاصيل',
  bengali: 'বিস্তারিত প্রিন্ট করুন',
  chinese: '打印详细信息',
  english: 'Print Details',
  estonian: 'Prindi üksikasjad',
  filipino: 'I-print ang mga detalye',
  french: 'Afficher les détails',
  german: 'Details drucken',
  hindi: 'विवरण प्रिंट करें',
  indonesian: 'Cetak detail',
  japanese: '詳細を印刷',
  korean: '세부정보 인쇄',
  portuguese: 'Imprimir detalhes',
  russian: 'Печать деталей',
  spanish: 'Imprimir detalles',
  swahili: 'Chapisha maelezo',
  vietnamese: 'In chi tiết',
};
export const deletePermanentlyText: Translation = {
  amharic: 'ለዘለአለም ሰርዝ',
  arabic: 'حذف نهائيًا',
  bengali: 'স্থায়ীভাবে মুছুন',
  chinese: '永久删除',
  english: 'Delete Permanently',
  estonian: 'Kustuta püsivalt',
  filipino: 'Permanenteng tanggalin',
  french: 'Supprimer définitivement',
  german: 'Dauerhaft löschen',
  hindi: 'स्थायी रूप से हटाएं',
  indonesian: 'Hapus permanen',
  japanese: '完全に削除',
  korean: '영구 삭제',
  portuguese: 'Excluir permanentemente',
  russian: 'Удалить навсегда',
  spanish: 'Eliminar permanentemente',
  swahili: 'Futa kabisa',
  vietnamese: 'Xóa vĩnh viễn',
};
export const moreActions: Translation = {
  amharic: 'ተጨማሪ ተግባራት',
  arabic: 'المزيد من الإجراءات',
  bengali: 'আরও কাজ',
  chinese: '更多操作',
  english: 'More Actions',
  estonian: 'Rohkem tegevusi',
  filipino: 'Higit pang mga aksyon',
  french: "Plus d'actions",
  german: 'Mehr Aktionen',
  hindi: 'अधिक क्रियाएं',
  indonesian: 'Tindakan lainnya',
  japanese: 'その他のアクション',
  korean: '더 많은 작업',
  portuguese: 'Mais ações',
  russian: 'Больше действий',
  spanish: 'Más acciones',
  swahili: 'Vitendo zaidi',
  vietnamese: 'Thêm hành động',
};
export const yourProfileText: Translation = {
  amharic: 'የእርስዎ መገለጫ',
  arabic: 'ملفك الشخصي',
  bengali: 'আপনার প্রোফাইল',
  chinese: '您的个人资料',
  english: 'Your profile',
  estonian: 'Sinu profiil',
  filipino: 'Iyong profile',
  french: 'Votre profil',
  german: 'Ihr Profil',
  hindi: 'आपकी प्रोफ़ाइल',
  indonesian: 'Profil Anda',
  japanese: 'あなたのプロフィール',
  korean: '귀하의 프로필',
  portuguese: 'Seu perfil',
  russian: 'Ваш профиль',
  spanish: 'Tu perfil',
  swahili: 'Wasifu wako',
  vietnamese: 'Hồ sơ của bạn',
};

export const documents: Translation = {
  amharic: 'ሰነዶች',
  arabic: 'الوثائق',
  bengali: 'নথি',
  chinese: '文档',
  english: 'Documents',
  estonian: 'Dokumendid',
  filipino: 'Mga dokumento',
  french: 'Documents',
  german: 'Dokumente',
  hindi: 'दस्तावेज़',
  indonesian: 'Dokumen',
  japanese: 'ドキュメント',
  korean: '문서',
  portuguese: 'Documentos',
  russian: 'Документы',
  spanish: 'Documentos',
  swahili: 'Hati',
  vietnamese: 'Tài liệu',
};
export const requests: Translation = {
  amharic: 'ጥያቄዎች',
  arabic: 'الطلبات',
  bengali: 'অনুরোধ',
  chinese: '请求',
  english: 'Requests',
  estonian: 'Taotlused',
  filipino: 'Mga kahilingan',
  french: 'Demandes',
  german: 'Anfragen',
  hindi: 'अनुरोध',
  indonesian: 'Permintaan',
  japanese: 'リクエスト',
  korean: '요청',
  portuguese: 'Solicitações',
  russian: 'Запросы',
  spanish: 'Solicitudes',
  swahili: 'Maombi',
  vietnamese: 'Yêu cầu',
};
export const services: Translation = {
  amharic: 'አገልግሎቶች',
  arabic: 'الخدمات',
  bengali: 'সেবা',
  chinese: '服务',
  english: 'Services',
  estonian: 'Teenused',
  filipino: 'Mga serbisyo',
  french: 'Services',
  german: 'Dienstleistungen',
  hindi: 'सेवाएं',
  indonesian: 'Layanan',
  japanese: 'サービス',
  korean: '서비스',
  portuguese: 'Serviços',
  russian: 'Услуги',
  spanish: 'Servicios',
  swahili: 'Huduma',
  vietnamese: 'Dịch vụ',
};
export const jobs: Translation = {
  amharic: 'ስራዎች',
  arabic: 'الوظائف',
  bengali: 'চাকরি',
  chinese: '职位',
  english: 'Jobs',
  estonian: 'Tööd',
  filipino: 'Mga trabaho',
  french: 'Emplois',
  german: 'Jobs',
  hindi: 'नौकरियाँ',
  indonesian: 'Pekerjaan',
  japanese: '仕事',
  korean: '일자리',
  portuguese: 'Empregos',
  russian: 'Вакансии',
  spanish: 'Trabajos',
  swahili: 'Kazi',
  vietnamese: 'Công việc',
};
export const addService: Translation = {
  amharic: 'አገልግሎት አክል',
  arabic: 'إضافة خدمة',
  bengali: 'সেবা যোগ করুন',
  chinese: '添加服务',
  english: 'Add Service',
  estonian: 'Lisa teenus',
  filipino: 'Idagdag ang serbisyo',
  french: 'Ajouter un service',
  german: 'Dienst hinzufügen',
  hindi: 'सेवा जोड़ें',
  indonesian: 'Tambah layanan',
  japanese: 'サービスを追加',
  korean: '서비스 추가',
  portuguese: 'Adicionar serviço',
  russian: 'Добавить услугу',
  spanish: 'Agregar servicio',
  swahili: 'Ongeza huduma',
  vietnamese: 'Thêm dịch vụ',
};
export const options: Translation = {
  amharic: 'አማራጮች',
  arabic: 'الخيارات',
  bengali: 'অপশন',
  chinese: '选项',
  english: 'Options',
  estonian: 'Valikud',
  filipino: 'Mga opsyon',
  french: 'Options',
  german: 'Optionen',
  hindi: 'विकल्प',
  indonesian: 'Opsi',
  japanese: 'オプション',
  korean: '옵션',
  portuguese: 'Opções',
  russian: 'Опции',
  spanish: 'Opciones',
  swahili: 'Chaguo',
  vietnamese: 'Tùy chọn',
};
export const requirements: Translation = {
  amharic: 'መስፈርቶች',
  arabic: 'المتطلبات',
  bengali: 'প্রয়োজনীয়তা',
  chinese: '要求',
  english: 'Requirements',
  estonian: 'Nõuded',
  filipino: 'Mga kinakailangan',
  french: 'Conditions',
  german: 'Anforderungen',
  hindi: 'आवश्यकताएं',
  indonesian: 'Persyaratan',
  japanese: '要件',
  korean: '요구사항',
  portuguese: 'Requisitos',
  russian: 'Требования',
  spanish: 'Requisitos',
  swahili: 'Mahitaji',
  vietnamese: 'Yêu cầu',
};
export const paymentsT: Translation = {
  amharic: 'ክፍያዎች',
  arabic: 'المدفوعات',
  bengali: 'পেমেন্ট',
  chinese: '付款',
  english: 'Payments',
  estonian: 'Makseviisid',
  filipino: 'Mga pagbabayad',
  french: 'Paiements',
  german: 'Zahlungen',
  hindi: 'भुगतान',
  indonesian: 'Pembayaran',
  japanese: '支払い',
  korean: '결제',
  portuguese: 'Pagamentos',
  russian: 'Платежи',
  spanish: 'Pagos',
  swahili: 'Malipo',
  vietnamese: 'Thanh toán',
};
export const reviews: Translation = {
  amharic: 'ግምገማዎች',
  arabic: 'المراجعات',
  bengali: 'পর্যালোচনা',
  chinese: '评论',
  english: 'Reviews',
  estonian: 'Hinnangud',
  filipino: 'Mga review',
  french: 'Avis',
  german: 'Bewertungen',
  hindi: 'समीक्षा',
  indonesian: 'Ulasan',
  japanese: 'レビュー',
  korean: '리뷰',
  portuguese: 'Avaliações',
  russian: 'Отзывы',
  spanish: 'Reseñas',
  swahili: 'Mapitio',
  vietnamese: 'Đánh giá',
};

export const english: Translation = {
  amharic: 'እንግሊዝኛ',
  arabic: 'الإنجليزية',
  bengali: 'ইংরেজি',
  chinese: '英语',
  english: 'English',
  estonian: 'Inglise keel',
  filipino: 'Ingles',
  french: 'Anglais',
  german: 'Englisch',
  hindi: 'अंग्रेज़ी',
  indonesian: 'Inggris',
  japanese: '英語',
  korean: '영어',
  portuguese: 'Inglês',
  russian: 'Английский',
  spanish: 'Inglés',
  swahili: 'Kiingereza',
  vietnamese: 'Tiếng Anh',
};
export const french: Translation = {
  amharic: 'ፈረንሳይኛ',
  arabic: 'الفرنسية',
  bengali: 'ফরাসি',
  chinese: '法语',
  english: 'French',
  estonian: 'Prantsuse keel',
  filipino: 'Pranses',
  french: 'Français',
  german: 'Französisch',
  hindi: 'फ़्रेंच',
  indonesian: 'Prancis',
  japanese: 'フランス語',
  korean: '프랑스어',
  portuguese: 'Francês',
  russian: 'Французский',
  spanish: 'Francés',
  swahili: 'Kifaransa',
  vietnamese: 'Tiếng Pháp',
};
export const german: Translation = {
  amharic: 'ጀርመንኛ',
  arabic: 'الألمانية',
  bengali: 'জার্মান',
  chinese: '德语',
  english: 'German',
  estonian: 'Saksa keel',
  filipino: 'Aleman',
  french: 'Allemand',
  german: 'Deutsch',
  hindi: 'जर्मन',
  indonesian: 'Jerman',
  japanese: 'ドイツ語',
  korean: '독일어',
  portuguese: 'Alemão',
  russian: 'Немецкий',
  spanish: 'Alemán',
  swahili: 'Kijerumani',
  vietnamese: 'Tiếng Đức',
};
export const russian: Translation = {
  amharic: 'ሩስያኛ',
  arabic: 'الروسية',
  bengali: 'রাশিয়ান',
  chinese: '俄语',
  english: 'Russian',
  estonian: 'Vene keel',
  filipino: 'Ruso',
  french: 'Russe',
  german: 'Russisch',
  hindi: 'रूसी',
  indonesian: 'Rusia',
  japanese: 'ロシア語',
  korean: '러시아어',
  portuguese: 'Russo',
  russian: 'Русский',
  spanish: 'Ruso',
  swahili: 'Kirusi',
  vietnamese: 'Tiếng Nga',
};
export const estonian: Translation = {
  amharic: 'ኢስቶኒያን',
  arabic: 'الإستونية',
  bengali: 'এস্তোনিয়ান',
  chinese: '爱沙尼亚语',
  english: 'Estonian',
  estonian: 'Eesti keel',
  filipino: 'Estonian',
  french: 'Estonien',
  german: 'Estnisch',
  hindi: 'एस्टोनियाई',
  indonesian: 'Estonia',
  japanese: 'エストニア語',
  korean: '에스토니아어',
  portuguese: 'Estoniano',
  russian: 'Эстонский',
  spanish: 'Estonio',
  swahili: 'Kiestonia',
  vietnamese: 'Tiếng Estonia',
};

export const shouldResetPasswordText: Translation = {
  amharic: 'የይለፍ ቃል ዳግም ማስጀመር አለበት',
  arabic: 'يجب إعادة تعيين كلمة المرور',
  bengali: 'পাসওয়ার্ড রিসেট করা উচিত',
  chinese: '应重置密码',
  english: 'Should Reset Password',
  estonian: 'Peab parooli lähtestama',
  filipino: 'Dapat i-reset ang password',
  french: 'Doit réinitialiser le mot de passe',
  german: 'Muss das Passwort zurücksetzen',
  hindi: 'पासवर्ड रीसेट करना चाहिए',
  indonesian: 'Harus reset kata sandi',
  japanese: 'パスワードをリセットする必要があります',
  korean: '비밀번호를 재설정해야 합니다',
  portuguese: 'Deve redefinir senha',
  russian: 'Должен сбросить пароль',
  spanish: 'Debe restablecer contraseña',
  swahili: 'Inapaswa kuweka upya nenosiri',
  vietnamese: 'Nên đặt lại mật khẩu',
};
export const markedForDeletionText: Translation = {
  amharic: 'ለመሰረዝ ምልክት ተደርጎበታል',
  arabic: 'موضوع علامة للحذف',
  bengali: 'মুছে ফেলার জন্য চিহ্নিত',
  chinese: '已标记删除',
  english: 'Marked for Deletion',
  estonian: 'Märgitud kustutamiseks',
  filipino: 'Minarkahan para sa pagtanggal',
  french: 'Marqué pour la suppression',
  german: 'Markiert für Löschung',
  hindi: 'हटाने के लिए चिह्नित',
  indonesian: 'Ditandai untuk dihapus',
  japanese: '削除のマーク済み',
  korean: '삭제 표시됨',
  portuguese: 'Marcado para exclusão',
  russian: 'Отмечен для удаления',
  spanish: 'Marcado para eliminación',
  swahili: 'Imewekwa alama kwa kufutwa',
  vietnamese: 'Đánh dấu để xóa',
};
export const startedOnText: Translation = {
  amharic: 'የተጀመረበት',
  arabic: 'بدأ في',
  bengali: 'শুরু হয়েছে',
  chinese: '开始于',
  english: 'Started On',
  estonian: 'Alustati',
  filipino: 'Nasimulan noong',
  french: 'Commencé le',
  german: 'Startete am',
  hindi: 'शुरू किया गया',
  indonesian: 'Dimulai pada',
  japanese: '開始日',
  korean: '시작일',
  portuguese: 'Iniciado em',
  russian: 'Начало',
  spanish: 'Iniciado el',
  swahili: 'Ilianza',
  vietnamese: 'Bắt đầu vào',
};
export const requestedText: Translation = {
  amharic: 'ተጠይቋል',
  arabic: 'مطلوب',
  bengali: 'অনুরোধ করা হয়েছে',
  chinese: '已请求',
  english: 'Requested',
  estonian: 'Taotletud',
  filipino: 'Hiniling',
  french: 'Demandé',
  german: 'Angefordert',
  hindi: 'अनुरोधित',
  indonesian: 'Diminta',
  japanese: 'リクエスト済み',
  korean: '요청됨',
  portuguese: 'Solicitado',
  russian: 'Запрошено',
  spanish: 'Solicitado',
  swahili: 'Imeombwa',
  vietnamese: 'Đã yêu cầu',
};
export const providedText: Translation = {
  amharic: 'ቀርቧል',
  arabic: 'مقدم',
  bengali: 'প্রদত্ত',
  chinese: '已提供',
  english: 'Provided',
  estonian: 'Pakutud',
  filipino: 'Ibinigay',
  french: 'Fourni',
  german: 'Bereitgestellt',
  hindi: 'प्रदान किया गया',
  indonesian: 'Disediakan',
  japanese: '提供済み',
  korean: '제공됨',
  portuguese: 'Fornecido',
  russian: 'Предоставлено',
  spanish: 'Proporcionado',
  swahili: 'Imetolewa',
  vietnamese: 'Đã cung cấp',
};
export const cityText: Translation = {
  amharic: 'ከተማ',
  arabic: 'المدينة',
  bengali: 'শহর',
  chinese: '城市',
  english: 'City',
  estonian: 'Linna',
  filipino: 'Lungsod',
  french: 'Ville',
  german: 'Stadt',
  hindi: 'शहर',
  indonesian: 'Kota',
  japanese: '都市',
  korean: '도시',
  portuguese: 'Cidade',
  russian: 'Город',
  spanish: 'Ciudad',
  swahili: 'Mji',
  vietnamese: 'Thành phố',
};
export const postalCodeText: Translation = {
  amharic: 'የፖስታ ኮድ',
  arabic: 'الرمز البريدي',
  bengali: 'পোস্টাল কোড',
  chinese: '邮政编码',
  english: 'Postal Code',
  estonian: 'Postiindeks',
  filipino: 'Postal code',
  french: 'Code postal',
  german: 'Postleitzahl',
  hindi: 'पिन कोड',
  indonesian: 'Kode pos',
  japanese: '郵便番号',
  korean: '우편번호',
  portuguese: 'Código postal',
  russian: 'Почтовый индекс',
  spanish: 'Código postal',
  swahili: 'Nambari ya posta',
  vietnamese: 'Mã bưu điện',
};
export const duplicateChoice: Translation = {
  amharic: 'የተባዛ ምርጫ',
  arabic: 'اختيار مكرر',
  bengali: 'সদৃশ পছন্দ',
  chinese: '重复选择',
  english: 'Duplicate choice',
  estonian: 'Kordne valik',
  filipino: 'Duplikadong pagpili',
  french: 'Choix dupliqué',
  german: 'Duplikativer Wahl',
  hindi: 'डुप्लिकेट विकल्प',
  indonesian: 'Pilihan duplikat',
  japanese: '重複選択',
  korean: '중복 선택',
  portuguese: 'Escolha duplicada',
  russian: 'Дубликатный выбор',
  spanish: 'Opción duplicada',
  swahili: 'Chaguo la kujirudia',
  vietnamese: 'Lựa chọn trùng lặp',
};
export const country: Translation = {
  amharic: 'አገር',
  arabic: 'البلد',
  bengali: 'দেশ',
  chinese: '国家',
  english: 'Country',
  estonian: 'Riik',
  filipino: 'Bansa',
  french: 'Pays',
  german: 'Land',
  hindi: 'देश',
  indonesian: 'Negara',
  japanese: '国',
  korean: '국가',
  portuguese: 'País',
  russian: 'Страна',
  spanish: 'País',
  swahili: 'Nchi',
  vietnamese: 'Quốc gia',
};

export const cancelText: Translation = cancel;
export const continueText: Translation = {
  amharic: 'ቀጥል',
  arabic: 'متابعة',
  bengali: 'চালিয়ে যান',
  chinese: '继续',
  english: 'Continue',
  estonian: 'Jätkata',
  filipino: 'Magpatuloy',
  french: 'Continuer',
  german: 'Fortfahren',
  hindi: 'जारी रखें',
  indonesian: 'Lanjutkan',
  japanese: '続ける',
  korean: '계속',
  portuguese: 'Continuar',
  russian: 'Продолжить',
  spanish: 'Continuar',
  swahili: 'Endelea',
  vietnamese: 'Tiếp tục',
};
export const markedForDeletionOnText: Translation = {
  amharic: 'ለመሰረዝ ምልክት ተደርጓል',
  arabic: 'موضوع علامة للحذف في',
  bengali: 'মুছে ফেলার জন্য চিহ্নিত',
  chinese: '标记删除于',
  english: 'Marked for Deletion On',
  estonian: 'Märgitud kustutamiseks',
  filipino: 'Minarkahan para sa pagtanggal noong',
  french: 'Marqué pour la suppression le',
  german: 'Markiert für Löschung am',
  hindi: 'हटाने के लिए चिह्नित',
  indonesian: 'Ditandai untuk dihapus pada',
  japanese: '削除のマーク日',
  korean: '삭제 표시됨',
  portuguese: 'Marcado para exclusão em',
  russian: 'Отмечен для удаления',
  spanish: 'Marcado para eliminación el',
  swahili: 'Imewekwa alama kwa kufutwa',
  vietnamese: 'Đánh dấu để xóa vào',
};
export const currencyT: Translation = {
  amharic: 'ምንዛሬ',
  arabic: 'العملة',
  bengali: 'মুদ্রা',
  chinese: '货币',
  english: 'Currency',
  estonian: 'Valuuta',
  filipino: 'Pera',
  french: 'Monnaie',
  german: 'Währung',
  hindi: 'मुद्रा',
  indonesian: 'Mata uang',
  japanese: '通貨',
  korean: '통화',
  portuguese: 'Moeda',
  russian: 'Валюта',
  spanish: 'Moneda',
  swahili: 'Sarafu',
  vietnamese: 'Tiền tệ',
};

export const clickToUpdate: Translation = {
  amharic: 'ለማዘመን ጠቅ ያድርጉ',
  arabic: 'انقر للتحديث',
  bengali: 'আপডেট করতে ক্লিক করুন',
  chinese: '点击更新',
  english: 'Click to update',
  estonian: 'Klõpsake, et uuendada',
  filipino: 'I-click para i-update',
  french: 'Cliquer pour mettre à jour',
  german: 'Klicken, um zu aktualisieren',
  hindi: 'अपडेट करने के लिए क्लिक करें',
  indonesian: 'Klik untuk memperbarui',
  japanese: '更新するにはクリック',
  korean: '업데이트하려면 클릭',
  portuguese: 'Clique para atualizar',
  russian: 'Нажмите, чтобы обновить',
  spanish: 'Haga clic para actualizar',
  swahili: 'Bonyeza ili kusasisha',
  vietnamese: 'Nhấp để cập nhật',
};
export const profilePictureText: Translation = {
  amharic: 'የመገለጫ ምስል',
  arabic: 'صورة الملف الشخصي',
  bengali: 'প্রোফাইল ছবি',
  chinese: '个人资料图片',
  english: 'Profile picture',
  estonian: 'Profiilpilt',
  filipino: 'Profile picture',
  french: 'Photo de profil',
  german: 'Profilbild',
  hindi: 'प्रोफ़ाइल चित्र',
  indonesian: 'Foto profil',
  japanese: 'プロフィール写真',
  korean: '프로필 사진',
  portuguese: 'Foto de perfil',
  russian: 'Фотография профиля',
  spanish: 'Foto de perfil',
  swahili: 'Picha ya wasifu',
  vietnamese: 'Ảnh hồ sơ',
};
export const confirmToDeleteUser: Translation = {
  amharic: 'ተጠቃሚውን ለዘለአለም መሰረዝ እርግጠኛ ነዎት',
  arabic: 'هل أنت متأكد من أنك تريد حذف المستخدم بشكل دائم',
  bengali: 'আপনি কি নিশ্চিত যে আপনি ব্যবহারকারীকে স্থায়ীভাবে মুছতে চান',
  chinese: '您确定要永久删除用户吗',
  english: 'Are you sure you want to permanently delete user',
  estonian: 'Kas olete kindel, et soovite kustutada kasutajat püsivalt',
  filipino: 'Sigurado ka ba na gusto mong permanenteng tanggalin ang user',
  french: "Êtes-vous sûr de vouloir supprimer définitivement l'utilisateur",
  german: 'Sind Sie sicher, dass Sie den Benutzer dauerhaft löschen möchten',
  hindi: 'क्या आप सुनिश्चित हैं कि आप उपयोगकर्ता को स्थायी रूप से हटाना चाहते हैं',
  indonesian: 'Apakah Anda yakin ingin menghapus pengguna secara permanen',
  japanese: 'ユーザーを完全に削除してもよろしいですか',
  korean: '사용자를 영구적으로 삭제하시겠습니까?',
  portuguese: 'Tem certeza de que deseja excluir permanentemente o usuário?',
  russian: 'Вы уверены, что хотите навсегда удалить пользователя',
  spanish: '¿Está seguro de que desea eliminar permanentemente al usuario?',
  swahili: 'Una uhakika unataka kufuta mtumiaji kabisa',
  vietnamese: 'Bạn có chắc chắn muốn xóa vĩnh viễn người dùng',
};
export const enterConfirmToDelete: Translation = {
  amharic: `ለመሰረዝ 'አረጋግጥ' የሚለውን ቃል ያስገቡ`,
  arabic: `أدخل كلمة 'تأكيد' للحذف`,
  bengali: `মুছে ফেলতে 'নিশ্চিত করুন' শব্দটি লিখুন`,
  chinese: `输入单词'确认'以删除`,
  english: `Enter the word 'confirm' to delete`,
  estonian: `Sisesta sõna 'kinnita' kustutamiseks`,
  filipino: `Ilagay ang salitang 'kumpirmahin' upang tanggalin`,
  french: `Entrez le mot 'confirmer' pour supprimer`,
  german: `Geben Sie das Wort 'bestätigen' ein, um zu löschen`,
  hindi: `हटाने के लिए शब्द 'पुष्टि करें' दर्ज करें`,
  indonesian: `Masukkan kata 'konfirmasi' untuk menghapus`,
  japanese: `削除するには'確認'と入力してください`,
  korean: `삭제하려면 '확인'을 입력하세요`,
  portuguese: `Digite a palavra 'confirmar' para excluir`,
  russian: `Введите слово 'подтвердить' для удаления`,
  spanish: `Ingrese la palabra 'confirmar' para eliminar`,
  swahili: `Weka neno 'thibitisha' kufuta`,
  vietnamese: `Nhập từ 'xác nhận' để xóa`,
};
export const confirmToRestoreUser: Translation = {
  amharic: 'ተጠቃሚውን መመለስ እርግጠኛ ነዎት',
  arabic: 'هل أنت متأكد من أنك تريد استعادة المستخدم',
  bengali: 'আপনি কি নিশ্চিত যে আপনি ব্যবহারকারীকে পুনরুদ্ধার করতে চান',
  chinese: '您确定要恢复用户吗',
  english: 'Are you sure you want to restore user',
  estonian: 'Kas olete kindel, et soovite kasutajat taastada',
  filipino: 'Sigurado ka ba na gusto mong ibalik ang user',
  french: "Êtes-vous sûr de vouloir restaurer l'utilisateur",
  german: 'Sind Sie sicher, dass Sie den Benutzer wiederherstellen möchten',
  hindi: 'क्या आप सुनिश्चित हैं कि आप उपयोगकर्ता को पुनर्स्थापित करना चाहते हैं',
  indonesian: 'Apakah Anda yakin ingin memulihkan pengguna',
  japanese: 'ユーザーを復元してもよろしいですか',
  korean: '사용자를 복원하시겠습니까?',
  portuguese: 'Tem certeza de que deseja restaurar o usuário?',
  russian: 'Вы уверены, что хотите восстановить пользователя',
  spanish: '¿Está seguro de que desea restaurar al usuario?',
  swahili: 'Una uhakika unataka kurejesha mtumiaji',
  vietnamese: 'Bạn có chắc chắn muốn khôi phục người dùng',
};
export const enterConfirmToRestore: Translation = {
  amharic: `ለመመለስ 'አረጋግጥ' የሚለውን ቃል ያስገቡ`,
  arabic: `أدخل كلمة 'تأكيد' للاستعادة`,
  bengali: `পুনরুদ্ধার করতে 'নিশ্চিত করুন' শব্দটি লিখুন`,
  chinese: `输入单词'确认'以恢复`,
  english: `Enter the word 'confirm' to restore`,
  estonian: `Sisesta sõna 'kinnita' taastamiseks`,
  filipino: `Ilagay ang salitang 'kumpirmahin' upang ibalik`,
  french: `Entrez le mot 'confirmer' pour restaurer`,
  german: `Geben Sie das Wort 'bestätigen' ein, um zu wiederherstellen`,
  hindi: `पुनर्स्थापित करने के लिए शब्द 'पुष्टि करें' दर्ज करें`,
  indonesian: `Masukkan kata 'konfirmasi' untuk memulihkan`,
  japanese: `復元するには'確認'と入力してください`,
  korean: `복원하려면 '확인'을 입력하세요`,
  portuguese: `Digite a palavra 'confirmar' para restaurar`,
  russian: `Введите слово 'подтвердить' для восстановления`,
  spanish: `Ingrese la palabra 'confirmar' para restaurar`,
  swahili: `Weka neno 'thibitisha' kurejesha`,
  vietnamese: `Nhập từ 'xác nhận' để khôi phục`,
};
export const updatePhone: Translation = {
  amharic: 'ስልክ አዘምን',
  arabic: 'تحديث الهاتف',
  bengali: 'ফোন আপডেট করুন',
  chinese: '更新电话',
  english: `Update phone`,
  estonian: `Telefonu uuendada`,
  filipino: 'I-update ang telepono',
  french: `Mettre à jour le téléphone`,
  german: `Telefon aktualisieren`,
  hindi: 'फ़ोन अपडेट करें',
  indonesian: 'Perbarui telepon',
  japanese: '電話を更新',
  korean: '전화 업데이트',
  portuguese: 'Atualizar telefone',
  russian: `Обновить телефон`,
  spanish: 'Actualizar teléfono',
  swahili: 'Sasisha simu',
  vietnamese: 'Cập nhật điện thoại',
};
export const updateUser: Translation = {
  amharic: 'ተጠቃሚ አዘምን',
  arabic: 'تحديث المستخدم',
  bengali: 'ব্যবহারকারী আপডেট করুন',
  chinese: '更新用户',
  english: `Update user`,
  estonian: `Kasutajat uuendada`,
  filipino: 'I-update ang user',
  french: `Mettre à jour l'utilisateur`,
  german: `Benutzer aktualisieren`,
  hindi: 'उपयोगकर्ता अपडेट करें',
  indonesian: 'Perbarui pengguna',
  japanese: 'ユーザーを更新',
  korean: '사용자 업데이트',
  portuguese: 'Atualizar usuário',
  russian: `Обновить пользователя`,
  spanish: 'Actualizar usuario',
  swahili: 'Sasisha mtumiaji',
  vietnamese: 'Cập nhật người dùng',
};
export const restoreT: Translation = {
  amharic: 'መልስ',
  arabic: 'استعادة',
  bengali: 'পুনরুদ্ধার',
  chinese: '恢复',
  english: `Restore`,
  estonian: `Taastada`,
  filipino: 'Ibalik',
  french: `Restaurer`,
  german: `Wiederherstellen`,
  hindi: 'पुनर्स्थापित करें',
  indonesian: 'Pulihkan',
  japanese: '復元',
  korean: '복원',
  portuguese: 'Restaurar',
  russian: `Восстановить`,
  spanish: 'Restaurar',
  swahili: 'Rejesha',
  vietnamese: 'Khôi phục',
};
export const restoreUserT: Translation = {
  amharic: 'ተጠቃሚ መልስ',
  arabic: 'استعادة المستخدم',
  bengali: 'ব্যবহারকারী পুনরুদ্ধার করুন',
  chinese: '恢复用户',
  english: `Restore user`,
  estonian: `Kasutajat taastada`,
  filipino: 'Ibalik ang user',
  french: `Restaurer l'utilisateur`,
  german: `Benutzer wiederherstellen`,
  hindi: 'उपयोगकर्ता को पुनर्स्थापित करें',
  indonesian: 'Pulihkan pengguna',
  japanese: 'ユーザーを復元',
  korean: '사용자 복원',
  portuguese: 'Restaurar usuário',
  russian: `Восстановить пользователя`,
  spanish: 'Restaurar usuario',
  swahili: 'Rejesha mtumiaji',
  vietnamese: 'Khôi phục người dùng',
};
export const successFullyCreatedT: Translation = {
  amharic: 'በስኬት ተፈጠረ!',
  arabic: 'تم الإنشاء بنجاح!',
  bengali: 'সফলভাবে তৈরি হয়েছে!',
  chinese: '创建成功！',
  english: `Successfully created!`,
  estonian: `Edukaselt loodud!`,
  filipino: 'Matagumpay na nilikha!',
  french: `Créé avec succès!`,
  german: `Erfolgreich erstellt!`,
  hindi: 'सफलतापूर्वक बनाया गया!',
  indonesian: 'Berhasil dibuat!',
  japanese: '正常に作成されました！',
  korean: '성공적으로 생성됨!',
  portuguese: 'Criado com sucesso!',
  russian: `Успешно создано!`,
  spanish: '¡Creado exitosamente!',
  swahili: 'Imeundwa kwa mafanikio!',
  vietnamese: 'Đã tạo thành công!',
};
export const successFullyUpdatedT: Translation = {
  amharic: 'በስኬት ተዘምኗል!',
  arabic: 'تم التحديث بنجاح!',
  bengali: 'সফলভাবে আপডেট হয়েছে!',
  chinese: '更新成功！',
  english: `Successfully updated!`,
  estonian: `Edukalt uuendatud!`,
  filipino: 'Matagumpay na na-update!',
  french: `Mise à jour réussie!`,
  german: `Erfolgreich aktualisiert!`,
  hindi: 'सफलतापूर्वक अपडेट किया गया!',
  indonesian: 'Berhasil diperbarui!',
  japanese: '正常に更新されました！',
  korean: '성공적으로 업데이트됨!',
  portuguese: 'Atualizado com sucesso!',
  russian: `Успешно обновлено!`,
  spanish: '¡Actualizado exitosamente!',
  swahili: 'Imesasishwa kwa mafanikio!',
  vietnamese: 'Đã cập nhật thành công!',
};
export const errorFetchingUsersT: Translation = {
  amharic: 'ተጠቃሚዎችን በማግኘት ላይ ስህተት',
  arabic: 'خطأ في جلب المستخدمين',
  bengali: 'ব্যবহারকারী আনতে ত্রুটি',
  chinese: '获取用户时出错',
  english: `Error fetching users`,
  estonian: `Viga kasutajate hankimisel`,
  filipino: 'Error sa pagkuha ng mga user',
  french: `Erreur lors de la récupération des utilisateurs`,
  german: `Fehler beim Abrufen der Benutzer`,
  hindi: 'उपयोगकर्ता प्राप्त करने में त्रुटि',
  indonesian: 'Kesalahan mengambil pengguna',
  japanese: 'ユーザーの取得エラー',
  korean: '사용자를 가져오는 중 오류',
  portuguese: 'Erro ao buscar usuários',
  russian: `Ошибка при получении пользователей`,
  spanish: 'Error al obtener usuarios',
  swahili: 'Hitilafu katika kupata watumiaji',
  vietnamese: 'Lỗi khi tải người dùng',
};
export const errorFetchingHousesT: Translation = {
  amharic: 'ቤቶችን በማግኘት ላይ ስህተት',
  arabic: 'خطأ في جلب المنازل',
  bengali: 'বাড়ি আনতে ত্রুটি',
  chinese: '获取房屋时出错',
  english: `Error fetching houses`,
  estonian: `Viga majade hankimisel`,
  filipino: 'Error sa pagkuha ng mga bahay',
  french: `Erreur lors de la récupération des maisons`,
  german: `Fehler beim Abrufen der Häuser`,
  hindi: 'घर प्राप्त करने में त्रुटि',
  indonesian: 'Kesalahan mengambil rumah',
  japanese: '家の取得エラー',
  korean: '주택을 가져오는 중 오류',
  portuguese: 'Erro ao buscar casas',
  russian: `Ошибка при получении домов`,
  spanish: 'Error al obtener casas',
  swahili: 'Hitilafu katika kupata nyumba',
  vietnamese: 'Lỗi khi tải nhà',
};
export const errorFetchingAuthDataT: Translation = {
  amharic: 'የማረጋገጫ መረጃን በማግኘት ላይ ስህተት',
  arabic: 'خطأ في جلب بيانات المصادقة',
  bengali: 'প্রমাণীকরণ ডেটা আনতে ত্রুটি',
  chinese: '获取认证数据时出错',
  english: `Error fetching auth data`,
  estonian: `Viga autentimisandmete hankimisel`,
  filipino: 'Error sa pagkuha ng auth data',
  french: `Erreur lors de la récupération des données d'authentification`,
  german: `Fehler beim Abrufen der Authentifizierungsdaten`,
  hindi: 'प्रमाणीकरण डेटा प्राप्त करने में त्रुटि',
  indonesian: 'Kesalahan mengambil data autentikasi',
  japanese: '認証データの取得エラー',
  korean: '인증 데이터를 가져오는 중 오류',
  portuguese: 'Erro ao buscar dados de autenticação',
  russian: `Ошибка при получении данных аутентификации`,
  spanish: 'Error al obtener datos de autenticación',
  swahili: 'Hitilafu katika kupata data ya uhalalishaji',
  vietnamese: 'Lỗi khi tải dữ liệu xác thực',
};
export const convertedAmountT: Translation = {
  amharic: 'የተቀየረ መጠን',
  arabic: 'المبلغ المحول',
  bengali: 'রূপান্তরিত পরিমাণ',
  chinese: '转换金额',
  english: `Converted amount`,
  estonian: `Teisendatud summa`,
  filipino: 'Na-convert na halaga',
  french: `Montant converti`,
  german: `Umgewandelter Betrag`,
  hindi: 'परिवर्तित राशि',
  indonesian: 'Jumlah terkonversi',
  japanese: '変換された金額',
  korean: '변환된 금액',
  portuguese: 'Valor convertido',
  russian: `Конвертированная сумма`,
  spanish: 'Monto convertido',
  swahili: 'Kiasi kilichobadilishwa',
  vietnamese: 'Số tiền đã chuyển đổi',
};
export const paidOnT: Translation = {
  amharic: 'የተከፈለበት',
  arabic: 'تم الدفع في',
  bengali: 'প্রদান করা হয়েছে',
  chinese: '支付于',
  english: `Paid on`,
  estonian: `Makstud`,
  filipino: 'Binayaran noong',
  french: `Payé le`,
  german: `Bezahlt am`,
  hindi: 'भुगतान किया गया',
  indonesian: 'Dibayar pada',
  japanese: '支払日',
  korean: '결제일',
  portuguese: 'Pago em',
  russian: `Оплачено`,
  spanish: 'Pagado el',
  swahili: 'Imelipwa',
  vietnamese: 'Đã thanh toán vào',
};
export const coordinatorT: Translation = {
  amharic: 'አስተባባሪ',
  arabic: 'المنسق',
  bengali: 'সমন্বয়কারী',
  chinese: '协调员',
  english: `Coordinator`,
  estonian: `Koordinator`,
  filipino: 'Coordinator',
  french: `Coordonnateur`,
  german: `Koordinator`,
  hindi: 'समन्वयक',
  indonesian: 'Koordinator',
  japanese: 'コーディネーター',
  korean: '코디네이터',
  portuguese: 'Coordenador',
  russian: `Координатор`,
  spanish: 'Coordinador',
  swahili: 'Mratibu',
  vietnamese: 'Điều phối viên',
};
export const fixedT: Translation = {
  amharic: 'ቋሚ',
  arabic: 'ثابت',
  bengali: 'স্থির',
  chinese: '固定',
  english: `Fixed`,
  estonian: `Fikseeritud`,
  filipino: 'Nakapirmi',
  french: `Fixé`,
  german: `Fest`,
  hindi: 'निश्चित',
  indonesian: 'Tetap',
  japanese: '固定',
  korean: '고정',
  portuguese: 'Fixo',
  russian: `Фиксированный`,
  spanish: 'Fijo',
  swahili: 'Fasta',
  vietnamese: 'Cố định',
};
export const flexibleT: Translation = {
  amharic: 'ተለዋዋጭ',
  arabic: 'مرن',
  bengali: 'নমনীয়',
  chinese: '灵活',
  english: `Flexible`,
  estonian: `Keerukas`,
  filipino: 'Flexible',
  french: `Flexible`,
  german: `Flexibel`,
  hindi: 'लचीला',
  indonesian: 'Fleksibel',
  japanese: '柔軟',
  korean: '유연한',
  portuguese: 'Flexível',
  russian: `Гибкий`,
  spanish: 'Flexible',
  swahili: 'Fleksibli',
  vietnamese: 'Linh hoạt',
};

export const densityT: Translation = {
  amharic: 'ጥግግት',
  arabic: 'الكثافة',
  bengali: 'ঘনত্ব',
  chinese: '密度',
  english: `Density`,
  estonian: `Tihedus`,
  filipino: 'Density',
  french: `Densité`,
  german: `Dichte`,
  hindi: 'घनत्व',
  indonesian: 'Kepadatan',
  japanese: '密度',
  korean: '밀도',
  portuguese: 'Densidade',
  russian: `Плотность`,
  spanish: 'Densidad',
  swahili: 'Msongamano',
  vietnamese: 'Mật độ',
};

export const rowSeparationT: Translation = {
  amharic: 'የረድፍ መለያ',
  arabic: 'فصل الصفوف',
  bengali: 'সারি বিভাজন',
  chinese: '行分隔',
  english: `Row separation`,
  estonian: `Ridade eraldus`,
  filipino: 'Paghihiwalay ng row',
  french: `Séparation des lignes`,
  german: `Zeilentrennung`,
  hindi: 'पंक्ति विभाजन',
  indonesian: 'Pemisah baris',
  japanese: '行の区切り',
  korean: '행 구분',
  portuguese: 'Separação de linhas',
  russian: `Разделение строк`,
  spanish: 'Separación de filas',
  swahili: 'Utenganisho wa safu',
  vietnamese: 'Phân cách hàng',
};

export const exportT: Translation = {
  amharic: 'ላክ',
  arabic: 'تصدير',
  bengali: 'রপ্তানি',
  chinese: '导出',
  english: `Export`,
  estonian: `Ekspordi`,
  filipino: 'I-export',
  french: `Exporter`,
  german: `Exportieren`,
  hindi: 'निर्यात',
  indonesian: 'Ekspor',
  japanese: 'エクスポート',
  korean: '내보내기',
  portuguese: 'Exportar',
  russian: `Экспорт`,
  spanish: 'Exportar',
  swahili: 'Hamisha',
  vietnamese: 'Xuất',
};

export const csvT: Translation = {
  amharic: 'CSV',
  arabic: 'CSV',
  bengali: 'CSV',
  chinese: 'CSV',
  english: `CSV`,
  estonian: `CSV`,
  filipino: 'CSV',
  french: `CSV`,
  german: `CSV`,
  hindi: 'CSV',
  indonesian: 'CSV',
  japanese: 'CSV',
  korean: 'CSV',
  portuguese: 'CSV',
  russian: `CSV`,
  spanish: 'CSV',
  swahili: 'CSV',
  vietnamese: 'CSV',
};

export const excelT: Translation = {
  amharic: 'Excel',
  arabic: 'Excel',
  bengali: 'Excel',
  chinese: 'Excel',
  english: `Excel`,
  estonian: `Excel`,
  filipino: 'Excel',
  french: `Excel`,
  german: `Excel`,
  hindi: 'Excel',
  indonesian: 'Excel',
  japanese: 'Excel',
  korean: 'Excel',
  portuguese: 'Excel',
  russian: `Excel`,
  spanish: 'Excel',
  swahili: 'Excel',
  vietnamese: 'Excel',
};

export const sortT: Translation = {
  amharic: 'ደርድር',
  arabic: 'الترتيب',
  bengali: 'সাজান',
  chinese: '排序',
  english: 'Sort',
  estonian: 'Sortimine',
  filipino: 'Pagsunod-sunod',
  french: 'Tri',
  german: 'Sortierung',
  hindi: 'क्रमबद्ध करें',
  indonesian: 'Urutkan',
  japanese: '並べ替え',
  korean: '정렬',
  portuguese: 'Ordenação',
  russian: 'Сортировка',
  spanish: 'Orden',
  swahili: 'Panga',
  vietnamese: 'Sắp xếp',
};

export const sortAscendingT: Translation = {
  amharic: 'በዕርገት ደርድር',
  arabic: 'ترتيب تصاعدي',
  bengali: 'ঊর্ধ্বক্রমে সাজান',
  chinese: '升序排列',
  english: `Sort ascending`,
  estonian: `Sordi kasvavalt`,
  filipino: 'Pataas na pagkakasunod',
  french: `Trier par ordre croissant`,
  german: `Aufsteigend sortieren`,
  hindi: 'आरोही क्रम में क्रमबद्ध करें',
  indonesian: 'Urutkan menaik',
  japanese: '昇順に並べ替え',
  korean: '오름차순 정렬',
  portuguese: 'Ordenar crescente',
  russian: `Сортировать по возрастанию`,
  spanish: 'Ordenar ascendente',
  swahili: 'Panga kwa kupanda',
  vietnamese: 'Sắp xếp tăng dần',
};

export const sortDescendingT: Translation = {
  amharic: 'በውረድ ደርድር',
  arabic: 'ترتيب تنازلي',
  bengali: 'অধোক্রমে সাজান',
  chinese: '降序排列',
  english: `Sort descending`,
  estonian: `Sordi kahanevalt`,
  filipino: 'Pababang pagkakasunod',
  french: `Trier par ordre décroissant`,
  german: `Absteigend sortieren`,
  hindi: 'अवरोही क्रम में क्रमबद्ध करें',
  indonesian: 'Urutkan menurun',
  japanese: '降順に並べ替え',
  korean: '내림차순 정렬',
  portuguese: 'Ordenar decrescente',
  russian: `Сортировать по убыванию`,
  spanish: 'Ordenar descendente',
  swahili: 'Panga kwa kushuka',
  vietnamese: 'Sắp xếp giảm dần',
};

/** The direction alone, for a control whose group label already says "Sort".
 *  Derived from the directional word inside `sortAscendingT`, so the two stay
 *  the same term: the long form remains the accessible name. */
/** The info trigger's accessible name. The button is what a reader reaches; the
 *  card is what it opens, so the NAME belongs on the button. `{name}` is the
 *  surface being explained. */
export const aboutSurfaceT: Translation = {
  amharic: 'ስለ {name}',
  arabic: 'حول {name}',
  bengali: '{name} সম্পর্কে',
  chinese: '关于{name}',
  english: `About {name}`,
  estonian: `{name} kohta`,
  filipino: 'Tungkol sa {name}',
  french: `À propos de {name}`,
  german: `Über {name}`,
  hindi: '{name} के बारे में',
  indonesian: 'Tentang {name}',
  japanese: '{name}について',
  korean: '{name} 정보',
  portuguese: 'Sobre {name}',
  russian: `О разделе {name}`,
  spanish: 'Acerca de {name}',
  swahili: 'Kuhusu {name}',
  vietnamese: 'Giới thiệu về {name}',
};

export const ascendingT: Translation = {
  amharic: 'በዕርገት',
  arabic: 'تصاعدي',
  bengali: 'ঊর্ধ্বক্রম',
  chinese: '升序',
  english: `Ascending`,
  estonian: `Kasvav`,
  filipino: 'Pataas',
  french: `Croissant`,
  german: `Aufsteigend`,
  hindi: 'आरोही',
  indonesian: 'Menaik',
  japanese: '昇順',
  korean: '오름차순',
  portuguese: 'Crescente',
  russian: `Возрастание`,
  spanish: 'Ascendente',
  swahili: 'Kupanda',
  vietnamese: 'Tăng dần',
};

export const descendingT: Translation = {
  amharic: 'በውረድ',
  arabic: 'تنازلي',
  bengali: 'অধোক্রম',
  chinese: '降序',
  english: `Descending`,
  estonian: `Kahanev`,
  filipino: 'Pababa',
  french: `Décroissant`,
  german: `Absteigend`,
  hindi: 'अवरोही',
  indonesian: 'Menurun',
  japanese: '降順',
  korean: '내림차순',
  portuguese: 'Decrescente',
  russian: `Убывание`,
  spanish: 'Descendente',
  swahili: 'Kushuka',
  vietnamese: 'Giảm dần',
};

export const clearSortT: Translation = {
  amharic: 'ደርድርን አጽዳ',
  arabic: 'مسح الترتيب',
  bengali: 'সাজানো মুছুন',
  chinese: '清除排序',
  english: `Clear sort`,
  estonian: `Tühista sortimine`,
  filipino: 'Alisin ang pagkakasunod',
  french: `Annuler le tri`,
  german: `Sortierung aufheben`,
  hindi: 'क्रम हटाएँ',
  indonesian: 'Hapus urutan',
  japanese: '並べ替えを解除',
  korean: '정렬 해제',
  portuguese: 'Limpar ordenação',
  russian: `Сбросить сортировку`,
  spanish: 'Quitar orden',
  swahili: 'Ondoa mpangilio',
  vietnamese: 'Xóa sắp xếp',
};

export const takesNoValueT: Translation = {
  amharic: 'ይህ አማራጭ ዋጋ አይፈልግም።',
  arabic: 'لا يتطلب هذا المعامل قيمة.',
  bengali: 'এই অপারেটরের কোনো মান লাগে না।',
  chinese: '此运算符不需要值。',
  english: 'This operator takes no value.',
  estonian: 'See tehe ei vaja väärtust.',
  filipino: 'Walang halagang kailangan ang operator na ito.',
  french: 'Cet operateur ne prend aucune valeur.',
  german: 'Dieser Operator benoetigt keinen Wert.',
  hindi: 'इस ऑपरेटर को कोई मान नहीं चाहिए।',
  indonesian: 'Operator ini tidak memerlukan nilai.',
  japanese: 'この演算子は値を必要としません。',
  korean: '이 연산자는 값이 필요하지 않습니다.',
  portuguese: 'Este operador nao usa valor.',
  russian: 'Этот оператор не требует значения.',
  spanish: 'Este operador no necesita valor.',
  swahili: 'Opereta hii haihitaji thamani.',
  vietnamese: 'Toán tử này không cần giá trị.',
};

export const columnT: Translation = {
  amharic: 'አምድ',
  arabic: 'العمود',
  bengali: 'কলাম',
  chinese: '列',
  english: 'Column',
  estonian: 'Veerg',
  filipino: 'Column',
  french: 'Colonne',
  german: 'Spalte',
  hindi: 'कॉलम',
  indonesian: 'Kolom',
  japanese: '列',
  korean: '열',
  portuguese: 'Coluna',
  russian: 'Столбец',
  spanish: 'Columna',
  swahili: 'Safu',
  vietnamese: 'Cột',
};

export const pinColumnT: Translation = {
  amharic: 'አምድ ይሰኩ',
  arabic: 'تثبيت العمود',
  bengali: 'কলাম পিন করুন',
  chinese: '固定列',
  english: 'Pin column',
  estonian: 'Kinnita veerg',
  filipino: 'I-pin ang column',
  french: 'Epingler la colonne',
  german: 'Spalte anheften',
  hindi: 'कॉलम पिन करें',
  indonesian: 'Sematkan kolom',
  japanese: '列を固定',
  korean: '열 고정',
  portuguese: 'Fixar coluna',
  russian: 'Закрепить столбец',
  spanish: 'Fijar columna',
  swahili: 'Bandika safu',
  vietnamese: 'Ghim cột',
};

export const unpinColumnT: Translation = {
  amharic: 'አምድ ይንቀሉ',
  arabic: 'إلغاء تثبيت العمود',
  bengali: 'কলাম আনপিন করুন',
  chinese: '取消固定列',
  english: 'Unpin column',
  estonian: 'Vabasta veerg',
  filipino: 'I-unpin ang column',
  french: 'Detacher la colonne',
  german: 'Spalte loesen',
  hindi: 'कॉलम अनपिन करें',
  indonesian: 'Lepas sematan kolom',
  japanese: '列の固定を解除',
  korean: '열 고정 해제',
  portuguese: 'Desafixar coluna',
  russian: 'Открепить столбец',
  spanish: 'Dejar de fijar la columna',
  swahili: 'Ondoa ubandiko wa safu',
  vietnamese: 'Bỏ ghim cột',
};

export const reorderColumnT: Translation = {
  amharic: 'አምድ አንቀሳቅስ',
  arabic: 'نقل العمود',
  bengali: 'কলাম সরান',
  chinese: '移动列',
  english: 'Move column',
  estonian: 'Teisalda veerg',
  filipino: 'Ilipat ang column',
  french: 'Deplacer la colonne',
  german: 'Spalte verschieben',
  hindi: 'कॉलम ले जाएं',
  indonesian: 'Pindahkan kolom',
  japanese: '列を移動',
  korean: '열 이동',
  portuguese: 'Mover coluna',
  russian: 'Переместить столбец',
  spanish: 'Mover columna',
  swahili: 'Hamisha safu',
  vietnamese: 'Di chuyển cột',
};

export const hideColumnT: Translation = {
  amharic: 'አምድ ደብቅ',
  arabic: 'إخفاء العمود',
  bengali: 'কলাম লুকান',
  chinese: '隐藏列',
  english: `Hide column`,
  estonian: `Peida veerg`,
  filipino: 'Itago ang column',
  french: `Masquer la colonne`,
  german: `Spalte ausblenden`,
  hindi: 'कॉलम छिपाएँ',
  indonesian: 'Sembunyikan kolom',
  japanese: '列を非表示',
  korean: '열 숨기기',
  portuguese: 'Ocultar coluna',
  russian: `Скрыть столбец`,
  spanish: 'Ocultar columna',
  swahili: 'Ficha safu',
  vietnamese: 'Ẩn cột',
};

export const resizeColumnT: Translation = {
  amharic: 'የአምድ ስፋት ቀይር',
  arabic: 'تغيير عرض العمود',
  bengali: 'কলামের প্রস্থ বদলান',
  chinese: '调整列宽',
  english: `Resize column`,
  estonian: `Muuda veeru laiust`,
  filipino: 'Baguhin ang lapad ng column',
  french: `Redimensionner la colonne`,
  german: `Spaltenbreite ändern`,
  hindi: 'कॉलम की चौड़ाई बदलें',
  indonesian: 'Ubah lebar kolom',
  japanese: '列幅を変更',
  korean: '열 너비 조정',
  portuguese: 'Redimensionar coluna',
  russian: `Изменить ширину столбца`,
  spanish: 'Cambiar ancho de columna',
  swahili: 'Badilisha upana wa safu',
  vietnamese: 'Đổi độ rộng cột',
};

export const columnMenuT: Translation = {
  amharic: 'የአምድ ምናሌ',
  arabic: 'قائمة العمود',
  bengali: 'কলাম মেনু',
  chinese: '列菜单',
  english: `Column menu`,
  estonian: `Veeru menüü`,
  filipino: 'Menu ng column',
  french: `Menu de la colonne`,
  german: `Spaltenmenü`,
  hindi: 'कॉलम मेनू',
  indonesian: 'Menu kolom',
  japanese: '列メニュー',
  korean: '열 메뉴',
  portuguese: 'Menu da coluna',
  russian: `Меню столбца`,
  spanish: 'Menú de columna',
  swahili: 'Menyu ya safu',
  vietnamese: 'Menu cột',
};

export const stripesT: Translation = {
  amharic: 'ጭረቶች',
  arabic: 'أشرطة',
  bengali: 'ডোরা',
  chinese: '条纹',
  english: `Stripes`,
  estonian: `Triibud`,
  filipino: 'Mga guhit',
  french: `Rayures`,
  german: `Streifen`,
  hindi: 'धारियाँ',
  indonesian: 'Garis belang',
  japanese: 'しま模様',
  korean: '줄무늬',
  portuguese: 'Listras',
  russian: `Полосы`,
  spanish: 'Franjas',
  swahili: 'Milia',
  vietnamese: 'Sọc',
};

export const linesT: Translation = {
  amharic: 'መስመሮች',
  arabic: 'خطوط',
  bengali: 'রেখা',
  chinese: '分隔线',
  english: `Lines`,
  estonian: `Jooned`,
  filipino: 'Mga linya',
  french: `Lignes`,
  german: `Linien`,
  hindi: 'रेखाएँ',
  indonesian: 'Garis',
  japanese: '罫線',
  korean: '구분선',
  portuguese: 'Linhas',
  russian: `Линии`,
  spanish: 'Líneas',
  swahili: 'Mistari',
  vietnamese: 'Đường kẻ',
};

export const stripesAndLinesT: Translation = {
  amharic: 'ጭረቶች እና መስመሮች',
  arabic: 'أشرطة وخطوط',
  bengali: 'ডোরা ও রেখা',
  chinese: '条纹和分隔线',
  english: `Stripes and lines`,
  estonian: `Triibud ja jooned`,
  filipino: 'Mga guhit at linya',
  french: `Rayures et lignes`,
  german: `Streifen und Linien`,
  hindi: 'धारियाँ और रेखाएँ',
  indonesian: 'Garis belang dan garis',
  japanese: 'しま模様と罫線',
  korean: '줄무늬와 구분선',
  portuguese: 'Listras e linhas',
  russian: `Полосы и линии`,
  spanish: 'Franjas y líneas',
  swahili: 'Milia na mistari',
  vietnamese: 'Sọc và đường kẻ',
};

export const filterT: Translation = {
  amharic: 'አጣራ',
  arabic: 'تصفية',
  bengali: 'ফিল্টার',
  chinese: '筛选',
  english: `Filter`,
  estonian: `Filtre`,
  filipino: 'Filter',
  french: `Filtre`,
  german: `Filter`,
  hindi: 'फ़िल्टर',
  indonesian: 'Filter',
  japanese: 'フィルター',
  korean: '필터',
  portuguese: 'Filtro',
  russian: `Фильтр`,
  spanish: 'Filtro',
  swahili: 'Chuja',
  vietnamese: 'Lọc',
};
export const columnsT: Translation = {
  amharic: 'አምዶች',
  arabic: 'الأعمدة',
  bengali: 'কলাম',
  chinese: '列',
  english: `Columns`,
  estonian: `Veerud`,
  filipino: 'Mga hanay',
  french: `Colonnes`,
  german: `Spalten`,
  hindi: 'स्तंभ',
  indonesian: 'Kolom',
  japanese: '列',
  korean: '열',
  portuguese: 'Colunas',
  russian: `Столбцы`,
  spanish: 'Columnas',
  swahili: 'Safu wima',
  vietnamese: 'Cột',
};
export const compactT: Translation = {
  amharic: 'የታመቀ',
  arabic: 'مضغوط',
  bengali: 'সংক্ষিপ্ত',
  chinese: '紧凑',
  english: `Compact`,
  estonian: `Kompaktne`,
  filipino: 'Compact',
  french: `Compact`,
  german: `Kompakt`,
  hindi: 'संक्षिप्त',
  indonesian: 'Kompak',
  japanese: 'コンパクト',
  korean: '컴팩트',
  portuguese: 'Compacto',
  russian: `Компактный`,
  spanish: 'Compacto',
  swahili: 'Fupi',
  vietnamese: 'Nhỏ gọn',
};
export const standardT: Translation = {
  amharic: 'መደበኛ',
  arabic: 'قياسي',
  bengali: 'মানক',
  chinese: '标准',
  english: `Standard`,
  estonian: `Standardne`,
  filipino: 'Standard',
  french: `Standard`,
  german: `Standard`,
  hindi: 'मानक',
  indonesian: 'Standar',
  japanese: '標準',
  korean: '표준',
  portuguese: 'Padrão',
  russian: `Стандартный`,
  spanish: 'Estándar',
  swahili: 'Kawaida',
  vietnamese: 'Tiêu chuẩn',
};
export const comfortableT: Translation = {
  amharic: 'ምቹ',
  arabic: 'مريح',
  bengali: 'আরামদায়ক',
  chinese: '舒适',
  english: `Comfortable`,
  estonian: `Komfortne`,
  filipino: 'Komportable',
  french: `Confortable`,
  german: `Komfortabel`,
  hindi: 'आरामदायक',
  indonesian: 'Nyaman',
  japanese: '快適',
  korean: '편안한',
  portuguese: 'Confortável',
  russian: `Комфортный`,
  spanish: 'Cómodo',
  swahili: 'Kwa starehe',
  vietnamese: 'Thoải mái',
};

export const downloadAsCsvT: Translation = {
  amharic: 'እንደ CSV አውርድ',
  arabic: 'تحميل بصيغة CSV',
  bengali: 'CSV হিসাবে ডাউনলোড করুন',
  chinese: '下载为CSV',
  english: `Download as CSV`,
  estonian: `CSV-i allalaadimine`,
  filipino: 'I-download bilang CSV',
  french: `Télécharger en CSV`,
  german: `Als CSV herunterladen`,
  hindi: 'CSV के रूप में डाउनलोड करें',
  indonesian: 'Unduh sebagai CSV',
  japanese: 'CSVとしてダウンロード',
  korean: 'CSV로 다운로드',
  portuguese: 'Baixar como CSV',
  russian: `Скачать как CSV`,
  spanish: 'Descargar como CSV',
  swahili: 'Pakua kama CSV',
  vietnamese: 'Tải xuống dưới dạng CSV',
};
export const printT: Translation = {
  amharic: 'አትም',
  arabic: 'طباعة',
  bengali: 'প্রিন্ট',
  chinese: '打印',
  english: `Print`,
  estonian: `Prindi`,
  filipino: 'I-print',
  french: `Imprimer`,
  german: `Drucken`,
  hindi: 'प्रिंट',
  indonesian: 'Cetak',
  japanese: '印刷',
  korean: '인쇄',
  portuguese: 'Imprimir',
  russian: `Печать`,
  spanish: 'Imprimir',
  swahili: 'Chapisha',
  vietnamese: 'In',
};

export const change: Translation = {
  amharic: 'ቀይር',
  arabic: 'تغيير',
  bengali: 'পরিবর্তন',
  chinese: '更改',
  english: 'Change',
  estonian: 'Muuta',
  filipino: 'Baguhin',
  french: 'Changer',
  german: 'Ändern',
  hindi: 'बदलें',
  indonesian: 'Ubah',
  japanese: '変更',
  korean: '변경',
  portuguese: 'Mudar',
  russian: 'Изменить',
  spanish: 'Cambiar',
  swahili: 'Badilisha',
  vietnamese: 'Thay đổi',
};
export const keepCurrent: Translation = {
  amharic: 'የአሁኑን ያቆዩ',
  arabic: 'احتفظ بالحالي',
  bengali: 'বর্তমান রাখুন',
  chinese: '保持当前',
  english: 'Keep Current',
  estonian: 'Jälgida praegust',
  filipino: 'Panatilihin ang kasalukuyan',
  french: 'Conserver le courant',
  german: 'Aktuell behalten',
  hindi: 'वर्तमान रखें',
  indonesian: 'Tetap saat ini',
  japanese: '現在を保持',
  korean: '현재 유지',
  portuguese: 'Manter atual',
  russian: 'Сохранить текущее',
  spanish: 'Mantener actual',
  swahili: 'Weka wa sasa',
  vietnamese: 'Giữ hiện tại',
};
export const addNew: Translation = {
  amharic: 'አዲስ አክል',
  arabic: 'إضافة جديد',
  bengali: 'নতুন যোগ করুন',
  chinese: '添加新的',
  english: 'Add New',
  estonian: 'Lisa uus',
  filipino: 'Magdagdag ng bago',
  french: 'Ajouter nouveau',
  german: 'Hinzufügen',
  hindi: 'नया जोड़ें',
  indonesian: 'Tambah baru',
  japanese: '新規追加',
  korean: '새로 추가',
  portuguese: 'Adicionar novo',
  russian: 'Добавить новый',
  spanish: 'Agregar nuevo',
  swahili: 'Ongeza mpya',
  vietnamese: 'Thêm mới',
};
export const findAndRemove: Translation = {
  amharic: 'ፈልግ እና አስወግድ',
  arabic: 'البحث والإزالة',
  bengali: 'খুঁজুন এবং সরান',
  chinese: '查找并删除',
  english: 'Find and Remove',
  estonian: 'Otsi ja kustuta',
  filipino: 'Hanapin at tanggalin',
  french: 'Trouver et supprimer',
  german: 'Finden und Löschen',
  hindi: 'खोजें और हटाएं',
  indonesian: 'Cari dan hapus',
  japanese: '検索して削除',
  korean: '찾아서 제거',
  portuguese: 'Encontrar e remover',
  russian: 'Найти и удалить',
  spanish: 'Buscar y eliminar',
  swahili: 'Tafuta na uondoe',
  vietnamese: 'Tìm và xóa',
};
export const removeAll: Translation = {
  amharic: 'ሁሉንም አስወግድ',
  arabic: 'إزالة الكل',
  bengali: 'সব সরান',
  chinese: '全部删除',
  english: 'Remove All',
  estonian: 'Kustuta kõik',
  filipino: 'Tanggalin lahat',
  french: 'Supprimer tous',
  german: 'Alle löschen',
  hindi: 'सभी हटाएं',
  indonesian: 'Hapus semua',
  japanese: 'すべて削除',
  korean: '모두 제거',
  portuguese: 'Remover tudo',
  russian: 'Удалить все',
  spanish: 'Eliminar todo',
  swahili: 'Ondoa zote',
  vietnamese: 'Xóa tất cả',
};
export const undo: Translation = {
  amharic: 'መልስ',
  arabic: 'تراجع',
  bengali: 'পূর্বাবস্থায়',
  chinese: '撤销',
  english: 'Undo',
  estonian: 'Tühista',
  filipino: 'I-undo',
  french: 'Annuler',
  german: 'Rückgängig machen',
  hindi: 'पूर्ववत करें',
  indonesian: 'Batalkan',
  japanese: '元に戻す',
  korean: '실행 취소',
  portuguese: 'Desfazer',
  russian: 'Отменить',
  spanish: 'Deshacer',
  swahili: 'Tendua',
  vietnamese: 'Hoàn tác',
};
export const reset: Translation = {
  amharic: 'ዳግም አስጀምር',
  arabic: 'إعادة تعيين',
  bengali: 'রিসেট',
  chinese: '重置',
  english: 'Reset',
  estonian: 'Lähtesta',
  filipino: 'I-reset',
  french: 'Réinitialiser',
  german: 'Zurücksetzen',
  hindi: 'रीसेट',
  indonesian: 'Reset',
  japanese: 'リセット',
  korean: '재설정',
  portuguese: 'Redefinir',
  russian: 'Сброс',
  spanish: 'Restablecer',
  swahili: 'Weka upya',
  vietnamese: 'Đặt lại',
};

export const bulkDeleteUsers: Translation = {
  amharic: 'ተጠቃሚዎችን በብዛት ሰርዝ',
  arabic: 'حذف المستخدمين بالجملة',
  bengali: 'ব্যবহারকারীদের বাল্ক মুছুন',
  chinese: '批量删除用户',
  english: 'Bulk Delete Users',
  estonian: 'Kustuta kõik kasutajad',
  filipino: 'Bulk delete ng mga user',
  french: 'Удалить всех пользователей',
  german: 'Alle Benutzer löschen',
  hindi: 'उपयोगकर्ताओं को थोक में हटाएं',
  indonesian: 'Hapus pengguna massal',
  japanese: 'ユーザーを一括削除',
  korean: '사용자 대량 삭제',
  portuguese: 'Excluir usuários em massa',
  russian: 'Удалить всех пользователей',
  spanish: 'Eliminar usuarios en masa',
  swahili: 'Futa watumiaji kwa wingi',
  vietnamese: 'Xóa người dùng hàng loạt',
};
export const bulkRestoreUsers: Translation = {
  amharic: 'ተጠቃሚዎችን በብዛት መልስ',
  arabic: 'استعادة المستخدمين بالجملة',
  bengali: 'ব্যবহারকারীদের বাল্ক পুনরুদ্ধার করুন',
  chinese: '批量恢复用户',
  english: 'Bulk Restore Users',
  estonian: 'Kasutajad taastada',
  filipino: 'Bulk restore ng mga user',
  french: 'Восстановить всех пользователей',
  german: 'Alle Benutzer wiederherstellen',
  hindi: 'उपयोगकर्ताओं को थोक में पुनर्स्थापित करें',
  indonesian: 'Pulihkan pengguna massal',
  japanese: 'ユーザーを一括復元',
  korean: '사용자 대량 복원',
  portuguese: 'Restaurar usuários em massa',
  russian: 'Восстановить всех пользователей',
  spanish: 'Restaurar usuarios en masa',
  swahili: 'Rejesha watumiaji kwa wingi',
  vietnamese: 'Khôi phục người dùng hàng loạt',
};
export const confirmBulkDeleteUsers: Translation = {
  amharic: 'የተመረጡትን ተጠቃሚዎች መሰረዝ እርግጠኛ ነዎት',
  arabic: 'هل أنت متأكد من أنك تريد حذف المستخدمين المحددين',
  bengali: 'আপনি কি নিশ্চিত যে আপনি নির্বাচিত ব্যবহারকারীদের মুছতে চান',
  chinese: '您确定要删除选定的用户吗',
  english: 'Are you sure you want to delete selected users',
  estonian: 'Kas olete kindel, et soovite kustutada valitud kasutajad',
  filipino: 'Sigurado ka ba na gusto mong tanggalin ang mga piniling user',
  french: 'Êtes-vous sûr de vouloir supprimer les utilisateurs sélectionnés',
  german: 'Sind Sie sicher, dass Sie die ausgewählten Benutzer löschen möchten',
  hindi: 'क्या आप सुनिश्चित हैं कि आप चयनित उपयोगकर्ताओं को हटाना चाहते हैं',
  indonesian: 'Apakah Anda yakin ingin menghapus pengguna yang dipilih',
  japanese: '選択したユーザーを削除してもよろしいですか',
  korean: '선택한 사용자를 삭제하시겠습니까?',
  portuguese: 'Tem certeza de que deseja excluir os usuários selecionados?',
  russian: 'Вы уверены, что хотите удалить выбранных пользователей',
  spanish: '¿Está seguro de que desea eliminar los usuarios seleccionados?',
  swahili: 'Una uhakika unataka kufuta watumiaji waliochaguliwa',
  vietnamese: 'Bạn có chắc chắn muốn xóa người dùng đã chọn',
};
export const confirmBulkRestoreUsers: Translation = {
  amharic: 'የተመረጡትን ተጠቃሚዎች መመለስ እርግጠኛ ነዎት',
  arabic: 'هل أنت متأكد من أنك تريد استعادة المستخدمين المحددين',
  bengali: 'আপনি কি নিশ্চিত যে আপনি নির্বাচিত ব্যবহারকারীদের পুনরুদ্ধার করতে চান',
  chinese: '您确定要恢复选定的用户吗',
  english: 'Are you sure you want to restore selected users',
  estonian: 'Kas olete kindel, et soovite taastada valitud kasutajad',
  filipino: 'Sigurado ka ba na gusto mong ibalik ang mga piniling user',
  french: 'Êtes-vous sûr de vouloir restaurer les utilisateurs sélectionnés',
  german: 'Sind Sie sicher, dass Sie die ausgewählten Benutzer wiederherstellen möchten',
  hindi: 'क्या आप सुनिश्चित हैं कि आप चयनित उपयोगकर्ताओं को पुनर्स्थापित करना चाहते हैं',
  indonesian: 'Apakah Anda yakin ingin memulihkan pengguna yang dipilih',
  japanese: '選択したユーザーを復元してもよろしいですか',
  korean: '선택한 사용자를 복원하시겠습니까?',
  portuguese: 'Tem certeza de que deseja restaurar os usuários selecionados?',
  russian: 'Вы уверены, что хотите восстановить выбранных пользователей',
  spanish: '¿Está seguro de que desea restaurar los usuarios seleccionados?',
  swahili: 'Una uhakika unataka kurejesha watumiaji waliochaguliwa',
  vietnamese: 'Bạn có chắc chắn muốn khôi phục người dùng đã chọn',
};
export const noLocationsFoundT: Translation = {
  amharic: 'ምንም አካባቢዎች አልተገኙም',
  arabic: 'لم يتم العثور على مواقع',
  bengali: 'কোনো অবস্থান পাওয়া যায়নি',
  chinese: '未找到位置',
  english: 'No locations found',
  estonian: 'Asukohti ei leitud',
  filipino: 'Walang nahanap na lokasyon',
  french: 'Aucun emplacement trouvé',
  german: 'Keine Orte gefunden',
  hindi: 'कोई स्थान नहीं मिला',
  indonesian: 'Tidak ada lokasi yang ditemukan',
  japanese: '場所が見つかりません',
  korean: '위치를 찾을 수 없음',
  portuguese: 'Nenhuma localização encontrada',
  russian: 'Ничего не найдено',
  spanish: 'No se encontraron ubicaciones',
  swahili: 'Hakuna maeneo yaliyopatikana',
  vietnamese: 'Không tìm thấy vị trí',
};
export const selectLocationT: Translation = {
  amharic: 'አካባቢ ምረጥ',
  arabic: 'حدد الموقع',
  bengali: 'অবস্থান নির্বাচন করুন',
  chinese: '选择位置',
  english: 'Select Location',
  estonian: 'Vali asukoht',
  filipino: 'Pumili ng lokasyon',
  french: 'Sélectionner un emplacement',
  german: 'Ort auswählen',
  hindi: 'स्थान चुनें',
  indonesian: 'Pilih lokasi',
  japanese: '場所を選択',
  korean: '위치 선택',
  portuguese: 'Selecionar localização',
  russian: 'Выбрать местоположение',
  spanish: 'Seleccionar ubicación',
  swahili: 'Chagua eneo',
  vietnamese: 'Chọn vị trí',
};
export const createdOnT: Translation = {
  amharic: 'የተፈጠረበት',
  arabic: 'تم الإنشاء في',
  bengali: 'তৈরি হয়েছে',
  chinese: '创建于',
  english: 'Created On',
  estonian: 'Loodud',
  filipino: 'Nilikha noong',
  french: 'Créé le',
  german: 'Erstellt am',
  hindi: 'बनाया गया',
  indonesian: 'Dibuat pada',
  japanese: '作成日',
  korean: '생성일',
  portuguese: 'Criado em',
  russian: 'Создано',
  spanish: 'Creado el',
  swahili: 'Iliundwa',
  vietnamese: 'Đã tạo vào',
};
export const descriptionT: Translation = {
  amharic: 'መግለጫ',
  arabic: 'الوصف',
  bengali: 'বর্ণনা',
  chinese: '描述',
  english: 'Description',
  estonian: 'Kirjeldus',
  filipino: 'Paglalarawan',
  french: 'Description',
  german: 'Beschreibung',
  hindi: 'विवरण',
  indonesian: 'Deskripsi',
  japanese: '説明',
  korean: '설명',
  portuguese: 'Descrição',
  russian: 'Описание',
  spanish: 'Descripción',
  swahili: 'Maelezo',
  vietnamese: 'Mô tả',
};
export const messageSent: Translation = {
  amharic: 'መልዕክት ተልኳል',
  arabic: 'تم إرسال الرسالة',
  bengali: 'বার্তা পাঠানো হয়েছে',
  chinese: '消息已发送',
  english: 'Message sent',
  estonian: 'Sõnum saadetud',
  filipino: 'Naipadala ang mensahe',
  french: 'Message envoyé',
  german: 'Nachricht gesendet',
  hindi: 'संदेश भेजा गया',
  indonesian: 'Pesan terkirim',
  japanese: 'メッセージが送信されました',
  korean: '메시지가 전송됨',
  portuguese: 'Mensagem enviada',
  russian: 'Сообщение отправлено',
  spanish: 'Mensaje enviado',
  swahili: 'Ujumbe umetumwa',
  vietnamese: 'Đã gửi tin nhắn',
};
export const errorSendingMessage: Translation = {
  amharic: 'መልዕክት በመላክ ላይ ስህተት',
  arabic: 'خطأ في إرسال الرسالة',
  bengali: 'বার্তা পাঠাতে ত্রুটি',
  chinese: '发送消息时出错',
  english: 'Error sending message',
  estonian: 'Viga sõnumi saatmisel',
  filipino: 'Error sa pagpapadala ng mensahe',
  french: "Erreur lors de l'envoi du message",
  german: 'Fehler beim Senden der Nachricht',
  hindi: 'संदेश भेजने में त्रुटि',
  indonesian: 'Kesalahan mengirim pesan',
  japanese: 'メッセージ送信エラー',
  korean: '메시지 전송 오류',
  portuguese: 'Erro ao enviar mensagem',
  russian: 'Ошибка при отправке сообщения',
  spanish: 'Error al enviar mensaje',
  swahili: 'Hitilafu katika kutuma ujumbe',
  vietnamese: 'Lỗi khi gửi tin nhắn',
};
export const fillRequiredFields: Translation = {
  amharic: 'እባክዎ ሁሉንም የሚያስፈልጉ መስኮች ይሙሉ',
  arabic: 'يرجى ملء جميع الحقول المطلوبة',
  bengali: 'অনুগ্রহ করে সমস্ত প্রয়োজনীয় ক্ষেত্র পূরণ করুন',
  chinese: '请填写所有必填字段',
  english: 'Please fill in all required fields',
  estonian: 'Palun täida kõik nõutud väljad',
  filipino: 'Mangyaring punan ang lahat ng kinakailangang field',
  french: 'Veuillez remplir tous les champs requis',
  german: 'Bitte füllen Sie alle erforderlichen Felder aus',
  hindi: 'कृपया सभी आवश्यक फ़ील्ड भरें',
  indonesian: 'Silakan isi semua bidang yang wajib',
  japanese: '必須フィールドをすべて入力してください',
  korean: '모든 필수 항목을 입력하세요',
  portuguese: 'Por favor preencha todos os campos obrigatórios',
  russian: 'Пожалуйста, заполните все обязательные поля',
  spanish: 'Por favor complete todos los campos obligatorios',
  swahili: 'Tafadhali jaza sehemu zote zinazohitajika',
  vietnamese: 'Vui lòng điền vào tất cả các trường bắt buộc',
};
export const continueOnBrowser: Translation = {
  amharic: 'በአሳሽ ላይ ቀጥል',
  arabic: 'متابعة على المتصفح',
  bengali: 'ব্রাউজারে চালিয়ে যান',
  chinese: '在浏览器中继续',
  english: 'Continue on Browser',
  estonian: 'Jätkake veebilehitsejaga',
  filipino: 'Magpatuloy sa browser',
  french: 'Continuer sur le navigateur',
  german: 'Im Browser fortfahren',
  hindi: 'ब्राउज़र पर जारी रखें',
  indonesian: 'Lanjutkan di browser',
  japanese: 'ブラウザで続ける',
  korean: '브라우저에서 계속',
  portuguese: 'Continuar no navegador',
  russian: 'Продолжить в браузере',
  spanish: 'Continuar en el navegador',
  swahili: 'Endelea kwenye kivinjari',
  vietnamese: 'Tiếp tục trên trình duyệt',
};
export const returnHome: Translation = {
  amharic: 'ወደ ቤት ተመለስ',
  arabic: 'العودة إلى الصفحة الرئيسية',
  bengali: 'হোমে ফিরে যান',
  chinese: '返回首页',
  english: 'Return Home',
  estonian: `Tagasi kodulehele`,
  filipino: 'Bumalik sa home',
  french: `Retourner à la page d'accueil`,
  german: `Zurück zur Startseite`,
  hindi: 'होम पर वापस जाएं',
  indonesian: 'Kembali ke beranda',
  japanese: 'ホームに戻る',
  korean: '홈으로 돌아가기',
  portuguese: 'Voltar ao início',
  russian: `На главную`,
  spanish: 'Volver al inicio',
  swahili: 'Rudi nyumbani',
  vietnamese: 'Quay về trang chủ',
};
export const somethingWentWrongT: Translation = {
  amharic: 'የሆነ ችግር ተፈጥሯል',
  arabic: 'حدث خطأ ما',
  bengali: 'কিছু ভুল হয়েছে',
  chinese: '出了点问题',
  english: 'Something went wrong',
  estonian: `Midagi läks valesti`,
  filipino: 'May nangyaring mali',
  french: `Quelque chose s'est mal passé`,
  german: `Etwas ist schiefgelaufen`,
  hindi: 'कुछ गलत हो गया',
  indonesian: 'Terjadi kesalahan',
  japanese: '何か問題が発生しました',
  korean: '문제가 발생했습니다',
  portuguese: 'Algo deu errado',
  russian: `Что-то пошло не так`,
  spanish: 'Algo salió mal',
  swahili: 'Kitu kilienda vibaya',
  vietnamese: 'Đã xảy ra lỗi',
};

export const transactionsText: Translation = {
  amharic: 'ግብይቶች',
  arabic: 'المعاملات',
  bengali: 'লেনদেন',
  chinese: '交易',
  english: 'Transactions',
  estonian: 'Tehingud',
  filipino: 'Mga Transaksyon',
  french: 'Transactions',
  german: 'Transaktionen',
  hindi: 'लेन-देन',
  indonesian: 'Transaksi',
  japanese: '取引',
  korean: '거래',
  portuguese: 'Transações',
  russian: 'Транзакции',
  spanish: 'Transacciones',
  swahili: 'Miamala',
  vietnamese: 'Giao dịch',
};
export const revenueText: Translation = {
  amharic: 'ገቢ',
  arabic: 'الإيرادات',
  bengali: 'রাজস্ব',
  chinese: '收入',
  english: 'Revenue',
  estonian: 'Tulu',
  filipino: 'Kita',
  french: 'Revenus',
  german: 'Einnahmen',
  hindi: 'राजस्व',
  indonesian: 'Pendapatan',
  japanese: '収益',
  korean: '수익',
  portuguese: 'Receita',
  russian: 'Доход',
  spanish: 'Ingresos',
  swahili: 'Mapato',
  vietnamese: 'Doanh thu',
};
export const countriesText: Translation = {
  amharic: 'አገሮች',
  arabic: 'البلدان',
  bengali: 'দেশসমূহ',
  chinese: '国家',
  english: 'Countries',
  estonian: 'Riigid',
  filipino: 'Mga Bansa',
  french: 'Pays',
  german: 'Länder',
  hindi: 'देश',
  indonesian: 'Negara',
  japanese: '国',
  korean: '국가',
  portuguese: 'Países',
  russian: 'Страны',
  spanish: 'Países',
  swahili: 'Nchi',
  vietnamese: 'Quốc gia',
};
export const jackpotsText: Translation = {
  amharic: 'ጃክፖቶች',
  arabic: 'الجوائز الكبرى',
  bengali: 'জ্যাকপট',
  chinese: '大奖',
  english: 'Jackpots',
  estonian: 'Jackpotid',
  filipino: 'Mga Jackpot',
  french: 'Jackpots',
  german: 'Jackpots',
  hindi: 'जैकपॉट',
  indonesian: 'Jackpot',
  japanese: 'ジャックポット',
  korean: '잭팟',
  portuguese: 'Jackpots',
  russian: 'Джекпоты',
  spanish: 'Jackpots',
  swahili: 'Jakpoti',
  vietnamese: 'Giải độc đắc',
};
export const gameConfigsText: Translation = {
  amharic: 'የጨዋታ ቅንብሮች',
  arabic: 'إعدادات اللعبة',
  bengali: 'গেম কনফিগ',
  chinese: '游戏配置',
  english: 'Game Configs',
  estonian: 'Mängu seaded',
  filipino: 'Mga Config ng Laro',
  french: 'Configs de jeu',
  german: 'Spielkonfigurationen',
  hindi: 'गेम कॉन्फ़िगरेशन',
  indonesian: 'Konfigurasi Game',
  japanese: 'ゲーム設定',
  korean: '게임 설정',
  portuguese: 'Configurações de Jogo',
  russian: 'Конфигурации игр',
  spanish: 'Configuraciones de Juego',
  swahili: 'Usanidi wa Mchezo',
  vietnamese: 'Cấu hình trò chơi',
};
export const analyticsText: Translation = {
  amharic: 'ትንታኔዎች',
  arabic: 'التحليلات',
  bengali: 'বিশ্লেষণ',
  chinese: '分析',
  english: 'Analytics',
  estonian: 'Analüütika',
  filipino: 'Mga Analytics',
  french: 'Analytique',
  german: 'Analytik',
  hindi: 'विश्लेषण',
  indonesian: 'Analitik',
  japanese: 'アナリティクス',
  korean: '분석',
  portuguese: 'Análises',
  russian: 'Аналитика',
  spanish: 'Análisis',
  swahili: 'Uchambuzi',
  vietnamese: 'Phân tích',
};
export const forecastText: Translation = {
  amharic: 'ትንበያ',
  arabic: 'التوقعات',
  bengali: 'পূর্বাভাস',
  chinese: '预测',
  english: 'Forecast',
  estonian: 'Prognoos',
  filipino: 'Hula',
  french: 'Prévisions',
  german: 'Prognose',
  hindi: 'पूर्वानुमान',
  indonesian: 'Prakiraan',
  japanese: '予測',
  korean: '예측',
  portuguese: 'Previsão',
  russian: 'Прогноз',
  spanish: 'Pronóstico',
  swahili: 'Utabiri',
  vietnamese: 'Dự báo',
};
export const totalRevenueText: Translation = {
  amharic: 'ጠቅላላ ገቢ',
  arabic: 'إجمالي الإيرادات',
  bengali: 'মোট রাজস্ব',
  chinese: '总收入',
  english: 'Total Revenue',
  estonian: 'Kogutulu',
  filipino: 'Kabuuang Kita',
  french: 'Revenus totaux',
  german: 'Gesamteinnahmen',
  hindi: 'कुल राजस्व',
  indonesian: 'Total Pendapatan',
  japanese: '総収益',
  korean: '총 수익',
  portuguese: 'Receita Total',
  russian: 'Общий доход',
  spanish: 'Ingresos Totales',
  swahili: 'Mapato Jumla',
  vietnamese: 'Tổng doanh thu',
};
export const gamesPlayedText: Translation = {
  amharic: 'የተጫወቱ ጨዋታዎች',
  arabic: 'الألعاب التي تم لعبها',
  bengali: 'খেলা হয়েছে',
  chinese: '已玩游戏',
  english: 'Games Played',
  estonian: 'Mängitud mänge',
  filipino: 'Mga Larong Nilaro',
  french: 'Parties jouées',
  german: 'Gespielte Spiele',
  hindi: 'खेले गए खेल',
  indonesian: 'Game Dimainkan',
  japanese: 'プレイしたゲーム',
  korean: '플레이한 게임',
  portuguese: 'Jogos Disputados',
  russian: 'Сыгранные игры',
  spanish: 'Juegos Jugados',
  swahili: 'Michezo Iliyochezwa',
  vietnamese: 'Trò chơi đã chơi',
};
export const payInCreditsText: Translation = {
  amharic: 'የገቢ ክሬዲቶች',
  arabic: 'أرصدة الإيداع',
  bengali: 'জমা ক্রেডিট',
  chinese: '充值额度',
  english: 'Pay In Credits',
  estonian: 'Sissemaksed',
  filipino: 'Mga Deposito',
  french: 'Crédits déposés',
  german: 'Einzahlungen',
  hindi: 'जमा क्रेडिट',
  indonesian: 'Kredit Masuk',
  japanese: '入金クレジット',
  korean: '입금 크레딧',
  portuguese: 'Créditos Depositados',
  russian: 'Зачисленные кредиты',
  spanish: 'Créditos Depositados',
  swahili: 'Mikopo ya Malipo',
  vietnamese: 'Tín dụng nạp',
};
export const payOutCreditsText: Translation = {
  amharic: 'የወጪ ክሬዲቶች',
  arabic: 'أرصدة السحب',
  bengali: 'উত্তোলন ক্রেডিট',
  chinese: '提现额度',
  english: 'Pay Out Credits',
  estonian: 'Väljamaksed',
  filipino: 'Mga Withdrawal',
  french: 'Crédits retirés',
  german: 'Auszahlungen',
  hindi: 'निकासी क्रेडिट',
  indonesian: 'Kredit Keluar',
  japanese: '出金クレジット',
  korean: '출금 크레딧',
  portuguese: 'Créditos Retirados',
  russian: 'Выведенные кредиты',
  spanish: 'Créditos Retirados',
  swahili: 'Mikopo ya Malipo ya Nje',
  vietnamese: 'Tín dụng rút',
};
export const commissionCreditsText: Translation = {
  amharic: 'የኮሚሽን ክሬዲቶች',
  arabic: 'أرصدة العمولة',
  bengali: 'কমিশন ক্রেডিট',
  chinese: '佣金额度',
  english: 'Commission Credits',
  estonian: 'Komisjonitasud',
  filipino: 'Mga Komisyon',
  french: 'Crédits de commission',
  german: 'Provisionen',
  hindi: 'कमीशन क्रेडिट',
  indonesian: 'Kredit Komisi',
  japanese: 'コミッションクレジット',
  korean: '커미션 크레딧',
  portuguese: 'Créditos de Comissão',
  russian: 'Комиссионные кредиты',
  spanish: 'Créditos de Comisión',
  swahili: 'Mikopo ya Kamisheni',
  vietnamese: 'Tín dụng hoa hồng',
};
export const platformRevenueText: Translation = {
  amharic: 'የመድረክ ገቢ',
  arabic: 'إيرادات المنصة',
  bengali: 'প্ল্যাটফর্ম রাজস্ব',
  chinese: '平台收入',
  english: 'Platform Revenue',
  estonian: 'Platvormi tulu',
  filipino: 'Kita ng Platform',
  french: 'Revenus de la plateforme',
  german: 'Plattformeinnahmen',
  hindi: 'प्लेटफ़ॉर्म राजस्व',
  indonesian: 'Pendapatan Platform',
  japanese: 'プラットフォーム収益',
  korean: '플랫폼 수익',
  portuguese: 'Receita da Plataforma',
  russian: 'Доход платформы',
  spanish: 'Ingresos de la Plataforma',
  swahili: 'Mapato ya Jukwaa',
  vietnamese: 'Doanh thu nền tảng',
};
export const gameAnalyticsText: Translation = {
  amharic: 'የጨዋታ ትንታኔዎች',
  arabic: 'تحليلات اللعبة',
  bengali: 'গেম বিশ্লেষণ',
  chinese: '游戏分析',
  english: 'Game Analytics',
  estonian: 'Mängu analüütika',
  filipino: 'Mga Analytics ng Laro',
  french: 'Analytique des jeux',
  german: 'Spielanalytik',
  hindi: 'गेम विश्लेषण',
  indonesian: 'Analitik Game',
  japanese: 'ゲーム分析',
  korean: '게임 분석',
  portuguese: 'Análises de Jogos',
  russian: 'Аналитика игр',
  spanish: 'Análisis de Juegos',
  swahili: 'Uchambuzi wa Michezo',
  vietnamese: 'Phân tích trò chơi',
};
export const gameConfigurationsText: Translation = {
  amharic: 'የጨዋታ ቅንብሮች',
  arabic: 'إعدادات اللعبة',
  bengali: 'গেম কনফিগারেশন',
  chinese: '游戏配置',
  english: 'Game Configurations',
  estonian: 'Mängu seadistused',
  filipino: 'Mga Konfigurasyong ng Laro',
  french: 'Configurations de jeu',
  german: 'Spielkonfigurationen',
  hindi: 'गेम कॉन्फ़िगरेशन',
  indonesian: 'Konfigurasi Permainan',
  japanese: 'ゲーム構成',
  korean: '게임 구성',
  portuguese: 'Configurações de Jogos',
  russian: 'Конфигурации игр',
  spanish: 'Configuraciones de Juegos',
  swahili: 'Usanidi wa Michezo',
  vietnamese: 'Cấu hình trò chơi',
};
export const newConfigurationText: Translation = {
  amharic: 'አዲስ ቅንብር',
  arabic: 'إعداد جديد',
  bengali: 'নতুন কনফিগারেশন',
  chinese: '新配置',
  english: 'New Configuration',
  estonian: 'Uus seadistus',
  filipino: 'Bagong Konfigurasyong',
  french: 'Nouvelle configuration',
  german: 'Neue Konfiguration',
  hindi: 'नया कॉन्फ़िगरेशन',
  indonesian: 'Konfigurasi Baru',
  japanese: '新しい設定',
  korean: '새 구성',
  portuguese: 'Nova Configuração',
  russian: 'Новая конфигурация',
  spanish: 'Nueva Configuración',
  swahili: 'Usanidi Mpya',
  vietnamese: 'Cấu hình mới',
};
export const totalStakesText: Translation = {
  amharic: 'ጠቅላላ ውርርዶች',
  arabic: 'إجمالي الرهانات',
  bengali: 'মোট বাজি',
  chinese: '总投注',
  english: 'Total Stakes',
  estonian: 'Panused kokku',
  filipino: 'Kabuuang Taya',
  french: 'Mises totales',
  german: 'Gesamteinsätze',
  hindi: 'कुल दांव',
  indonesian: 'Total Taruhan',
  japanese: '総ステーク',
  korean: '총 스테이크',
  portuguese: 'Apostas Totais',
  russian: 'Общие ставки',
  spanish: 'Apuestas Totales',
  swahili: 'Jumla ya Vigingi',
  vietnamese: 'Tổng cược',
};
export const overallRtpText: Translation = {
  amharic: 'ጠቅላላ RTP',
  arabic: 'RTP الإجمالي',
  bengali: 'সামগ্রিক RTP',
  chinese: '总RTP',
  english: 'Overall RTP',
  estonian: 'Üldine RTP',
  filipino: 'Kabuuang RTP',
  french: 'RTP global',
  german: 'Gesamt-RTP',
  hindi: 'समग्र RTP',
  indonesian: 'RTP Keseluruhan',
  japanese: '全体RTP',
  korean: '전체 RTP',
  portuguese: 'RTP Geral',
  russian: 'Общий RTP',
  spanish: 'RTP General',
  swahili: 'RTP Jumla',
  vietnamese: 'RTP tổng thể',
};
export const houseEdgeText: Translation = {
  amharic: 'የቤት ጥቅም',
  arabic: 'ميزة الكازينو',
  bengali: 'হাউস এজ',
  chinese: '庄家优势',
  english: 'House Edge',
  estonian: 'Maja eelis',
  filipino: 'Bentahe ng Bahay',
  french: 'Avantage maison',
  german: 'Hausvorteil',
  hindi: 'हाउस एज',
  indonesian: 'Keunggulan Rumah',
  japanese: 'ハウスエッジ',
  korean: '하우스 엣지',
  portuguese: 'Vantagem da Casa',
  russian: 'Преимущество казино',
  spanish: 'Ventaja de la Casa',
  swahili: 'Faida ya Nyumba',
  vietnamese: 'Lợi thế nhà cái',
};
export const totalGamesText: Translation = {
  amharic: 'ጠቅላላ ጨዋታዎች',
  arabic: 'إجمالي الألعاب',
  bengali: 'মোট গেম',
  chinese: '总游戏数',
  english: 'Total Games',
  estonian: 'Mänge kokku',
  filipino: 'Kabuuang Laro',
  french: 'Total des parties',
  german: 'Spiele gesamt',
  hindi: 'कुल गेम',
  indonesian: 'Total Game',
  japanese: 'ゲーム合計',
  korean: '총 게임',
  portuguese: 'Total de Jogos',
  russian: 'Всего игр',
  spanish: 'Juegos Totales',
  swahili: 'Jumla ya Michezo',
  vietnamese: 'Tổng số trò chơi',
};
export const revenueOverTimeText: Translation = {
  amharic: 'ከጊዜ ወደ ጊዜ ገቢ',
  arabic: 'الإيرادات عبر الزمن',
  bengali: 'সময়ের সাথে রাজস্ব',
  chinese: '收入趋势',
  english: 'Revenue Over Time',
  estonian: 'Tulu aja jooksul',
  filipino: 'Kita sa Paglipas ng Panahon',
  french: 'Revenus dans le temps',
  german: 'Einnahmen im Zeitverlauf',
  hindi: 'समय के साथ राजस्व',
  indonesian: 'Pendapatan Seiring Waktu',
  japanese: '収益推移',
  korean: '시간에 따른 수익',
  portuguese: 'Receita ao Longo do Tempo',
  russian: 'Доход за период',
  spanish: 'Ingresos en el Tiempo',
  swahili: 'Mapato kwa Wakati',
  vietnamese: 'Doanh thu theo thời gian',
};
export const actualRtpOverTimeText: Translation = {
  amharic: 'ከጊዜ ወደ ጊዜ ትክክለኛ RTP',
  arabic: 'RTP الفعلي عبر الزمن',
  bengali: 'সময়ের সাথে প্রকৃত RTP',
  chinese: '实际RTP趋势',
  english: 'Actual RTP Over Time',
  estonian: 'Tegelik RTP aja jooksul',
  filipino: 'Aktwal na RTP sa Paglipas ng Panahon',
  french: 'RTP réel dans le temps',
  german: 'Tatsächlicher RTP im Zeitverlauf',
  hindi: 'समय के साथ वास्तविक RTP',
  indonesian: 'RTP Aktual Seiring Waktu',
  japanese: '実際のRTP推移',
  korean: '시간에 따른 실제 RTP',
  portuguese: 'RTP Real ao Longo do Tempo',
  russian: 'Фактический RTP за период',
  spanish: 'RTP Real en el Tiempo',
  swahili: 'RTP Halisi kwa Wakati',
  vietnamese: 'RTP thực tế theo thời gian',
};
export const gameVolumeByTypeText: Translation = {
  amharic: 'በዓይነት የጨዋታ መጠን',
  arabic: 'حجم اللعب حسب النوع',
  bengali: 'ধরন অনুযায়ী গেমের পরিমাণ',
  chinese: '按类型的游戏量',
  english: 'Game Volume by Type',
  estonian: 'Mängude maht tüübi järgi',
  filipino: 'Dami ng Laro ayon sa Uri',
  french: 'Volume de jeu par type',
  german: 'Spielvolumen nach Typ',
  hindi: 'प्रकार के अनुसार गेम वॉल्यूम',
  indonesian: 'Volume Game per Jenis',
  japanese: 'タイプ別ゲーム数',
  korean: '유형별 게임 볼륨',
  portuguese: 'Volume de Jogos por Tipo',
  russian: 'Объём игр по типу',
  spanish: 'Volumen de Juegos por Tipo',
  swahili: 'Kiasi cha Michezo kwa Aina',
  vietnamese: 'Khối lượng trò chơi theo loại',
};
export const dailyBreakdownText: Translation = {
  amharic: 'ዕለታዊ ትንታኔ',
  arabic: 'التفصيل اليومي',
  bengali: 'দৈনিক বিশ্লেষণ',
  chinese: '每日明细',
  english: 'Daily Breakdown',
  estonian: 'Päevane ülevaade',
  filipino: 'Pang-araw-araw na Breakdown',
  french: 'Répartition quotidienne',
  german: 'Tägliche Aufschlüsselung',
  hindi: 'दैनिक विवरण',
  indonesian: 'Rincian Harian',
  japanese: '日次内訳',
  korean: '일별 분석',
  portuguese: 'Análise Diária',
  russian: 'Ежедневная разбивка',
  spanish: 'Desglose Diario',
  swahili: 'Uchambuzi wa Kila Siku',
  vietnamese: 'Phân tích hàng ngày',
};
export const revenueLast30DaysText: Translation = {
  amharic: 'ባለፉት 30 ቀናት ገቢ',
  arabic: 'الإيرادات (آخر 30 يومًا)',
  bengali: 'রাজস্ব (গত ৩০ দিন)',
  chinese: '收入（近30天）',
  english: 'Revenue (Last 30 Days)',
  estonian: 'Tulu (viimased 30 päeva)',
  filipino: 'Kita (Huling 30 Araw)',
  french: 'Revenus (30 derniers jours)',
  german: 'Einnahmen (letzte 30 Tage)',
  hindi: 'राजस्व (पिछले 30 दिन)',
  indonesian: 'Pendapatan (30 Hari Terakhir)',
  japanese: '収益（過去30日間）',
  korean: '수익 (최근 30일)',
  portuguese: 'Receita (Últimos 30 Dias)',
  russian: 'Доход (за 30 дней)',
  spanish: 'Ingresos (Últimos 30 Días)',
  swahili: 'Mapato (Siku 30 Zilizopita)',
  vietnamese: 'Doanh thu (30 ngày qua)',
};
export const activePlayersLast30DaysText: Translation = {
  amharic: 'ንቁ ተጫዋቾች (ባለፉት 30 ቀናት)',
  arabic: 'اللاعبون النشطون (آخر 30 يومًا)',
  bengali: 'সক্রিয় খেলোয়াড় (গত ৩০ দিন)',
  chinese: '活跃玩家（近30天）',
  english: 'Active Players (Last 30 Days)',
  estonian: 'Aktiivsed mängijad (viimased 30 päeva)',
  filipino: 'Mga Aktibong Manlalaro (Huling 30 Araw)',
  french: 'Joueurs actifs (30 derniers jours)',
  german: 'Aktive Spieler (letzte 30 Tage)',
  hindi: 'सक्रिय खिलाड़ी (पिछले 30 दिन)',
  indonesian: 'Pemain Aktif (30 Hari Terakhir)',
  japanese: 'アクティブプレイヤー（過去30日間）',
  korean: '활성 플레이어 (최근 30일)',
  portuguese: 'Jogadores Ativos (Últimos 30 Dias)',
  russian: 'Активные игроки (за 30 дней)',
  spanish: 'Jugadores Activos (Últimos 30 Días)',
  swahili: 'Wachezaji Hai (Siku 30 Zilizopita)',
  vietnamese: 'Người chơi hoạt động (30 ngày qua)',
};
export const revenueByGameText: Translation = {
  amharic: 'በጨዋታ ገቢ',
  arabic: 'الإيرادات حسب اللعبة',
  bengali: 'গেম অনুযায়ী রাজস্ব',
  chinese: '按游戏收入',
  english: 'Revenue by Game',
  estonian: 'Tulu mängu järgi',
  filipino: 'Kita ayon sa Laro',
  french: 'Revenus par jeu',
  german: 'Einnahmen nach Spiel',
  hindi: 'गेम के अनुसार राजस्व',
  indonesian: 'Pendapatan per Game',
  japanese: 'ゲーム別収益',
  korean: '게임별 수익',
  portuguese: 'Receita por Jogo',
  russian: 'Доход по играм',
  spanish: 'Ingresos por Juego',
  swahili: 'Mapato kwa Mchezo',
  vietnamese: 'Doanh thu theo trò chơi',
};
export const gamesPlayedByTypeText: Translation = {
  amharic: 'በዓይነት የተጫወቱ ጨዋታዎች',
  arabic: 'الألعاب حسب النوع',
  bengali: 'ধরন অনুযায়ী খেলা',
  chinese: '按类型已玩游戏',
  english: 'Games Played by Type',
  estonian: 'Mängitud mänge tüübi järgi',
  filipino: 'Mga Larong Nilaro ayon sa Uri',
  french: 'Parties jouées par type',
  german: 'Gespielte Spiele nach Typ',
  hindi: 'प्रकार के अनुसार खेले गए खेल',
  indonesian: 'Game Dimainkan per Jenis',
  japanese: 'タイプ別プレイゲーム',
  korean: '유형별 플레이한 게임',
  portuguese: 'Jogos por Tipo',
  russian: 'Игры по типу',
  spanish: 'Juegos por Tipo',
  swahili: 'Michezo kwa Aina',
  vietnamese: 'Trò chơi theo loại',
};
export const jackpotPoolsText: Translation = {
  amharic: 'የጃክፖት ገንዳዎች',
  arabic: 'مجمعات الجوائز',
  bengali: 'জ্যাকপট পুল',
  chinese: '奖池',
  english: 'Jackpot Pools',
  estonian: 'Jackpoti fondid',
  filipino: 'Mga Pool ng Jackpot',
  french: 'Cagnottes',
  german: 'Jackpot-Pools',
  hindi: 'जैकपॉट पूल',
  indonesian: 'Pool Jackpot',
  japanese: 'ジャックポットプール',
  korean: '잭팟 풀',
  portuguese: 'Pools de Jackpot',
  russian: 'Пулы джекпотов',
  spanish: 'Pools de Jackpot',
  swahili: 'Dimbwi la Jakpoti',
  vietnamese: 'Quỹ giải độc đắc',
};
export const topWinnersText: Translation = {
  amharic: 'ከፍተኛ አሸናፊዎች',
  arabic: 'أفضل الفائزين',
  bengali: 'শীর্ষ বিজয়ী',
  chinese: '最大赢家',
  english: 'Top Winners',
  estonian: 'Parimad võitjad',
  filipino: 'Mga Nangungunang Panalo',
  french: 'Meilleurs gagnants',
  german: 'Top-Gewinner',
  hindi: 'शीर्ष विजेता',
  indonesian: 'Pemenang Teratas',
  japanese: 'トップ勝者',
  korean: '최고 우승자',
  portuguese: 'Maiores Vencedores',
  russian: 'Лучшие победители',
  spanish: 'Mejores Ganadores',
  swahili: 'Washindi Wakuu',
  vietnamese: 'Người thắng lớn nhất',
};
export const slotsRevenueText: Translation = {
  amharic: 'የስሎት ገቢ',
  arabic: 'إيرادات السلوت',
  bengali: 'স্লট রাজস্ব',
  chinese: '老虎机收入',
  english: 'Slots Revenue',
  estonian: 'Slotide tulu',
  filipino: 'Kita ng Slots',
  french: 'Revenus des machines à sous',
  german: 'Slots-Einnahmen',
  hindi: 'स्लॉट राजस्व',
  indonesian: 'Pendapatan Slot',
  japanese: 'スロット収益',
  korean: '슬롯 수익',
  portuguese: 'Receita de Slots',
  russian: 'Доход от слотов',
  spanish: 'Ingresos de Slots',
  swahili: 'Mapato ya Sloti',
  vietnamese: 'Doanh thu máy xèng',
};
export const blackjackRevenueText: Translation = {
  amharic: 'የብላክጃክ ገቢ',
  arabic: 'إيرادات البلاك جاك',
  bengali: 'ব্ল্যাকজ্যাক রাজস্ব',
  chinese: '21点收入',
  english: 'Blackjack Revenue',
  estonian: 'Blackjacki tulu',
  filipino: 'Kita ng Blackjack',
  french: 'Revenus du blackjack',
  german: 'Blackjack-Einnahmen',
  hindi: 'ब्लैकजैक राजस्व',
  indonesian: 'Pendapatan Blackjack',
  japanese: 'ブラックジャック収益',
  korean: '블랙잭 수익',
  portuguese: 'Receita de Blackjack',
  russian: 'Доход от блэкджека',
  spanish: 'Ingresos de Blackjack',
  swahili: 'Mapato ya Blackjack',
  vietnamese: 'Doanh thu Blackjack',
};
export const baccaratRevenueText: Translation = {
  amharic: 'የባካራ ገቢ',
  arabic: 'إيرادات الباكارا',
  bengali: 'ব্যাকার্যাট রাজস্ব',
  chinese: '百家乐收入',
  english: 'Baccarat Revenue',
  estonian: 'Baccarat tulu',
  filipino: 'Kita ng Baccarat',
  french: 'Revenus du baccara',
  german: 'Baccarat-Einnahmen',
  hindi: 'बैकारेट राजस्व',
  indonesian: 'Pendapatan Baccarat',
  japanese: 'バカラ収益',
  korean: '바카라 수익',
  portuguese: 'Receita de Baccarat',
  russian: 'Доход от баккары',
  spanish: 'Ingresos de Baccarat',
  swahili: 'Mapato ya Baccarat',
  vietnamese: 'Doanh thu Baccarat',
};
export const kenoRevenueText: Translation = {
  amharic: 'የኬኖ ገቢ',
  arabic: 'إيرادات الكينو',
  bengali: 'কেনো রাজস্ব',
  chinese: '基诺收入',
  english: 'Keno Revenue',
  estonian: 'Keno tulu',
  filipino: 'Kita ng Keno',
  french: 'Revenus du keno',
  german: 'Keno-Einnahmen',
  hindi: 'कीनो राजस्व',
  indonesian: 'Pendapatan Keno',
  japanese: 'ケノ収益',
  korean: '케노 수익',
  portuguese: 'Receita de Keno',
  russian: 'Доход от кено',
  spanish: 'Ingresos de Keno',
  swahili: 'Mapato ya Keno',
  vietnamese: 'Doanh thu Keno',
};
export const bingoRevenueText: Translation = {
  amharic: 'የቢንጎ ገቢ',
  arabic: 'إيرادات البينغو',
  bengali: 'বিঙ্গো রাজস্ব',
  chinese: '宾果收入',
  english: 'Bingo Revenue',
  estonian: 'Bingo tulu',
  filipino: 'Kita ng Bingo',
  french: 'Revenus du bingo',
  german: 'Bingo-Einnahmen',
  hindi: 'बिंगो राजस्व',
  indonesian: 'Pendapatan Bingo',
  japanese: 'ビンゴ収益',
  korean: '빙고 수익',
  portuguese: 'Receita de Bingo',
  russian: 'Доход от бинго',
  spanish: 'Ingresos de Bingo',
  swahili: 'Mapato ya Bingo',
  vietnamese: 'Doanh thu Bingo',
};
export const pokerRevenueText: Translation = {
  amharic: 'የፖከር ገቢ',
  arabic: 'إيرادات البوكر',
  bengali: 'পোকার রাজস্ব',
  chinese: '扑克收入',
  english: 'Poker Revenue',
  estonian: 'Pokkeri tulu',
  filipino: 'Kita ng Poker',
  french: 'Revenus du poker',
  german: 'Poker-Einnahmen',
  hindi: 'पोकर राजस्व',
  indonesian: 'Pendapatan Poker',
  japanese: 'ポーカー収益',
  korean: '포커 수익',
  portuguese: 'Receita de Poker',
  russian: 'Доход от покера',
  spanish: 'Ingresos de Poker',
  swahili: 'Mapato ya Poker',
  vietnamese: 'Doanh thu Poker',
};
export const rouletteRevenueText: Translation = {
  amharic: 'የሩሌት ገቢ',
  arabic: 'إيرادات الروليت',
  bengali: 'রুলেট রাজস্ব',
  chinese: '轮盘收入',
  english: 'Roulette Revenue',
  estonian: 'Ruleti tulu',
  filipino: 'Kita ng Roulette',
  french: 'Revenus de la roulette',
  german: 'Roulette-Einnahmen',
  hindi: 'रूलेट राजस्व',
  indonesian: 'Pendapatan Roulette',
  japanese: 'ルーレット収益',
  korean: '룰렛 수익',
  portuguese: 'Receita de Roleta',
  russian: 'Доход от рулетки',
  spanish: 'Ingresos de Ruleta',
  swahili: 'Mapato ya Roulette',
  vietnamese: 'Doanh thu Roulette',
};
export const mercuryRevenueText: Translation = {
  amharic: 'የሜርኩሪ ገቢ',
  arabic: 'إيرادات ميركوري',
  bengali: 'মার্কারি রাজস্ব',
  chinese: '水星收入',
  english: 'Mercury Revenue',
  estonian: 'Merkuuri tulu',
  filipino: 'Kita ng Mercury',
  french: 'Revenus de Mercure',
  german: 'Mercury-Einnahmen',
  hindi: 'मर्करी राजस्व',
  indonesian: 'Pendapatan Mercury',
  japanese: 'マーキュリー収益',
  korean: '머큐리 수익',
  portuguese: 'Receita de Mercury',
  russian: 'Доход от Mercury',
  spanish: 'Ingresos de Mercury',
  swahili: 'Mapato ya Mercury',
  vietnamese: 'Doanh thu Mercury',
};
export const speedBlackjackRevenueText: Translation = {
  amharic: 'የፈጣን ብላክጃክ ገቢ',
  arabic: 'إيرادات بلاك جاك السريع',
  bengali: 'স্পিড ব্ল্যাকজ্যাক রাজস্ব',
  chinese: '极速21点收入',
  english: 'Speed Blackjack Revenue',
  estonian: 'Kiire Blackjacki tulu',
  filipino: 'Kita ng Speed Blackjack',
  french: 'Revenus du blackjack rapide',
  german: 'Speed-Blackjack-Einnahmen',
  hindi: 'स्पीड ब्लैकजैक राजस्व',
  indonesian: 'Pendapatan Speed Blackjack',
  japanese: 'スピードブラックジャック収益',
  korean: '스피드 블랙잭 수익',
  portuguese: 'Receita de Speed Blackjack',
  russian: 'Доход от скоростного блэкджека',
  spanish: 'Ingresos de Speed Blackjack',
  swahili: 'Mapato ya Speed Blackjack',
  vietnamese: 'Doanh thu Speed Blackjack',
};
export const sportsBettingRevenueText: Translation = {
  amharic: 'የስፖርት ውርርድ ገቢ',
  arabic: 'إيرادات المراهنات الرياضية',
  bengali: 'ক্রীড়া বাজি রাজস্ব',
  chinese: '体育博彩收入',
  english: 'Sports Betting Revenue',
  estonian: 'Spordiennustuste tulu',
  filipino: 'Kita ng Sports Betting',
  french: 'Revenus des paris sportifs',
  german: 'Sportwetten-Einnahmen',
  hindi: 'स्पोर्ट्स बेटिंग राजस्व',
  indonesian: 'Pendapatan Taruhan Olahraga',
  japanese: 'スポーツベッティング収益',
  korean: '스포츠 베팅 수익',
  portuguese: 'Receita de Apostas Esportivas',
  russian: 'Доход от ставок на спорт',
  spanish: 'Ingresos de Apuestas Deportivas',
  swahili: 'Mapato ya Kamari za Michezo',
  vietnamese: 'Doanh thu cá cược thể thao',
};

export const docsTocOnThisPage: Translation = {
  amharic: 'በዚህ ገጽ ላይ',
  arabic: 'في هذه الصفحة',
  bengali: 'এই পৃষ্ঠায়',
  chinese: '本页内容',
  english: 'On this page',
  estonian: 'Sellel lehel',
  filipino: 'Sa pahinang ito',
  french: 'Sur cette page',
  german: 'Auf dieser Seite',
  hindi: 'इस पृष्ठ पर',
  indonesian: 'Di halaman ini',
  japanese: 'このページの内容',
  korean: '이 페이지에서',
  portuguese: 'Nesta página',
  russian: 'На этой странице',
  spanish: 'En esta página',
  swahili: 'Kwenye ukurasa huu',
  vietnamese: 'Trên trang này',
};

export const docsNavPrevious: Translation = {
  amharic: 'ቀዳሚ',
  arabic: 'السابق',
  bengali: 'পূর্ববর্তী',
  chinese: '上一篇',
  english: 'Previous',
  estonian: 'Eelmine',
  filipino: 'Nakaraan',
  french: 'Précédent',
  german: 'Zurück',
  hindi: 'पिछला',
  indonesian: 'Sebelumnya',
  japanese: '前へ',
  korean: '이전',
  portuguese: 'Anterior',
  russian: 'Назад',
  spanish: 'Anterior',
  swahili: 'Iliyotangulia',
  vietnamese: 'Trước',
};

export const docsNavNext: Translation = {
  amharic: 'ቀጣይ',
  arabic: 'التالي',
  bengali: 'পরবর্তী',
  chinese: '下一篇',
  english: 'Next',
  estonian: 'Järgmine',
  filipino: 'Susunod',
  french: 'Suivant',
  german: 'Weiter',
  hindi: 'अगला',
  indonesian: 'Selanjutnya',
  japanese: '次へ',
  korean: '다음',
  portuguese: 'Próximo',
  russian: 'Далее',
  spanish: 'Siguiente',
  swahili: 'Inayofuata',
  vietnamese: 'Tiếp',
};

export const carouselT: Translation = {
  amharic: 'ተንሸራታች',
  arabic: 'دوّار العرض',
  bengali: 'ক্যারোজেল',
  chinese: '轮播',
  english: 'Carousel',
  estonian: 'Karussell',
  filipino: 'Carousel',
  french: 'Carrousel',
  german: 'Karussell',
  hindi: 'कैरोसेल',
  indonesian: 'Korsel',
  japanese: 'カルーセル',
  korean: '캐러셀',
  portuguese: 'Carrossel',
  russian: 'Карусель',
  spanish: 'Carrusel',
  swahili: 'Kaurseli',
  vietnamese: 'Băng chuyền',
};
export const clearT: Translation = {
  amharic: 'አጽዳ',
  arabic: 'مسح',
  bengali: 'পরিষ্কার করুন',
  chinese: '清除',
  english: 'Clear',
  estonian: 'Tühjenda',
  filipino: 'I-clear',
  french: 'Effacer',
  german: 'Leeren',
  hindi: 'साफ़ करें',
  indonesian: 'Kosongkan',
  japanese: 'クリア',
  korean: '지우기',
  portuguese: 'Limpar',
  russian: 'Очистить',
  spanish: 'Limpiar',
  swahili: 'Futa',
  vietnamese: 'Xóa',
};
export const searchT: Translation = {
  amharic: 'ፈልግ',
  arabic: 'بحث',
  bengali: 'খুঁজুন',
  chinese: '搜索',
  english: 'Search',
  estonian: 'Otsi',
  filipino: 'Maghanap',
  french: 'Rechercher',
  german: 'Suchen',
  hindi: 'खोजें',
  indonesian: 'Cari',
  japanese: '検索',
  korean: '검색',
  portuguese: 'Pesquisar',
  russian: 'Поиск',
  spanish: 'Buscar',
  swahili: 'Tafuta',
  vietnamese: 'Tìm kiếm',
};

export const bulkAction: Translation = {
  amharic: 'የጅምላ እርምጃ',
  arabic: 'إجراء جماعي',
  bengali: 'বাল্ক অ্যাকশন',
  chinese: '批量操作',
  english: 'Bulk action',
  estonian: 'Hulgitoiming',
  filipino: 'Bulk na aksyon',
  french: 'Action groupée',
  german: 'Massenaktion',
  hindi: 'थोक कार्रवाई',
  indonesian: 'Tindakan massal',
  japanese: '一括操作',
  korean: '일괄 작업',
  portuguese: 'Ação em massa',
  russian: 'Массовое действие',
  spanish: 'Acción masiva',
  swahili: 'Kitendo cha wingi',
  vietnamese: 'Hành động hàng loạt',
};

export const noRows: Translation = {
  amharic: 'ረድፎች የሉም',
  arabic: 'لا توجد صفوف',
  bengali: 'কোনো সারি নেই',
  chinese: '无行',
  english: 'No rows',
  estonian: 'Ridu pole',
  filipino: 'Walang mga hilera',
  french: 'Aucune ligne',
  german: 'Keine Zeilen',
  hindi: 'कोई पंक्ति नहीं',
  indonesian: 'Tidak ada baris',
  japanese: '行がありません',
  korean: '행이 없습니다',
  portuguese: 'Sem linhas',
  russian: 'Нет строк',
  spanish: 'Sin filas',
  swahili: 'Hakuna safu',
  vietnamese: 'Không có hàng',
};

export const rowsPerPage: Translation = {
  amharic: 'ረድፎች በገጽ፦',
  arabic: 'عدد الصفوف في الصفحة:',
  bengali: 'প্রতি পৃষ্ঠায় সারি:',
  chinese: '每页行数：',
  english: 'Rows per page:',
  estonian: 'Ridu lehel:',
  filipino: 'Mga hilera bawat pahina:',
  french: 'Lignes par page :',
  german: 'Zeilen pro Seite:',
  hindi: 'प्रति पृष्ठ पंक्तियाँ:',
  indonesian: 'Baris per halaman:',
  japanese: 'ページあたりの行数：',
  korean: '페이지당 행 수:',
  portuguese: 'Linhas por página:',
  russian: 'Строк на странице:',
  spanish: 'Filas por página:',
  swahili: 'Safu kwa ukurasa:',
  vietnamese: 'Số hàng mỗi trang:',
};

export const displayedRowsRange: Translation = {
  amharic: '{from}–{to} ከ {count}',
  arabic: '{from}–{to} من {count}',
  bengali: '{count}টির মধ্যে {from}–{to}',
  chinese: '第 {from}–{to} 条，共 {count} 条',
  english: '{from}–{to} of {count}',
  estonian: '{from}–{to} / {count}',
  filipino: '{from}–{to} ng {count}',
  french: '{from}–{to} sur {count}',
  german: '{from}–{to} von {count}',
  hindi: '{count} में से {from}–{to}',
  indonesian: '{from}–{to} dari {count}',
  japanese: '{count}件中 {from}–{to}件',
  korean: '{count}개 중 {from}–{to}',
  portuguese: '{from}–{to} de {count}',
  russian: '{from}–{to} из {count}',
  spanish: '{from}–{to} de {count}',
  swahili: '{from}–{to} kati ya {count}',
  vietnamese: '{from}–{to} trong {count}',
};

export const goToNextPage: Translation = {
  amharic: 'ወደ ቀጣዩ ገጽ ሂድ',
  arabic: 'الانتقال إلى الصفحة التالية',
  bengali: 'পরবর্তী পৃষ্ঠায় যান',
  chinese: '转到下一页',
  english: 'Go to next page',
  estonian: 'Mine järgmisele lehele',
  filipino: 'Pumunta sa susunod na pahina',
  french: 'Aller à la page suivante',
  german: 'Zur nächsten Seite',
  hindi: 'अगले पृष्ठ पर जाएँ',
  indonesian: 'Ke halaman berikutnya',
  japanese: '次のページへ',
  korean: '다음 페이지로 이동',
  portuguese: 'Ir para a próxima página',
  russian: 'Перейти на следующую страницу',
  spanish: 'Ir a la página siguiente',
  swahili: 'Nenda ukurasa unaofuata',
  vietnamese: 'Đến trang tiếp theo',
};

export const goToPreviousPage: Translation = {
  amharic: 'ወደ ቀዳሚው ገጽ ሂድ',
  arabic: 'الانتقال إلى الصفحة السابقة',
  bengali: 'পূর্ববর্তী পৃষ্ঠায় যান',
  chinese: '转到上一页',
  english: 'Go to previous page',
  estonian: 'Mine eelmisele lehele',
  filipino: 'Pumunta sa nakaraang pahina',
  french: 'Aller à la page précédente',
  german: 'Zur vorherigen Seite',
  hindi: 'पिछले पृष्ठ पर जाएँ',
  indonesian: 'Ke halaman sebelumnya',
  japanese: '前のページへ',
  korean: '이전 페이지로 이동',
  portuguese: 'Ir para a página anterior',
  russian: 'Перейти на предыдущую страницу',
  spanish: 'Ir a la página anterior',
  swahili: 'Nenda ukurasa uliopita',
  vietnamese: 'Về trang trước',
};

export const noResultsFound: Translation = {
  amharic: 'ምንም ውጤት አልተገኘም',
  arabic: 'لم يتم العثور على نتائج',
  bengali: 'কোনো ফলাফল পাওয়া যায়নি',
  chinese: '未找到结果',
  english: 'No results found',
  estonian: 'Tulemusi ei leitud',
  filipino: 'Walang nahanap na resulta',
  french: 'Aucun résultat trouvé',
  german: 'Keine Ergebnisse gefunden',
  hindi: 'कोई परिणाम नहीं मिला',
  indonesian: 'Tidak ada hasil yang ditemukan',
  japanese: '結果が見つかりません',
  korean: '결과를 찾을 수 없습니다',
  portuguese: 'Nenhum resultado encontrado',
  russian: 'Результаты не найдены',
  spanish: 'No se encontraron resultados',
  swahili: 'Hakuna matokeo yaliyopatikana',
  vietnamese: 'Không tìm thấy kết quả',
};

export const checkboxSelectionT: Translation = {
  amharic: 'የምልክት ሳጥን ምርጫ',
  arabic: 'تحديد بمربع اختيار',
  bengali: 'চেকবক্স নির্বাচন',
  chinese: '复选框选择',
  english: 'Checkbox selection',
  estonian: 'Märkeruuduga valik',
  filipino: 'Pagpili gamit ang checkbox',
  french: 'Sélection par case à cocher',
  german: 'Auswahl per Kontrollkästchen',
  hindi: 'चेकबॉक्स चयन',
  indonesian: 'Pilihan kotak centang',
  japanese: 'チェックボックス選択',
  korean: '체크박스 선택',
  portuguese: 'Seleção por caixa de seleção',
  russian: 'Выбор флажком',
  spanish: 'Selección con casilla',
  swahili: 'Uteuzi wa kisanduku tiki',
  vietnamese: 'Chọn bằng hộp kiểm',
};

export const selectAllRowsT: Translation = {
  amharic: 'ሁሉንም ረድፎች ምረጥ',
  arabic: 'تحديد كل الصفوف',
  bengali: 'সব সারি নির্বাচন করুন',
  chinese: '选择所有行',
  english: 'Select all rows',
  estonian: 'Vali kõik read',
  filipino: 'Piliin ang lahat ng hilera',
  french: 'Sélectionner toutes les lignes',
  german: 'Alle Zeilen auswählen',
  hindi: 'सभी पंक्तियाँ चुनें',
  indonesian: 'Pilih semua baris',
  japanese: 'すべての行を選択',
  korean: '모든 행 선택',
  portuguese: 'Selecionar todas as linhas',
  russian: 'Выбрать все строки',
  spanish: 'Seleccionar todas las filas',
  swahili: 'Chagua safu zote',
  vietnamese: 'Chọn tất cả các hàng',
};

export const unselectAllRowsT: Translation = {
  amharic: 'የሁሉንም ረድፎች ምርጫ አንሳ',
  arabic: 'إلغاء تحديد كل الصفوف',
  bengali: 'সব সারির নির্বাচন বাতিল করুন',
  chinese: '取消选择所有行',
  english: 'Unselect all rows',
  estonian: 'Tühista kõigi ridade valik',
  filipino: 'Alisin ang pagpili sa lahat ng hilera',
  french: 'Désélectionner toutes les lignes',
  german: 'Auswahl aller Zeilen aufheben',
  hindi: 'सभी पंक्तियों का चयन हटाएँ',
  indonesian: 'Batalkan pilihan semua baris',
  japanese: 'すべての行の選択を解除',
  korean: '모든 행 선택 해제',
  portuguese: 'Desmarcar todas as linhas',
  russian: 'Снять выбор со всех строк',
  spanish: 'Deseleccionar todas las filas',
  swahili: 'Ondoa uteuzi wa safu zote',
  vietnamese: 'Bỏ chọn tất cả các hàng',
};

export const selectRowT: Translation = {
  amharic: 'ረድፍ ምረጥ',
  arabic: 'تحديد الصف',
  bengali: 'সারি নির্বাচন করুন',
  chinese: '选择行',
  english: 'Select row',
  estonian: 'Vali rida',
  filipino: 'Piliin ang hilera',
  french: 'Sélectionner la ligne',
  german: 'Zeile auswählen',
  hindi: 'पंक्ति चुनें',
  indonesian: 'Pilih baris',
  japanese: '行を選択',
  korean: '행 선택',
  portuguese: 'Selecionar linha',
  russian: 'Выбрать строку',
  spanish: 'Seleccionar fila',
  swahili: 'Chagua safu',
  vietnamese: 'Chọn hàng',
};

export const unselectRowT: Translation = {
  amharic: 'የረድፍ ምርጫ አንሳ',
  arabic: 'إلغاء تحديد الصف',
  bengali: 'সারির নির্বাচন বাতিল করুন',
  chinese: '取消选择行',
  english: 'Unselect row',
  estonian: 'Tühista rea valik',
  filipino: 'Alisin ang pagpili sa hilera',
  french: 'Désélectionner la ligne',
  german: 'Zeilenauswahl aufheben',
  hindi: 'पंक्ति का चयन हटाएँ',
  indonesian: 'Batalkan pilihan baris',
  japanese: '行の選択を解除',
  korean: '행 선택 해제',
  portuguese: 'Desmarcar linha',
  russian: 'Снять выбор со строки',
  spanish: 'Deseleccionar fila',
  swahili: 'Ondoa uteuzi wa safu',
  vietnamese: 'Bỏ chọn hàng',
};

export const operatorT: Translation = {
  amharic: 'ኦፕሬተር',
  arabic: 'المُعامل',
  bengali: 'অপারেটর',
  chinese: '运算符',
  english: 'Operator',
  estonian: 'Operaator',
  filipino: 'Operator',
  french: 'Opérateur',
  german: 'Operator',
  hindi: 'ऑपरेटर',
  indonesian: 'Operator',
  japanese: '演算子',
  korean: '연산자',
  portuguese: 'Operador',
  russian: 'Оператор',
  spanish: 'Operador',
  swahili: 'Opereta',
  vietnamese: 'Toán tử',
};

export const valueT: Translation = {
  amharic: 'እሴት',
  arabic: 'القيمة',
  bengali: 'মান',
  chinese: '值',
  english: 'Value',
  estonian: 'Väärtus',
  filipino: 'Halaga',
  french: 'Valeur',
  german: 'Wert',
  hindi: 'मान',
  indonesian: 'Nilai',
  japanese: '値',
  korean: '값',
  portuguese: 'Valor',
  russian: 'Значение',
  spanish: 'Valor',
  swahili: 'Thamani',
  vietnamese: 'Giá trị',
};

export const filterValueT: Translation = {
  amharic: 'የማጣሪያ እሴት',
  arabic: 'قيمة التصفية',
  bengali: 'ফিল্টার মান',
  chinese: '筛选值',
  english: 'Filter value',
  estonian: 'Filtri väärtus',
  filipino: 'Halaga ng filter',
  french: 'Valeur du filtre',
  german: 'Filterwert',
  hindi: 'फ़िल्टर मान',
  indonesian: 'Nilai filter',
  japanese: 'フィルター値',
  korean: '필터 값',
  portuguese: 'Valor do filtro',
  russian: 'Значение фильтра',
  spanish: 'Valor del filtro',
  swahili: 'Thamani ya kichujio',
  vietnamese: 'Giá trị bộ lọc',
};

export const yesT: Translation = {
  amharic: 'አዎ',
  arabic: 'نعم',
  bengali: 'হ্যাঁ',
  chinese: '是',
  english: 'Yes',
  estonian: 'Jah',
  filipino: 'Oo',
  french: 'Oui',
  german: 'Ja',
  hindi: 'हाँ',
  indonesian: 'Ya',
  japanese: 'はい',
  korean: '예',
  portuguese: 'Sim',
  russian: 'Да',
  spanish: 'Sí',
  swahili: 'Ndiyo',
  vietnamese: 'Có',
};

export const noT: Translation = {
  amharic: 'አይ',
  arabic: 'لا',
  bengali: 'না',
  chinese: '否',
  english: 'No',
  estonian: 'Ei',
  filipino: 'Hindi',
  french: 'Non',
  german: 'Nein',
  hindi: 'नहीं',
  indonesian: 'Tidak',
  japanese: 'いいえ',
  korean: '아니요',
  portuguese: 'Não',
  russian: 'Нет',
  spanish: 'No',
  swahili: 'Hapana',
  vietnamese: 'Không',
};

export const containsT: Translation = {
  amharic: 'ይዟል',
  arabic: 'يحتوي على',
  bengali: 'ধারণ করে',
  chinese: '包含',
  english: 'contains',
  estonian: 'sisaldab',
  filipino: 'naglalaman ng',
  french: 'contient',
  german: 'enthält',
  hindi: 'शामिल है',
  indonesian: 'mengandung',
  japanese: '含む',
  korean: '포함',
  portuguese: 'contém',
  russian: 'содержит',
  spanish: 'contiene',
  swahili: 'ina',
  vietnamese: 'chứa',
};

export const equalsT: Translation = {
  amharic: 'እኩል ነው',
  arabic: 'يساوي',
  bengali: 'সমান',
  chinese: '等于',
  english: 'equals',
  estonian: 'võrdub',
  filipino: 'katumbas ng',
  french: 'égale',
  german: 'ist gleich',
  hindi: 'बराबर है',
  indonesian: 'sama dengan',
  japanese: '等しい',
  korean: '같음',
  portuguese: 'é igual a',
  russian: 'равно',
  spanish: 'es igual a',
  swahili: 'sawa na',
  vietnamese: 'bằng',
};

export const startsWithT: Translation = {
  amharic: 'የሚጀምረው በ',
  arabic: 'يبدأ بـ',
  bengali: 'দিয়ে শুরু হয়',
  chinese: '开头是',
  english: 'starts with',
  estonian: 'algab',
  filipino: 'nagsisimula sa',
  french: 'commence par',
  german: 'beginnt mit',
  hindi: 'से शुरू होता है',
  indonesian: 'dimulai dengan',
  japanese: 'で始まる',
  korean: '시작 문자',
  portuguese: 'começa com',
  russian: 'начинается с',
  spanish: 'empieza por',
  swahili: 'huanza na',
  vietnamese: 'bắt đầu bằng',
};

export const endsWithT: Translation = {
  amharic: 'የሚጨርሰው በ',
  arabic: 'ينتهي بـ',
  bengali: 'দিয়ে শেষ হয়',
  chinese: '结尾是',
  english: 'ends with',
  estonian: 'lõpeb',
  filipino: 'nagtatapos sa',
  french: 'se termine par',
  german: 'endet mit',
  hindi: 'से समाप्त होता है',
  indonesian: 'diakhiri dengan',
  japanese: 'で終わる',
  korean: '끝 문자',
  portuguese: 'termina com',
  russian: 'заканчивается на',
  spanish: 'termina en',
  swahili: 'huishia na',
  vietnamese: 'kết thúc bằng',
};

export const isEmptyT: Translation = {
  amharic: 'ባዶ ነው',
  arabic: 'فارغ',
  bengali: 'খালি',
  chinese: '为空',
  english: 'is empty',
  estonian: 'on tühi',
  filipino: 'walang laman',
  french: 'est vide',
  german: 'ist leer',
  hindi: 'खाली है',
  indonesian: 'kosong',
  japanese: '空である',
  korean: '비어 있음',
  portuguese: 'está vazio',
  russian: 'пусто',
  spanish: 'está vacío',
  swahili: 'ni tupu',
  vietnamese: 'trống',
};

export const isNotEmptyT: Translation = {
  amharic: 'ባዶ አይደለም',
  arabic: 'ليس فارغًا',
  bengali: 'খালি নয়',
  chinese: '不为空',
  english: 'is not empty',
  estonian: 'ei ole tühi',
  filipino: 'may laman',
  french: "n'est pas vide",
  german: 'ist nicht leer',
  hindi: 'खाली नहीं है',
  indonesian: 'tidak kosong',
  japanese: '空でない',
  korean: '비어 있지 않음',
  portuguese: 'não está vazio',
  russian: 'не пусто',
  spanish: 'no está vacío',
  swahili: 'si tupu',
  vietnamese: 'không trống',
};

export const isAnyOfT: Translation = {
  amharic: 'ከእነዚህ አንዱ ነው',
  arabic: 'أي من',
  bengali: 'যেকোনো একটি',
  chinese: '是其中之一',
  english: 'is any of',
  estonian: 'on üks järgmistest',
  filipino: 'alinman sa',
  french: 'fait partie de',
  german: 'ist eines von',
  hindi: 'इनमें से कोई है',
  indonesian: 'salah satu dari',
  japanese: 'いずれかである',
  korean: '다음 중 하나',
  portuguese: 'é qualquer um de',
  russian: 'любое из',
  spanish: 'es cualquiera de',
  swahili: 'ni mojawapo ya',
  vietnamese: 'là một trong',
};

export const isT: Translation = {
  amharic: 'ነው',
  arabic: 'يساوي',
  bengali: 'হল',
  chinese: '是',
  english: 'is',
  estonian: 'on',
  filipino: 'ay',
  french: 'est',
  german: 'ist',
  hindi: 'है',
  indonesian: 'adalah',
  japanese: 'である',
  korean: '같음',
  portuguese: 'é',
  russian: 'равно',
  spanish: 'es',
  swahili: 'ni',
  vietnamese: 'là',
};

export const isNotT: Translation = {
  amharic: 'አይደለም',
  arabic: 'لا يساوي',
  bengali: 'নয়',
  chinese: '不是',
  english: 'is not',
  estonian: 'ei ole',
  filipino: 'ay hindi',
  french: "n'est pas",
  german: 'ist nicht',
  hindi: 'नहीं है',
  indonesian: 'bukan',
  japanese: 'でない',
  korean: '같지 않음',
  portuguese: 'não é',
  russian: 'не равно',
  spanish: 'no es',
  swahili: 'si',
  vietnamese: 'không phải là',
};

export const isAfterT: Translation = {
  amharic: 'ከዚያ በኋላ ነው',
  arabic: 'بعد',
  bengali: 'পরে',
  chinese: '晚于',
  english: 'is after',
  estonian: 'on pärast',
  filipino: 'ay pagkatapos ng',
  french: 'est après',
  german: 'ist nach',
  hindi: 'के बाद है',
  indonesian: 'setelah',
  japanese: 'より後',
  korean: '이후',
  portuguese: 'é depois de',
  russian: 'после',
  spanish: 'es posterior a',
  swahili: 'ni baada ya',
  vietnamese: 'sau',
};

export const isOnOrAfterT: Translation = {
  amharic: 'በዚያ ቀን ወይም በኋላ ነው',
  arabic: 'في أو بعد',
  bengali: 'ঐ দিনে বা পরে',
  chinese: '等于或晚于',
  english: 'is on or after',
  estonian: 'on samal ajal või pärast',
  filipino: 'ay sa o pagkatapos ng',
  french: 'est le ou après',
  german: 'ist am oder nach',
  hindi: 'उस दिन या बाद है',
  indonesian: 'pada atau setelah',
  japanese: '以降',
  korean: '해당일 또는 이후',
  portuguese: 'é em ou depois de',
  russian: 'в эту дату или после',
  spanish: 'es en o posterior a',
  swahili: 'ni siku hiyo au baada yake',
  vietnamese: 'vào hoặc sau',
};

export const isBeforeT: Translation = {
  amharic: 'ከዚያ በፊት ነው',
  arabic: 'قبل',
  bengali: 'আগে',
  chinese: '早于',
  english: 'is before',
  estonian: 'on enne',
  filipino: 'ay bago ang',
  french: 'est avant',
  german: 'ist vor',
  hindi: 'के पहले है',
  indonesian: 'sebelum',
  japanese: 'より前',
  korean: '이전',
  portuguese: 'é antes de',
  russian: 'до',
  spanish: 'es anterior a',
  swahili: 'ni kabla ya',
  vietnamese: 'trước',
};

export const isOnOrBeforeT: Translation = {
  amharic: 'በዚያ ቀን ወይም በፊት ነው',
  arabic: 'في أو قبل',
  bengali: 'ঐ দিনে বা আগে',
  chinese: '等于或早于',
  english: 'is on or before',
  estonian: 'on samal ajal või enne',
  filipino: 'ay sa o bago ang',
  french: 'est le ou avant',
  german: 'ist am oder vor',
  hindi: 'उस दिन या पहले है',
  indonesian: 'pada atau sebelum',
  japanese: '以前',
  korean: '해당일 또는 이전',
  portuguese: 'é em ou antes de',
  russian: 'в эту дату или до',
  spanish: 'es en o anterior a',
  swahili: 'ni siku hiyo au kabla yake',
  vietnamese: 'vào hoặc trước',
};

export const dataDeletionEyebrow: Translation = {
  amharic: 'ሕጋዊ',
  arabic: 'قانوني',
  bengali: 'আইনি',
  chinese: '法律',
  english: 'Legal',
  estonian: 'Õiguslik',
  filipino: 'Legal',
  french: 'Mentions légales',
  german: 'Rechtliches',
  hindi: 'कानूनी',
  indonesian: 'Hukum',
  japanese: '法的事項',
  korean: '법적 고지',
  portuguese: 'Jurídico',
  russian: 'Юридическая информация',
  spanish: 'Legal',
  swahili: 'Kisheria',
  vietnamese: 'Pháp lý',
};

export const dataDeletionTitle: Translation = {
  amharic: 'መለያ እና ውሂብ',
  arabic: 'الحساب والبيانات',
  bengali: 'অ্যাকাউন্ট ও ডেটা',
  chinese: '账户与数据',
  english: 'Account & data',
  estonian: 'Konto ja andmed',
  filipino: 'Account at data',
  french: 'Compte et données',
  german: 'Konto & Daten',
  hindi: 'खाता और डेटा',
  indonesian: 'Akun & data',
  japanese: 'アカウントとデータの',
  korean: '계정 및 데이터',
  portuguese: 'Conta e dados',
  russian: 'Аккаунт и данные',
  spanish: 'Cuenta y datos',
  swahili: 'Akaunti na data',
  vietnamese: 'Tài khoản & dữ liệu',
};

export const dataDeletionTitleAccent: Translation = {
  amharic: 'መሰረዝ',
  arabic: 'حذف',
  bengali: 'মুছে ফেলা',
  chinese: '删除',
  english: 'deletion',
  estonian: 'kustutamine',
  filipino: 'pagtanggal',
  french: 'suppression',
  german: 'Löschung',
  hindi: 'विलोपन',
  indonesian: 'penghapusan',
  japanese: '削除',
  korean: '삭제',
  portuguese: 'exclusão',
  russian: 'удаление',
  spanish: 'eliminación',
  swahili: 'kufuta',
  vietnamese: 'xóa',
};

export const dataDeletionLastUpdated: Translation = {
  amharic: 'መጨረሻ የተዘመነው ሰኔ 28, 2026',
  arabic: 'آخر تحديث في 28 يونيو 2026',
  bengali: 'সর্বশেষ আপডেট ২৮ জুন, ২০২৬',
  chinese: '最后更新于 2026 年 6 月 28 日',
  english: 'Last updated June 28, 2026',
  estonian: 'Viimati uuendatud 28. juunil 2026',
  filipino: 'Huling na-update noong Hunyo 28, 2026',
  french: 'Dernière mise à jour le 28 juin 2026',
  german: 'Zuletzt aktualisiert am 28. Juni 2026',
  hindi: 'अंतिम बार 28 जून, 2026 को अपडेट किया गया',
  indonesian: 'Terakhir diperbarui 28 Juni 2026',
  japanese: '最終更新日 2026年6月28日',
  korean: '2026년 6월 28일 최종 업데이트',
  portuguese: 'Atualizado pela última vez em 28 de junho de 2026',
  russian: 'Последнее обновление 28 июня 2026 г.',
  spanish: 'Última actualización: 28 de junio de 2026',
  swahili: 'Ilisasishwa mwisho Juni 28, 2026',
  vietnamese: 'Cập nhật lần cuối ngày 28 tháng 6 năm 2026',
};

export const dataDeletionIntro: Translation = {
  amharic: 'በማንኛውም ጊዜ {appName} የተወሰነ ውሂብዎን፣ ወይም ሙሉ መለያዎን እና ተያያዥ ውሂብዎን በሙሉ እንዲሰርዝ መጠየቅ ይችላሉ።',
  arabic: 'يمكنك في أي وقت أن تطلب من {appName} حذف بعض بياناتك، أو حذف حسابك بالكامل وجميع البيانات المرتبطة به.',
  bengali: 'আপনি যেকোনো সময় {appName}-কে আপনার কিছু ডেটা, অথবা আপনার সম্পূর্ণ অ্যাকাউন্ট ও সংশ্লিষ্ট সমস্ত ডেটা মুছে ফেলতে অনুরোধ করতে পারেন।',
  chinese: '您可以随时要求 {appName} 删除您的部分数据，或删除您的整个账户及所有相关数据。',
  english: 'You can ask {appName} to delete some of your data, or your entire account and all associated data, at any time.',
  estonian: 'Võite igal ajal paluda {appName}-l kustutada osa oma andmetest või kogu oma konto ja kõik sellega seotud andmed.',
  filipino: 'Maaari mong hilingin sa {appName} na tanggalin ang ilan sa iyong data, o ang buo mong account at lahat ng kaugnay na data, anumang oras.',
  french: 'Vous pouvez à tout moment demander à {appName} de supprimer une partie de vos données, ou l’intégralité de votre compte et de toutes les données associées.',
  german: 'Sie können {appName} jederzeit bitten, einen Teil Ihrer Daten oder Ihr gesamtes Konto und alle zugehörigen Daten zu löschen.',
  hindi: 'आप किसी भी समय {appName} से अपने कुछ डेटा, या अपने पूरे खाते और सभी संबंधित डेटा को हटाने का अनुरोध कर सकते हैं।',
  indonesian: 'Anda dapat meminta {appName} untuk menghapus sebagian data Anda, atau seluruh akun dan semua data terkait, kapan saja.',
  japanese: 'いつでも {appName} に対して、一部のデータの削除、またはアカウント全体と関連するすべてのデータの削除を依頼できます。',
  korean: '언제든지 {appName}에 일부 데이터 또는 전체 계정과 모든 관련 데이터의 삭제를 요청할 수 있습니다.',
  portuguese: 'Você pode pedir ao {appName} para excluir parte dos seus dados, ou toda a sua conta e todos os dados associados, a qualquer momento.',
  russian: 'Вы можете в любое время попросить {appName} удалить часть ваших данных или весь ваш аккаунт и все связанные с ним данные.',
  spanish: 'Puede pedir a {appName} que elimine parte de sus datos, o toda su cuenta y todos los datos asociados, en cualquier momento.',
  swahili: 'Unaweza kuomba {appName} kufuta baadhi ya data yako, au akaunti yako yote na data yote inayohusiana, wakati wowote.',
  vietnamese: 'Bạn có thể yêu cầu {appName} xóa một phần dữ liệu của bạn, hoặc toàn bộ tài khoản và mọi dữ liệu liên quan, bất cứ lúc nào.',
};

export const dataDeletionInAppHeading: Translation = {
  amharic: 'ከመተግበሪያው ይሰርዙ',
  arabic: 'الحذف من التطبيق',
  bengali: 'অ্যাপ থেকে মুছুন',
  chinese: '在应用内删除',
  english: 'Delete from the app',
  estonian: 'Kustuta rakendusest',
  filipino: 'Magtanggal mula sa app',
  french: 'Supprimer depuis l’application',
  german: 'In der App löschen',
  hindi: 'ऐप से हटाएं',
  indonesian: 'Hapus dari aplikasi',
  japanese: 'アプリから削除する',
  korean: '앱에서 삭제',
  portuguese: 'Excluir pelo aplicativo',
  russian: 'Удалить в приложении',
  spanish: 'Eliminar desde la aplicación',
  swahili: 'Futa kutoka kwa programu',
  vietnamese: 'Xóa từ ứng dụng',
};

export const dataDeletionInAppBody: Translation = {
  amharic: '{appName} ን ይክፈቱ፣ ወደ መገለጫ → ቅንብሮች ይሂዱ እና “መለያ ሰርዝ” የሚለውን ይንኩ። ይህ የመለያዎን እና የተያያዥ ውሂብዎን መሰረዝ በቀጥታ ይጀምራል።',
  arabic: 'افتح {appName}، وانتقل إلى الملف الشخصي ← الإعدادات، ثم اضغط على «حذف الحساب». يبدأ هذا حذف حسابك والبيانات المرتبطة به مباشرةً.',
  bengali: '{appName} খুলুন, প্রোফাইল → সেটিংসে যান এবং “Delete account” ট্যাপ করুন। এটি সরাসরি আপনার অ্যাকাউন্ট ও সংশ্লিষ্ট ডেটা মুছে ফেলা শুরু করে।',
  chinese: '打开 {appName}，进入“个人资料 → 设置”，点按“删除账户”。这将直接开始删除您的账户及相关数据。',
  english: 'Open {appName}, go to Profile → Settings and tap Delete account. This starts the deletion of your account and associated data directly.',
  estonian: 'Avage {appName}, minge jaotisse Profiil → Seaded ja puudutage „Kustuta konto“. See alustab teie konto ja sellega seotud andmete kustutamist otse.',
  filipino: 'Buksan ang {appName}, pumunta sa Profile → Settings at i-tap ang Delete account. Direktang sisimulan nito ang pagtanggal ng iyong account at kaugnay na data.',
  french: 'Ouvrez {appName}, allez dans Profil → Paramètres et appuyez sur Supprimer le compte. La suppression de votre compte et des données associées démarre directement.',
  german: 'Öffnen Sie {appName}, gehen Sie zu Profil → Einstellungen und tippen Sie auf Konto löschen. Die Löschung Ihres Kontos und der zugehörigen Daten beginnt direkt.',
  hindi: '{appName} खोलें, प्रोफ़ाइल → सेटिंग्स पर जाएं और “Delete account” पर टैप करें। इससे आपके खाते और संबंधित डेटा का विलोपन सीधे शुरू हो जाता है।',
  indonesian: 'Buka {appName}, buka Profil → Pengaturan dan ketuk Hapus akun. Ini langsung memulai penghapusan akun Anda dan data terkait.',
  japanese: '{appName} を開き、プロフィール → 設定 に移動して「アカウントを削除」をタップします。アカウントと関連データの削除が直接始まります。',
  korean: '{appName}을(를) 열고 프로필 → 설정으로 이동한 다음 계정 삭제를 누릅니다. 계정과 관련 데이터의 삭제가 바로 시작됩니다.',
  portuguese: 'Abra o {appName}, vá em Perfil → Configurações e toque em Excluir conta. Isso inicia diretamente a exclusão da sua conta e dos dados associados.',
  russian: 'Откройте {appName}, перейдите в Профиль → Настройки и нажмите «Удалить аккаунт». Удаление вашего аккаунта и связанных данных начнётся сразу.',
  spanish: 'Abra {appName}, vaya a Perfil → Ajustes y toque Eliminar cuenta. Esto inicia directamente la eliminación de su cuenta y los datos asociados.',
  swahili: 'Fungua {appName}, nenda kwa Wasifu → Mipangilio kisha gusa “Futa akaunti”. Hii huanza kufuta akaunti yako na data inayohusiana moja kwa moja.',
  vietnamese: 'Mở {appName}, vào Hồ sơ → Cài đặt và nhấn Xóa tài khoản. Thao tác này bắt đầu xóa trực tiếp tài khoản và dữ liệu liên quan của bạn.',
};

export const dataDeletionEmailHeading: Translation = {
  amharic: 'በኢሜይl ይጠይቁ',
  arabic: 'الطلب عبر البريد الإلكتروني',
  bengali: 'ইমেলের মাধ্যমে অনুরোধ করুন',
  chinese: '通过电子邮件请求',
  english: 'Request by email',
  estonian: 'Taotle e-posti teel',
  filipino: 'Humiling sa pamamagitan ng email',
  french: 'Demander par e-mail',
  german: 'Per E-Mail anfordern',
  hindi: 'ईमेल द्वारा अनुरोध करें',
  indonesian: 'Minta melalui email',
  japanese: 'メールで依頼する',
  korean: '이메일로 요청',
  portuguese: 'Solicitar por e-mail',
  russian: 'Запросить по электронной почте',
  spanish: 'Solicitar por correo electrónico',
  swahili: 'Omba kwa barua pepe',
  vietnamese: 'Yêu cầu qua email',
};

export const dataDeletionEmailBody: Translation = {
  amharic: 'ከመለያዎ ጋር ከተያያዘው አድራሻ ወደ {email} ኢሜይl ይላኩ። የተወሰነ ውሂብ እንዲወገድ ወይም ሙሉ መለያዎ እና ውሂብዎ እንዲሰረዝ የሚፈልጉ መሆኑን ይንገሩን፣ እኛም በሂደቱ እንመራዎታለን።',
  arabic: 'أرسل بريدًا إلكترونيًا إلى {email} من العنوان المرتبط بحسابك. أخبرنا ما إذا كنت تريد إزالة بيانات محددة أو حذف حسابك وبياناتك بالكامل، وسنرشدك خلال الخطوات.',
  bengali: 'আপনার অ্যাকাউন্টের সাথে যুক্ত ঠিকানা থেকে {email}-এ ইমেল করুন। নির্দিষ্ট ডেটা মুছতে চান নাকি পুরো অ্যাকাউন্ট ও ডেটা মুছতে চান তা জানান, আমরা আপনাকে পথনির্দেশ দেব।',
  chinese: '请从与您账户关联的地址发送电子邮件至 {email}。告诉我们您希望删除特定数据，还是删除整个账户及数据，我们会指导您完成。',
  english: 'Email {email} from the address linked to your account. Tell us whether you want specific data removed or your whole account and data deleted, and we will guide you through it.',
  estonian: 'Saatke e-kiri aadressile {email} oma kontoga seotud aadressilt. Andke teada, kas soovite eemaldada konkreetseid andmeid või kustutada kogu oma konto ja andmed, ning me juhendame teid.',
  filipino: 'Mag-email sa {email} mula sa address na naka-link sa iyong account. Sabihin sa amin kung gusto mong tanggalin ang partikular na data o ang buo mong account at data, at gagabayan ka namin.',
  french: 'Envoyez un e-mail à {email} depuis l’adresse liée à votre compte. Indiquez-nous si vous souhaitez supprimer des données précises ou l’ensemble de votre compte et de vos données, et nous vous accompagnerons.',
  german: 'Senden Sie eine E-Mail an {email} von der mit Ihrem Konto verknüpften Adresse. Teilen Sie uns mit, ob bestimmte Daten entfernt oder Ihr gesamtes Konto und Ihre Daten gelöscht werden sollen, und wir begleiten Sie dabei.',
  hindi: 'अपने खाते से जुड़े पते से {email} पर ईमेल करें। हमें बताएं कि आप विशिष्ट डेटा हटाना चाहते हैं या अपना पूरा खाता और डेटा हटाना चाहते हैं, और हम आपका मार्गदर्शन करेंगे।',
  indonesian: 'Kirim email ke {email} dari alamat yang tertaut dengan akun Anda. Beri tahu kami apakah Anda ingin menghapus data tertentu atau seluruh akun dan data Anda, dan kami akan memandu Anda.',
  japanese: 'アカウントに登録されているアドレスから {email} までメールしてください。特定のデータの削除を希望するか、アカウントとデータ全体の削除を希望するかをお知らせいただければ、手順をご案内します。',
  korean: '계정에 연결된 주소에서 {email}로 이메일을 보내 주세요. 특정 데이터 삭제를 원하는지 아니면 전체 계정과 데이터 삭제를 원하는지 알려 주시면 절차를 안내해 드립니다.',
  portuguese: 'Envie um e-mail para {email} a partir do endereço vinculado à sua conta. Diga-nos se quer remover dados específicos ou excluir toda a sua conta e dados, e nós o orientaremos.',
  russian: 'Напишите на {email} с адреса, привязанного к вашему аккаунту. Сообщите, хотите ли вы удалить отдельные данные или весь аккаунт и данные, и мы поможем вам с этим.',
  spanish: 'Escriba a {email} desde la dirección vinculada a su cuenta. Indíquenos si desea eliminar datos concretos o toda su cuenta y datos, y le guiaremos en el proceso.',
  swahili: 'Tuma barua pepe kwa {email} kutoka anwani iliyounganishwa na akaunti yako. Tuambie kama unataka kuondoa data fulani au kufuta akaunti yako yote na data, nasi tutakuongoza.',
  vietnamese: 'Gửi email tới {email} từ địa chỉ liên kết với tài khoản của bạn. Hãy cho chúng tôi biết bạn muốn xóa dữ liệu cụ thể hay toàn bộ tài khoản và dữ liệu, và chúng tôi sẽ hướng dẫn bạn.',
};

export const dataDeletionLimitsHeading: Translation = {
  amharic: 'ምን ሊሰረዝ ይችላል ምን አይችልም',
  arabic: 'ما الذي يمكن وما الذي لا يمكن حذفه',
  bengali: 'কী মুছে ফেলা যায় এবং কী যায় না',
  chinese: '哪些可以删除，哪些不能',
  english: 'What can and cannot be deleted',
  estonian: 'Mida saab ja mida ei saa kustutada',
  filipino: 'Ano ang maaari at hindi maaaring tanggalin',
  french: 'Ce qui peut et ne peut pas être supprimé',
  german: 'Was gelöscht werden kann und was nicht',
  hindi: 'क्या हटाया जा सकता है और क्या नहीं',
  indonesian: 'Apa yang dapat dan tidak dapat dihapus',
  japanese: '削除できるものとできないもの',
  korean: '삭제할 수 있는 것과 없는 것',
  portuguese: 'O que pode e o que não pode ser excluído',
  russian: 'Что можно и что нельзя удалить',
  spanish: 'Qué se puede y qué no se puede eliminar',
  swahili: 'Kinachoweza na kisichoweza kufutwa',
  vietnamese: 'Những gì có thể và không thể xóa',
};

export const dataDeletionLimitsBody: Translation = {
  amharic:
    'የተወሰነ ውሂብ ወይም ሁሉንም እንዲሰረዝ መጠየቅ ይችላሉ። የውሂብዎን ክፍል ብቻ ማስወገድ መለያዎን ወይም መተግበሪያውን ባልተሟላ ወይም ጥቅም ላይ ሊውል በማይችል ሁኔታ የሚተወው ከሆነ ሁልጊዜ አይቻልም፤ እኛ እንነግርዎታለን እና አማራጮችን እናቀርባለን። እንዲሁም መዝገቦችን ለማቆየት የምንገደድበት ወይም የሚፈቀድልን ሲሆን (ለምሳሌ ያልተከፈሉ ደረሰኞች ወይም ቀሪ ሂሳብ፣ የማጭበርበር መከላከያ፣ ወይም የሕግ እና የቁጥጥር ማቆያ ግዴታዎች) ሙሉ መለያ መሰረዝን ልናከለክል ወይም ልናዘገይ እንችላለን። ምክንያቱን እና መጀመሪያ መሆን ያለበትን እናብራራለን።',
  arabic:
    'يمكنك طلب حذف بعض البيانات أو كلها. إزالة جزء فقط من بياناتك ليست ممكنة دائمًا إذا كانت ستترك حسابك أو التطبيق في حالة غير مكتملة أو غير قابلة للاستخدام؛ وسنخبرك بذلك ونقترح بدائل. وقد نرفض أو نؤجل حذف الحساب بالكامل عندما يكون الاحتفاظ بالسجلات مطلوبًا أو مسموحًا (على سبيل المثال الفواتير غير المدفوعة أو رصيد مستحق، أو منع الاحتيال، أو التزامات الاحتفاظ القانونية والتنظيمية). وسنوضح السبب وما يجب أن يحدث أولًا.',
  bengali:
    'আপনি কিছু ডেটা বা সমস্ত ডেটা মুছে ফেলার অনুরোধ করতে পারেন। আপনার ডেটার শুধু একটি অংশ সরিয়ে ফেলা সবসময় সম্ভব নয় যদি তা আপনার অ্যাকাউন্ট বা অ্যাপকে অসম্পূর্ণ বা ব্যবহার-অযোগ্য অবস্থায় ফেলে দেয়; আমরা আপনাকে জানাব এবং বিকল্প দেব। আমরা সম্পূর্ণ অ্যাকাউন্ট মুছে ফেলা প্রত্যাখ্যান বা বিলম্বিত করতে পারি যেখানে রেকর্ড রাখা আমাদের জন্য আবশ্যক বা অনুমোদিত (যেমন অপরিশোধিত ইনভয়েস বা বকেয়া ব্যালেন্স, জালিয়াতি প্রতিরোধ, অথবা আইনি ও নিয়ন্ত্রক সংরক্ষণ বাধ্যবাধকতা)। আমরা কারণ এবং প্রথমে কী করা দরকার তা ব্যাখ্যা করব।',
  chinese:
    '您可以请求删除部分或全部数据。如果仅删除部分数据会使您的账户或应用处于不完整或不可用的状态，则并非总能实现；我们会告知您并提供替代方案。当我们被要求或被允许保留记录时（例如未付发票或欠款、欺诈防范，或法律和监管的保留义务），我们也可能拒绝或推迟删除整个账户。我们会说明原因以及需要先完成的事项。',
  english:
    'You can request deletion of some data or all of it. Removing only part of your data is not always possible if it would leave your account or the app in an incomplete or unusable state; we will tell you and offer alternatives. We may also decline or delay full account deletion where we are required or permitted to keep records (for example, unpaid invoices or an outstanding balance, fraud prevention, or legal and regulatory retention obligations). We will explain the reason and what needs to happen first.',
  estonian:
    'Võite taotleda osa või kõigi andmete kustutamist. Ainult osa andmete eemaldamine ei ole alati võimalik, kui see jätaks teie konto või rakenduse mittetäielikku või kasutuskõlbmatusse seisu; me anname teada ja pakume alternatiive. Samuti võime keelduda täielikust konto kustutamisest või seda edasi lükata, kui oleme kohustatud või meil on lubatud andmeid säilitada (näiteks tasumata arved või võlgnevus, pettuste ennetamine või õiguslikud ja regulatiivsed säilituskohustused). Me selgitame põhjust ja seda, mis peab kõigepealt toimuma.',
  filipino:
    'Maaari kang humiling na tanggalin ang ilang data o lahat ng ito. Hindi laging posible na alisin lamang ang bahagi ng iyong data kung mag-iiwan ito sa iyong account o sa app na hindi kumpleto o hindi magagamit; sasabihin namin sa iyo at mag-aalok ng alternatibo. Maaari rin naming tanggihan o ipagpaliban ang buong pagtanggal ng account kung kinakailangan o pinapayagan kaming magtago ng mga record (halimbawa, hindi bayad na invoice o natitirang balanse, pag-iwas sa pandaraya, o mga obligasyon sa legal at regulatory na pagpapanatili). Ipapaliwanag namin ang dahilan at kung ano ang kailangang mangyari muna.',
  french:
    'Vous pouvez demander la suppression de certaines données ou de toutes. Supprimer seulement une partie de vos données n’est pas toujours possible si cela laissait votre compte ou l’application dans un état incomplet ou inutilisable ; nous vous le dirons et proposerons des alternatives. Nous pouvons aussi refuser ou retarder la suppression complète du compte lorsque nous sommes tenus ou autorisés à conserver des enregistrements (par exemple des factures impayées ou un solde dû, la prévention de la fraude, ou des obligations légales et réglementaires de conservation). Nous expliquerons la raison et ce qui doit se passer au préalable.',
  german:
    'Sie können die Löschung einzelner oder aller Daten verlangen. Nur einen Teil Ihrer Daten zu entfernen ist nicht immer möglich, wenn dadurch Ihr Konto oder die App in einem unvollständigen oder unbrauchbaren Zustand zurückbliebe; wir informieren Sie und bieten Alternativen an. Wir können eine vollständige Kontolöschung auch ablehnen oder verzögern, wenn wir zur Aufbewahrung von Aufzeichnungen verpflichtet oder berechtigt sind (etwa bei unbezahlten Rechnungen oder einem offenen Saldo, zur Betrugsprävention oder aufgrund gesetzlicher und regulatorischer Aufbewahrungspflichten). Wir erklären den Grund und was zuvor geschehen muss.',
  hindi:
    'आप कुछ डेटा या सभी डेटा को हटाने का अनुरोध कर सकते हैं। यदि आपके डेटा का केवल एक हिस्सा हटाने से आपका खाता या ऐप अधूरी या अनुपयोगी स्थिति में रह जाए, तो ऐसा हमेशा संभव नहीं होता; हम आपको बताएंगे और विकल्प देंगे। जहां हमें रिकॉर्ड रखना आवश्यक या अनुमत हो (उदाहरण के लिए अवैतनिक चालान या बकाया राशि, धोखाधड़ी की रोकथाम, या कानूनी और नियामक प्रतिधारण दायित्व) वहां हम पूर्ण खाता विलोपन से इनकार या उसमें देरी कर सकते हैं। हम कारण और पहले क्या करना आवश्यक है यह समझाएंगे।',
  indonesian:
    'Anda dapat meminta penghapusan sebagian data atau seluruhnya. Menghapus hanya sebagian data Anda tidak selalu memungkinkan jika hal itu membuat akun atau aplikasi Anda dalam keadaan tidak lengkap atau tidak dapat digunakan; kami akan memberi tahu Anda dan menawarkan alternatif. Kami juga dapat menolak atau menunda penghapusan akun sepenuhnya jika kami diwajibkan atau diizinkan menyimpan catatan (misalnya faktur yang belum dibayar atau saldo terutang, pencegahan penipuan, atau kewajiban penyimpanan hukum dan regulasi). Kami akan menjelaskan alasannya dan apa yang harus dilakukan terlebih dahulu.',
  japanese:
    '一部のデータまたはすべてのデータの削除を依頼できます。データの一部のみを削除すると、アカウントやアプリが不完全または使用できない状態になる場合は、必ずしも対応できないことがあります。その場合はお知らせし、代替案をご提案します。また、記録の保持が義務付けられている、または認められている場合（たとえば未払いの請求書や残高、不正防止、法令および規制上の保持義務など）には、アカウント全体の削除をお断りまたは延期することがあります。理由と、まず何が必要かをご説明します。',
  korean:
    '일부 데이터 또는 전체 데이터의 삭제를 요청할 수 있습니다. 데이터의 일부만 제거하면 계정이나 앱이 불완전하거나 사용할 수 없는 상태가 되는 경우에는 항상 가능한 것은 아니며, 그런 경우 알려 드리고 대안을 제시합니다. 또한 기록 보관이 요구되거나 허용되는 경우(예를 들어 미납 청구서나 미결제 잔액, 사기 방지, 법적·규제상의 보관 의무) 전체 계정 삭제를 거부하거나 지연할 수 있습니다. 그 이유와 먼저 처리해야 할 사항을 설명해 드립니다.',
  portuguese:
    'Você pode solicitar a exclusão de alguns dados ou de todos. Remover apenas parte dos seus dados nem sempre é possível se isso deixar sua conta ou o aplicativo em um estado incompleto ou inutilizável; nós avisaremos e ofereceremos alternativas. Também podemos recusar ou adiar a exclusão total da conta quando somos obrigados ou autorizados a manter registros (por exemplo, faturas não pagas ou saldo em aberto, prevenção de fraude, ou obrigações legais e regulatórias de retenção). Explicaremos o motivo e o que precisa acontecer antes.',
  russian:
    'Вы можете запросить удаление части данных или всех данных. Удалить только часть данных не всегда возможно, если это оставит ваш аккаунт или приложение в неполном или неработоспособном состоянии; мы сообщим вам об этом и предложим альтернативы. Мы также можем отклонить или отложить полное удаление аккаунта, если обязаны или вправе хранить записи (например, при неоплаченных счетах или непогашенном балансе, для предотвращения мошенничества либо в силу правовых и нормативных обязательств по хранению). Мы объясним причину и что нужно сделать сначала.',
  spanish:
    'Puede solicitar la eliminación de algunos datos o de todos. Eliminar solo una parte de sus datos no siempre es posible si dejara su cuenta o la aplicación en un estado incompleto o inutilizable; se lo indicaremos y le ofreceremos alternativas. También podemos rechazar o retrasar la eliminación total de la cuenta cuando estemos obligados o autorizados a conservar registros (por ejemplo, facturas impagadas o un saldo pendiente, prevención del fraude, u obligaciones legales y regulatorias de conservación). Explicaremos el motivo y qué debe ocurrir primero.',
  swahili:
    'Unaweza kuomba kufutwa kwa baadhi ya data au yote. Kuondoa sehemu tu ya data yako si mara zote kunawezekana ikiwa kungeacha akaunti yako au programu katika hali isiyokamilika au isiyoweza kutumika; tutakuambia na kukupa njia mbadala. Tunaweza pia kukataa au kuchelewesha kufutwa kwa akaunti nzima pale tunapotakiwa au kuruhusiwa kuhifadhi kumbukumbu (kwa mfano ankara ambazo hazijalipwa au salio linalodaiwa, kuzuia ulaghai, au wajibu wa kisheria na wa udhibiti wa kuhifadhi). Tutaeleza sababu na kinachohitaji kufanyika kwanza.',
  vietnamese:
    'Bạn có thể yêu cầu xóa một phần hoặc toàn bộ dữ liệu. Việc chỉ xóa một phần dữ liệu không phải lúc nào cũng khả thi nếu nó khiến tài khoản hoặc ứng dụng của bạn ở trạng thái không đầy đủ hoặc không sử dụng được; chúng tôi sẽ thông báo và đề xuất phương án thay thế. Chúng tôi cũng có thể từ chối hoặc trì hoãn việc xóa toàn bộ tài khoản khi chúng tôi được yêu cầu hoặc được phép lưu giữ hồ sơ (ví dụ hóa đơn chưa thanh toán hoặc số dư còn nợ, phòng chống gian lận, hoặc nghĩa vụ lưu giữ theo pháp luật và quy định). Chúng tôi sẽ giải thích lý do và điều cần thực hiện trước.',
};

export const dataDeletionTimelineHeading: Translation = {
  amharic: 'ቀጥሎ ምን ይሆናል',
  arabic: 'ماذا يحدث بعد ذلك',
  bengali: 'এরপর কী হয়',
  chinese: '接下来会怎样',
  english: 'What happens next',
  estonian: 'Mis juhtub edasi',
  filipino: 'Ano ang susunod na mangyayari',
  french: 'Ce qui se passe ensuite',
  german: 'Was als Nächstes passiert',
  hindi: 'आगे क्या होता है',
  indonesian: 'Apa yang terjadi selanjutnya',
  japanese: 'この後の流れ',
  korean: '다음 단계',
  portuguese: 'O que acontece a seguir',
  russian: 'Что происходит дальше',
  spanish: 'Qué ocurre a continuación',
  swahili: 'Nini hufuata',
  vietnamese: 'Điều gì xảy ra tiếp theo',
};

export const dataDeletionTimelineBody: Translation = {
  amharic: 'ጥያቄዎን ካረጋገጥን እና ማንነትዎን ካረጋገጥን በኋላ፣ ብቁ የሆነ ውሂብ በ30 ቀናት ውስጥ እንሰርዛለን። በሕግ እንድናስቀምጠው የተገደድነው ማንኛውም ውሂብ ሕጉ በሚጠይቀው ጊዜ ብቻ ይቆያል ከዚያም ይሰረዛል። ጥያቄዎች: {email}።',
  arabic: 'بمجرد تأكيد طلبك والتحقق من هويتك، نحذف البيانات المؤهلة خلال 30 يومًا. وأي بيانات يُلزمنا القانون بالاحتفاظ بها تُحفظ فقط للمدة التي يتطلبها القانون ثم تُحذف. للاستفسارات: {email}.',
  bengali: 'আমরা আপনার অনুরোধ নিশ্চিত করে এবং আপনার পরিচয় যাচাই করার পরে, যোগ্য ডেটা ৩০ দিনের মধ্যে মুছে ফেলি। আইনত যে ডেটা রাখতে আমরা বাধ্য তা কেবল আইনের প্রয়োজন অনুযায়ী রাখা হয়, তারপর মুছে ফেলা হয়। প্রশ্ন: {email}।',
  chinese: '在我们确认您的请求并验证您的身份后，我们会在 30 天内删除符合条件的数据。法律要求我们保留的任何数据，仅在法律规定的期限内保留，然后删除。有疑问请联系：{email}。',
  english: 'Once we confirm your request and verify your identity, we delete eligible data within 30 days. Any data we are legally required to keep is retained only for as long as the law requires and then deleted. Questions: {email}.',
  estonian: 'Kui oleme teie taotluse kinnitanud ja teie isiku tuvastanud, kustutame sobivad andmed 30 päeva jooksul. Andmeid, mida oleme seadusega kohustatud säilitama, hoitakse ainult nii kaua, kui seadus nõuab, ja seejärel kustutatakse. Küsimused: {email}.',
  filipino:
    'Kapag nakumpirma namin ang iyong kahilingan at na-verify ang iyong pagkakakilanlan, tatanggalin namin ang kwalipikadong data sa loob ng 30 araw. Ang anumang data na kinakailangan naming itago ayon sa batas ay pinananatili lamang hangga’t kinakailangan ng batas at pagkatapos ay tatanggalin. Mga tanong: {email}.',
  french: 'Une fois votre demande confirmée et votre identité vérifiée, nous supprimons les données éligibles sous 30 jours. Les données que nous sommes légalement tenus de conserver ne le sont que pour la durée exigée par la loi, puis elles sont supprimées. Questions : {email}.',
  german: 'Sobald wir Ihre Anfrage bestätigt und Ihre Identität überprüft haben, löschen wir die infrage kommenden Daten innerhalb von 30 Tagen. Daten, die wir gesetzlich aufbewahren müssen, werden nur so lange gespeichert, wie das Gesetz es verlangt, und danach gelöscht. Fragen: {email}.',
  hindi: 'जब हम आपके अनुरोध की पुष्टि और आपकी पहचान सत्यापित कर लेते हैं, तो हम पात्र डेटा को 30 दिनों के भीतर हटा देते हैं। जिस डेटा को रखना कानूनन आवश्यक है, उसे केवल कानून द्वारा अपेक्षित अवधि तक रखा जाता है और फिर हटा दिया जाता है। प्रश्न: {email}।',
  indonesian: 'Setelah kami mengonfirmasi permintaan Anda dan memverifikasi identitas Anda, kami menghapus data yang memenuhi syarat dalam 30 hari. Data apa pun yang secara hukum wajib kami simpan hanya disimpan selama yang diwajibkan hukum lalu dihapus. Pertanyaan: {email}.',
  japanese: 'ご依頼を確認し、ご本人確認が完了した後、対象となるデータを30日以内に削除します。法律により保持が義務付けられているデータは、法律が求める期間のみ保持し、その後削除します。お問い合わせ: {email}。',
  korean: '요청을 확인하고 본인 확인이 완료되면 해당 데이터를 30일 이내에 삭제합니다. 법적으로 보관이 요구되는 데이터는 법이 요구하는 기간 동안만 보관한 후 삭제합니다. 문의: {email}.',
  portuguese: 'Assim que confirmarmos a sua solicitação e verificarmos a sua identidade, excluímos os dados elegíveis em até 30 dias. Quaisquer dados que somos legalmente obrigados a manter são retidos apenas pelo tempo exigido por lei e depois excluídos. Dúvidas: {email}.',
  russian: 'После подтверждения вашего запроса и проверки вашей личности мы удаляем подходящие данные в течение 30 дней. Данные, которые мы обязаны хранить по закону, хранятся только в течение требуемого законом срока, а затем удаляются. Вопросы: {email}.',
  spanish: 'Una vez que confirmemos su solicitud y verifiquemos su identidad, eliminamos los datos elegibles en un plazo de 30 días. Los datos que estamos legalmente obligados a conservar se mantienen solo durante el tiempo que exige la ley y luego se eliminan. Preguntas: {email}.',
  swahili: 'Mara tu tunapothibitisha ombi lako na kuhakiki utambulisho wako, tunafuta data inayostahili ndani ya siku 30. Data yoyote ambayo tunatakiwa kisheria kuihifadhi huhifadhiwa kwa muda tu unaohitajika na sheria kisha hufutwa. Maswali: {email}.',
  vietnamese: 'Sau khi chúng tôi xác nhận yêu cầu và xác minh danh tính của bạn, chúng tôi sẽ xóa dữ liệu đủ điều kiện trong vòng 30 ngày. Bất kỳ dữ liệu nào chúng tôi buộc phải lưu giữ theo pháp luật chỉ được giữ trong thời gian luật yêu cầu rồi sẽ bị xóa. Câu hỏi: {email}.',
};

export const deleteDeviceTokensT: Translation = {
  amharic: 'የመሣሪያ ቶከኖችን ሰርዝ',
  arabic: 'حذف رموز الجهاز',
  bengali: 'ডিভাইস টোকেন মুছুন',
  chinese: '删除设备令牌',
  english: 'Delete Device Tokens',
  estonian: 'Kustuta seadmemärgid',
  filipino: 'Tanggalin ang mga Token ng Device',
  french: 'Supprimer les jetons d’appareil',
  german: 'Gerätetoken löschen',
  hindi: 'डिवाइस टोकन हटाएं',
  indonesian: 'Hapus Token Perangkat',
  japanese: 'デバイストークンを削除',
  korean: '기기 토큰 삭제',
  portuguese: 'Excluir tokens de dispositivo',
  russian: 'Удалить токены устройства',
  spanish: 'Eliminar tokens de dispositivo',
  swahili: 'Futa Tokeni za Kifaa',
  vietnamese: 'Xóa mã thiết bị',
};

export const deleteDeviceTokensConfirmT: Translation = {
  amharic: 'እርግጠኛ ነዎት {count} የመሣሪያ ቶከን(ኖች) መሰረዝ ይፈልጋሉ?',
  arabic: 'هل أنت متأكد أنك تريد حذف {count} من رموز الجهاز؟',
  bengali: 'আপনি কি নিশ্চিত যে আপনি {count}টি ডিভাইস টোকেন মুছতে চান?',
  chinese: '确定要删除 {count} 个设备令牌吗？',
  english: 'Are you sure you want to delete {count} device token(s)?',
  estonian: 'Kas olete kindel, et soovite kustutada {count} seadmemärki?',
  filipino: 'Sigurado ka bang gusto mong tanggalin ang {count} device token?',
  french: 'Voulez-vous vraiment supprimer {count} jeton(s) d’appareil ?',
  german: 'Möchten Sie wirklich {count} Gerätetoken löschen?',
  hindi: 'क्या आप वाकई {count} डिवाइस टोकन हटाना चाहते हैं?',
  indonesian: 'Yakin ingin menghapus {count} token perangkat?',
  japanese: '{count} 個のデバイストークンを削除してもよろしいですか？',
  korean: '{count}개의 기기 토큰을 삭제하시겠습니까?',
  portuguese: 'Tem certeza de que deseja excluir {count} token(s) de dispositivo?',
  russian: 'Вы уверены, что хотите удалить {count} токен(ов) устройства?',
  spanish: '¿Seguro que quieres eliminar {count} token(s) de dispositivo?',
  swahili: 'Una uhakika unataka kufuta tokeni {count} za kifaa?',
  vietnamese: 'Bạn có chắc muốn xóa {count} mã thiết bị không?',
};

export const dataDeletionNavLabel: Translation = {
  amharic: 'ውሂብ መሰረዝ',
  arabic: 'حذف البيانات',
  bengali: 'ডেটা মুছে ফেলা',
  chinese: '数据删除',
  english: 'Data deletion',
  estonian: 'Andmete kustutamine',
  filipino: 'Pagtanggal ng data',
  french: 'Suppression des données',
  german: 'Datenlöschung',
  hindi: 'डेटा विलोपन',
  indonesian: 'Penghapusan data',
  japanese: 'データの削除',
  korean: '데이터 삭제',
  portuguese: 'Exclusão de dados',
  russian: 'Удаление данных',
  spanish: 'Eliminación de datos',
  swahili: 'Kufuta data',
  vietnamese: 'Xóa dữ liệu',
};

export const dataDeletionPrivacyPointer: Translation = {
  amharic: 'በማንኛውም ጊዜ የተወሰነ ወይም ሁሉንም ውሂብዎን እና መለያዎን እንዲሰረዝ መጠየቅ ይችላሉ (በመተግበሪያው ውስጥ ወይም በኢሜይl)። ገደቦችን እና የጊዜ ሰሌዳዎችን ጨምሮ ሙሉ ዝርዝሮች በውሂብ መሰረዝ ገጻችን ላይ ይገኛሉ።',
  arabic: 'يمكنك في أي وقت طلب حذف بعض بياناتك أو كلها وحسابك (داخل التطبيق أو عبر البريد الإلكتروني). تتوفر كل التفاصيل، بما في ذلك القيود والمهل الزمنية، في صفحة حذف البيانات.',
  bengali: 'আপনি যেকোনো সময় আপনার কিছু বা সমস্ত ডেটা ও অ্যাকাউন্ট মুছে ফেলার অনুরোধ করতে পারেন (অ্যাপে বা ইমেলের মাধ্যমে)। সীমাবদ্ধতা ও সময়সীমা সহ সম্পূর্ণ বিবরণ আমাদের ডেটা মুছে ফেলার পৃষ্ঠায় রয়েছে।',
  chinese: '您可以随时请求删除部分或全部数据及账户（在应用内或通过电子邮件）。包括限制和时限在内的完整详情，请见我们的数据删除页面。',
  english: 'You can request deletion of some or all of your data and account at any time (in the app or by email). Full details, including limits and timelines, are on our data deletion page.',
  estonian: 'Võite igal ajal taotleda osa või kõigi oma andmete ja konto kustutamist (rakenduses või e-posti teel). Täielikud üksikasjad, sealhulgas piirangud ja tähtajad, on meie andmete kustutamise lehel.',
  filipino: 'Maaari kang humiling na tanggalin ang ilan o lahat ng iyong data at account anumang oras (sa app o sa pamamagitan ng email). Ang kumpletong detalye, kabilang ang mga limitasyon at timeline, ay nasa aming pahina ng pagtanggal ng data.',
  french: 'Vous pouvez à tout moment demander la suppression d’une partie ou de la totalité de vos données et de votre compte (dans l’application ou par e-mail). Tous les détails, y compris les limites et les délais, figurent sur notre page de suppression des données.',
  german: 'Sie können jederzeit die Löschung eines Teils oder aller Ihrer Daten und Ihres Kontos verlangen (in der App oder per E-Mail). Alle Einzelheiten, einschließlich Einschränkungen und Fristen, finden Sie auf unserer Seite zur Datenlöschung.',
  hindi: 'आप किसी भी समय अपने कुछ या सभी डेटा और खाते को हटाने का अनुरोध कर सकते हैं (ऐप में या ईमेल द्वारा)। सीमाओं और समय-सीमा सहित पूरी जानकारी हमारे डेटा विलोपन पृष्ठ पर है।',
  indonesian: 'Anda dapat meminta penghapusan sebagian atau seluruh data dan akun Anda kapan saja (di aplikasi atau melalui email). Detail lengkap, termasuk batasan dan tenggat waktu, ada di halaman penghapusan data kami.',
  japanese: 'いつでも、一部またはすべてのデータとアカウントの削除を依頼できます（アプリ内またはメールで）。制限や期間を含む詳細は、データ削除ページに記載しています。',
  korean: '언제든지 일부 또는 전체 데이터와 계정의 삭제를 요청할 수 있습니다(앱에서 또는 이메일로). 제한 사항과 처리 기간을 포함한 자세한 내용은 데이터 삭제 페이지에 있습니다.',
  portuguese: 'Você pode solicitar a exclusão de parte ou de todos os seus dados e da sua conta a qualquer momento (no aplicativo ou por e-mail). Todos os detalhes, incluindo limites e prazos, estão na nossa página de exclusão de dados.',
  russian: 'Вы можете в любое время запросить удаление части или всех ваших данных и аккаунта (в приложении или по электронной почте). Полная информация, включая ограничения и сроки, приведена на нашей странице удаления данных.',
  spanish: 'Puede solicitar la eliminación de parte o de todos sus datos y de su cuenta en cualquier momento (en la aplicación o por correo electrónico). Todos los detalles, incluidos los límites y los plazos, están en nuestra página de eliminación de datos.',
  swahili: 'Unaweza kuomba kufutwa kwa baadhi au data yako yote na akaunti wakati wowote (ndani ya programu au kwa barua pepe). Maelezo kamili, ikiwa ni pamoja na vikomo na muda, yapo kwenye ukurasa wetu wa kufuta data.',
  vietnamese: 'Bạn có thể yêu cầu xóa một phần hoặc toàn bộ dữ liệu và tài khoản của bạn bất cứ lúc nào (trong ứng dụng hoặc qua email). Toàn bộ chi tiết, bao gồm giới hạn và thời hạn, có trên trang xóa dữ liệu của chúng tôi.',
};

// Signed-in account controls, shared by the product landings.
export const signOut: Translation = {
  amharic: 'ውጣ',
  arabic: 'تسجيل الخروج',
  bengali: 'সাইন আউট',
  chinese: '退出登录',
  english: 'Sign out',
  estonian: 'Logi välja',
  filipino: 'Mag-sign out',
  french: 'Se déconnecter',
  german: 'Abmelden',
  hindi: 'साइन आउट करें',
  indonesian: 'Keluar',
  japanese: 'ログアウト',
  korean: '로그아웃',
  portuguese: 'Sair',
  russian: 'Выйти',
  spanish: 'Cerrar sesión',
  swahili: 'Toka',
  vietnamese: 'Đăng xuất',
};
export const manageAccount: Translation = {
  amharic: 'መለያ አስተዳድር',
  arabic: 'إدارة الحساب',
  bengali: 'অ্যাকাউন্ট পরিচালনা করুন',
  chinese: '管理账户',
  english: 'Manage account',
  estonian: 'Halda kontot',
  filipino: 'Pamahalaan ang account',
  french: 'Gérer le compte',
  german: 'Konto verwalten',
  hindi: 'खाता प्रबंधित करें',
  indonesian: 'Kelola akun',
  japanese: 'アカウント管理',
  korean: '계정 관리',
  portuguese: 'Gerir conta',
  russian: 'Управление аккаунтом',
  spanish: 'Gestionar cuenta',
  swahili: 'Dhibiti akaunti',
  vietnamese: 'Quản lý tài khoản',
};
export const goToApp: Translation = {
  amharic: 'መተግበሪያውን ክፈት',
  arabic: 'افتح التطبيق',
  bengali: 'অ্যাপ খুলুন',
  chinese: '打开应用',
  english: 'Open the app',
  estonian: 'Ava rakendus',
  filipino: 'Buksan ang app',
  french: "Ouvrir l'application",
  german: 'App öffnen',
  hindi: 'ऐप खोलें',
  indonesian: 'Buka aplikasi',
  japanese: 'アプリを開く',
  korean: '앱 열기',
  portuguese: 'Abrir o aplicativo',
  russian: 'Открыть приложение',
  spanish: 'Abrir la aplicación',
  swahili: 'Fungua programu',
  vietnamese: 'Mở ứng dụng',
};
export const accountSwitcherCancel: Translation = {
  amharic: 'ሰርዝ',
  arabic: 'إلغاء',
  bengali: 'বাতিল',
  chinese: '取消',
  english: 'Cancel',
  estonian: 'Loobu',
  filipino: 'Kanselahin',
  french: 'Annuler',
  german: 'Abbrechen',
  hindi: 'रद्द करें',
  indonesian: 'Batal',
  japanese: 'キャンセル',
  korean: '취소',
  portuguese: 'Cancelar',
  russian: 'Отмена',
  spanish: 'Cancelar',
  swahili: 'Ghairi',
  vietnamese: 'Hủy',
};
export const accountSwitcherCapMeter: Translation = {
  amharic: 'ከ{max} መለያዎች {held} ጥቅም ላይ ውሏል',
  arabic: 'تم استخدام {held} من {max} حسابات',
  bengali: '{max}টির মধ্যে {held}টি অ্যাকাউন্ট ব্যবহৃত',
  chinese: '已使用 {held} / {max} 个账户',
  english: '{held} of {max} accounts used',
  estonian: '{held} kontot {max}-st kasutusel',
  filipino: '{held} sa {max} account ang gamit',
  french: '{held} comptes sur {max} utilisés',
  german: '{held} von {max} Konten verwendet',
  hindi: '{max} में से {held} खाते उपयोग में',
  indonesian: '{held} dari {max} akun terpakai',
  japanese: '{max} 件中 {held} 件のアカウントを使用中',
  korean: '{max}개 중 {held}개 계정 사용 중',
  portuguese: '{held} de {max} contas usadas',
  russian: 'Использовано {held} из {max} аккаунтов',
  spanish: '{held} de {max} cuentas usadas',
  swahili: 'Akaunti {held} kati ya {max} zimetumika',
  vietnamese: 'Đã dùng {held} trong {max} tài khoản',
};
export const accountSwitcherCapReached: Translation = {
  amharic: 'የመለያ ገደብ ደርሷል ({held} ከ{max})',
  arabic: 'تم بلوغ حد الحسابات ({held} من {max})',
  bengali: 'অ্যাকাউন্ট সীমায় পৌঁছেছে ({max}টির মধ্যে {held}টি)',
  chinese: '已达账户上限（{held} / {max}）',
  english: 'Account limit reached ({held} of {max})',
  estonian: 'Kontode limiit on täis ({held} {max}-st)',
  filipino: 'Naabot na ang limitasyon ng account ({held} sa {max})',
  french: 'Limite de comptes atteinte ({held} sur {max})',
  german: 'Kontolimit erreicht ({held} von {max})',
  hindi: 'खाता सीमा पूरी हुई ({max} में से {held})',
  indonesian: 'Batas akun tercapai ({held} dari {max})',
  japanese: 'アカウント数が上限に達しました（{max} 件中 {held} 件）',
  korean: '계정 한도 도달 ({max}개 중 {held}개)',
  portuguese: 'Limite de contas atingido ({held} de {max})',
  russian: 'Достигнут лимит аккаунтов ({held} из {max})',
  spanish: 'Límite de cuentas alcanzado ({held} de {max})',
  swahili: 'Kikomo cha akaunti kimefikiwa ({held} kati ya {max})',
  vietnamese: 'Đã đạt giới hạn tài khoản ({held} trong {max})',
};
export const accountSwitcherCreate: Translation = {
  amharic: 'መለያ ፍጠር',
  arabic: 'إنشاء حساب',
  bengali: 'অ্যাকাউন্ট তৈরি করুন',
  chinese: '创建账户',
  english: 'Create account',
  estonian: 'Loo konto',
  filipino: 'Gumawa ng account',
  french: 'Créer le compte',
  german: 'Konto erstellen',
  hindi: 'खाता बनाएं',
  indonesian: 'Buat akun',
  japanese: 'アカウントを作成',
  korean: '계정 만들기',
  portuguese: 'Criar conta',
  russian: 'Создать аккаунт',
  spanish: 'Crear cuenta',
  swahili: 'Unda akaunti',
  vietnamese: 'Tạo tài khoản',
};
export const accountSwitcherCreateFailed: Translation = {
  amharic: 'መለያውን መፍጠር አልተቻለም። እንደገና ይሞክሩ።',
  arabic: 'تعذر إنشاء الحساب. حاول مرة أخرى.',
  bengali: 'অ্যাকাউন্ট তৈরি করা যায়নি। আবার চেষ্টা করুন।',
  chinese: '无法创建账户。请重试。',
  english: "Couldn't create the account. Try again.",
  estonian: 'Kontot ei õnnestunud luua. Proovi uuesti.',
  filipino: 'Hindi nagawa ang account. Subukan muli.',
  french: 'Impossible de créer le compte. Réessayez.',
  german: 'Das Konto konnte nicht erstellt werden. Bitte erneut versuchen.',
  hindi: 'खाता नहीं बन सका। फिर से प्रयास करें।',
  indonesian: 'Tidak dapat membuat akun. Coba lagi.',
  japanese: 'アカウントを作成できませんでした。もう一度お試しください。',
  korean: '계정을 만들지 못했습니다. 다시 시도하세요.',
  portuguese: 'Não foi possível criar a conta. Tente novamente.',
  russian: 'Не удалось создать аккаунт. Попробуйте ещё раз.',
  spanish: 'No se pudo crear la cuenta. Inténtalo de nuevo.',
  swahili: 'Imeshindikana kuunda akaunti. Jaribu tena.',
  vietnamese: 'Không thể tạo tài khoản. Hãy thử lại.',
};
export const accountSwitcherDialogBody: Translation = {
  amharic: 'የተለየ መለያ በዚህ ምርት ውስጥ የራሱ ሚናዎች እና መዳረሻ ይይዛል። እርስዎ ሆነው ገብተው ይቆያሉ እና በማንኛውም ጊዜ መቀየር ይችላሉ።',
  arabic: 'يحتفظ الحساب المنفصل بأدواره وصلاحياته الخاصة في هذا المنتج. تبقى مسجل الدخول بهويتك ويمكنك التبديل في أي وقت.',
  bengali: 'আলাদা অ্যাকাউন্ট এই পণ্যে নিজস্ব ভূমিকা ও অ্যাক্সেস রাখে। আপনি নিজের পরিচয়ে সাইন ইন থাকবেন এবং যেকোনো সময় পাল্টাতে পারবেন।',
  chinese: '独立账户在本产品中拥有自己的角色和访问权限。您仍以本人身份登录，可随时切换。',
  english: 'A separate account keeps its own roles and access in this product. You stay signed in as you and can switch any time.',
  estonian: 'Eraldi kontol on selles tootes oma rollid ja ligipääs. Jääd sisse logituks iseendana ja saad igal ajal vahetada.',
  filipino: 'May sariling mga tungkulin at access ang hiwalay na account sa produktong ito. Mananatili kang naka-sign in bilang ikaw at maaaring lumipat anumang oras.',
  french: 'Un compte distinct conserve ses propres rôles et accès dans ce produit. Vous restez connecté en tant que vous et pouvez changer à tout moment.',
  german: 'Ein separates Konto hat in diesem Produkt eigene Rollen und Zugriffe. Du bleibst als du angemeldet und kannst jederzeit wechseln.',
  hindi: 'अलग खाता इस उत्पाद में अपनी भूमिकाएं और पहुंच रखता है। आप स्वयं के रूप में साइन इन रहते हैं और कभी भी बदल सकते हैं।',
  indonesian: 'Akun terpisah menyimpan peran dan aksesnya sendiri di produk ini. Anda tetap masuk sebagai diri Anda dan dapat beralih kapan saja.',
  japanese: '別のアカウントは、この製品内で独自のロールとアクセス権を持ちます。あなたとしてサインインしたまま、いつでも切り替えられます。',
  korean: '별도 계정은 이 제품에서 고유한 역할과 액세스 권한을 가집니다. 본인으로 로그인한 상태로 언제든지 전환할 수 있습니다.',
  portuguese: 'Uma conta separada mantém seus próprios papéis e acessos neste produto. Você continua conectado como você e pode alternar a qualquer momento.',
  russian: 'Отдельный аккаунт хранит собственные роли и доступы в этом продукте. Вы остаётесь в системе под своим именем и можете переключиться в любой момент.',
  spanish: 'Una cuenta separada mantiene sus propios roles y accesos en este producto. Sigues con tu sesión iniciada y puedes cambiar en cualquier momento.',
  swahili: 'Akaunti tofauti huhifadhi majukumu na ufikiaji wake katika bidhaa hii. Unabaki umeingia kama wewe na unaweza kubadilisha wakati wowote.',
  vietnamese: 'Tài khoản riêng giữ vai trò và quyền truy cập riêng trong sản phẩm này. Bạn vẫn đăng nhập với danh tính của mình và có thể chuyển bất cứ lúc nào.',
};
export const accountSwitcherDialogTitle: Translation = {
  amharic: 'አዲስ መለያ',
  arabic: 'حساب جديد',
  bengali: 'নতুন অ্যাকাউন্ট',
  chinese: '新账户',
  english: 'New account',
  estonian: 'Uus konto',
  filipino: 'Bagong account',
  french: 'Nouveau compte',
  german: 'Neues Konto',
  hindi: 'नया खाता',
  indonesian: 'Akun baru',
  japanese: '新しいアカウント',
  korean: '새 계정',
  portuguese: 'Nova conta',
  russian: 'Новый аккаунт',
  spanish: 'Cuenta nueva',
  swahili: 'Akaunti mpya',
  vietnamese: 'Tài khoản mới',
};
export const accountSwitcherLoadFailed: Translation = {
  amharic: 'መለያዎችን መጫን አልተቻለም።',
  arabic: 'تعذر تحميل الحسابات.',
  bengali: 'অ্যাকাউন্ট লোড করা যায়নি।',
  chinese: '无法加载账户。',
  english: "Couldn't load accounts.",
  estonian: 'Kontosid ei õnnestunud laadida.',
  filipino: 'Hindi na-load ang mga account.',
  french: 'Impossible de charger les comptes.',
  german: 'Konten konnten nicht geladen werden.',
  hindi: 'खाते लोड नहीं हो सके।',
  indonesian: 'Tidak dapat memuat akun.',
  japanese: 'アカウントを読み込めませんでした。',
  korean: '계정을 불러오지 못했습니다.',
  portuguese: 'Não foi possível carregar as contas.',
  russian: 'Не удалось загрузить аккаунты.',
  spanish: 'No se pudieron cargar las cuentas.',
  swahili: 'Imeshindikana kupakia akaunti.',
  vietnamese: 'Không thể tải tài khoản.',
};
export const accountSwitcherManage: Translation = {
  amharic: 'መለያዎችን አስተዳድር',
  arabic: 'إدارة الحسابات',
  bengali: 'অ্যাকাউন্ট পরিচালনা করুন',
  chinese: '管理账户',
  english: 'Manage accounts',
  estonian: 'Halda kontosid',
  filipino: 'Pamahalaan ang mga account',
  french: 'Gérer les comptes',
  german: 'Konten verwalten',
  hindi: 'खाते प्रबंधित करें',
  indonesian: 'Kelola akun',
  japanese: 'アカウントを管理',
  korean: '계정 관리',
  portuguese: 'Gerenciar contas',
  russian: 'Управление аккаунтами',
  spanish: 'Gestionar cuentas',
  swahili: 'Dhibiti akaunti',
  vietnamese: 'Quản lý tài khoản',
};
export const accountSwitcherNameLabel: Translation = {
  amharic: 'የመለያ ስም',
  arabic: 'اسم الحساب',
  bengali: 'অ্যাকাউন্টের নাম',
  chinese: '账户名称',
  english: 'Account name',
  estonian: 'Konto nimi',
  filipino: 'Pangalan ng account',
  french: 'Nom du compte',
  german: 'Kontoname',
  hindi: 'खाते का नाम',
  indonesian: 'Nama akun',
  japanese: 'アカウント名',
  korean: '계정 이름',
  portuguese: 'Nome da conta',
  russian: 'Название аккаунта',
  spanish: 'Nombre de la cuenta',
  swahili: 'Jina la akaunti',
  vietnamese: 'Tên tài khoản',
};
export const accountSwitcherNew: Translation = {
  amharic: 'አዲስ መለያ',
  arabic: 'حساب جديد',
  bengali: 'নতুন অ্যাকাউন্ট',
  chinese: '新账户',
  english: 'New account',
  estonian: 'Uus konto',
  filipino: 'Bagong account',
  french: 'Nouveau compte',
  german: 'Neues Konto',
  hindi: 'नया खाता',
  indonesian: 'Akun baru',
  japanese: '新しいアカウント',
  korean: '새 계정',
  portuguese: 'Nova conta',
  russian: 'Новый аккаунт',
  spanish: 'Cuenta nueva',
  swahili: 'Akaunti mpya',
  vietnamese: 'Tài khoản mới',
};
export const accountSwitcherRetry: Translation = {
  amharic: 'እንደገና ሞክር',
  arabic: 'إعادة المحاولة',
  bengali: 'আবার চেষ্টা করুন',
  chinese: '重试',
  english: 'Retry',
  estonian: 'Proovi uuesti',
  filipino: 'Subukan muli',
  french: 'Réessayer',
  german: 'Erneut versuchen',
  hindi: 'फिर से प्रयास करें',
  indonesian: 'Coba lagi',
  japanese: '再試行',
  korean: '다시 시도',
  portuguese: 'Tentar novamente',
  russian: 'Повторить',
  spanish: 'Reintentar',
  swahili: 'Jaribu tena',
  vietnamese: 'Thử lại',
};
export const accountSwitcherSuspended: Translation = {
  amharic: 'ታግዷል',
  arabic: 'موقوف',
  bengali: 'স্থগিত',
  chinese: '已停用',
  english: 'Suspended',
  estonian: 'Peatatud',
  filipino: 'Suspendido',
  french: 'Suspendu',
  german: 'Gesperrt',
  hindi: 'निलंबित',
  indonesian: 'Ditangguhkan',
  japanese: '停止中',
  korean: '정지됨',
  portuguese: 'Suspensa',
  russian: 'Приостановлен',
  spanish: 'Suspendida',
  swahili: 'Imesimamishwa',
  vietnamese: 'Bị đình chỉ',
};
export const accountSwitcherSwitchFailed: Translation = {
  amharic: 'መቀየር አልተቻለም።',
  arabic: 'تعذر التبديل.',
  bengali: 'পাল্টানো যায়নি।',
  chinese: '无法切换。',
  english: "Couldn't switch.",
  estonian: 'Vahetus ebaõnnestus.',
  filipino: 'Hindi nakalipat.',
  french: 'Impossible de changer.',
  german: 'Wechsel fehlgeschlagen.',
  hindi: 'बदला नहीं जा सका।',
  indonesian: 'Tidak dapat beralih.',
  japanese: '切り替えられませんでした。',
  korean: '전환하지 못했습니다.',
  portuguese: 'Não foi possível alternar.',
  russian: 'Не удалось переключиться.',
  spanish: 'No se pudo cambiar.',
  swahili: 'Imeshindikana kubadilisha.',
  vietnamese: 'Không thể chuyển.',
};
export const accountSwitcherSwitching: Translation = {
  amharic: 'በመቀየር ላይ…',
  arabic: 'جارٍ التبديل…',
  bengali: 'পাল্টানো হচ্ছে…',
  chinese: '切换中…',
  english: 'Switching…',
  estonian: 'Vahetamine…',
  filipino: 'Lumilipat…',
  french: 'Changement…',
  german: 'Wechseln…',
  hindi: 'बदला जा रहा है…',
  indonesian: 'Beralih…',
  japanese: '切り替え中…',
  korean: '전환 중…',
  portuguese: 'Alternando…',
  russian: 'Переключение…',
  spanish: 'Cambiando…',
  swahili: 'Inabadilisha…',
  vietnamese: 'Đang chuyển…',
};
export const accountSwitcherUnnamedAccount: Translation = {
  amharic: 'መለያ',
  arabic: 'الحساب',
  bengali: 'অ্যাকাউন্ট',
  chinese: '账户',
  english: 'Account',
  estonian: 'Konto',
  filipino: 'Account',
  french: 'Compte',
  german: 'Konto',
  hindi: 'खाता',
  indonesian: 'Akun',
  japanese: 'アカウント',
  korean: '계정',
  portuguese: 'Conta',
  russian: 'Аккаунт',
  spanish: 'Cuenta',
  swahili: 'Akaunti',
  vietnamese: 'Tài khoản',
};

export const switchOn: Translation = {
  amharic: 'በርቷል',
  arabic: 'تشغيل',
  bengali: 'চালু',
  chinese: '开',
  english: 'On',
  estonian: 'Sees',
  filipino: 'Naka-on',
  french: 'Activé',
  german: 'Ein',
  hindi: 'चालू',
  indonesian: 'Aktif',
  japanese: 'オン',
  korean: '켜짐',
  portuguese: 'Ligado',
  russian: 'Вкл',
  spanish: 'Activado',
  swahili: 'Imewashwa',
  vietnamese: 'Bật',
};

export const switchOff: Translation = {
  amharic: 'ጠፍቷል',
  arabic: 'إيقاف',
  bengali: 'বন্ধ',
  chinese: '关',
  english: 'Off',
  estonian: 'Väljas',
  filipino: 'Naka-off',
  french: 'Désactivé',
  german: 'Aus',
  hindi: 'बंद',
  indonesian: 'Nonaktif',
  japanese: 'オフ',
  korean: '꺼짐',
  portuguese: 'Desligado',
  russian: 'Выкл',
  spanish: 'Desactivado',
  swahili: 'Imezimwa',
  vietnamese: 'Tắt',
};

export const bomdisoftProductLabel: Translation = {
  amharic: 'የBomdisoft ምርት',
  arabic: 'منتج من Bomdisoft',
  bengali: 'একটি Bomdisoft পণ্য',
  chinese: 'Bomdisoft 旗下产品',
  english: 'A Bomdisoft product',
  estonian: 'Bomdisofti toode',
  filipino: 'Isang produkto ng Bomdisoft',
  french: 'Un produit Bomdisoft',
  german: 'Ein Bomdisoft-Produkt',
  hindi: 'एक Bomdisoft उत्पाद',
  indonesian: 'Produk Bomdisoft',
  japanese: 'Bomdisoft のプロダクト',
  korean: 'Bomdisoft 제품',
  portuguese: 'Um produto Bomdisoft',
  russian: 'Продукт Bomdisoft',
  spanish: 'Un producto de Bomdisoft',
  swahili: 'Bidhaa ya Bomdisoft',
  vietnamese: 'Sản phẩm của Bomdisoft',
};
export const retry: Translation = {
  amharic: 'እንደገና ሞክር',
  arabic: 'إعادة المحاولة',
  bengali: 'আবার চেষ্টা করুন',
  chinese: '重试',
  english: 'Retry',
  estonian: 'Proovi uuesti',
  filipino: 'Subukan muli',
  french: 'Réessayer',
  german: 'Erneut versuchen',
  hindi: 'पुनः प्रयास करें',
  indonesian: 'Coba lagi',
  japanese: '再試行',
  korean: '다시 시도',
  portuguese: 'Tentar novamente',
  russian: 'Повторить',
  spanish: 'Reintentar',
  swahili: 'Jaribu tena',
  vietnamese: 'Thử lại',
};
export const consoleLoadFailed: Translation = {
  amharic: 'ይህ ገጽ አልተጫነም። እባክዎ እንደገና ይሞክሩ።',
  arabic: 'تعذّر تحميل هذه الصفحة. يرجى المحاولة مرة أخرى.',
  bengali: 'এই পৃষ্ঠাটি লোড করা যায়নি। অনুগ্রহ করে আবার চেষ্টা করুন।',
  chinese: '无法加载此页面，请重试。',
  english: 'This page could not be loaded. Please try again.',
  estonian: 'Seda lehte ei õnnestunud laadida. Palun proovi uuesti.',
  filipino: 'Hindi ma-load ang pahinang ito. Pakisubukang muli.',
  french: 'Cette page n’a pas pu être chargée. Veuillez réessayer.',
  german: 'Diese Seite konnte nicht geladen werden. Bitte versuche es erneut.',
  hindi: 'यह पृष्ठ लोड नहीं हो सका। कृपया पुनः प्रयास करें।',
  indonesian: 'Halaman ini tidak dapat dimuat. Silakan coba lagi.',
  japanese: 'このページを読み込めませんでした。もう一度お試しください。',
  korean: '이 페이지를 불러올 수 없습니다. 다시 시도해 주세요.',
  portuguese: 'Não foi possível carregar esta página. Tente novamente.',
  russian: 'Не удалось загрузить эту страницу. Попробуйте ещё раз.',
  spanish: 'No se pudo cargar esta página. Inténtalo de nuevo.',
  swahili: 'Ukurasa huu haukuweza kupakiwa. Tafadhali jaribu tena.',
  vietnamese: 'Không thể tải trang này. Vui lòng thử lại.',
};
// Store badges and the get-the-app page
export const badgeDownloadOnThe: Translation = {
  amharic: 'አውርድ ከ',
  arabic: 'حمّل من',
  bengali: 'ডাউনলোড করুন',
  chinese: '下载于',
  english: 'Download on the',
  estonian: 'Laadi alla',
  filipino: 'I-download sa',
  french: 'Télécharger sur',
  german: 'Laden im',
  hindi: 'डाउनलोड करें',
  indonesian: 'Unduh di',
  japanese: 'ダウンロード',
  korean: '다운로드',
  portuguese: 'Baixar na',
  russian: 'Загрузите в',
  spanish: 'Descargar en',
  swahili: 'Pakua kwenye',
  vietnamese: 'Tải về trên',
};

export const badgeGetItOn: Translation = {
  amharic: 'አግኝ በ',
  arabic: 'احصل عليه من',
  bengali: 'পান',
  chinese: '获取于',
  english: 'Get it on',
  estonian: 'Hangi rakendusest',
  filipino: 'Kunin sa',
  french: 'Disponible sur',
  german: 'Jetzt bei',
  hindi: 'प्राप्त करें',
  indonesian: 'Dapatkan di',
  japanese: '入手',
  korean: '다운로드',
  portuguese: 'Disponível no',
  russian: 'Доступно в',
  spanish: 'Disponible en',
  swahili: 'Ipate kwenye',
  vietnamese: 'Tải về tại',
};

export const badgeComingSoonToThe: Translation = {
  amharic: 'በቅርቡ በ',
  arabic: 'قريبًا على',
  bengali: 'শীঘ্রই আসছে',
  chinese: '即将登陆',
  english: 'Coming soon to the',
  estonian: 'Peagi saadaval',
  filipino: 'Malapit na sa',
  french: 'Bientôt sur',
  german: 'Bald im',
  hindi: 'जल्द ही आ रहा है',
  indonesian: 'Segera hadir di',
  japanese: '近日公開',
  korean: '곧 출시',
  portuguese: 'Em breve na',
  russian: 'Скоро в',
  spanish: 'Próximamente en',
  swahili: 'Inakuja hivi karibuni kwenye',
  vietnamese: 'Sắp có trên',
};

export const badgeComingSoonOn: Translation = {
  amharic: 'በቅርቡ በ',
  arabic: 'قريبًا على',
  bengali: 'শীঘ্রই আসছে',
  chinese: '即将登陆',
  english: 'Coming soon on',
  estonian: 'Peagi saadaval',
  filipino: 'Malapit na sa',
  french: 'Bientôt sur',
  german: 'Bald bei',
  hindi: 'जल्द ही आ रहा है',
  indonesian: 'Segera hadir di',
  japanese: '近日公開',
  korean: '곧 출시',
  portuguese: 'Em breve no',
  russian: 'Скоро в',
  spanish: 'Próximamente en',
  swahili: 'Inakuja hivi karibuni kwenye',
  vietnamese: 'Sắp có trên',
};

export const getTheAppTitle: Translation = {
  amharic: 'መተግበሪያውን ያግኙ',
  arabic: 'احصل على التطبيق',
  bengali: 'অ্যাপটি নিন',
  chinese: '获取应用',
  english: 'Get the app',
  estonian: 'Hangi rakendus',
  filipino: 'Kunin ang app',
  french: 'Obtenir l’application',
  german: 'App holen',
  hindi: 'ऐप प्राप्त करें',
  indonesian: 'Dapatkan aplikasinya',
  japanese: 'アプリを入手',
  korean: '앱 받기',
  portuguese: 'Obter o app',
  russian: 'Скачать приложение',
  spanish: 'Obtener la app',
  swahili: 'Pata programu',
  vietnamese: 'Tải ứng dụng',
};

export const getTheAppHeadline: Translation = {
  amharic: '{product}ን እንዴት መክፈት ይፈልጋሉ?',
  arabic: 'كيف تريد فتح {product}؟',
  bengali: 'আপনি {product} কীভাবে খুলতে চান?',
  chinese: '你想如何打开 {product}？',
  english: 'How do you want to open {product}?',
  estonian: 'Kuidas soovid {product} avada?',
  filipino: 'Paano mo gustong buksan ang {product}?',
  french: 'Comment voulez-vous ouvrir {product} ?',
  german: 'Wie möchtest du {product} öffnen?',
  hindi: 'आप {product} कैसे खोलना चाहते हैं?',
  indonesian: 'Bagaimana Anda ingin membuka {product}?',
  japanese: '{product} をどのように開きますか？',
  korean: '{product}을(를) 어떻게 열까요?',
  portuguese: 'Como você quer abrir o {product}?',
  russian: 'Как вы хотите открыть {product}?',
  spanish: '¿Cómo quieres abrir {product}?',
  swahili: 'Unataka kufungua {product} vipi?',
  vietnamese: 'Bạn muốn mở {product} bằng cách nào?',
};

export const getTheAppSubhead: Translation = {
  amharic: 'መተግበሪያው ለስልክዎ የተሰራ ነው። ድረ-ገጹም እዚህ ይሰራል።',
  arabic: 'التطبيق مصمم لهاتفك. والموقع يعمل هنا أيضًا.',
  bengali: 'অ্যাপটি আপনার ফোনের জন্য তৈরি। সাইটটিও এখানে কাজ করে।',
  chinese: '应用专为你的手机打造。网站在这里同样可用。',
  english: 'The app is made for your phone. The site works here too.',
  estonian: 'Rakendus on tehtud sinu telefoni jaoks. Veebisait töötab siin samuti.',
  filipino: 'Ginawa ang app para sa iyong telepono. Gumagana rin dito ang site.',
  french: 'L’application est conçue pour votre téléphone. Le site fonctionne ici aussi.',
  german: 'Die App ist für dein Telefon gemacht. Die Website funktioniert hier auch.',
  hindi: 'ऐप आपके फ़ोन के लिए बना है। साइट यहाँ भी काम करती है।',
  indonesian: 'Aplikasi ini dibuat untuk ponsel Anda. Situsnya juga berfungsi di sini.',
  japanese: 'アプリはスマートフォン向けに作られています。サイトもここで使えます。',
  korean: '앱은 휴대폰에 맞게 만들어졌습니다. 사이트도 여기서 쓸 수 있습니다.',
  portuguese: 'O app foi feito para o seu celular. O site também funciona aqui.',
  russian: 'Приложение создано для вашего телефона. Сайт здесь тоже работает.',
  spanish: 'La app está hecha para tu teléfono. El sitio también funciona aquí.',
  swahili: 'Programu imetengenezwa kwa simu yako. Tovuti pia inafanya kazi hapa.',
  vietnamese: 'Ứng dụng được làm cho điện thoại của bạn. Trang web cũng dùng được ở đây.',
};

export const getTheAppSubheadUnlisted: Translation = {
  amharic: 'መተግበሪያው በቅርቡ በ{store} ይመጣል። ድረ-ገጹ እዚህ ይሰራል።',
  arabic: 'التطبيق قادم إلى {store}. الموقع يعمل هنا.',
  bengali: 'অ্যাপটি শীঘ্রই {store}-এ আসছে। সাইটটি এখানে কাজ করে।',
  chinese: '应用即将登陆 {store}。网站在这里可用。',
  english: 'The app is coming to the {store}. The site works here.',
  estonian: 'Rakendus jõuab peagi {store}-i. Veebisait töötab siin.',
  filipino: 'Malapit nang dumating ang app sa {store}. Gumagana dito ang site.',
  french: 'L’application arrive bientôt sur {store}. Le site fonctionne ici.',
  german: 'Die App kommt bald in den {store}. Die Website funktioniert hier.',
  hindi: 'ऐप जल्द ही {store} पर आ रहा है। साइट यहाँ काम करती है।',
  indonesian: 'Aplikasi akan segera hadir di {store}. Situsnya berfungsi di sini.',
  japanese: 'アプリは近日 {store} に登場します。サイトはここで使えます。',
  korean: '앱이 곧 {store}에 출시됩니다. 사이트는 여기서 쓸 수 있습니다.',
  portuguese: 'O app chega em breve na {store}. O site funciona aqui.',
  russian: 'Приложение скоро появится в {store}. Сайт здесь работает.',
  spanish: 'La app llegará pronto a {store}. El sitio funciona aquí.',
  swahili: 'Programu inakuja hivi karibuni kwenye {store}. Tovuti inafanya kazi hapa.',
  vietnamese: 'Ứng dụng sắp có trên {store}. Trang web dùng được ở đây.',
};

export const getTheAppStoreRowAppStore: Translation = {
  amharic: 'ከApp Store ያውርዱ',
  arabic: 'حمّل من App Store',
  bengali: 'App Store থেকে ডাউনলোড করুন',
  chinese: '在 App Store 下载',
  english: 'Download on the App Store',
  estonian: 'Laadi alla App Store’ist',
  filipino: 'I-download sa App Store',
  french: 'Télécharger sur l’App Store',
  german: 'Im App Store laden',
  hindi: 'App Store से डाउनलोड करें',
  indonesian: 'Unduh di App Store',
  japanese: 'App Store からダウンロード',
  korean: 'App Store에서 다운로드',
  portuguese: 'Baixar na App Store',
  russian: 'Загрузить в App Store',
  spanish: 'Descargar en el App Store',
  swahili: 'Pakua kwenye App Store',
  vietnamese: 'Tải về trên App Store',
};

export const getTheAppStoreRowGooglePlay: Translation = {
  amharic: 'በGoogle Play ያግኙ',
  arabic: 'احصل عليه من Google Play',
  bengali: 'Google Play থেকে নিন',
  chinese: '在 Google Play 获取',
  english: 'Get it on Google Play',
  estonian: 'Hangi Google Playst',
  filipino: 'Kunin sa Google Play',
  french: 'Disponible sur Google Play',
  german: 'Jetzt bei Google Play',
  hindi: 'Google Play पर प्राप्त करें',
  indonesian: 'Dapatkan di Google Play',
  japanese: 'Google Play で入手',
  korean: 'Google Play에서 다운로드',
  portuguese: 'Disponível no Google Play',
  russian: 'Доступно в Google Play',
  spanish: 'Disponible en Google Play',
  swahili: 'Ipate kwenye Google Play',
  vietnamese: 'Tải về trên Google Play',
};

export const getTheAppStoreRowSoonAppStore: Translation = {
  amharic: 'በቅርቡ በApp Store',
  arabic: 'قريبًا على App Store',
  bengali: 'শীঘ্রই App Store-এ আসছে',
  chinese: '即将登陆 App Store',
  english: 'Coming soon to the App Store',
  estonian: 'Peagi App Store’is',
  filipino: 'Malapit na sa App Store',
  french: 'Bientôt sur l’App Store',
  german: 'Bald im App Store',
  hindi: 'जल्द ही App Store पर',
  indonesian: 'Segera hadir di App Store',
  japanese: 'App Store に近日公開',
  korean: 'App Store에 곧 출시',
  portuguese: 'Em breve na App Store',
  russian: 'Скоро в App Store',
  spanish: 'Próximamente en el App Store',
  swahili: 'Inakuja hivi karibuni kwenye App Store',
  vietnamese: 'Sắp có trên App Store',
};

export const getTheAppStoreRowSoonGooglePlay: Translation = {
  amharic: 'በቅርቡ በGoogle Play',
  arabic: 'قريبًا على Google Play',
  bengali: 'শীঘ্রই Google Play-তে আসছে',
  chinese: '即将登陆 Google Play',
  english: 'Coming soon on Google Play',
  estonian: 'Peagi Google Plays',
  filipino: 'Malapit na sa Google Play',
  french: 'Bientôt sur Google Play',
  german: 'Bald bei Google Play',
  hindi: 'जल्द ही Google Play पर',
  indonesian: 'Segera hadir di Google Play',
  japanese: 'Google Play に近日公開',
  korean: 'Google Play에 곧 출시',
  portuguese: 'Em breve no Google Play',
  russian: 'Скоро в Google Play',
  spanish: 'Próximamente en Google Play',
  swahili: 'Inakuja hivi karibuni kwenye Google Play',
  vietnamese: 'Sắp có trên Google Play',
};

export const getTheAppStoreRowMeta: Translation = {
  amharic: 'መተግበሪያው፣ ለስልክዎ የተሰራ',
  arabic: 'التطبيق، مصمم لهاتفك',
  bengali: 'অ্যাপটি, আপনার ফোনের জন্য তৈরি',
  chinese: '专为你的手机打造的应用',
  english: 'The app, made for your phone',
  estonian: 'Rakendus, tehtud sinu telefoni jaoks',
  filipino: 'Ang app, ginawa para sa iyong telepono',
  french: 'L’application, conçue pour votre téléphone',
  german: 'Die App, gemacht für dein Telefon',
  hindi: 'ऐप, आपके फ़ोन के लिए बना',
  indonesian: 'Aplikasi, dibuat untuk ponsel Anda',
  japanese: 'スマートフォン向けに作られたアプリ',
  korean: '휴대폰에 맞게 만든 앱',
  portuguese: 'O app, feito para o seu celular',
  russian: 'Приложение, созданное для вашего телефона',
  spanish: 'La app, hecha para tu teléfono',
  swahili: 'Programu, iliyotengenezwa kwa simu yako',
  vietnamese: 'Ứng dụng, làm cho điện thoại của bạn',
};

export const getTheAppStoreRowSoonMeta: Translation = {
  amharic: 'እስካሁን አልተዘረዘረም',
  arabic: 'غير متوفر بعد',
  bengali: 'এখনও তালিকাভুক্ত নয়',
  chinese: '尚未上架',
  english: 'Not listed yet',
  estonian: 'Pole veel saadaval',
  filipino: 'Hindi pa nakalista',
  french: 'Pas encore disponible',
  german: 'Noch nicht gelistet',
  hindi: 'अभी सूचीबद्ध नहीं',
  indonesian: 'Belum tersedia',
  japanese: 'まだ公開されていません',
  korean: '아직 등록되지 않음',
  portuguese: 'Ainda não disponível',
  russian: 'Пока недоступно',
  spanish: 'Aún no disponible',
  swahili: 'Bado haijaorodheshwa',
  vietnamese: 'Chưa có trên cửa hàng',
};

export const getTheAppWebRow: Translation = {
  amharic: 'በድር ላይ ይቀጥሉ',
  arabic: 'المتابعة على الويب',
  bengali: 'ওয়েবে চালিয়ে যান',
  chinese: '继续使用网页版',
  english: 'Continue on the web',
  estonian: 'Jätka veebis',
  filipino: 'Magpatuloy sa web',
  french: 'Continuer sur le web',
  german: 'Im Web fortfahren',
  hindi: 'वेब पर जारी रखें',
  indonesian: 'Lanjutkan di web',
  japanese: 'ウェブで続ける',
  korean: '웹에서 계속하기',
  portuguese: 'Continuar na web',
  russian: 'Продолжить в браузере',
  spanish: 'Continuar en la web',
  swahili: 'Endelea kwenye wavuti',
  vietnamese: 'Tiếp tục trên web',
};

export const getTheAppWebRowMeta: Translation = {
  amharic: 'ድረ-ገጹ፣ ለዚህ ስልክ የተዘጋጀ',
  arabic: 'الموقع، بتنسيق يناسب هذا الهاتف',
  bengali: 'সাইটটি, এই ফোনের জন্য সাজানো',
  chinese: '适配这部手机的网站布局',
  english: 'The site, laid out for this phone',
  estonian: 'Veebisait, paigutatud selle telefoni jaoks',
  filipino: 'Ang site, nakaayos para sa teleponong ito',
  french: 'Le site, mis en page pour ce téléphone',
  german: 'Die Website, angepasst an dieses Telefon',
  hindi: 'साइट, इस फ़ोन के लिए व्यवस्थित',
  indonesian: 'Situs, ditata untuk ponsel ini',
  japanese: 'このスマートフォン向けにレイアウトされたサイト',
  korean: '이 휴대폰에 맞춘 사이트',
  portuguese: 'O site, no layout deste celular',
  russian: 'Сайт, свёрстанный под этот телефон',
  spanish: 'El sitio, adaptado a este teléfono',
  swahili: 'Tovuti, iliyopangwa kwa simu hii',
  vietnamese: 'Trang web, bố cục cho điện thoại này',
};

export const getTheAppDesktopRow: Translation = {
  amharic: 'የዴስክቶፕ ስሪት',
  arabic: 'نسخة سطح المكتب',
  bengali: 'ডেস্কটপ সংস্করণ',
  chinese: '桌面版',
  english: 'Desktop version',
  estonian: 'Töölauaversioon',
  filipino: 'Bersyong desktop',
  french: 'Version ordinateur',
  german: 'Desktop-Version',
  hindi: 'डेस्कटॉप संस्करण',
  indonesian: 'Versi desktop',
  japanese: 'デスクトップ版',
  korean: '데스크톱 버전',
  portuguese: 'Versão para computador',
  russian: 'Версия для компьютера',
  spanish: 'Versión de escritorio',
  swahili: 'Toleo la kompyuta',
  vietnamese: 'Phiên bản máy tính',
};

export const getTheAppDesktopRowMeta: Translation = {
  amharic: 'ሙሉ ስፋት ያለው ድረ-ገጽ፣ እንዲገጥም የተቀነሰ',
  arabic: 'الموقع بعرضه الكامل، مصغّر ليناسب الشاشة',
  bengali: 'পূর্ণ প্রস্থের সাইট, মানানসই করতে ছোট করা',
  chinese: '全宽网站，缩小以适应屏幕',
  english: 'The full-width site, zoomed out to fit',
  estonian: 'Täislaiuses veebisait, sobitamiseks vähendatud',
  filipino: 'Ang buong-lapad na site, pinaliit para magkasya',
  french: 'Le site en pleine largeur, réduit pour tenir à l’écran',
  german: 'Die Website in voller Breite, verkleinert auf den Bildschirm',
  hindi: 'पूरी चौड़ाई वाली साइट, फ़िट करने के लिए छोटी की गई',
  indonesian: 'Situs lebar penuh, diperkecil agar pas',
  japanese: 'フル幅のサイトを画面に合わせて縮小表示',
  korean: '전체 너비 사이트를 화면에 맞게 축소',
  portuguese: 'O site em largura total, reduzido para caber',
  russian: 'Сайт во всю ширину, уменьшенный под экран',
  spanish: 'El sitio a ancho completo, reducido para que quepa',
  swahili: 'Tovuti ya upana kamili, imepunguzwa ili itoshe',
  vietnamese: 'Trang web bản đầy đủ, thu nhỏ cho vừa màn hình',
};

export const getTheAppRemembered: Translation = {
  amharic: 'ምርጫዎ በዚህ ስልክ ላይ ይታወሳል።',
  arabic: 'سيتم تذكّر اختيارك على هذا الهاتف.',
  bengali: 'আপনার পছন্দ এই ফোনে মনে রাখা হবে।',
  chinese: '你的选择将保存在这部手机上。',
  english: 'Your choice is remembered on this phone.',
  estonian: 'Sinu valik jäetakse selles telefonis meelde.',
  filipino: 'Maaalala ang pinili mo sa teleponong ito.',
  french: 'Votre choix est mémorisé sur ce téléphone.',
  german: 'Deine Wahl wird auf diesem Telefon gespeichert.',
  hindi: 'आपकी पसंद इस फ़ोन पर याद रखी जाएगी।',
  indonesian: 'Pilihan Anda diingat di ponsel ini.',
  japanese: 'この選択はこのスマートフォンに記憶されます。',
  korean: '선택한 내용은 이 휴대폰에 기억됩니다.',
  portuguese: 'Sua escolha fica salva neste celular.',
  russian: 'Ваш выбор будет сохранён на этом телефоне.',
  spanish: 'Tu elección se recuerda en este teléfono.',
  swahili: 'Chaguo lako litakumbukwa kwenye simu hii.',
  vietnamese: 'Lựa chọn của bạn được ghi nhớ trên điện thoại này.',
};

export const languageOfferBody: Translation = {
  amharic: 'በ{language} ደግሞ ይገኛል።',
  arabic: 'متاح أيضًا {language}.',
  bengali: '{language}ও পাওয়া যাচ্ছে।',
  chinese: '也提供{language}版本。',
  english: 'Also in {language}.',
  estonian: 'Saadaval ka {language}.',
  filipino: 'Available din sa {language}.',
  french: 'Aussi en {language}.',
  german: 'Auch auf {language}.',
  hindi: '{language} में भी उपलब्ध है।',
  indonesian: 'Tersedia juga dalam {language}.',
  japanese: '{language}でもご覧いただけます。',
  korean: '{language}로도 볼 수 있습니다.',
  portuguese: 'Também em {language}.',
  russian: 'Также на {language}.',
  spanish: 'También en {language}.',
  swahili: 'Inapatikana pia kwa {language}.',
  vietnamese: 'Cũng có bằng {language}.',
};

export const languageOfferName: Translation = {
  amharic: 'አማርኛ',
  arabic: 'بالعربية',
  bengali: 'বাংলা',
  chinese: '中文',
  english: 'English',
  estonian: 'eesti keeles',
  filipino: 'Filipino',
  french: 'français',
  german: 'Deutsch',
  hindi: 'हिन्दी',
  indonesian: 'Bahasa Indonesia',
  japanese: '日本語',
  korean: '한국어',
  portuguese: 'português',
  russian: 'русском',
  spanish: 'español',
  swahili: 'Kiswahili',
  vietnamese: 'tiếng Việt',
};

export const languageOfferAction: Translation = {
  amharic: 'በ{language} ይመልከቱ',
  arabic: 'اعرضه {language}',
  bengali: '{language}য় দেখুন',
  chinese: '查看{language}版本',
  english: 'View in {language}',
  estonian: 'Vaata {language}',
  filipino: 'Tingnan sa {language}',
  french: 'Voir en {language}',
  german: 'Auf {language} ansehen',
  hindi: '{language} में देखें',
  indonesian: 'Lihat dalam {language}',
  japanese: '{language}で見る',
  korean: '{language}로 보기',
  portuguese: 'Ver em {language}',
  russian: 'Смотреть на {language}',
  spanish: 'Ver en {language}',
  swahili: 'Tazama kwa {language}',
  vietnamese: 'Xem bằng {language}',
};

export const languageOfferActionShort: Translation = {
  amharic: 'ይመልከቱ',
  arabic: 'اعرضه',
  bengali: 'দেখুন',
  chinese: '查看',
  english: 'View',
  estonian: 'Vaata',
  filipino: 'Tingnan',
  french: 'Voir',
  german: 'Ansehen',
  hindi: 'देखें',
  indonesian: 'Lihat',
  japanese: '見る',
  korean: '보기',
  portuguese: 'Ver',
  russian: 'Смотреть',
  spanish: 'Ver',
  swahili: 'Tazama',
  vietnamese: 'Xem',
};

export const languageOfferDismiss: Translation = {
  amharic: 'ዝጋ',
  arabic: 'إغلاق',
  bengali: 'বন্ধ করুন',
  chinese: '关闭',
  english: 'Close',
  estonian: 'Sulge',
  filipino: 'Isara',
  french: 'Fermer',
  german: 'Schließen',
  hindi: 'बंद करें',
  indonesian: 'Tutup',
  japanese: '閉じる',
  korean: '닫기',
  portuguese: 'Fechar',
  russian: 'Закрыть',
  spanish: 'Cerrar',
  swahili: 'Funga',
  vietnamese: 'Đóng',
};

// Bomdisoft ID console, shared by the login, accounts and billing apps
//
// NOTE: four of these have an older twin further up this file carrying the same
// English, and three of those twins differ in a language nobody reviewing an
// English diff can see: cancelLabel against cancel (Estonian Loobu, not
// Tühista), navGroupAccount against account (Russian Аккаунт, not Счет), and
// metaTitle against signIn (Amharic and Hindi). Folding a differing pair on an
// English-only read ships a copy change nobody decided to make, so those three
// stay separate. saveLabel is the exception and is byte-identical to save, so
// folding that one is safe whenever its three call sites are next touched.
export const cancelLabel: Translation = {
  amharic: 'ሰርዝ',
  arabic: 'إلغاء',
  bengali: 'বাতিল',
  chinese: '取消',
  english: 'Cancel',
  estonian: 'Loobu',
  filipino: 'Kanselahin',
  french: 'Annuler',
  german: 'Abbrechen',
  hindi: 'रद्द करें',
  indonesian: 'Batal',
  japanese: 'キャンセル',
  korean: '취소',
  portuguese: 'Cancelar',
  russian: 'Отмена',
  spanish: 'Cancelar',
  swahili: 'Ghairi',
  vietnamese: 'Hủy',
};

export const chipTwoFactorOff: Translation = {
  amharic: '2ደረጃ ጠፍቷል',
  arabic: 'الثنائية معطّلة',
  bengali: '2FA বন্ধ',
  chinese: '两步验证已关',
  english: '2FA off',
  estonian: '2FA väljas',
  filipino: 'Off ang 2FA',
  french: 'A2F désactivée',
  german: '2FA aus',
  hindi: '2FA बंद',
  indonesian: '2FA nonaktif',
  japanese: '二要素認証オフ',
  korean: '2단계 인증 꺼짐',
  portuguese: '2FA desativada',
  russian: '2FA выключена',
  spanish: '2FA desactivada',
  swahili: '2FA imezimwa',
  vietnamese: 'Tắt 2FA',
};

export const chipTwoFactorOn: Translation = {
  amharic: '2ደረጃ በርቷል',
  arabic: 'الثنائية مفعّلة',
  bengali: '2FA চালু',
  chinese: '两步验证已开',
  english: '2FA on',
  estonian: '2FA sees',
  filipino: 'On ang 2FA',
  french: 'A2F activée',
  german: '2FA an',
  hindi: '2FA चालू',
  indonesian: '2FA aktif',
  japanese: '二要素認証オン',
  korean: '2단계 인증 켜짐',
  portuguese: '2FA ativada',
  russian: '2FA включена',
  spanish: '2FA activada',
  swahili: '2FA imewashwa',
  vietnamese: 'Bật 2FA',
};

export const collapseSidebar: Translation = {
  amharic: 'የጎን አሞሌ ሰብስብ',
  arabic: 'طيّ الشريط الجانبي',
  bengali: 'সাইডবার সঙ্কুচিত করুন',
  chinese: '收起侧边栏',
  english: 'Collapse sidebar',
  estonian: 'Ahenda külgriba',
  filipino: 'I-collapse ang sidebar',
  french: 'Réduire la barre latérale',
  german: 'Seitenleiste einklappen',
  hindi: 'साइडबार समेटें',
  indonesian: 'Ciutkan bilah sisi',
  japanese: 'サイドバーを折りたたむ',
  korean: '사이드바 접기',
  portuguese: 'Recolher barra lateral',
  russian: 'Свернуть боковую панель',
  spanish: 'Contraer la barra lateral',
  swahili: 'Kunja upau wa kando',
  vietnamese: 'Thu gọn thanh bên',
};

export const expandSidebar: Translation = {
  amharic: 'የጎን አሞሌ ዘርጋ',
  arabic: 'توسيع الشريط الجانبي',
  bengali: 'সাইডবার প্রসারিত করুন',
  chinese: '展开侧边栏',
  english: 'Expand sidebar',
  estonian: 'Laienda külgriba',
  filipino: 'I-expand ang sidebar',
  french: 'Développer la barre latérale',
  german: 'Seitenleiste ausklappen',
  hindi: 'साइडबार फैलाएँ',
  indonesian: 'Bentangkan bilah sisi',
  japanese: 'サイドバーを展開する',
  korean: '사이드바 펼치기',
  portuguese: 'Expandir barra lateral',
  russian: 'Развернуть боковую панель',
  spanish: 'Expandir la barra lateral',
  swahili: 'Panua upau wa kando',
  vietnamese: 'Mở rộng thanh bên',
};

export const metaDescription: Translation = {
  amharic: 'ወደ Bomdisoft መለያዎ ይግቡ።',
  arabic: 'سجّل الدخول إلى حساب Bomdisoft الخاص بك.',
  bengali: 'আপনার Bomdisoft অ্যাকাউন্টে সাইন ইন করুন।',
  chinese: '登录您的 Bomdisoft 账户。',
  english: 'Sign in to your Bomdisoft account.',
  estonian: 'Logi sisse oma Bomdisofti kontole.',
  filipino: 'Mag-sign in sa iyong Bomdisoft account.',
  french: 'Connectez-vous à votre compte Bomdisoft.',
  german: 'Melden Sie sich bei Ihrem Bomdisoft-Konto an.',
  hindi: 'अपने Bomdisoft खाते में साइन इन करें।',
  indonesian: 'Masuk ke akun Bomdisoft Anda.',
  japanese: 'Bomdisoft アカウントにサインインします。',
  korean: 'Bomdisoft 계정에 로그인하세요.',
  portuguese: 'Entre na sua conta Bomdisoft.',
  russian: 'Войдите в свой аккаунт Bomdisoft.',
  spanish: 'Inicia sesión en tu cuenta de Bomdisoft.',
  swahili: 'Ingia katika akaunti yako ya Bomdisoft.',
  vietnamese: 'Đăng nhập vào tài khoản Bomdisoft của bạn.',
};

export const metaTitle: Translation = {
  amharic: 'ይግቡ',
  arabic: 'تسجيل الدخول',
  bengali: 'সাইন ইন',
  chinese: '登录',
  english: 'Sign in',
  estonian: 'Logi sisse',
  filipino: 'Mag-sign in',
  french: 'Se connecter',
  german: 'Anmelden',
  hindi: 'साइन इन करें',
  indonesian: 'Masuk',
  japanese: 'サインイン',
  korean: '로그인',
  portuguese: 'Entrar',
  russian: 'Войти',
  spanish: 'Iniciar sesión',
  swahili: 'Ingia',
  vietnamese: 'Đăng nhập',
};

export const navData: Translation = {
  amharic: 'ውሂብ እና ስረዛ',
  arabic: 'البيانات والحذف',
  bengali: 'ডেটা ও মুছে ফেলা',
  chinese: '数据与删除',
  english: 'Data and deletion',
  estonian: 'Andmed ja kustutamine',
  filipino: 'Data at pagtanggal',
  french: 'Données et suppression',
  german: 'Daten und Löschung',
  hindi: 'डेटा और विलोपन',
  indonesian: 'Data dan penghapusan',
  japanese: 'データと削除',
  korean: '데이터 및 삭제',
  portuguese: 'Dados e exclusão',
  russian: 'Данные и удаление',
  spanish: 'Datos y eliminación',
  swahili: 'Data na ufutaji',
  vietnamese: 'Dữ liệu và xóa',
};

export const navDevices: Translation = {
  amharic: 'መሣሪያዎች እና ክፍለ ጊዜዎች',
  arabic: 'الأجهزة والجلسات',
  bengali: 'ডিভাইস ও সেশন',
  chinese: '设备与会话',
  english: 'Devices and sessions',
  estonian: 'Seadmed ja seansid',
  filipino: 'Mga device at session',
  french: 'Appareils et sessions',
  german: 'Geräte und Sitzungen',
  hindi: 'डिवाइस और सत्र',
  indonesian: 'Perangkat dan sesi',
  japanese: 'デバイスとセッション',
  korean: '기기 및 세션',
  portuguese: 'Dispositivos e sessões',
  russian: 'Устройства и сеансы',
  spanish: 'Dispositivos y sesiones',
  swahili: 'Vifaa na vipindi',
  vietnamese: 'Thiết bị và phiên',
};

export const navGroupAccount: Translation = {
  amharic: 'መለያ',
  arabic: 'الحساب',
  bengali: 'অ্যাকাউন্ট',
  chinese: '账户',
  english: 'Account',
  estonian: 'Konto',
  filipino: 'Account',
  french: 'Compte',
  german: 'Konto',
  hindi: 'खाता',
  indonesian: 'Akun',
  japanese: 'アカウント',
  korean: '계정',
  portuguese: 'Conta',
  russian: 'Аккаунт',
  spanish: 'Cuenta',
  swahili: 'Akaunti',
  vietnamese: 'Tài khoản',
};

export const navMore: Translation = {
  amharic: 'ተጨማሪ',
  arabic: 'المزيد',
  bengali: 'আরও',
  chinese: '更多',
  english: 'More',
  estonian: 'Rohkem',
  filipino: 'Higit pa',
  french: 'Plus',
  german: 'Mehr',
  hindi: 'और',
  indonesian: 'Lainnya',
  japanese: 'その他',
  korean: '더 보기',
  portuguese: 'Mais',
  russian: 'Ещё',
  spanish: 'Más',
  swahili: 'Zaidi',
  vietnamese: 'Thêm',
};

export const navOverview: Translation = {
  amharic: 'አጠቃላይ እይታ',
  arabic: 'نظرة عامة',
  bengali: 'সংক্ষিপ্ত বিবরণ',
  chinese: '概览',
  english: 'Overview',
  estonian: 'Ülevaade',
  filipino: 'Pangkalahatang-ideya',
  french: "Vue d'ensemble",
  german: 'Übersicht',
  hindi: 'अवलोकन',
  indonesian: 'Ikhtisar',
  japanese: '概要',
  korean: '개요',
  portuguese: 'Visão geral',
  russian: 'Обзор',
  spanish: 'Resumen',
  swahili: 'Muhtasari',
  vietnamese: 'Tổng quan',
};

export const navProducts: Translation = {
  amharic: 'የተገናኙ ምርቶች',
  arabic: 'المنتجات المتصلة',
  bengali: 'সংযুক্ত পণ্য',
  chinese: '已连接的产品',
  english: 'Connected products',
  estonian: 'Ühendatud tooted',
  filipino: 'Mga nakakonektang produkto',
  french: 'Produits connectés',
  german: 'Verbundene Produkte',
  hindi: 'जुड़े हुए उत्पाद',
  indonesian: 'Produk yang terhubung',
  japanese: '連携中のプロダクト',
  korean: '연결된 제품',
  portuguese: 'Produtos conectados',
  russian: 'Подключённые продукты',
  spanish: 'Productos conectados',
  swahili: 'Bidhaa zilizounganishwa',
  vietnamese: 'Sản phẩm đã kết nối',
};

export const navSecurity: Translation = {
  amharic: 'መግቢያ እና ደህንነት',
  arabic: 'تسجيل الدخول والأمان',
  bengali: 'সাইন ইন ও সুরক্ষা',
  chinese: '登录与安全',
  english: 'Sign-in and security',
  estonian: 'Sisselogimine ja turvalisus',
  filipino: 'Pag-sign in at seguridad',
  french: 'Connexion et sécurité',
  german: 'Anmeldung und Sicherheit',
  hindi: 'साइन इन और सुरक्षा',
  indonesian: 'Masuk dan keamanan',
  japanese: 'サインインとセキュリティ',
  korean: '로그인 및 보안',
  portuguese: 'Entrada e segurança',
  russian: 'Вход и безопасность',
  spanish: 'Inicio de sesión y seguridad',
  swahili: 'Kuingia na usalama',
  vietnamese: 'Đăng nhập và bảo mật',
};

export const removeLabel: Translation = {
  amharic: 'አስወግድ',
  arabic: 'إزالة',
  bengali: 'সরান',
  chinese: '移除',
  english: 'Remove',
  estonian: 'Eemalda',
  filipino: 'Alisin',
  french: 'Supprimer',
  german: 'Entfernen',
  hindi: 'हटाएँ',
  indonesian: 'Hapus',
  japanese: '削除',
  korean: '제거',
  portuguese: 'Remover',
  russian: 'Удалить',
  spanish: 'Quitar',
  swahili: 'Ondoa',
  vietnamese: 'Xóa',
};

export const saveLabel: Translation = {
  amharic: 'አስቀምጥ',
  arabic: 'حفظ',
  bengali: 'সংরক্ষণ',
  chinese: '保存',
  english: 'Save',
  estonian: 'Salvesta',
  filipino: 'I-save',
  french: 'Enregistrer',
  german: 'Speichern',
  hindi: 'सहेजें',
  indonesian: 'Simpan',
  japanese: '保存',
  korean: '저장',
  portuguese: 'Salvar',
  russian: 'Сохранить',
  spanish: 'Guardar',
  swahili: 'Hifadhi',
  vietnamese: 'Lưu',
};

export const securityActionFailed: Translation = {
  amharic: 'አልተሳካም። እባክዎ ደግመው ይሞክሩ።',
  arabic: 'لم ينجح ذلك. حاول مرة أخرى.',
  bengali: 'কাজ করেনি। আবার চেষ্টা করুন।',
  chinese: '操作失败，请重试。',
  english: 'That did not work. Please try again.',
  estonian: 'See ei õnnestunud. Palun proovi uuesti.',
  filipino: 'Hindi ito gumana. Pakiulit.',
  french: 'Cela n’a pas fonctionné. Veuillez réessayer.',
  german: 'Das hat nicht funktioniert. Bitte versuchen Sie es erneut.',
  hindi: 'यह काम नहीं आया। कृपया पुनः प्रयास करें।',
  indonesian: 'Gagal. Silakan coba lagi.',
  japanese: 'うまくいきませんでした。もう一度お試しください。',
  korean: '실패했습니다. 다시 시도해 주세요.',
  portuguese: 'Não funcionou. Tente novamente.',
  russian: 'Не получилось. Попробуйте снова.',
  spanish: 'No funcionó. Inténtalo de nuevo.',
  swahili: 'Haikufanya kazi. Tafadhali jaribu tena.',
  vietnamese: 'Không thành công. Vui lòng thử lại.',
};

export const setUpTwoFactor: Translation = {
  amharic: 'አዘጋጅ',
  arabic: 'إعداد',
  bengali: 'সেট আপ করুন',
  chinese: '设置',
  english: 'Set up',
  estonian: 'Seadista',
  filipino: 'I-set up',
  french: 'Configurer',
  german: 'Einrichten',
  hindi: 'सेट अप करें',
  indonesian: 'Siapkan',
  japanese: '設定',
  korean: '설정',
  portuguese: 'Configurar',
  russian: 'Настроить',
  spanish: 'Configurar',
  swahili: 'Sanidi',
  vietnamese: 'Thiết lập',
};
export const connectAgentText: Translation = {
  amharic: 'ወኪል ያገናኙ',
  arabic: 'ربط وكيل',
  bengali: 'একটি এজেন্ট সংযুক্ত করুন',
  chinese: '连接智能体',
  english: 'Connect an agent',
  estonian: 'Ühenda agent',
  filipino: 'Magkonekta ng ahente',
  french: 'Connecter un agent',
  german: 'Agenten verbinden',
  hindi: 'एजेंट कनेक्ट करें',
  indonesian: 'Hubungkan agen',
  japanese: 'エージェントを接続',
  korean: '에이전트 연결',
  portuguese: 'Conectar um agente',
  russian: 'Подключить агента',
  spanish: 'Conectar un agente',
  swahili: 'Unganisha wakala',
  vietnamese: 'Kết nối tác nhân',
};
export const connectAgentAddressText: Translation = {
  amharic: 'የአገልጋይ አድራሻ',
  arabic: 'عنوان الخادم',
  bengali: 'সার্ভারের ঠিকানা',
  chinese: '服务器地址',
  english: 'Server address',
  estonian: 'Serveri aadress',
  filipino: 'Address ng server',
  french: 'Adresse du serveur',
  german: 'Serveradresse',
  hindi: 'सर्वर का पता',
  indonesian: 'Alamat server',
  japanese: 'サーバーアドレス',
  korean: '서버 주소',
  portuguese: 'Endereço do servidor',
  russian: 'Адрес сервера',
  spanish: 'Dirección del servidor',
  swahili: 'Anwani ya seva',
  vietnamese: 'Địa chỉ máy chủ',
};
export const connectAgentCopyText: Translation = {
  amharic: 'አድራሻውን ቅዳ',
  arabic: 'نسخ العنوان',
  bengali: 'ঠিকানা কপি করুন',
  chinese: '复制地址',
  english: 'Copy address',
  estonian: 'Kopeeri aadress',
  filipino: 'Kopyahin ang address',
  french: "Copier l'adresse",
  german: 'Adresse kopieren',
  hindi: 'पता कॉपी करें',
  indonesian: 'Salin alamat',
  japanese: 'アドレスをコピー',
  korean: '주소 복사',
  portuguese: 'Copiar endereço',
  russian: 'Скопировать адрес',
  spanish: 'Copiar dirección',
  swahili: 'Nakili anwani',
  vietnamese: 'Sao chép địa chỉ',
};
export const connectAgentCopiedText: Translation = {
  amharic: 'ተቀድቷል',
  arabic: 'تم النسخ',
  bengali: 'কপি হয়েছে',
  chinese: '已复制',
  english: 'Copied',
  estonian: 'Kopeeritud',
  filipino: 'Nakopya na',
  french: 'Copiée',
  german: 'Kopiert',
  hindi: 'कॉपी हो गया',
  indonesian: 'Tersalin',
  japanese: 'コピーしました',
  korean: '복사됨',
  portuguese: 'Copiado',
  russian: 'Скопировано',
  spanish: 'Copiada',
  swahili: 'Imenakiliwa',
  vietnamese: 'Đã sao chép',
};
export const connectAgentClientText: Translation = {
  amharic: 'የእርስዎ የAI መተግበሪያ',
  arabic: 'تطبيق الذكاء الاصطناعي لديك',
  bengali: 'আপনার AI অ্যাপ',
  chinese: '你的 AI 应用',
  english: 'Your AI app',
  estonian: 'Teie AI-rakendus',
  filipino: 'Ang iyong AI app',
  french: "Votre application d'IA",
  german: 'Ihre KI-App',
  hindi: 'आपका AI ऐप',
  indonesian: 'Aplikasi AI Anda',
  japanese: 'お使いの AI アプリ',
  korean: '사용하는 AI 앱',
  portuguese: 'Seu app de IA',
  russian: 'Ваше ИИ-приложение',
  spanish: 'Tu aplicación de IA',
  swahili: 'Programu yako ya AI',
  vietnamese: 'Ứng dụng AI của bạn',
};
export const connectAgentClaudeStepText: Translation = {
  amharic: 'በ Claude ውስጥ የማገናኛ ቅንብሮችን ይክፈቱ እና {link} ያክሉ።',
  arabic: 'في Claude، افتح إعدادات الموصلات وأضف {link}.',
  bengali: 'Claude-এ কানেক্টর সেটিংস খুলুন এবং একটি {link} যোগ করুন।',
  chinese: '在 Claude 中打开连接器设置，然后添加{link}。',
  english: 'In Claude, open the connector settings and add a {link}.',
  estonian: "Avage Claude'is konnektorite seaded ja lisage {link}.",
  filipino: 'Sa Claude, buksan ang mga setting ng connector at magdagdag ng {link}.',
  french: 'Dans Claude, ouvrez les paramètres des connecteurs et ajoutez un {link}.',
  german: 'Öffnen Sie in Claude die Connector-Einstellungen und fügen Sie einen {link} hinzu.',
  hindi: 'Claude में कनेक्टर सेटिंग खोलें और एक {link} जोड़ें।',
  indonesian: 'Di Claude, buka pengaturan konektor dan tambahkan {link}.',
  japanese: 'Claude でコネクタの設定を開き、{link}を追加します。',
  korean: 'Claude에서 커넥터 설정을 열고 {link}를 추가하세요.',
  portuguese: 'No Claude, abra as configurações de conectores e adicione um {link}.',
  russian: 'В Claude откройте настройки коннекторов и добавьте {link}.',
  spanish: 'En Claude, abre la configuración de conectores y añade un {link}.',
  swahili: 'Katika Claude, fungua mipangilio ya viunganishi na uongeze {link}.',
  vietnamese: 'Trong Claude, mở phần cài đặt trình kết nối và thêm {link}.',
};
export const connectAgentClaudeLinkText: Translation = {
  amharic: 'ብጁ ማገናኛ',
  arabic: 'موصلًا مخصصًا',
  bengali: 'কাস্টম কানেক্টর',
  chinese: '自定义连接器',
  english: 'custom connector',
  estonian: 'kohandatud konnektor',
  filipino: 'custom connector',
  french: 'connecteur personnalisé',
  german: 'benutzerdefinierten Connector',
  hindi: 'कस्टम कनेक्टर',
  indonesian: 'konektor kustom',
  japanese: 'カスタムコネクタ',
  korean: '사용자 지정 커넥터',
  portuguese: 'conector personalizado',
  russian: 'пользовательский коннектор',
  spanish: 'conector personalizado',
  swahili: 'kiunganishi maalum',
  vietnamese: 'trình kết nối tùy chỉnh',
};
export const connectAgentChatgptStepText: Translation = {
  amharic: 'በ ChatGPT ውስጥ {link}፣ ከዚያ ከ Plugins ገጽ መተግበሪያ ያክሉ።',
  arabic: 'في ChatGPT، {link}، ثم أضف تطبيقًا من صفحة Plugins.',
  bengali: 'ChatGPT-এ {link}, তারপর Plugins পৃষ্ঠা থেকে একটি অ্যাপ যোগ করুন।',
  chinese: '在 ChatGPT 中{link}，然后在 Plugins 页面添加一个应用。',
  english: 'In ChatGPT, {link}, then add an app from the Plugins page.',
  estonian: 'ChatGPT-s {link} ja lisage seejärel lehel Plugins uus rakendus.',
  filipino: 'Sa ChatGPT, {link}, pagkatapos ay magdagdag ng app mula sa Plugins page.',
  french: 'Dans ChatGPT, {link}, puis ajoutez une application depuis la page Plugins.',
  german: 'Öffnen Sie ChatGPT, {link} und fügen Sie dann auf der Seite Plugins eine App hinzu.',
  hindi: 'ChatGPT में {link}, फिर Plugins पेज से एक ऐप जोड़ें।',
  indonesian: 'Di ChatGPT, {link}, lalu tambahkan aplikasi dari halaman Plugins.',
  japanese: 'ChatGPT で{link}、Plugins ページからアプリを追加します。',
  korean: 'ChatGPT에서 {link} Plugins 페이지에서 앱을 추가하세요.',
  portuguese: 'No ChatGPT, {link} e depois adicione um app na página Plugins.',
  russian: 'В ChatGPT {link}, затем добавьте приложение на странице Plugins.',
  spanish: 'En ChatGPT, {link} y luego añade una aplicación desde la página Plugins.',
  swahili: 'Katika ChatGPT, {link}, kisha ongeza programu kutoka ukurasa wa Plugins.',
  vietnamese: 'Trong ChatGPT, {link}, rồi thêm một ứng dụng từ trang Plugins.',
};
export const connectAgentChatgptLinkText: Translation = {
  amharic: 'Developer mode ያብሩ',
  arabic: 'فعّل وضع المطوّر',
  bengali: 'ডেভেলপার মোড চালু করুন',
  chinese: '开启开发者模式',
  english: 'turn on Developer mode',
  estonian: 'lülitage sisse arendajarežiim',
  filipino: 'i-on ang Developer mode',
  french: 'activez le mode développeur',
  german: 'aktivieren Sie den Entwicklermodus',
  hindi: 'डेवलपर मोड चालू करें',
  indonesian: 'aktifkan Mode developer',
  japanese: '開発者モードをオンにし',
  korean: '개발자 모드를 켠 다음',
  portuguese: 'ative o modo de desenvolvedor',
  russian: 'включите режим разработчика',
  spanish: 'activa el modo de desarrollador',
  swahili: 'washa Developer mode',
  vietnamese: 'bật Chế độ nhà phát triển',
};
export const connectAgentPasteClaudeText: Translation = {
  amharic: 'የአገልጋዩን አድራሻ ለጥፈው ያገናኙ።',
  arabic: 'الصق عنوان الخادم ثم اتصل.',
  bengali: 'সার্ভারের ঠিকানা পেস্ট করে সংযুক্ত করুন।',
  chinese: '粘贴服务器地址并连接。',
  english: 'Paste the server address and connect.',
  estonian: 'Kleepige serveri aadress ja looge ühendus.',
  filipino: 'I-paste ang address ng server at kumonekta.',
  french: "Collez l'adresse du serveur et connectez-vous.",
  german: 'Fügen Sie die Serveradresse ein und verbinden Sie.',
  hindi: 'सर्वर का पता पेस्ट करें और कनेक्ट करें।',
  indonesian: 'Tempel alamat server dan hubungkan.',
  japanese: 'サーバーアドレスを貼り付けて接続します。',
  korean: '서버 주소를 붙여넣고 연결하세요.',
  portuguese: 'Cole o endereço do servidor e conecte.',
  russian: 'Вставьте адрес сервера и подключитесь.',
  spanish: 'Pega la dirección del servidor y conecta.',
  swahili: 'Bandika anwani ya seva na uunganishe.',
  vietnamese: 'Dán địa chỉ máy chủ và kết nối.',
};
export const connectAgentPasteChatgptText: Translation = {
  amharic: 'የአገልጋዩን አድራሻ ለጥፈው መተግበሪያውን ይፍጠሩ።',
  arabic: 'الصق عنوان الخادم وأنشئ التطبيق.',
  bengali: 'সার্ভারের ঠিকানা পেস্ট করে অ্যাপটি তৈরি করুন।',
  chinese: '粘贴服务器地址并创建应用。',
  english: 'Paste the server address and create the app.',
  estonian: 'Kleepige serveri aadress ja looge rakendus.',
  filipino: 'I-paste ang address ng server at gawin ang app.',
  french: "Collez l'adresse du serveur et créez l'application.",
  german: 'Fügen Sie die Serveradresse ein und erstellen Sie die App.',
  hindi: 'सर्वर का पता पेस्ट करें और ऐप बनाएँ।',
  indonesian: 'Tempel alamat server dan buat aplikasinya.',
  japanese: 'サーバーアドレスを貼り付けてアプリを作成します。',
  korean: '서버 주소를 붙여넣고 앱을 만드세요.',
  portuguese: 'Cole o endereço do servidor e crie o app.',
  russian: 'Вставьте адрес сервера и создайте приложение.',
  spanish: 'Pega la dirección del servidor y crea la aplicación.',
  swahili: 'Bandika anwani ya seva na uunde programu.',
  vietnamese: 'Dán địa chỉ máy chủ và tạo ứng dụng.',
};
export const connectAgentSignInText: Translation = {
  amharic: 'በ Bomdisoft ይግቡ፣ ከዚያ ኩባንያውን፣ ፕሮጀክቶቹን እና ወኪሉ ምን ማድረግ እንደሚችል ይምረጡ።',
  arabic: 'سجّل الدخول باستخدام Bomdisoft، ثم اختر الشركة والمشاريع وما يُسمح للوكيل بفعله.',
  bengali: 'Bomdisoft দিয়ে সাইন ইন করুন, তারপর কোম্পানি, প্রকল্প এবং এজেন্ট কী করতে পারবে তা বেছে নিন।',
  chinese: '使用 Bomdisoft 登录，然后选择公司、项目以及智能体可以执行的操作。',
  english: 'Sign in with Bomdisoft, then choose the company, the projects and what the agent may do.',
  estonian: 'Logige sisse Bomdisofti kontoga, seejärel valige ettevõte, projektid ja see, mida agent teha tohib.',
  filipino: 'Mag-sign in gamit ang Bomdisoft, pagkatapos ay piliin ang kumpanya, ang mga proyekto at kung ano ang puwedeng gawin ng ahente.',
  french: "Connectez-vous avec Bomdisoft, puis choisissez l'entreprise, les projets et ce que l'agent peut faire.",
  german: 'Melden Sie sich mit Bomdisoft an und wählen Sie dann das Unternehmen, die Projekte und was der Agent tun darf.',
  hindi: 'Bomdisoft से साइन इन करें, फिर कंपनी, प्रोजेक्ट और यह चुनें कि एजेंट क्या कर सकता है।',
  indonesian: 'Masuk dengan Bomdisoft, lalu pilih perusahaan, proyek, dan apa yang boleh dilakukan agen.',
  japanese: 'Bomdisoft でサインインし、会社、プロジェクト、エージェントに許可する操作を選びます。',
  korean: 'Bomdisoft로 로그인한 다음 회사, 프로젝트, 에이전트가 할 수 있는 작업을 선택하세요.',
  portuguese: 'Entre com a Bomdisoft e escolha a empresa, os projetos e o que o agente pode fazer.',
  russian: 'Войдите через Bomdisoft, затем выберите компанию, проекты и то, что разрешено агенту.',
  spanish: 'Inicia sesión con Bomdisoft y elige la empresa, los proyectos y lo que puede hacer el agente.',
  swahili: 'Ingia kwa Bomdisoft, kisha uchague kampuni, miradi na kile ambacho wakala anaruhusiwa kufanya.',
  vietnamese: 'Đăng nhập bằng Bomdisoft, rồi chọn công ty, các dự án và những việc tác nhân được phép làm.',
};
export const connectAgentSignInWorkspacesText: Translation = {
  amharic: 'በ Bomdisoft ይግቡ፣ ከዚያ ኩባንያውን፣ የስራ ቦታዎቹን እና ወኪሉ ምን ማድረግ እንደሚችል ይምረጡ።',
  arabic: 'سجّل الدخول باستخدام Bomdisoft، ثم اختر الشركة ومساحات العمل وما يُسمح للوكيل بفعله.',
  bengali: 'Bomdisoft দিয়ে সাইন ইন করুন, তারপর কোম্পানি, কর্মক্ষেত্র এবং এজেন্ট কী করতে পারবে তা বেছে নিন।',
  chinese: '使用 Bomdisoft 登录，然后选择公司、工作区以及智能体可以执行的操作。',
  english: 'Sign in with Bomdisoft, then choose the company, the workspaces and what the agent may do.',
  estonian: 'Logige sisse Bomdisofti kontoga, seejärel valige ettevõte, tööruumid ja see, mida agent teha tohib.',
  filipino: 'Mag-sign in gamit ang Bomdisoft, pagkatapos ay piliin ang kumpanya, ang mga workspace at kung ano ang puwedeng gawin ng ahente.',
  french: "Connectez-vous avec Bomdisoft, puis choisissez l'entreprise, les espaces de travail et ce que l'agent peut faire.",
  german: 'Melden Sie sich mit Bomdisoft an und wählen Sie dann das Unternehmen, die Arbeitsbereiche und was der Agent tun darf.',
  hindi: 'Bomdisoft से साइन इन करें, फिर कंपनी, कार्यस्थान और यह चुनें कि एजेंट क्या कर सकता है।',
  indonesian: 'Masuk dengan Bomdisoft, lalu pilih perusahaan, ruang kerja, dan apa yang boleh dilakukan agen.',
  japanese: 'Bomdisoft でサインインし、会社、ワークスペース、エージェントに許可する操作を選びます。',
  korean: 'Bomdisoft로 로그인한 다음 회사, 워크스페이스, 에이전트가 할 수 있는 작업을 선택하세요.',
  portuguese: 'Entre com a Bomdisoft e escolha a empresa, os espaços de trabalho e o que o agente pode fazer.',
  russian: 'Войдите через Bomdisoft, затем выберите компанию, рабочие пространства и то, что разрешено агенту.',
  spanish: 'Inicia sesión con Bomdisoft y elige la empresa, los espacios de trabajo y lo que puede hacer el agente.',
  swahili: 'Ingia kwa Bomdisoft, kisha uchague kampuni, maeneo ya kazi na kile ambacho wakala anaruhusiwa kufanya.',
  vietnamese: 'Đăng nhập bằng Bomdisoft, rồi chọn công ty, các không gian làm việc và những việc tác nhân được phép làm.',
};
export const connectAgentDoneText: Translation = {
  amharic: 'ተከናውኗል',
  arabic: 'تم',
  bengali: 'সম্পন্ন',
  chinese: '完成',
  english: 'Done',
  estonian: 'Valmis',
  filipino: 'Tapos na',
  french: 'Terminé',
  german: 'Fertig',
  hindi: 'हो गया',
  indonesian: 'Selesai',
  japanese: '完了',
  korean: '완료',
  portuguese: 'Concluído',
  russian: 'Готово',
  spanish: 'Listo',
  swahili: 'Nimemaliza',
  vietnamese: 'Xong',
};
export const connectAgentProductText: Translation = {
  amharic: 'ምርት',
  arabic: 'المنتج',
  bengali: 'পণ্য',
  chinese: '产品',
  english: 'Product',
  estonian: 'Toode',
  filipino: 'Produkto',
  french: 'Produit',
  german: 'Produkt',
  hindi: 'उत्पाद',
  indonesian: 'Produk',
  japanese: 'プロダクト',
  korean: '제품',
  portuguese: 'Produto',
  russian: 'Продукт',
  spanish: 'Producto',
  swahili: 'Bidhaa',
  vietnamese: 'Sản phẩm',
};

export const chartRightAxisT: Translation = {
  amharic: 'የቀኝ ዘንግ',
  arabic: 'المحور الأيمن',
  bengali: 'ডান অক্ষ',
  chinese: '右轴',
  english: 'right axis',
  estonian: 'parempoolne telg',
  filipino: 'kanang axis',
  french: 'axe de droite',
  german: 'rechte Achse',
  hindi: 'दायां अक्ष',
  indonesian: 'sumbu kanan',
  japanese: '右軸',
  korean: '오른쪽 축',
  portuguese: 'eixo direito',
  russian: 'правая ось',
  spanish: 'eje derecho',
  swahili: 'mhimili wa kulia',
  vietnamese: 'trục bên phải',
};

export const chartOnBucketT: Translation = {
  amharic: '{series} በ{bucket}',
  arabic: '{series} في {bucket}',
  bengali: '{bucket}-এ {series}',
  chinese: '{bucket} 的 {series}',
  english: '{series} on {bucket}',
  estonian: '{series}, {bucket}',
  filipino: '{series} noong {bucket}',
  french: '{series} le {bucket}',
  german: '{series} am {bucket}',
  hindi: '{bucket} को {series}',
  indonesian: '{series} pada {bucket}',
  japanese: '{bucket} の {series}',
  korean: '{bucket}의 {series}',
  portuguese: '{series} em {bucket}',
  russian: '{series}, {bucket}',
  spanish: '{series} el {bucket}',
  swahili: '{series} tarehe {bucket}',
  vietnamese: '{series} vào {bucket}',
};

export const chartAnnotationT: Translation = {
  amharic: 'ማብራሪያ፦ {text}',
  arabic: 'تعليق توضيحي: {text}',
  bengali: 'টীকা: {text}',
  chinese: '注释：{text}',
  english: 'Annotation: {text}',
  estonian: 'Märkus: {text}',
  filipino: 'Anotasyon: {text}',
  french: 'Annotation : {text}',
  german: 'Anmerkung: {text}',
  hindi: 'एनोटेशन: {text}',
  indonesian: 'Anotasi: {text}',
  japanese: '注釈: {text}',
  korean: '주석: {text}',
  portuguese: 'Anotação: {text}',
  russian: 'Аннотация: {text}',
  spanish: 'Anotación: {text}',
  swahili: 'Maelezo: {text}',
  vietnamese: 'Chú thích: {text}',
};

export const chartAnnotationOnReportT: Translation = {
  amharic: '{name} · በዚህ ሪፖርት ላይ',
  arabic: '{name} · في هذا التقرير',
  bengali: '{name} · এই রিপোর্টে',
  chinese: '{name} · 仅此报告',
  english: '{name} · on this report',
  estonian: '{name} · selles aruandes',
  filipino: '{name} · sa ulat na ito',
  french: '{name} · sur ce rapport',
  german: '{name} · in diesem Bericht',
  hindi: '{name} · इस रिपोर्ट पर',
  indonesian: '{name} · di laporan ini',
  japanese: '{name} · このレポート',
  korean: '{name} · 이 보고서',
  portuguese: '{name} · neste relatório',
  russian: '{name} · в этом отчёте',
  spanish: '{name} · en este informe',
  swahili: '{name} · kwenye ripoti hii',
  vietnamese: '{name} · trên báo cáo này',
};

export const chartAnnotationOnProjectT: Translation = {
  amharic: '{name} · በፕሮጀክቱ ላይ',
  arabic: '{name} · في المشروع',
  bengali: '{name} · প্রকল্পে',
  chinese: '{name} · 整个项目',
  english: '{name} · on the project',
  estonian: '{name} · projektis',
  filipino: '{name} · sa proyekto',
  french: '{name} · sur le projet',
  german: '{name} · im Projekt',
  hindi: '{name} · प्रोजेक्ट पर',
  indonesian: '{name} · di proyek',
  japanese: '{name} · プロジェクト全体',
  korean: '{name} · 프로젝트 전체',
  portuguese: '{name} · no projeto',
  russian: '{name} · в проекте',
  spanish: '{name} · en el proyecto',
  swahili: '{name} · kwenye mradi',
  vietnamese: '{name} · trên dự án',
};

export const rowActionsT: Translation = {
  amharic: 'የረድፍ እርምጃዎች',
  arabic: 'إجراءات الصف',
  bengali: 'সারির ক্রিয়া',
  chinese: '行操作',
  english: 'Row actions',
  estonian: 'Rea toimingud',
  filipino: 'Mga aksyon sa row',
  french: 'Actions de la ligne',
  german: 'Zeilenaktionen',
  hindi: 'पंक्ति क्रियाएँ',
  indonesian: 'Tindakan baris',
  japanese: '行の操作',
  korean: '행 작업',
  portuguese: 'Ações da linha',
  russian: 'Действия со строкой',
  spanish: 'Acciones de la fila',
  swahili: 'Vitendo vya safu',
  vietnamese: 'Thao tác hàng',
};

export const memberColumnT: Translation = {
  amharic: 'አባል',
  arabic: 'العضو',
  bengali: 'সদস্য',
  chinese: '成员',
  english: 'Member',
  estonian: 'Liige',
  filipino: 'Miyembro',
  french: 'Membre',
  german: 'Mitglied',
  hindi: 'सदस्य',
  indonesian: 'Anggota',
  japanese: 'メンバー',
  korean: '멤버',
  portuguese: 'Membro',
  russian: 'Участник',
  spanish: 'Miembro',
  swahili: 'Mwanachama',
  vietnamese: 'Thành viên',
};

export const emailCopiedT: Translation = {
  amharic: 'የኢሜይል አድራሻ ተቀድቷል',
  arabic: 'تم نسخ البريد الإلكتروني',
  bengali: 'ইমেল ঠিকানা কপি হয়েছে',
  chinese: '邮箱地址已复制',
  english: 'Email address copied',
  estonian: 'E-posti aadress kopeeritud',
  filipino: 'Nakopya ang email address',
  french: 'Adresse e-mail copiée',
  german: 'E-Mail-Adresse kopiert',
  hindi: 'ईमेल पता कॉपी किया गया',
  indonesian: 'Alamat email disalin',
  japanese: 'メールアドレスをコピーしました',
  korean: '이메일 주소를 복사했습니다',
  portuguese: 'Endereço de e-mail copiado',
  russian: 'Адрес электронной почты скопирован',
  spanish: 'Dirección de correo copiada',
  swahili: 'Anwani ya barua pepe imenakiliwa',
  vietnamese: 'Đã sao chép địa chỉ email',
};

export const emailCopyFailedT: Translation = {
  amharic: 'መቅዳት አልተቻለም። አድራሻው በዝርዝሩ ውስጥ ይገኛል።',
  arabic: 'تعذّر النسخ. العنوان موجود في القائمة.',
  bengali: 'কপি করা যায়নি। ঠিকানাটি তালিকায় রয়েছে।',
  chinese: '无法复制。该地址在列表中。',
  english: 'Could not copy. The address is in the list.',
  estonian: 'Kopeerimine ebaõnnestus. Aadress on loendis.',
  filipino: 'Hindi makopya. Nasa listahan ang address.',
  french: 'Copie impossible. L’adresse figure dans la liste.',
  german: 'Kopieren nicht möglich. Die Adresse steht in der Liste.',
  hindi: 'कॉपी नहीं हो सका। पता सूची में है।',
  indonesian: 'Tidak dapat menyalin. Alamatnya ada di daftar.',
  japanese: 'コピーできませんでした。アドレスは一覧にあります。',
  korean: '복사할 수 없습니다. 주소는 목록에 있습니다.',
  portuguese: 'Não foi possível copiar. O endereço está na lista.',
  russian: 'Не удалось скопировать. Адрес есть в списке.',
  spanish: 'No se pudo copiar. La dirección está en la lista.',
  swahili: 'Imeshindwa kunakili. Anwani ipo kwenye orodha.',
  vietnamese: 'Không thể sao chép. Địa chỉ có trong danh sách.',
};

export const copyEmailT: Translation = {
  amharic: 'ኢሜይል አድራሻ ቅዳ',
  arabic: 'نسخ البريد الإلكتروني',
  bengali: 'ইমেল ঠিকানা কপি করুন',
  chinese: '复制邮箱地址',
  english: 'Copy email address',
  estonian: 'Kopeeri e-posti aadress',
  filipino: 'Kopyahin ang email address',
  french: 'Copier l’adresse e-mail',
  german: 'E-Mail-Adresse kopieren',
  hindi: 'ईमेल पता कॉपी करें',
  indonesian: 'Salin alamat email',
  japanese: 'メールアドレスをコピー',
  korean: '이메일 주소 복사',
  portuguese: 'Copiar endereço de e-mail',
  russian: 'Копировать адрес эл. почты',
  spanish: 'Copiar dirección de correo',
  swahili: 'Nakili anwani ya barua pepe',
  vietnamese: 'Sao chép địa chỉ email',
};

export const noMemberMatchesT: Translation = {
  amharic: 'ተዛማጅ አባል የለም።',
  arabic: 'لا يوجد عضو مطابق.',
  bengali: 'মিলে যাওয়া কোনো সদস্য নেই।',
  chinese: '没有匹配的成员。',
  english: 'No member matches that.',
  estonian: 'Ükski liige ei vasta sellele.',
  filipino: 'Walang miyembrong tumutugma.',
  french: 'Aucun membre ne correspond.',
  german: 'Kein Mitglied passt dazu.',
  hindi: 'कोई मेल खाता सदस्य नहीं।',
  indonesian: 'Tidak ada anggota yang cocok.',
  japanese: '一致するメンバーはいません。',
  korean: '일치하는 멤버가 없습니다.',
  portuguese: 'Nenhum membro corresponde.',
  russian: 'Нет подходящих участников.',
  spanish: 'Ningún miembro coincide.',
  swahili: 'Hakuna mwanachama anayelingana.',
  vietnamese: 'Không có thành viên nào khớp.',
};

export const searchMembersT: Translation = {
  amharic: 'አባላትን ፈልግ',
  arabic: 'ابحث عن الأعضاء',
  bengali: 'সদস্য খুঁজুন',
  chinese: '搜索成员',
  english: 'Search members',
  estonian: 'Otsi liikmeid',
  filipino: 'Maghanap ng miyembro',
  french: 'Rechercher des membres',
  german: 'Mitglieder suchen',
  hindi: 'सदस्य खोजें',
  indonesian: 'Cari anggota',
  japanese: 'メンバーを検索',
  korean: '멤버 검색',
  portuguese: 'Pesquisar membros',
  russian: 'Поиск участников',
  spanish: 'Buscar miembros',
  swahili: 'Tafuta wanachama',
  vietnamese: 'Tìm thành viên',
};
export const scrollTabsBackT: Translation = {
  amharic: 'ትሮችን ወደ ኋላ አሸብልል',
  arabic: 'تمرير علامات التبويب للخلف',
  bengali: 'ট্যাবগুলো পেছনে স্ক্রোল করুন',
  chinese: '向后滚动标签页',
  english: 'Scroll tabs back',
  estonian: 'Keri sakke tagasi',
  filipino: 'I-scroll pabalik ang mga tab',
  french: "Faire défiler les onglets vers l'arrière",
  german: 'Reiter zurückscrollen',
  hindi: 'टैब पीछे स्क्रॉल करें',
  indonesian: 'Gulir tab ke belakang',
  japanese: 'タブを後ろへスクロール',
  korean: '탭을 뒤로 스크롤',
  portuguese: 'Rolar as abas para trás',
  russian: 'Прокрутить вкладки назад',
  spanish: 'Desplazar las pestañas hacia atrás',
  swahili: 'Sogeza vichupo nyuma',
  vietnamese: 'Cuộn các thẻ lùi lại',
};
export const scrollTabsForwardT: Translation = {
  amharic: 'ትሮችን ወደ ፊት አሸብልል',
  arabic: 'تمرير علامات التبويب للأمام',
  bengali: 'ট্যাবগুলো সামনে স্ক্রোল করুন',
  chinese: '向前滚动标签页',
  english: 'Scroll tabs forward',
  estonian: 'Keri sakke edasi',
  filipino: 'I-scroll pasulong ang mga tab',
  french: "Faire défiler les onglets vers l'avant",
  german: 'Reiter vorwärtsscrollen',
  hindi: 'टैब आगे स्क्रॉल करें',
  indonesian: 'Gulir tab ke depan',
  japanese: 'タブを先へスクロール',
  korean: '탭을 앞으로 스크롤',
  portuguese: 'Rolar as abas para a frente',
  russian: 'Прокрутить вкладки вперёд',
  spanish: 'Desplazar las pestañas hacia delante',
  swahili: 'Sogeza vichupo mbele',
  vietnamese: 'Cuộn các thẻ tới trước',
};
export const loadingT: Translation = {
  amharic: 'በመጫን ላይ',
  arabic: 'جارٍ التحميل',
  bengali: 'লোড হচ্ছে',
  chinese: '正在加载',
  english: 'Loading',
  estonian: 'Laadimine',
  filipino: 'Naglo-load',
  french: 'Chargement',
  german: 'Wird geladen',
  hindi: 'लोड हो रहा है',
  indonesian: 'Memuat',
  japanese: '読み込み中',
  korean: '로드 중',
  portuguese: 'Carregando',
  russian: 'Загрузка',
  spanish: 'Cargando',
  swahili: 'Inapakia',
  vietnamese: 'Đang tải',
};
export const ratingSelectorT: Translation = {
  amharic: 'የደረጃ መምረጫ',
  arabic: 'محدد التقييم',
  bengali: 'রেটিং নির্বাচক',
  chinese: '评分选择器',
  english: 'Rating selector',
  estonian: 'Hinde valija',
  filipino: 'Pumili ng rating',
  french: 'Sélecteur de note',
  german: 'Bewertungsauswahl',
  hindi: 'रेटिंग चयनकर्ता',
  indonesian: 'Pemilih peringkat',
  japanese: '評価の選択',
  korean: '평점 선택',
  portuguese: 'Seletor de avaliação',
  russian: 'Выбор оценки',
  spanish: 'Selector de valoración',
  swahili: 'Kichaguzi cha ukadiriaji',
  vietnamese: 'Bộ chọn đánh giá',
};
export const resizeDrawerT: Translation = {
  amharic: 'የጎን ፓነሉን መጠን ቀይር',
  arabic: 'تغيير حجم اللوحة الجانبية',
  bengali: 'পাশের প্যানেলের আকার বদলান',
  chinese: '调整侧边面板大小',
  english: 'Resize drawer',
  estonian: 'Muuda külgpaneeli suurust',
  filipino: 'Baguhin ang laki ng drawer',
  french: 'Redimensionner le panneau',
  german: 'Seitenleiste in der Größe ändern',
  hindi: 'साइड पैनल का आकार बदलें',
  indonesian: 'Ubah ukuran panel samping',
  japanese: 'サイドパネルのサイズを変更',
  korean: '사이드 패널 크기 조정',
  portuguese: 'Redimensionar o painel lateral',
  russian: 'Изменить размер боковой панели',
  spanish: 'Cambiar el tamaño del panel lateral',
  swahili: 'Badilisha ukubwa wa paneli ya pembeni',
  vietnamese: 'Đổi kích thước bảng bên',
};
export const navigationTabsT: Translation = {
  amharic: 'የአሰሳ ትሮች',
  arabic: 'علامات تبويب التنقل',
  bengali: 'নেভিগেশন ট্যাব',
  chinese: '导航标签页',
  english: 'Navigation tabs',
  estonian: 'Navigeerimise sakid',
  filipino: 'Mga tab ng nabigasyon',
  french: 'Onglets de navigation',
  german: 'Navigationsreiter',
  hindi: 'नेविगेशन टैब',
  indonesian: 'Tab navigasi',
  japanese: 'ナビゲーションタブ',
  korean: '탐색 탭',
  portuguese: 'Abas de navegação',
  russian: 'Вкладки навигации',
  spanish: 'Pestañas de navegación',
  swahili: 'Vichupo vya urambazaji',
  vietnamese: 'Các thẻ điều hướng',
};
export const closeNotificationT: Translation = {
  amharic: 'ማሳወቂያውን ዝጋ',
  arabic: 'إغلاق الإشعار',
  bengali: 'বিজ্ঞপ্তি বন্ধ করুন',
  chinese: '关闭通知',
  english: 'Close notification',
  estonian: 'Sulge teavitus',
  filipino: 'Isara ang abiso',
  french: 'Fermer la notification',
  german: 'Benachrichtigung schließen',
  hindi: 'सूचना बंद करें',
  indonesian: 'Tutup notifikasi',
  japanese: '通知を閉じる',
  korean: '알림 닫기',
  portuguese: 'Fechar notificação',
  russian: 'Закрыть уведомление',
  spanish: 'Cerrar notificación',
  swahili: 'Funga arifa',
  vietnamese: 'Đóng thông báo',
};
export const socialMediaLinksT: Translation = {
  amharic: 'የማኅበራዊ ሚዲያ አገናኞች',
  arabic: 'روابط وسائل التواصل الاجتماعي',
  bengali: 'সোশ্যাল মিডিয়া লিঙ্ক',
  chinese: '社交媒体链接',
  english: 'Social media links',
  estonian: 'Sotsiaalmeedia lingid',
  filipino: 'Mga link sa social media',
  french: 'Liens vers les réseaux sociaux',
  german: 'Links zu sozialen Medien',
  hindi: 'सोशल मीडिया लिंक',
  indonesian: 'Tautan media sosial',
  japanese: 'ソーシャルメディアのリンク',
  korean: '소셜 미디어 링크',
  portuguese: 'Links das redes sociais',
  russian: 'Ссылки на социальные сети',
  spanish: 'Enlaces a redes sociales',
  swahili: 'Viungo vya mitandao ya kijamii',
  vietnamese: 'Liên kết mạng xã hội',
};
export const visitBrandT: Translation = {
  amharic: '{name}ን ጎብኝ',
  arabic: 'زيارة {name}',
  bengali: '{name} দেখুন',
  chinese: '访问 {name}',
  english: 'Visit {name}',
  estonian: 'Külasta {name}',
  filipino: 'Bisitahin ang {name}',
  french: 'Visiter {name}',
  german: '{name} besuchen',
  hindi: '{name} पर जाएँ',
  indonesian: 'Kunjungi {name}',
  japanese: '{name} を開く',
  korean: '{name} 방문',
  portuguese: 'Visitar {name}',
  russian: 'Перейти в {name}',
  spanish: 'Visitar {name}',
  swahili: 'Tembelea {name}',
  vietnamese: 'Truy cập {name}',
};
export const shareActionT: Translation = {
  amharic: 'አጋራ',
  arabic: 'مشاركة',
  bengali: 'শেয়ার করুন',
  chinese: '分享',
  english: 'Share',
  estonian: 'Jaga',
  filipino: 'Ibahagi',
  french: 'Partager',
  german: 'Teilen',
  hindi: 'साझा करें',
  indonesian: 'Bagikan',
  japanese: '共有',
  korean: '공유',
  portuguese: 'Compartilhar',
  russian: 'Поделиться',
  spanish: 'Compartir',
  swahili: 'Shiriki',
  vietnamese: 'Chia sẻ',
};
export const shareOnSocialMediaT: Translation = {
  amharic: 'በማኅበራዊ ሚዲያ አጋራ',
  arabic: 'المشاركة على وسائل التواصل الاجتماعي',
  bengali: 'সোশ্যাল মিডিয়ায় শেয়ার করুন',
  chinese: '分享到社交媒体',
  english: 'Share on social media',
  estonian: 'Jaga sotsiaalmeedias',
  filipino: 'Ibahagi sa social media',
  french: 'Partager sur les réseaux sociaux',
  german: 'In sozialen Medien teilen',
  hindi: 'सोशल मीडिया पर साझा करें',
  indonesian: 'Bagikan di media sosial',
  japanese: 'SNS で共有',
  korean: '소셜 미디어에 공유',
  portuguese: 'Compartilhar nas redes sociais',
  russian: 'Поделиться в соцсетях',
  spanish: 'Compartir en redes sociales',
  swahili: 'Shiriki kwenye mitandao ya kijamii',
  vietnamese: 'Chia sẻ lên mạng xã hội',
};
export const shareOnBrandT: Translation = {
  amharic: 'በ{name} አጋራ',
  arabic: 'المشاركة على {name}',
  bengali: '{name}-এ শেয়ার করুন',
  chinese: '分享到 {name}',
  english: 'Share on {name}',
  estonian: 'Jaga: {name}',
  filipino: 'Ibahagi sa {name}',
  french: 'Partager sur {name}',
  german: 'Auf {name} teilen',
  hindi: '{name} पर साझा करें',
  indonesian: 'Bagikan di {name}',
  japanese: '{name} で共有',
  korean: '{name}에 공유',
  portuguese: 'Compartilhar no {name}',
  russian: 'Поделиться в {name}',
  spanish: 'Compartir en {name}',
  swahili: 'Shiriki kwenye {name}',
  vietnamese: 'Chia sẻ lên {name}',
};
export const openDocsNavigationT: Translation = {
  amharic: 'የሰነዶችን አሰሳ ክፈት',
  arabic: 'فتح تنقل المستندات',
  bengali: 'ডকুমেন্টেশনের নেভিগেশন খুলুন',
  chinese: '打开文档导航',
  english: 'Open docs navigation',
  estonian: 'Ava dokumentatsiooni navigeerimine',
  filipino: 'Buksan ang nabigasyon ng docs',
  french: 'Ouvrir la navigation de la documentation',
  german: 'Dokumentationsnavigation öffnen',
  hindi: 'दस्तावेज़ नेविगेशन खोलें',
  indonesian: 'Buka navigasi dokumentasi',
  japanese: 'ドキュメントのナビゲーションを開く',
  korean: '문서 탐색 열기',
  portuguese: 'Abrir a navegação da documentação',
  russian: 'Открыть навигацию по документации',
  spanish: 'Abrir la navegación de la documentación',
  swahili: 'Fungua urambazaji wa nyaraka',
  vietnamese: 'Mở điều hướng tài liệu',
};
export const ratingValueT: Translation = {
  amharic: 'ደረጃ: {value}',
  arabic: 'التقييم: {value}',
  bengali: 'রেটিং: {value}',
  chinese: '评分：{value}',
  english: 'Rating: {value}',
  estonian: 'Hinne: {value}',
  filipino: 'Rating: {value}',
  french: 'Note : {value}',
  german: 'Bewertung: {value}',
  hindi: 'रेटिंग: {value}',
  indonesian: 'Peringkat: {value}',
  japanese: '評価: {value}',
  korean: '평점: {value}',
  portuguese: 'Avaliação: {value}',
  russian: 'Оценка: {value}',
  spanish: 'Valoración: {value}',
  swahili: 'Ukadiriaji: {value}',
  vietnamese: 'Đánh giá: {value}',
};
export const callNumberT: Translation = {
  amharic: 'ወደ {number} ደውል',
  arabic: 'الاتصال بالرقم {number}',
  bengali: '{number}-এ কল করুন',
  chinese: '拨打 {number}',
  english: 'Call {number}',
  estonian: 'Helista numbrile {number}',
  filipino: 'Tawagan ang {number}',
  french: 'Appeler le {number}',
  german: '{number} anrufen',
  hindi: '{number} पर कॉल करें',
  indonesian: 'Telepon {number}',
  japanese: '{number} に電話',
  korean: '{number}에 전화',
  portuguese: 'Ligar para {number}',
  russian: 'Позвонить по номеру {number}',
  spanish: 'Llamar al {number}',
  swahili: 'Piga simu {number}',
  vietnamese: 'Gọi {number}',
};
export const sendEmailToT: Translation = {
  amharic: 'ወደ {email} ኢሜይል ላክ',
  arabic: 'إرسال بريد إلكتروني إلى {email}',
  bengali: '{email}-এ ইমেল পাঠান',
  chinese: '发送邮件至 {email}',
  english: 'Send email to {email}',
  estonian: 'Saada e-kiri aadressile {email}',
  filipino: 'Mag-email sa {email}',
  french: 'Envoyer un e-mail à {email}',
  german: 'E-Mail an {email} senden',
  hindi: '{email} पर ईमेल भेजें',
  indonesian: 'Kirim email ke {email}',
  japanese: '{email} にメールを送信',
  korean: '{email}(으)로 이메일 보내기',
  portuguese: 'Enviar e-mail para {email}',
  russian: 'Написать на {email}',
  spanish: 'Enviar un correo a {email}',
  swahili: 'Tuma barua pepe kwa {email}',
  vietnamese: 'Gửi email đến {email}',
};

export const editFieldT: Translation = {
  amharic: '{name} አርትዕ',
  arabic: 'تعديل {name}',
  bengali: '{name} সম্পাদনা করুন',
  chinese: '编辑{name}',
  english: 'Edit {name}',
  estonian: 'Muuda: {name}',
  filipino: 'I-edit ang {name}',
  french: 'Modifier {name}',
  german: '{name} bearbeiten',
  hindi: '{name} संपादित करें',
  indonesian: 'Edit {name}',
  japanese: '{name}を編集',
  korean: '{name} 편집',
  portuguese: 'Editar {name}',
  russian: 'Изменить: {name}',
  spanish: 'Editar {name}',
  swahili: 'Hariri {name}',
  vietnamese: 'Sửa {name}',
};
